/* aa-qubelok-designer.js - r90: the designer JavaScript, moved out of the Liquid
   section (which sat 3.3KB from Shopify's 262144-byte cap). The section keeps ONLY
   the Liquid-generated catalogue data, published on window.__QD50 BEFORE this file
   loads. One closure, exactly as before - no globals leak (the code defines its own $).
   Shopify serves theme .js MINIFIED: verify deploys by code markers and occurrence
   counts, never by checksum (SETTLE-IT trap, 25 Aug 2026). */

(function(){
  var QD_ENDPOINT='https://alucut.allaluminium.workers.dev/quote';
  /* r-shortlink (8 Sep 2026): THE TYPED ADDRESS. ?o=261091&k=AB12 carries no design - only the order
     number and the 4-symbol key the OS minted for it (aa-jobsheet r352) and the packing slip prints under
     the QR. Ask alucut which design that is (GET /design-by-order, alucut 1.39.0) and open it in build
     view, exactly the address the QR itself carries - so from the redirect on, nothing new runs. Runs
     BEFORE anything below reads the query. A link that already carries a design (w=) is left alone; a
     plain visit is left alone; a wrong key gets words in the designer's own message box, not a broken
     page. No backslash-sensitive tricks: this file is a plain asset, not a template literal. */
  (function(){
    try{
      var sl=new URLSearchParams(location.search);
      var slO=String(sl.get('o')||'').replace(/[^0-9]/g,'').slice(0,12);
      var slK=String(sl.get('k')||'').trim().toUpperCase();
      if(!slO || !/^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{4}$/.test(slK) || sl.get('w')) return;
      if(window.__aaShortLinkAsked) return;
      window.__aaShortLinkAsked=1;
      var say=function(msg){
        /* r-shortlink-2: its OWN box, never #qd-msg - the designer blanks #qd-msg the moment its default
           price loads (measured on the live page, 8 Sep), so words put there lasted about a second. */
        try{
          var b=document.getElementById('aa-shortlink-msg');
          if(!b){
            b=document.createElement('div'); b.id='aa-shortlink-msg';
            b.setAttribute('style','margin:12px 0;padding:12px 14px;border:1px solid #b42318;border-radius:8px;background:#fff5f5;font:14px/1.45 system-ui,sans-serif;color:#0e1a4d');
            var host=document.getElementById('qd-app')||document.body;
            if(host.firstChild) host.insertBefore(b, host.firstChild); else host.appendChild(b);
          }
          b.textContent=msg;
        }catch(_es){}
      };
      var fail=function(msg){ say(msg||'No design for that order number and key. Check the letters under the QR code - or email sales@allaluminium.com.au with your order number.'); };
      fetch('https://alucut.allaluminium.workers.dev/design-by-order?o='+encodeURIComponent(slO)+'&k='+encodeURIComponent(slK),{method:'GET',mode:'cors',credentials:'omit',cache:'no-store'})
        .then(function(r){ return r.json().then(function(j){ return {st:r.status,j:j}; },function(){ return {st:r.status,j:null}; }); })
        .then(function(x){
          var u=(x&&x.j&&x.j.ok&&x.j.url)?String(x.j.url):'';
          if(u && u.indexOf('/pages/alucube-designer')>=0){
            var q=u.indexOf('?'), base=(q<0)?u:u.slice(0,q), keep=[];
            var parts=(q<0)?[]:u.slice(q+1).split('&');
            for(var i=0;i<parts.length;i++){
              if(!parts[i]) continue;
              var kk=parts[i].split('=')[0];
              if(kk==='build'||kk==='o'||kk==='k'||kk==='edit_bundle'||kk==='edit_key') continue;
              keep.push(parts[i]);
            }
            keep.push('build=1'); keep.push('o='+slO);
            location.replace(base+'?'+keep.join('&'));
            return;
          }
          var words=(x&&x.j&&x.j.errors&&x.j.errors[0])?String(x.j.errors[0]):'';
          if(x&&x.st===429) fail(words||'Too many tries. Wait a minute and type the address again.');
          else if(!x||!x.j||x.st>=500) fail('Could not look that address up right now. Try again in a minute, or email sales@allaluminium.com.au with your order number.');
          else fail(words);
        })
        .catch(function(){ fail('Could not look that address up right now. Try again in a minute, or email sales@allaluminium.com.au with your order number.'); });
    }catch(_esl){}
  })();
  // Route the worker call through the shared session gate when present (attaches the
  // Turnstile session when the gate is on; plain fetch when off). Returns a
  // Response-like object so the existing .then(r=>r.json()) chain keeps working.
  function aaFetch(url, opts){
    /* r-one-gate-2 22 Aug 2026: this used to prefer window.AACut.quote - which runs
       its OWN full session cycle - and then the global fetch wrapper in theme.liquid
       gated the same request AGAIN. On a device Cloudflare refuses (VPNs), that
       chained TWO multi-minute challenge cycles before any error could show:
       measured as "waiting over a minute" at $0.00. Plain fetch now: the wrapper is
       the single gate - it delegates to AACut's visible-challenge machinery, keeps
       the session in memory, and fails fast after a refusal. One cycle, ever. */
    return fetch(url, opts);
  }
  var QD_CACHE={};
  // Warm the Cloudflare worker the moment the page loads, so it's ready before the
  // first real quote (removes the cold-start pause on the very first price).
  try{ fetch('https://alucut.allaluminium.workers.dev/',{method:'GET',mode:'cors'}).catch(function(){}); }catch(e){}
  // ---- live price lookup -------------------------------------------------
  // Prices below used to be baked in and went stale every time the store was
  // repriced, which showed the customer one number and charged another. They
  // are now read from Shopify at render time. The literal after each qdP() is
  // the value as at 16 Aug 2026 and is used only if the lookup comes back empty
  // (product renamed / unpublished / all_products budget exhausted), so the
  // worst case is today's behaviour, never a zero price.
  // all_products budget: 18 used here + 1 at line ~276 ('cutting-charge') = 19 of 20.
  /* (a Liquid comment lived here in the section; see theme history) */
  var QD_LIVE=window.__QD50.QD_LIVE;
  function qdP(id, fallback){ var c = QD_LIVE[String(id)]; return (typeof c === 'number' && c > 0) ? c : fallback; }
  /* r227: part weights in grams, from the SAME Shopify read as the prices ("w<id>" keys, r227
     section). Missing is null - never 0 - and the engine names what it could not weigh. */
  function qdWeights(){ var o={}, k; for(k in QD_LIVE){ if(k.charAt(0)==='w' && typeof QD_LIVE[k]==='number' && QD_LIVE[k]>0) o[k.slice(1)]=QD_LIVE[k]; } return o; }
  // ------------------------------------------------------------------------
  var TUBE={full:{id:43210644947021,price:qdP(43210644947021,4322)},half:{id:43210644979789,price:qdP(43210644979789,2377)}};
  // Finish choice. Anodised is stocked in FULL length only (no half), so anodised frames buy
  // all bars as full 6.5m lengths. Cutting metafields (3 free, $1/cut) are the same for all finishes.
  var FINISH={
    mill:{ full:{id:43210644947021,price:qdP(43210644947021,4322)}, half:{id:43210644979789,price:qdP(43210644979789,2377)}, hasHalf:true, desc:'25.4 x 25.4 x 1.42mm mill' },
    clear:{ full:{id:43213600096333,price:qdP(43213600096333,5407)}, half:null, hasHalf:false, desc:'25.4 x 25.4 x 1.22mm clear anodised' },
    black:{ full:{id:43213600129101,price:qdP(43213600129101,6124)}, half:null, hasHalf:false, desc:'25.4 x 25.4 x 1.22mm black anodised' }
  };
  var qdFinish='mill';
  var LIPPED={   // one-leg lipped tube, matches the frame finish (full length only, all finishes)
    mill:  { full:{id:43273391079501, price:qdP(43273391079501,4101)} },   // ALLAST2512-1LM
    clear: { full:{id:43213600817229, price:qdP(43213600817229,5982)} },   // ALLAST2512-1LC
    black: { full:{id:43273413591117, price:qdP(43273413591117,6798)} }    // ALLAST2512-1LBK
  };
  var SHEET6=[
    {id:42897541660749, price:qdP(42897541660749,34770), w:1200, l:1200, label:'6mm flat, half sheet (1200x1200)'},
    {id:42897541627981, price:qdP(42897541627981,63219), w:1200, l:2400, label:'6mm flat, full sheet (1200x2400)'},
    {id:42897541693517, price:qdP(42897541693517,79024), w:1200, l:3000, label:'6mm flat, full sheet (1200x3000)'},
    {id:42897541759053, price:qdP(42897541759053,98780), w:1500, l:3000, label:'6mm flat, full sheet (1500x3000)'}
  ];
  // 6mm 5083 marine plate, cut-to-size — the "we supply" AluCube panel (replaces 5005 whole sheets).
  // Priced server-side by the AluCut worker.
  // unit001 is DOLLARS per 0.01 m2, so it is the variant price in cents divided by 100.
  var QD_PLATE={ varId:43290874871885, unit001:(qdP(43290874871885,256)/100), marginMm:10, cutFee:5 };
  /* 20 x 20 x 1.6 equal angle, 6.5m bar — the screw-on panel ledge, matched to the frame finish.
     An existing stocked line; bare "Black" is powder coat with NO setup fee. Prices are read live
     from Shopify like every other line here; the literal is only the 23 Aug 2026 fallback. */
  var ANGLE={
    mill:  { full:{id:43471501787213, price:qdP(43471501787213,1963)} },   // ALLAA2016-FL
    clear: { full:{id:43471501852749, price:qdP(43471501852749,3332)} },   // ALLAA2016C-FL
    black: { full:{id:43471501885517, price:qdP(43471501885517,2983)} }    // ALLAA2016BLA-FL
  };
  /* r78 FEET. Castor wheel + castor socket, one of each per standing leg; caps ride the
     existing end cap entry in CONN. Product ids are the 26 Aug drafts - price falls back
     to the Capral cash-sale match until they are ACTIVE in the store. */
  var QD_FEET={
    castor:  {id:43549489692749, price:qdP(43549489692749,1818)},   // ALLACASTOR
    castsock:{id:43549489758285, price:qdP(43549489758285,1153)}    // ALLACASTSOCK
  };
  var panelFix='lip';        // 'lip' = ET7200 lipped rail (default, all the Worker knew before 1.4.0)
  var qdFeet='none';         // r78: 'caps' | 'castors' - feet under every standing leg
  /* r218 CASTOR HEIGHT. alucut 1.35.0 takes castorFit: 'trim' (default) cuts each
     wheeled leg 61mm shorter so the finished frame stands at the height typed;
     'under' leaves the legs and the frame stands about 61mm taller. Patryk's tick
     sheet, 2 Sep Q2: trim is the default. Anything else the engine REFUSES, so this
     is only ever one of those two strings. */
  var qdCastorFit='trim';
  var qdCastorUIFn=null;   /* r218: set once the Feet control is built */
  var qdFloorRailsFn=null, qdFloorBarsFn=null;   /* r-cf6: Rails=per-bay removal list; Bars=tube count for display */
  /* r219 CASTOR NUMBERS. Every printed number comes from the engine: castorRiseMm and
     floorClearMm arrive on the quote from alucut 1.35.1; before that the rise is read out
     of the engine's OWN feetHeightNote sentence, and the floor clearance is only printed
     where the response lets it be derived (feetTrimmedLens + rise). Nothing is typed here
     twice. The one 61 below is for the DRAWING alone - the wheel stack is a picture of the
     part as Patryk measured it with calipers (r218), the same status as the 3.18mm cap lip
     (r107) - and the engine's figure overrides it the moment one is known. */
  var QD_RISE=null;        /* mm, from the engine; null = unknown, print nothing */
  var QD_FLOORCLEAR=null;  /* mm clear under the bottom rail, floor included; null = unknown */
  var QD_CASTOR_DRAW_MM=61;
  var QD_CAP_DRAW_MM=3;    /* CAP_TRIM_MM: a capped floor leg is cut 3 short, the cap stands 3.18 proud */
  function qdRiseMm(){ return (typeof QD_RISE==='number' && QD_RISE>0) ? QD_RISE : QD_CASTOR_DRAW_MM; }
  /* how much comes off each BARE floor leg piece in the picture - the engine's own rule,
     alucut 1.16.0 (caps, 3) and 1.35.0 (castors 'trim', 61). 'under' trims nothing. */
  function qdFloorTrim(){
    if(qdFeet==='caps') return QD_CAP_DRAW_MM;
    if(qdFeet==='castors' && qdCastorFit==='trim') return qdRiseMm();
    return 0;
  }
  var qdBraceWeak=false;   /* r219: the 2-tier castor bracing fact, painted by the Strength box */
  /* r221 PART CODES ON THE DRAWING - staff only. The codes are the ENGINE's (alucut 1.36.0
     `labels` on the quote, one per role + cut length). A drawn piece gets the code whose role
     and length match its own: the picture's piece lengths equal the engine's cut list piece
     for piece (r219 geo-parity, 242/242), so a mismatch prints "?" rather than a guess.
     Never shown to a customer: the tick only exists inside the is_staff Liquid branch. */
  var qdCodesOn=false;
  var qdGuideOn=false;   /* r227: staff "Load guide" toggle - the table only paints while this is on */
  /* r222 BUILD VIEW. ?build=1 on a design link opens the customer's OWN frame read-only:
     no prices, no cart, no controls, the codes painted on every piece, and a tap on a piece
     says what it is and where it goes - the same engine labels as the stickers in the box
     and the sheet packed with them. The link is only ever sent AFTER the sale (shipping
     email, QR on the sheet), so nothing with a code is shown before purchase. The quote
     still runs - it is where the labels come from - it is just not shown as a price. */
  var qdBuildView=false, qdBuildOrder='';
  var QD_STEP=-1, QD_STEP_PLAN=null;   /* r240: step-by-step build view; -1 = the whole frame */
  /* r-bv4: socket directions from the LAST frameParts used to draw, keyed by grid mm "x,y,z"
     -> ['+x','-y',...]. bvConnStubs reads it to draw a peg in a socket no tube has filled yet
     at the current step. Unused on the whole frame. Same frameParts the cut list uses. */
  var qdNodeDirs=null, qdStubMat=null;
  try{ var _bo=/(^|[?&])o=(\d{1,10})(&|$)/.exec(location.search); if(_bo) qdBuildOrder=_bo[2]; }catch(_ebo){}
  /* r224: the pre-filled assembly enquiry - the contact form's 'AluCube assembly help' branch
     reads enquiry, order, design and piece from the query string (sections/aa-contact r224). */
  function qdAskURL(piece){
    var u='/pages/contact?enquiry=assembly';
    try{ var d=(typeof qdShareURL==='function')?qdShareURL():''; if(d) u+='&design='+encodeURIComponent(d); }catch(_ea){}
    if(qdBuildOrder) u+='&order='+qdBuildOrder;
    if(piece) u+='&piece='+encodeURIComponent(String(piece).slice(0,20));
    return u;
  }
  try{ qdBuildView = /(^|[?&])build=1(&|$)/.test(location.search); }catch(_eb){}
  /* ===== r-qv, 17 Sep 2026: QUOTE VIEW. =========================================
     ?qv=1 is the view a CUSTOMER may be sent BEFORE paying. It shows the drawing and
     the overall size and nothing else: no parts table, no lengths, no step-by-step,
     no "Print this list", no tap-chip. qv implies the build view's read-only chrome,
     so every control and the Add-frame-to-cart button are hidden by the same CSS.
     AND IT DOES NOT PRICE THE FRAME. The pricing call is skipped, so the cut list and
     the part lengths are not in the DOM and not in JS state either - CSS hiding would
     have left them one dev-tools click away. */
  var qdQuoteView = false;
  try{ qdQuoteView = /(^|[?&])qv=1(&|$)/.test(location.search); }catch(_eqv){}
  if(qdQuoteView){
    qdBuildView = true;
    try{ document.body.classList.add('qd-qv'); }catch(_eqv2){}
    /* NOTHING WILL EVER CALL qdBuildPanel IN QV MODE - it is called when a quote lands,
       and qv never asks for one - so the panel sat on "Loading your frame..." for good.
       Measured on staging before this line existed. Paint it once, here. */
    try{
      if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ try{ qdBuildPanel({}); }catch(_e){} });
      else setTimeout(function(){ try{ qdBuildPanel({}); }catch(_e){} },0);
    }catch(_eqv3){}
  }
  /* a promise that never settles: the .then chains below simply never run, so no
     refusal panel fires and nothing is stored. Deliberate, not an oversight. */
  function qdPriceFetch(u, o){ if(qdQuoteView) return new Promise(function(){}); return aaFetch(u, o); }
  /* r230 STALE-QUOTE GUARD (Patryk, 3 Sep: "the connectors are incorrect when editing uprights and
     crossbars"). Every pill, code and kg figure on the drawing reads window.aaLastQuote - which is
     the PREVIOUS frame from the moment an edit changes the grid until the new price lands, and
     stays the previous frame for good when the engine refuses the new one (aaLastQuote keeps the
     last GOOD quote on purpose, r218c - the price panel needs it). Joints are looked up by grid
     index, so after a support is added every index past it names a different joint and the pills
     read another frame's connectors. Read through qdQuoteNow(): null unless the quote on hand is
     for the design on screen (same request key, not refused). A hidden pill is honest. */
  var QD_WANT_KEY=null, QD_LAST_KEY=null, QD_QSER=0;
  function qdQuoteFresh(){ return !window.aaQuoteRefused && QD_LAST_KEY!==null && QD_LAST_KEY===QD_WANT_KEY; }
  function qdQuoteNow(){ var q=window.aaLastQuote; return (q && q.ok===true && qdQuoteFresh()) ? q : null; }
  function qdLabelFor(ax,len,sp){
    var q=qdQuoteNow(), L=(q&&q.labels)||null; if(!L||!L.length) return null;
    var role=sp?'B':((ax==='y')?'P':(ax==='x')?'W':'D'), want=Math.round(len);
    for(var i=0;i<L.length;i++){ if(L[i].code && (L[i].kind||'tube')==='tube' && L[i].code.charAt(0)===role && Math.round(+L[i].len)===want) return L[i]; }
    return null;
  }
  /* r225: panels and joints. A panel is matched by its engine size (either way round, 2mm);
     a joint by its grid indices against the engine's joints[] (yi >= N is a back-board line). */
  var qdConnsOn=false;
  var QD_CONN_TAG={'3corner':'3C','3flat':'3F','4corner':'4C','4flat':'4F','5way':'5W','2way':'2W','6way':'6W'};
  var QD_CONN_NAME={'3C':'3 way corner','3F':'3 way flat','4C':'4 way corner','4F':'4 way flat','5W':'5 way','2W':'2 way','6W':'6 way'};
  function qdPanelLabel(w,h){
    var q=qdQuoteNow(), L=(q&&q.labels)||null; if(!L||!L.length) return null;
    for(var i=0;i<L.length;i++){ var l=L[i]; if(l.kind!=='panel') continue;
      if((Math.abs(l.w-w)<=2&&Math.abs(l.h-h)<=2)||(Math.abs(l.w-h)<=2&&Math.abs(l.h-w)<=2)) return l; }
    return null;
  }
  function qdJointType(xi,yi,zi){
    var q=qdQuoteNow(), J=(q&&q.joints)||null; if(!J||!J.length) return null;
    for(var i=0;i<J.length;i++){ var j=J[i]; if(j[0]===xi&&j[1]===yi&&j[2]===zi) return j[3]; }
    return null;
  }
  function qdJointLabel(xi,yi,zi){ var t=qdJointType(xi,yi,zi); if(!t) return null; var tag=QD_CONN_TAG[t]||'?'; var q=qdQuoteNow(), L=(q&&q.labels)||[]; for(var i=0;i<L.length;i++){ if(L[i].kind==='conn'&&L[i].code===tag) return L[i]; } return {code:tag, role:(QD_CONN_NAME[tag]||t)+' connector', qty:0, where:''}; }
  function qdBuildChip(piece){
    /* r-qv: OFF in quote view. This chip names the piece AND ITS LENGTH, and the build
       view's own comment notes it needs no quote to do that - so it is a length leak on
       a pre-payment document. The whole point of qv is that no length is reachable. */
    if(typeof qdQuoteView !== 'undefined' && qdQuoteView) return;
    var st=document.querySelector('.qd-stage'); if(!st) return;
    var chip=$('qd-build-chip');
    if(!piece){ if(chip) chip.style.display='none'; return; }
    if(!chip){
      chip=document.createElement('div'); chip.id='qd-build-chip';
      chip.style.cssText='position:absolute;top:10px;left:50%;transform:translateX(-50%);z-index:6;display:flex;align-items:center;gap:10px;max-width:min(92%,460px);'
        +'background:rgba(14,26,77,.94);color:#fff;border-radius:14px;padding:8px 10px 8px 14px;font-size:12.5px;line-height:1.35;box-shadow:0 2px 10px rgba(15,23,42,.25)';
      chip.innerHTML='<span id="qd-build-chip-t"></span><button type="button" id="qd-build-chip-x" aria-label="Close" style="flex:0 0 auto;border:0;cursor:pointer;background:rgba(255,255,255,.16);color:#fff;width:24px;height:24px;border-radius:999px;font-size:14px;line-height:1">\u00d7</button>';
      st.appendChild(chip);
      chip.querySelector('#qd-build-chip-x').addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); qdBuildChip(null); });
    }
    var t=$('qd-build-chip-t');
    if(piece.kind==='panel'){
      var PL=qdPanelLabel(piece.w,piece.h);
      t.innerHTML = PL ? ('<strong style="color:#fdba74;font-size:15px">'+PL.code+'</strong> \u2014 '+PL.role+', <strong>'+PL.size+'</strong><br>'+PL.where+(PL.qty?' <span style="opacity:.8">\u00b7 '+PL.qty+' of these</span>':'')+' <a href="'+qdAskURL(PL.code)+'" style="color:#fdba74;text-decoration:underline;white-space:nowrap">Ask us about this piece</a>')
                        : ('<strong>Panel</strong> about '+Math.round(piece.w)+' x '+Math.round(piece.h)+' mm \u2014 no code on this quote yet');
      chip.style.display='flex'; return;
    }
    if(piece.kind==='joint'){
      var JL=qdJointLabel(piece.xi,piece.yi,piece.zi);
      t.innerHTML = JL ? ('<strong style="color:#93c5fd;font-size:15px">'+JL.code+'</strong> \u2014 '+JL.role+(JL.where?': '+JL.where:'')+(JL.qty?' <span style="opacity:.8">\u00b7 '+JL.qty+' on this frame</span>':'')) : '<strong>Connector</strong> \u2014 type not on this quote yet';
      chip.style.display='flex'; return;
    }
    var L=qdLabelFor(piece.ax,piece.len,piece.sp);
    if(L) t.innerHTML='<strong style="color:#fdba74;font-size:15px">'+L.code+'</strong> \u2014 '+L.role+', <strong>'+L.len+' mm</strong><br>'+L.where+(L.qty?' <span style="opacity:.8">\u00b7 '+L.qty+' of these, sticker '+L.code+'</span>':'')+' <a href="'+qdAskURL(L.code)+'" style="color:#fdba74;text-decoration:underline;white-space:nowrap">Ask us about this piece</a>';
    else t.innerHTML='<strong>'+Math.round(piece.len)+' mm</strong> '+(piece.sp?'back board piece':(piece.ax==='y'?'upright':(piece.ax==='x'?'cross rail':'depth rail')))+' \u2014 no code on this quote yet';
    chip.style.display='flex';
  }
  function qdCodeFor(ax,len,sp){
    var q=qdQuoteNow(), L=(q&&q.labels)||null; if(!L||!L.length) return null;
    var l=qdLabelFor(ax,len,sp); return l?l.code:'?';
  }
  var footHL=false;          // r107: RETIRED. The cap is always drawn as the real part; nothing reads this to decide geometry any more.
  var qdAddPending=null;     // r79: {X: mm from the LEFT EDGE to the new support's centre, zi: depth-line index}
  var railLevels='all';      // which levels the INTERIOR divider rails run at; 'all' = every level
  /* r53: DELETED UPRIGHTS. [[xi, zi], ...] grid crossings, mirroring alucut 1.7.0's `noPosts`.
     Grid LINES, not bays: xi runs 0..cols, zi runs 0..rows. Corners can never go. */
  var qdNoPosts=[];
  var qdDelMode=false;        // r54: taps only remove an upright while this is ticked
  /* r55: DELETED RAILS. ['w', level, line, bay] or ['d', level, line, bay] - the horizontal
     pieces between the uprights, mirroring alucut 1.8.0's `noRails`. */
  var qdNoRails=[];
  var qdDelRail=false;
  /* r65: DELETED PANELS. [[li, bk, dj], ...] level / width bay / depth bay, mirroring alucut
     1.13.0's noPanels. The rails under a deleted panel STAY, and stay lipped - Patryk's call,
     25 Aug: deleting a panel changes the panel, never the frame. */
  var qdNoPanels=[];
  var qdDelPanel=false;
  var ENGINE113=false;       // true once a Worker answers 1.13.0 or later (deleted panels)
  var ENGINE111=false;       // r66: true once a Worker answers 1.11.0 or later (single leg PIECES)
  /* r56: tapping SELECTS. Nothing leaves the frame until Delete is pressed. */
  var qdSelPosts=[], qdSelRails=[], qdSelPanels=[];
  /* r197 - WHICH RAILS HOLD THIS PANEL. Patryk: "is there also a way we can see which panel
     gets paired with its rails?" The existing toggle turns EVERY lipped rail green at once,
     which answers "which rails are lipped" and not "which rails hold THIS one".
     Display only: nothing here can reach a part, a cut or a price.
     🛑 THE RULE IS NOT RE-DERIVED HERE. _panelDropped3D already asks exactly this question -
     the cell's two width rails, or its two DEPTH rails on a single-bay frame deeper than it
     is wide, because the lips flip - and that function is itself a mirror of the engine's
     _held / _shelfHeld. A second copy of a rule is a second copy that drifts. */
  /* r202 - THE BACK BOARD AS A SUB-FRAME (needs alucut 1.32+).
     qdSpRows 1..4 · qdSpRails one 'lip'|'plain' per rail line, bottom->top · qdSpOff the
     cells left open. Every default is 1.31.0's single lipped band, and while they are at
     their defaults NOTHING extra goes on the wire. */
  var qdSpRows=1, qdSpRails=null, qdSpOff=[], qdPendSf=null;
  var qdPairSel=null, QD_PAIR_KEY=null, QD_PAIR_ON=true;   // {panel:[li,bk,dj]} | {rail:[...]} | {face:'left'}
  /* r199: the ENGINE'S OWN ECHO of whether this design is on the enclosure branch, where
     floor/top sit in the DEPTH rails by assignment rather than by the flip heuristic.
     Read, never re-derived: mirroring _lipEncl's eleven conditions in the page would be a
     second copy of a rule, and the two would drift the first time one of them changed. */
  var QD_LIP_DEPTH=null;
  function qdLipsFlip(){ return (state.cols||1)===1 && (state.rows||1)===1 && state.D>state.W; }
  /* r199 CORRECTION, caught by the harness before it shipped. On an ENCLOSURE box the top
     and floor are drawn as horizontal cells, so this function answered for them - and it
     was returning the WIDTH rails while the engine reserves the DEPTH rails:
         lipOnSpanShelfG = _lipEncl ? true   "1.23.0: floor/top sit in the DEPTH rails by assignment"
     Lighting the wrong rail is worse than lighting none.
     The engine echoes ONE flag covering both cases it flips for - lipShelfEcho is
     (_deepShelf || _lipEncl) - so prefer that echo over any local re-derivation, and fall
     back to the local deep-shelf test only before the first quote has landed. */
  function qdLipsOnDepth(){
    return (QD_LIP_DEPTH===null) ? qdLipsFlip() : (QD_LIP_DEPTH===true);
  }
  function qdHoldersOf(li,bk,dj){
    return qdLipsOnDepth() ? [['d',li,0,0],['d',li,1,0]]
                           : [['w',li,dj,bk],['w',li,dj+1,bk]];
  }
  /* r218d: is there a SHELF PANEL at this level/bay/row on the design as drawn? The same
     rule rebuild3D uses to decide which shelves to draw (its pLevels block), in one place,
     so the tooltip can never disagree with the picture. */
  function qdPanelAt(li,levels,bk,dj){
    if(panelMode==='none') return false;
    if((panelMode==='back'||panelMode==='backfront') && state.type==='box') return false;   /* vertical faces only */
    if(panelMode==='top' && li!==levels-1) return false;
    if(panelMode==='custom' && !((li===0&&qdFaces.bottom)||(li===levels-1&&qdFaces.top))) return false;
    return !npnHas(li,bk,dj);
  }
  function qdRailHolds(r){
    /* the reverse direction: every panel this rail carries */
    var out=[]; if(!r) return out;
    var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
    var levels=g.ys.length, bays=Math.max(1,state.cols||1), deep=Math.max(1,state.rows||1);
    for(var li=0; li<levels; li++) for(var bk=0; bk<bays; bk++) for(var dj=0; dj<deep; dj++){
      if(!qdPanelAt(li,levels,bk,dj)) continue;   /* r218d: no panel there, nothing to carry */
      var hs=qdHoldersOf(li,bk,dj);
      for(var i=0;i<hs.length;i++){
        if(hs[i][0]===r[0] && hs[i][1]===r[1] && hs[i][2]===r[2] && hs[i][3]===r[3]){ out.push([li,bk,dj]); break; }
      }
    }
    return out;
  }
  function qdPairClear(){ if(qdPairSel){ qdPairSel=null; qdPairNote(); return true; } return false; }
  /* r199 - WHICH MEMBERS HOLD A VERTICAL FACE PANEL.
     🛑 NOT INVENTED. This is the engine's own reservation, alucut 1.31.0 lines 2459-2481,
     comments included:
         floor/top  -> pull(dSegs[0], 2)   "floor/top: their depth rails"
         back/front -> pull(wSegs[0], 2)   "back/front: their width rails"
         left/right -> pull(hSegs[0], 2)   "sides: their own legs"
     and four-edge support lips the OTHER two members of each ticked face:
         floor/top extra  -> that level's WIDTH rails
         back/front extra -> that face's own LEGS
         left/right extra -> that side's DEPTH rails
     Note this is DIFFERENT from the shelf-cell rule, which uses the width rails - which is
     exactly why guessing here would have lit the wrong tubes.
     It applies on the enclosure branch only, and the engine REFUSES face-by-face panels off
     that branch, so a priced faces design is always on it. QD_LIP_DEPTH is the proof. */
  function qdFaceHolders(fk){
    var TOP=1, FLOOR=0;                       // a box frame has exactly two levels
    var out=[], i;
    if(fk==='top'||fk==='bottom'){
      var li=(fk==='top')?TOP:FLOOR;
      for(i=0;i<2;i++) out.push({k:'rail', ax:'d', li:li, line:i});
      if(qdLips4 && qdLips4[fk]) for(i=0;i<2;i++) out.push({k:'rail', ax:'w', li:li, line:i, extra:1});
    } else if(fk==='back'||fk==='front'){
      var zl=(fk==='back')?0:1;
      for(i=0;i<2;i++) out.push({k:'rail', ax:'w', li:i, line:zl});
      if(qdLips4 && qdLips4[fk]) for(i=0;i<2;i++) out.push({k:'post', xi:i, zi:zl, extra:1});
    } else if(fk==='left'||fk==='right'){
      var xl=(fk==='left')?0:1;
      for(i=0;i<2;i++) out.push({k:'post', xi:xl, zi:i});
      if(qdLips4 && qdLips4[fk]) for(i=0;i<2;i++) out.push({k:'rail', ax:'d', li:i, line:xl, extra:1});
    }
    return out;
  }
  /* r199: NOT called QD_FACE_NAME - that name is ALREADY TAKEN further down this file
     ({top:'top', bottom:'bottom', ...}) and a second `var` of the same name in the same
     scope is silent: the later one wins and mine was never used. The note read "The right
     side sits in..." instead of "The right side panel sits in..." and that one word is the
     only reason I noticed. Same family as the duplicate-object-key trap already on record. */
  var QD_PAIR_FACE_NAME={top:'top panel',bottom:'floor panel',front:'front panel',back:'back panel',left:'left side panel',right:'right side panel'};
  function qdFaceMemberName(h){
    if(h.k==='post') return (h.xi===0?'left':'right')+' '+(h.zi===0?'back':'front')+' leg';
    var lvl=(h.li===0)?'floor':'top';
    if(h.ax==='d') return lvl+' rail, '+(h.line===0?'left':'right')+' (runs front to back)';
    return lvl+' rail, '+(h.line===0?'back':'front')+' (runs across the width)';
  }
  function qdRailName(r){
    var lvl = (r[1]===0) ? 'floor' : ((r[1]===1 && (state.type!=='shelf')) ? 'top' : ('level ' + (r[1]+1)));
    if(state.type==='shelf' && r[1]===(Math.max(2,state.tiers)-1)) lvl='top';
    var side;
    if(r[0]==='w') side = (r[2]===0) ? 'back' : ((r[2]===(state.rows||1)) ? 'front' : 'middle');
    else           side = (r[2]===0) ? 'left' : ((r[2]===(state.cols||1)) ? 'right' : 'middle');
    return lvl + ' rail, ' + side + (r[0]==='w' ? ' (runs across the width)' : ' (runs front to back)');
  }
  /* r210: THE WAY OUT HAS TO BE WHERE THE CHANGE IS.
     The explanation and its Clear link live in #qd-pair-note, UNDER the drawing - off the
     bottom of the screen in Easy mode. So a customer tapped a panel, watched the frame change
     at the top, and had no visible way back: "then after im not sure what i have to do as it
     feels like i hit a trap" (Patryk, 31 Aug). This puts a chip ON the drawing with an x, and
     Esc and a tap on empty space both clear it as well. */
  function qdPairChipText(){
    if(!qdPairSel) return '';
    if(qdPairSel.face){
      var fk=qdPairSel.face, fh=qdFaceHolders(fk), nm=(QD_PAIR_FACE_NAME[fk]||'panel');
      if(QD_LIP_DEPTH!==true || !fh.length) return 'Lips here are picked by the engine \u2014 not shown';
      return 'The ' + nm + ' sits in ' + fh.filter(function(h){return !h.extra;}).length + ' lipped members';
    }
    if(qdPairSel.panel){
      var hs=qdHoldersOf(qdPairSel.panel[0],qdPairSel.panel[1],qdPairSel.panel[2]);
      return 'These ' + hs.length + ' amber rails hold that panel';
    }
    var hold=qdRailHolds(qdPairSel.rail);
    return qdRailName(qdPairSel.rail) + (hold.length ? (' \u2014 carries ' + hold.length + ' panel' + (hold.length===1?'':'s')) : ' \u2014 no panel on it');   /* r218d */
  }
  function qdPairChip(){
    var st=document.querySelector('.qd-stage'); if(!st) return;
    var chip=$('qd-pair-chip');
    if(!qdPairSel){ if(chip) chip.style.display='none'; return; }
    if(!chip){
      chip=document.createElement('div'); chip.id='qd-pair-chip';
      chip.style.cssText='position:absolute;top:10px;left:50%;transform:translateX(-50%);z-index:6;'
        +'display:flex;align-items:center;gap:10px;max-width:min(92%,460px);'
        +'background:rgba(14,26,77,.94);color:#fff;border-radius:999px;padding:7px 8px 7px 14px;'
        +'font-size:12.5px;line-height:1.35;box-shadow:0 2px 10px rgba(15,23,42,.25)';
      chip.innerHTML='<span id="qd-pair-chip-t"></span>'
        +'<button type="button" id="qd-pair-chip-x" aria-label="Stop showing this"'
        +' style="flex:0 0 auto;border:0;cursor:pointer;background:rgba(255,255,255,.16);color:#fff;'
        +'width:24px;height:24px;border-radius:999px;font-size:14px;line-height:1">\u00d7</button>';
      st.appendChild(chip);
      chip.querySelector('#qd-pair-chip-x').addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation(); if(qdPairClear()) rebuild3D(); });
    }
    var t=$('qd-pair-chip-t'); if(t) t.textContent=qdPairChipText();
    chip.style.display='flex';
  }
  function qdPairNote(){
    qdPairChip();
    try{ qdGuideRowHL(); }catch(_e228b){}   /* r228 */
    var el=$('qd-pair-note'); if(!el) return;
    if(!qdPairSel){ el.style.display='none'; el.innerHTML=''; return; }
    var html='';
    if(qdPairSel.face){
      var fk=qdPairSel.face, fh=qdFaceHolders(fk);
      if(QD_LIP_DEPTH!==true || !fh.length){
        /* Say what cannot be shown rather than show a confident wrong answer. The
           assignment above is the enclosure branch's; off that branch the engine picks
           the lips with a heuristic and this page has no right to claim which. */
        html='<strong>'+(QD_PAIR_FACE_NAME[fk]||'panel')+'</strong> \u2014 on this frame the lips are '
           + 'assigned by the engine\u2019s own heuristic rather than a fixed rule, so I will not '
           + 'guess which rails hold it. It is priced correctly either way.';
      } else {
        var base=fh.filter(function(h){ return !h.extra; }).map(qdFaceMemberName);
        var extra=fh.filter(function(h){ return h.extra; }).map(qdFaceMemberName);
        html='<strong>The '+(QD_PAIR_FACE_NAME[fk]||'panel')+' sits in '+base.length+' lipped members</strong> \u2014 '
           + base.join(' and ') + '.';
        if(extra.length) html+=' <strong>All four edges</strong> is on, so '+extra.join(' and ')
           + ' are lipped as well \u2014 where two lips meet at a corner one pair needs a 7\u201310mm notch at each end, and the exact millimetres print with your order.';
        html+=' They are amber on the drawing.';
      }
    }
    else if(qdPairSel.panel){
      var p=qdPairSel.panel, hs=qdHoldersOf(p[0],p[1],p[2]);
      html='<strong>This panel sits in '+hs.length+' lipped rails</strong> \u2014 '
         + hs.map(qdRailName).join(' and ')
         + '. They are amber on the drawing.';
      if(qdLipsOnDepth()) html+=' The engine seats this panel in the DEPTH rails on this frame &mdash; a single bay deeper than it is wide, or a fully enclosed box &mdash; which is why these two run front to back.';
    } else {
      var hold=qdRailHolds(qdPairSel.rail);
      html='<strong>'+qdRailName(qdPairSel.rail)+'</strong> \u2014 '
         + (hold.length ? ('carries '+hold.length+' panel'+(hold.length===1?'':'s')+', lit on the drawing.')
                        : 'carries no panel on this design.');
    }
    html+=' <a href="#" id="qd-pair-clear" style="color:#0e7490;font-weight:600">Clear</a>';
    el.innerHTML=html; el.style.display='block';
    var c=$('qd-pair-clear');
    if(c) c.addEventListener('click', function(ev){ ev.preventDefault(); if(qdPairClear()) rebuild3D(); });
  }
  function selPostHas(xi,zi){ for(var i=0;i<qdSelPosts.length;i++) if(qdSelPosts[i][0]===xi&&qdSelPosts[i][1]===zi) return true; return false; }
  function selRailHas(a){ for(var i=0;i<qdSelRails.length;i++) if(nrKey(qdSelRails[i])===nrKey(a)) return true; return false; }
  function nrKey(a){ return a[0]+'|'+a[1]+'|'+a[2]+'|'+a[3]; }
  function nrHas(a){ for(var i=0;i<qdNoRails.length;i++) if(nrKey(qdNoRails[i])===nrKey(a)) return true; return false; }
  function npKey(xi,zi){ return xi+'|'+zi; }
  /* r66: is THIS piece of the leg deleted? A two-part [xi,zi] entry covers every piece. */
  function legDel(xi,zi,li){
    for(var i=0;i<qdNoPosts.length;i++){ var p=qdNoPosts[i];
      if(p[0]!==xi||p[1]!==zi) continue;
      if(p.length===2) return true;
      if(p[2]===li) return true;
    } return false;
  }
  function legSel(xi,zi,li){
    for(var i=0;i<qdSelPosts.length;i++){ var p=qdSelPosts[i];
      if(p[0]===xi&&p[1]===zi&&p.length===3&&p[2]===li) return true;
    } return false;
  }
  function npnKey(a){ return a[0]+'|'+a[1]+'|'+a[2]; }
  function npnHas(li,bk,dj){ for(var i=0;i<qdNoPanels.length;i++) if(qdNoPanels[i][0]===li&&qdNoPanels[i][1]===bk&&qdNoPanels[i][2]===dj) return true; return false; }
  function selPanelHas(li,bk,dj){ for(var i=0;i<qdSelPanels.length;i++) if(qdSelPanels[i][0]===li&&qdSelPanels[i][1]===bk&&qdSelPanels[i][2]===dj) return true; return false; }
  function npHas(xi,zi){ for(var i=0;i<qdNoPosts.length;i++) if(qdNoPosts[i][0]===xi&&qdNoPosts[i][1]===zi) return true; return false; }
  var ENGINE17=false;        // r53: true once a Worker answers 1.7.0 or later (deleted uprights)
  var QD_E117=false;         // r84: true once a Worker answers 1.17.0+ (end reclaim + cap trim)
  var qdFeetNoteFn=null;     // r84: lets engineSeen refresh the feet note when QD_E117 flips
  var ENGINE18=false;        // r55: true once a Worker answers 1.8.0 or later (deleted rails)
  var ENGINE15=false;        // true once a Worker answers 1.5.0 or later
  var openShares=null;       // {w:[],d:[],h:[]} of desired opening sizes in mm; null = even
  var ENGINE14=false;        // flipped true the first time a Worker answers 1.4.0 or later
  var panelMode='none';
  /* r144 - the face picker. qdFaces = which faces carry a panel; qdLips4 = which
     of those are held on all four edges (engine 1.25.0 'lips4'). Both only reach
     a request while panelMode === 'custom'. */
  var qdFaces={top:false,bottom:false,front:false,back:false,left:false,right:false};
  var qdLips4={top:false,bottom:false,front:false,back:false,left:false,right:false};
  function qdF6Str(o){ var r=[],K=['top','bottom','front','back','left','right']; for(var i=0;i<K.length;i++) if(o[K[i]]) r.push(K[i]); return r.join('.'); }
  function qdFacesAny(){ return qdF6Str(qdFaces)!==''; }
  function qdLips4Any(){ return qdF6Str(qdLips4)!==''; }
   /* r154 - BACK WALLS (alucut 1.26.0). qdBackSel = [[opening, bay], ...],
      opening 0 = bottom. qdBwLip is PURE and the parity harness executes it:
      which leg piece paints lipped. Rear line only (pzi 0 = the drawn back),
      the two uprights beside each ticked bay, that opening's own segment -
      mirrors the engine's pull of 2 leg segments per wall. */
   var qdBackSel=[], qdPendingBw=null;
   /* r172 - BACK BOARD ABOVE THE TOP (alucut 1.27.0 `upstand`). qdUpstand is the
      board's height in mm, 0 = no board. One number, one place; the tick and
      the height box both write it and nothing else holds a second copy. */
   var qdUpstand=0, qdPendingUp=null, qdUpFlush='out';
   var QD_UP_MIN=300, QD_UP_MAX=600;
    /* r178. The riser is the ENGINE's number, not ours. It was 25 here and 66 in
       alucut 1.29.x (2 x 30.5mm spigot + 5mm clear tube), so the board was drawn
       41mm lower and 41mm taller than the one being cut. qdUpRiser() reads what
       the engine sent if it sends it, and only then falls back - so the day the
       worker returns spRiser, this stops being a second copy of anything. */
    var QD_UP_RISER_FALLBACK=66;
    function qdUpRiser(){
      var r = window.QD_LAST_RISER;
      return (typeof r === 'number' && r > 0) ? r : QD_UP_RISER_FALLBACK;
    }
   /* r176: back ON. The rebuilt arrangement (alucut 1.28.0) lips the two
      horizontal rails instead of the two short ends, which is what r174 was
      withdrawn for. */
   /* r179, 31 Aug: OFF SALE. The engine's riser piece is 50.8mm longer than the
       gap between its two connectors - every other piece in the engine has
       spacing - piece = 50.8 and the riser has 0 - so the board cannot be
       assembled as cut. Patryk found it on the live store. The fold goes back
       to hidden until the geometry is right; nothing else is touched, and
       flipping this one flag back is the whole of putting it back. */
   var QD_UP_OFFER=true;
   function qdBwLip(pxi,pzi,li,cells){
     if(pzi!==0) return false;
     for(var i=0;i<cells.length;i++){ if(cells[i][0]===li && (cells[i][1]===pxi || cells[i][1]===pxi-1)) return true; }
     return false;
   }
  /* Mirrors alucut 1.25.0's edge budget EXACTLY - a four-edged face borrows the
     two members its neighbours would use as carriers, so those faces must be
     open. Named + pure so liptest-custom can execute this very function against
     the engine's own accept/refuse across every combination. */
  function qdL4Blocked(k,F){
    if(k==='top'||k==='bottom') return !!(F.front||F.back);
    if(k==='front'||k==='back') return !!(F.left||F.right);
    return !!(F.top||F.bottom);
  }
  /* Which members are lipped in custom mode - the drawing-side mirror of the
     engine's pulls: 2 carriers per panelled face (1.23.0 assignment) plus the 2
     extras per four-edged face. ax: 'x' width rails, 'z' depth rails, 'y' legs.
     pos: b/t bottom-top, f/k front-back, l/r left-right (booleans). Named + pure
     for the same reason as qdL4Blocked. */
  function qdCustomLip(ax,pos,F,L4){
    if(ax==='z') return !!((F.bottom&&pos.b)||(F.top&&pos.t)||(L4.left&&pos.l)||(L4.right&&pos.r));
    if(ax==='x') return !!((F.front&&pos.f)||(F.back&&pos.k)||(L4.bottom&&pos.b)||(L4.top&&pos.t));
    if(ax==='y') return !!((F.left&&pos.l)||(F.right&&pos.r)||(L4.front&&pos.f)||(L4.back&&pos.k));
    return false;
  }
  var panelSupply='byo';   // default: customer supplies own panel (glass/timber ≤6mm). 'us' = premium 6mm aluminium upgrade
  var qdPanelTh=6;   /* r150: DRAWN + GUIDED thickness only. One lipped rail seats 6mm one
                        way up and 17mm flipped, so this can never change a part or a price. */
  var lipHL=true;   // 3D: highlight the lip ledges in teal so the customer can see where panels sit; toggle off for a plain view
  /* r61, Patryk 24 Aug: "there should be a button to hide so you can see it in the colour you
     chose? but it still needs to be flagged". So the amber is a TICK, not a fixed paint job.
     Turning it off changes the PICTURE only - the warning text, the amber key itself and the
     acceptance tick above Add all stay exactly where they are. Hiding a colour must never hide
     a risk. */
  var spanHL=true;
  var CONN={
    '2way':{id:43210762879053,price:qdP(43210762879053,197),label:'2 way'},
    '3flat':{id:43210762911821,price:qdP(43210762911821,198),label:'3 way flat'},
    '3corner':{id:43210762944589,price:qdP(43210762944589,197),label:'3 way corner'},
    '4flat':{id:43210762977357,price:qdP(43210762977357,210),label:'4 way flat'},
    '4corner':{id:43210763010125,price:qdP(43210763010125,235),label:'4 way corner'},
    '5way':{id:43210763042893,price:qdP(43210763042893,237),label:'5 way'},
    '6way':{id:43210763075661,price:qdP(43210763075661,266),label:'6 way'},
    'endcap':{id:43210763141197,price:qdP(43210763141197,56),label:'end cap'}
  };
  var QD_CUT=window.__QD50.QD_CUT;
  var QD_FEES=window.__QD50.QD_FEES;
  function qdFeeVariant(rate){ for(var i=0;i<QD_FEES.length;i++){ if(String(QD_FEES[i].service).trim()==='Up-Saw Cut' && String(QD_FEES[i].rate).trim()===String(Number(rate))) return QD_FEES[i]; } return {id:0, price:Math.round(Number(rate||0)*100)}; }
  var $=function(id){return document.getElementById(id);};
  /* GRID, OPENING-AWARE. This used to divide W, D and H into EQUAL parts and place the nodes on
     those divisions. Two things now make that a lie rather than an approximation:
       - openings can be uneven, so the bays are not equal; and
       - the connectors are real, so a node sits 25.4mm along from the last one, not on a
         mathematical fraction of the overall size.
     It now walks the ACTUAL openings, exactly as the engine does — so the drawing and the cut
     list are the same frame. Absent openings fall back to the even split, which is what every
     frame designed before today is. */
  var QD_A = 25.4;
  /* r58: the widest opening we recommend leaving unsupported. 1200 is the number that was
     already on this page before today - it is not a new structural claim. */
  var QD_SPAN_MAX = 1200;
  function qdAxis(total, n, list){
    var seg;
    if(list && list.length===n && list.every(function(v){return v>0;})) seg=list.slice();
    else { var av=total-(n+1)*QD_A, e=Math.max(1,Math.round(av/n)); seg=[]; for(var i=0;i<n;i++) seg.push(e); }
    var span=0; for(var k=0;k<seg.length;k++) span+=seg[k];
    span += (n+1)*QD_A;
    var p=-span/2+QD_A/2, pos=[p];
    for(var i2=0;i2<n;i2++){ p+=seg[i2]+QD_A; pos.push(p); }
    return {pos:pos, seg:seg};
  }
  /* r187 (Patryk, 31 Aug): "still not picking the backboard as timber... and even the back wall".
     He is right, and it was two separate faults with one cause. r173 taught the SHELF panel to
     draw as timber when the customer picks 17mm and supplies their own. The BACK WALLS (r154)
     and the BACK BOARD (r176) each hard-coded their own 0xccd6e2 grey and were never told. So a
     customer picking timber saw timber shelves and grey walls in the same picture.
     WHY IT KEPT HAPPENING: each panel type was added in a different revision and each one chose
     its own colour inline. There was nothing to keep them in step. One helper now - the next
     panel that gets added cannot drift away from the other three.
     `ghostable` is true only for the shelf panels: their ghost is deliberately turned off during
     delete mode and after a hand-deletion so the panel can be tapped (r101/r173). Back walls and
     the back board are not tappable, so that carve-out must not apply to them - using the shelf
     predicate would turn a back wall solid just because a SHELF panel had been deleted.
     Shelf behaviour is byte-identical to r173; proved by colourtest.mjs across all three states. */
  /* r189 (Patryk chose look "D", 31 Aug): the 17mm timber panel was one flat colour at 55%
     and read as amber plastic. It now carries a real oak grain, drawn ONCE on a canvas at
     run time - no image file, nothing to download, works with no network.
     Built once and cached: this is called on every rebuild, and a new CanvasTexture per
     rebuild would pile up GPU textures for the life of the page. */
  /* r191 - PANEL MATERIAL PER GROUP (needs alucut 1.31.0). Empty string means "inherit the
     two supply cards", which is the default on both selects - so a customer who never touches
     them sends nothing new and gets exactly the design and the price they got before. */
  var qdMatWalls='', qdMatBoard='', qdPendMatW='', qdPendMatB='';
  function qdSupplyBy(){
    var o=null;
    if(qdMatWalls){ o=o||{}; o.walls=qdMatWalls; }
    if(qdMatBoard){ o=o||{}; o.board=qdMatBoard; }
    return o;
  }
  /* what a group ACTUALLY resolves to, for the drawing and for the labels */
  function qdSupplyOf(group){
    var g=(group==='walls')?qdMatWalls:(group==='board')?qdMatBoard:'';
    return g || panelSupply;   /* r191: the engine defaults every group to panelSupply - measured, not assumed */
  }
  var QD_WOOD=null;
  function qdWoodTex(){
    if(QD_WOOD) return QD_WOOD;
    try{
      var c=document.createElement('canvas'); c.width=512; c.height=512;
      var x=c.getContext('2d'); if(!x) return null;
      var BASE='#a9763f', DARK='#5f3a18', LIGHT='#d1a271', WOB=11, i, y, px, px2;
      x.fillStyle=BASE; x.fillRect(0,0,512,512);
      for(i=0;i<70;i++){
        y=Math.random()*512; var hgt=2+Math.random()*14;
        x.globalAlpha=0.05+Math.random()*0.10;
        x.fillStyle=(Math.random()<0.5)?DARK:LIGHT;
        x.beginPath();
        for(px=0;px<=512;px+=16){ x[(px===0)?'moveTo':'lineTo'](px, y+Math.sin((px/512)*Math.PI*(1+Math.random()*0.4)+i)*WOB); }
        for(px2=512;px2>=0;px2-=16){ x.lineTo(px2, y+Math.sin((px2/512)*Math.PI*(1+Math.random()*0.4)+i)*WOB+hgt); }
        x.closePath(); x.fill();
      }
      x.globalAlpha=0.16; x.strokeStyle=DARK; x.lineWidth=0.8;
      for(i=0;i<160;i++){
        y=Math.random()*512; x.beginPath();
        for(var q=0;q<=512;q+=24){ x[(q===0)?'moveTo':'lineTo'](q, y+Math.sin((q/512)*6+i)*WOB*0.6); }
        x.stroke();
      }
      for(i=0;i<2;i++){
        var kx=60+Math.random()*392, ky=60+Math.random()*392, r=6+Math.random()*10;
        for(var k=0;k<7;k++){ x.globalAlpha=0.10; x.strokeStyle=DARK; x.lineWidth=1.2;
          x.beginPath(); x.ellipse(kx,ky,r+k*2.4,(r+k*2.4)*0.55,0.5,0,Math.PI*2); x.stroke(); }
      }
      x.globalAlpha=1;
      var t=new T.CanvasTexture(c);
      t.wrapS=t.wrapT=T.RepeatWrapping; t.repeat.set(2,0.8);
      QD_WOOD=t; return t;
    }catch(e){ return null; }
  }
  /* r187: one helper for the shelf panels, the back walls and the back board - see the note
     above qdGrid. r189 changes only what the TIMBER case looks like.
     ON r101: the customer-supplied panel was deliberately a ghost so it could never be taken
     for something we charge for. That still holds for GLASS AND ACRYLIC, which are genuinely
     see-through and stay a ghost. Timber is not see-through, and Patryk chose the solid look
     with his eyes on it. The r101 risk is covered a different way now: the plate we supply is
     flat grey metal and the timber is oak grain, so the two can no longer be confused with
     each other, and the two supply cards state $0 against + $X either way. */
  function qdPanelMat(ghostable, group){
    /* r191: `group` is 'walls' or 'board' for those two, absent for the shelf panels.
       r200 (Patryk, 31 Aug): "now it doesnt show the timber for the shelfing panels, only
       for the back walls?" MEASURED, on r193/r195/r197/r199 alike, so it is NOT new - the
       shelves have been dropping to plate grey the moment Edit > Panels is opened, while
       the back walls keep their timber because they are drawn with ghostable=false.
       Two panels, the same material choice, different looks under the same mode.
       The `ghostable` gate is redundant as well as inconsistent: addPanel ALREADY overrides
       per panel for deleted (pghostMat) and picked-for-deletion (pselMat), so those two
       looks survive without it. What it was additionally doing was repainting every OTHER
       panel as aluminium - which reads as "these are plate now" on a design the customer
       has told us they are supplying themselves.
       The material is a statement about what is being BOUGHT. It does not change because
       someone opened a tool. */
    var _sup = group ? qdSupplyOf(group) : panelSupply;
    var _byoGhost = (_sup === 'byo');
    if(_byoGhost && qdPanelTh===17){
      var wt=qdWoodTex();
      return wt ? new T.MeshLambertMaterial({map:wt})
                : new T.MeshLambertMaterial({color:0xa9763f});   /* no canvas - still timber-coloured */
    }
    if(_byoGhost){
      /* r193 (Patryk, 31 Aug, option D): the old 0xb8c4d2 at 0.30 over the stage's
         #f4f7fb-#e7edf5 gradient measured 7.7 levels of difference out of 255 against
         bare background - about 3%. He could not see his own glass. Green-glass tint,
         a specular highlight so it catches the light, and an OUTLINE added by
         qdGlassEdges() below: 21.1 / 255 average and a 10x stronger edge, measured the
         same way. Drawing only - qdPanelMat has never been able to reach a part or a
         price, and this changes nothing about that. */
      var _gm = new T.MeshPhongMaterial({color:0x9fc0c4, transparent:true, opacity:0.42,
                                         shininess:70, specular:0x9fd6e0});
      _gm.userData.glass = 1;   /* the flag qdGlassEdges looks for */
      return _gm;
    }
    return new T.MeshLambertMaterial({color:0xccd6e2});
  }
  /* r193: outline every glass panel, wherever it was drawn. Real glass reads as glass
     because of its EDGES, not its face - which is why CAD packages outline it. Doing this
     as ONE traverse of the finished group, keyed off the material flag, rather than at each
     draw site: there are three panel sites today (shelves, back walls, back board) and side
     walls will be a fourth, and an outline added per-site is an outline someone forgets to
     add to the next one.
     The line material is created ONCE and reused. A new material per panel per rebuild is
     the same GPU leak the wood texture had before it was cached. */
  var QD_EDGE_MAT=null;
  function qdGlassEdges(g){
    if(!g) return 0;
    var hits=[];
    g.traverse(function(o){
      if(o && o.isMesh && o.material && o.material.userData && o.material.userData.glass) hits.push(o);
    });
    if(!hits.length) return 0;
    if(!QD_EDGE_MAT) QD_EDGE_MAT=new T.LineBasicMaterial({color:0x4d7f8c});
    for(var i=0;i<hits.length;i++){
      var m=hits[i];
      try{
        var e=new T.LineSegments(new T.EdgesGeometry(m.geometry), QD_EDGE_MAT);
        e.position.copy(m.position);
        e.rotation.copy(m.rotation);
        e.scale.copy(m.scale);
        e.userData.glassEdge=1;
        g.add(e);
      }catch(_ge){}
    }
    return hits.length;
  }
  /* One material each, reused - a new material per piece per rebuild is the GPU leak the
     wood texture had before it was cached. */
  var QD_PAIR_HOT=null, QD_PAIR_DIM=null;
  function qdPairHotMat(){ if(!QD_PAIR_HOT) QD_PAIR_HOT=new T.MeshLambertMaterial({color:0xf59e0b}); return QD_PAIR_HOT; }
  function qdPairDimMat(){ if(!QD_PAIR_DIM) QD_PAIR_DIM=new T.MeshLambertMaterial({color:0xe3e9f0}); return QD_PAIR_DIM; }
  function qdPairHolderList(){
    if(!qdPairSel) return [];
    if(qdPairSel.panel) return qdHoldersOf(qdPairSel.panel[0],qdPairSel.panel[1],qdPairSel.panel[2]);
    if(qdPairSel.rail) return [qdPairSel.rail];
    return [];
  }
  function qdPairIsHolder(r){
    if(qdPairSel && qdPairSel.face){
      var fs=qdFaceHolders(qdPairSel.face);
      for(var j=0;j<fs.length;j++){ var f=fs[j];
        if(f.k!=='rail') continue;
        if(f.ax===r.ax && f.li===r.li && f.line===r.line) return true; }
      return false;
    }
    var hs=qdPairHolderList();
    for(var i=0;i<hs.length;i++){
      var h=hs[i];
      if(h[0]!==r.ax || h[1]!==r.li || h[2]!==r.line) continue;
      if(!r.bays || !r.bays.length) return true;
      if(r.bays.indexOf(h[3])>=0) return true;
    }
    return false;
  }
  /* the sides are held by LEGS, not rails, so the posts have to answer too */
  function qdPairPostIsHolder(p){
    if(!qdPairSel || !qdPairSel.face || !p) return false;
    var fs=qdFaceHolders(qdPairSel.face);
    for(var i=0;i<fs.length;i++){ var f=fs[i];
      if(f.k==='post' && f.xi===p[0] && f.zi===p[1]) return true; }
    return false;
  }
  function qdPairPanelLit(id){
    if(!qdPairSel || !id) return true;
    if(qdPairSel.face) return false;   /* a face is picked - no shelf cell is the subject */
    if(qdPairSel.panel) return id[0]===qdPairSel.panel[0] && id[1]===qdPairSel.panel[1] && id[2]===qdPairSel.panel[2];
    if(!qdPairSel.rail) return true;
    var hs=qdRailHolds(qdPairSel.rail);
    for(var i=0;i<hs.length;i++) if(hs[i][0]===id[0]&&hs[i][1]===id[1]&&hs[i][2]===id[2]) return true;
    return false;
  }
  function qdPairFaceLit(fk){
    if(!qdPairSel) return true;
    return qdPairSel.face===fk;
  }
  function qdGrid(type,W,D,H,tiers,cols,rows,sh){
    cols=Math.max(1,cols||1); rows=Math.max(1,rows||1);
    var N=(type==='box')?2:Math.max(tiers,2);
    var X=qdAxis(W,cols,sh&&sh.w), Z=qdAxis(D,rows,sh&&sh.d), Y=qdAxis(H,N-1,sh&&sh.h);
    return {hw:W/2,hd:D/2,hh:H/2,N:N,xs:X.pos,ys:Y.pos,zs:Z.pos,wSeg:X.seg,dSeg:Z.seg,hSeg:Y.seg};
  }
  /* `railLv` mirrors the engine: the levels at which the INTERIOR divider rails run. Null = every
     level. The legs are never filtered — that is the whole safety story, and the picture has to
     show it, or someone will think the frame lost a post when it did not. */
  /* r53: beams() and nodes() are a MIRROR of alucut's geom(). They have to be, or the picture
     shows a frame the customer is not buying. Both now take `noPosts` and both merge exactly the
     way the engine does: a rail runs through a crossing where nothing stands, a post runs through
     a level where no rail arrives, and a joint is only drawn where something actually meets.
     Verified against the live Worker's own connector count - see the record. */
  function frameParts(type,W,D,H,tiers,cols,rows,sh,railLv,noPosts,noRails,trimFloor){
    var g=qdGrid(type,W,D,H,tiers,cols,rows,sh), b=[], deg={}, pos={};
    var A=QD_A;
    function K(x,y,z){ return x+','+y+','+z; }
    var dirs={};
    function bump(x,y,z,d){ var k=K(x,y,z); deg[k]=(deg[k]||0)+1; pos[k]=[x,y,z]; if(d){ var _a=dirs[k]||(dirs[k]=[]); if(_a.indexOf(d)<0) _a.push(d); } }
    function bx(len,cx,cy,cz,ax,extra){ var o={len:len,cx:cx,cy:cy,cz:cz,ax:ax}; if(extra){for(var q in extra)o[q]=extra[q];} b.push(o); }
    var on=function(li){ return !railLv || railLv.indexOf(li)>=0; };
    /* r66 mirrors alucut 1.11.0: a two-part entry [xi,zi] is the WHOLE column (every share
       link ever issued keeps its meaning); a three-part entry [xi,zi,li] is ONE PIECE, li=0
       at the floor. legSegF/legAtF are the engine's legSeg/legAt, name for name. */
    var skip={}, skipLeg={};
    if(noPosts) for(var q=0;q<noPosts.length;q++){
      var np=noPosts[q];
      if(np.length>=3) skipLeg[np[0]+'|'+np[1]+'|'+np[2]]=true;
      else skip[np[0]+'|'+np[1]]=true;
    }
    var hasPost=function(xi,zi){ return !skip[xi+'|'+zi]; };
    var NLV=g.ys.length;
    var legSegF=function(xi,zi,li){ return hasPost(xi,zi) && !skipLeg[xi+'|'+zi+'|'+li]; };
    var legAtF=function(xi,zi,li){ return (li>0 && legSegF(xi,zi,li-1)) || (li<NLV-1 && legSegF(xi,zi,li)); };
    var skipR={}; if(noRails) for(var q2=0;q2<noRails.length;q2++){ var rr=noRails[q2]; skipR[rr[0]+'|'+rr[1]+'|'+rr[2]+'|'+rr[3]]=true; }
    var railGone=function(ax,li,line,bay){ return !!skipR[ax+'|'+li+'|'+line+'|'+bay]; };
    var wRow=function(li,zi){ return !(zi>0 && zi<g.zs.length-1 && !on(li)); };
    var dRow=function(li,xi){ return !(xi>0 && xi<g.xs.length-1 && !on(li)); };
    /* r56 mirrors alucut 1.9.0: a rail runs through a crossing only if nothing is actually
       THERE. The crossing rail's ROW existing is not the same question once rails can be
       deleted - the row can be present while both of its rails at this node are gone. */
    var dTouch=function(li,xi,zi){ return dRow(li,xi) && (((zi>0)&&!railGone('d',li,xi,zi-1)) || ((zi<rows)&&!railGone('d',li,xi,zi))); };
    var wTouch=function(li,zi,xi){ return wRow(li,zi) && (((xi>0)&&!railGone('w',li,zi,xi-1)) || ((xi<cols)&&!railGone('w',li,zi,xi))); };
    // width rails
    for(var li=0;li<g.ys.length;li++)
      for(var zi=0;zi<g.zs.length;zi++){
        if(!wRow(li,zi)) continue;
        var i=0;
        while(i<cols){
          if(railGone('w',li,zi,i)){ i++; continue; }
          var len=g.wSeg[i], j=i, bays=[i];
          while(j+1<cols && !railGone('w',li,zi,j+1) && !dTouch(li,j+1,zi) && !legAtF(j+1,zi,li)){ len+=A+g.wSeg[j+1]; j++; bays.push(j); }   /* r230: a run THROUGH an empty node reclaims the whole connector (settled: 1183+25.4+1183); A/2 drew every such rail 12.7 short - the '?' codes on David's 5350 frame */
          len=Math.round(len);
          bx(len,(g.xs[i]+g.xs[j+1])/2,g.ys[li],g.zs[zi],'x',{rail:{ax:'w',li:li,line:zi,bays:bays}});
          bump(g.xs[i],g.ys[li],g.zs[zi],'+x'); bump(g.xs[j+1],g.ys[li],g.zs[zi],'-x');
          i=j+1;
        }
      }
    // depth rails
    for(var li2=0;li2<g.ys.length;li2++)
      for(var xi=0;xi<g.xs.length;xi++){
        if(!dRow(li2,xi)) continue;
        var j0=0;
        while(j0<rows){
          if(railGone('d',li2,xi,j0)){ j0++; continue; }
          var len2=g.dSeg[j0], j2=j0, bays2=[j0];
          while(j2+1<rows && !railGone('d',li2,xi,j2+1) && !wTouch(li2,j2+1,xi) && !legAtF(xi,j2+1,li2)){ len2+=A+g.dSeg[j2+1]; j2++; bays2.push(j2); }   /* r230: whole connector, see the width loop */
          len2=Math.round(len2);
          bx(len2,g.xs[xi],g.ys[li2],(g.zs[j0]+g.zs[j2+1])/2,'z',{rail:{ax:'d',li:li2,line:xi,bays:bays2}});
          bump(g.xs[xi],g.ys[li2],g.zs[j0],'+z'); bump(g.xs[xi],g.ys[li2],g.zs[j2+1],'-z');
          j0=j2+1;
        }
      }
    // legs: skipped where deleted, merged through levels no rail reaches
    var railDeg={}; for(var k0 in deg) railDeg[k0]=deg[k0];
    var vert={}, N=g.ys.length;
    for(var xi2=0;xi2<g.xs.length;xi2++) for(var zi2=0;zi2<g.zs.length;zi2++){
      if(!hasPost(xi2,zi2)) continue;
      var x=g.xs[xi2], z=g.zs[zi2], k=0;
      while(k<N-1){
        /* r66: this PIECE was deleted - a leg with a hole in it is two legs, not one longer
           one. Merge also stops at the 6.5m stock bar, exactly as the engine cuts it. */
        if(skipLeg[xi2+'|'+zi2+'|'+k]){ k++; continue; }
        var len3=g.hSeg[k], m=k;
        while(m+1<N-1 && !railDeg[K(x,g.ys[m+1],z)]
              && !skipLeg[xi2+'|'+zi2+'|'+(m+1)]
              && Math.round(len3+A+g.hSeg[m+1])<=6500){ len3+=A+g.hSeg[m+1]; m++; }   /* r230: a leg straight through a level with no rail reclaims the whole connector (P1 2322 on David's frame, drawn 2309) */
        /* r84 mirrors alucut 1.17.0 END RECLAIM (Patryk's "B"): a leg whose END node no rail
           arrives at (floor cross bars removed) gets the vanished connector's A/2 back, so the
           drawn tube reaches the designed plane. The "floating caps" Patryk reported were this
           drawing faithfully showing the OLD short cuts - the gap was real, 25.4mm of it. */
        /* r219: the engine's "ALLOW/2" is a whole 25.4mm connector (its ALLOW is 50.8), so a
           bare end reclaims A here, not A/2. Measured against the live cut list on Patryk's
           900x450x750 with the floor rails out: the engine cuts the floor legs 241 (216 + 25.4);
           this picture had them 229 and ending 12.7mm above the floor plane. Invisible at
           frame zoom, but the wheel stack below has to start where the tube really ends. */
        var _bare0=(k===0 && !railDeg[K(x,g.ys[0],z)]);
        var _botX=_bare0 ? A : 0;
        var _topX=(m+1===N-1 && !railDeg[K(x,g.ys[N-1],z)]) ? A : 0;
        /* r219: the floor trim, mirrored from the engine - caps take 3 off a bare floor piece
           (1.16.0), castors on 'keep my height' take the rise off it (1.35.0). Comes off the
           BOTTOM of the piece, so the centre moves up by half of it. */
        var _trim=(_bare0 && trimFloor>0) ? trimFloor : 0;
        len3=Math.round(len3+_botX+_topX-_trim);
        bx(len3,x,(g.ys[k]+g.ys[m+1])/2+(_topX-_botX+_trim)/2,z,'y',{pxi:xi2,pzi:zi2,pl0:k,pl1:m});
        bump(x,g.ys[k],z,'+y'); bump(x,g.ys[m+1],z,'-y');
        vert[K(x,g.ys[k],z)]=true; vert[K(x,g.ys[m+1],z)]=true;
        k=m+1;
      }
    }
    /* A joint is only drawn where the engine bills one, and the engine's part map runs 2..6.
       Degree 1 is a free tube END - the top of a post at a level where no rail arrives - and it
       takes no connector, so it must not get a black cube either. This was drawing a joint the
       customer was never charged for. */
    var nd=[]; for(var kk in deg) if(deg[kk]>=2) nd.push(pos[kk]);
    return { beams:b, nodes:nd, deg:deg, vert:vert, railDeg:railDeg, dirs:dirs };
  }
  function beams(type,W,D,H,tiers,cols,rows,sh,railLv,noPosts,noRails,trimFloor){
    return frameParts(type,W,D,H,tiers,cols,rows,sh,railLv,noPosts,noRails,trimFloor).beams;
  }
  function nodes(type,W,D,H,tiers,cols,rows,sh,railLv,noPosts,noRails){
    return frameParts(type,W,D,H,tiers,cols,rows,sh,railLv,noPosts,noRails).nodes;
  }
  /* r58: THE SPAN WAS AN AVERAGE, AND THE AVERAGE HID THE PROBLEM. It was W/cols - the bay
     PITCH - which is only the truth when every bay is equal and every upright is present. On
     the 5350 x 3650 frame with openings 1177/2894/1177 it read 1783mm when the widest opening
     is 2894mm.
     Nor is it simply the longest TUBE. Delete an upright and the width rails still stop at that
     crossing, because the depth rails arrive there and hold the joint - so every tube stays
     short while the frame now has nothing standing under that point. A perpendicular rail is
     itself a beam; it is not a support. So a run is only broken by an UPRIGHT THAT REACHES THE
     GROUND, and everything here is derived from frameParts() - the same geometry the drawing
     and the cut list are built from - rather than re-deciding the rules a second time. */
  function qdSpanFacts(){
    var o={mm:0, ax:'x', over:0, n:0, postGone:false, bad:{}, wide:{}};
    try{
      var cols=Math.max(1,state.cols||1), rows=Math.max(1,state.rows||1);
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,cols,rows,openShares);
      var fp=frameParts(state.type,state.W,state.D,state.H,state.tiers,cols,rows,openShares,railLvArr(),qdNoPosts,qdNoRails);
      var postAt={}, legAt2={}, railAt={}, i, e, q;
      for(i=0;i<fp.beams.length;i++){
        e=fp.beams[i];
        if(e.ax==='y'){ if(e.pxi!=null){ postAt[e.pxi+'|'+e.pzi]=true;
          var _a=(e.pl0!=null?e.pl0:0), _b=(e.pl1!=null?e.pl1:0);
          for(q=_a;q<=_b;q++) legAt2[e.pxi+'|'+e.pzi+'|'+q]=true; } }
        else if(e.rail && e.rail.bays){ for(q=0;q<e.rail.bays.length;q++) railAt[e.rail.ax+'|'+e.rail.li+'|'+e.rail.line+'|'+e.rail.bays[q]]=true; }
      }
      /* r66: a rail at level li is only SUPPORTED at a crossing if the leg under it reaches
         the ground - every piece from the floor up to that level present. Before this, a
         crossing counted as supported if ANY piece of the leg survived, even one hanging in
         the air above a gap - the warning could show green over a span with nothing under it. */
      var grounded=function(xi,zi,li){
        if(!postAt[xi+'|'+zi]) return false;
        for(var p2=0;p2<li;p2++) if(!legAt2[xi+'|'+zi+'|'+p2]) return false;
        return true;
      };
      var walk=function(ax, nLines, nBays, seg, stops){
        /* r59, 24 Aug, Patryk: "does it really matter when the tube will be touching the
           ground?" No - and it was wrong, not just noisy. Level 0 IS the floor: the bottom
           connector is the foot, so a bottom rail's underside is the frame's ground plane
           along its whole length and it cannot sag into anything. Skipping it took his frame
           from 34 amber runs to 24 and did not move the headline number on any frame tested. */
        for(var li=1; li<g.ys.length; li++)
          for(var line=0; line<=nLines; line++){
            var i2=0;
            while(i2<nBays){
              if(!railAt[ax+'|'+li+'|'+line+'|'+i2]){ i2++; continue; }
              var j=i2, mm=seg[i2], run=[i2];
              while(j+1<nBays && railAt[ax+'|'+li+'|'+line+'|'+(j+1)] && !stops(j+1,line,li)){ mm+=QD_A+seg[j+1]; j++; run.push(j); }
              mm=Math.round(mm); o.n++;
              if(mm>QD_SPAN_MAX){ o.over++; for(var r2=0;r2<run.length;r2++) o.bad[ax+'|'+li+'|'+line+'|'+run[r2]]=true; }
              if(mm>o.mm){ o.mm=mm; o.ax=(ax==='w')?'x':'z'; o.postGone=(run.length>1);
                /* r108: keep the widest run's own bay keys so the drawing can print its length
                   ON it. o.bad is every OVER-guide run; this is the single longest one. */
                o.wide={}; for(var r3=0;r3<run.length;r3++) o.wide[ax+'|'+li+'|'+line+'|'+run[r3]]=true; }
              i2=j+1;
            }
          }
      };
      /* r121, 28 Aug, Patryk: "yes a cross rail into the grounded upright counts as support,
         its touching the ground". He is right that there is a real load path - rail -> cross
         rail -> upright -> floor - and I had found the same thing myself on his 5350 frame and
         parked it rather than act on it.

         BOUNDED TO THE IMMEDIATELY ADJACENT LINE, on purpose. The upright reaching the floor is
         only half the path: the cross rail has to carry the load sideways to get there, and it
         bends while doing it. At one bay (~600mm on his frame) that is real. Let it chain any
         distance and the cross rail is itself a long unsupported span, so the warning would
         just move somewhere the customer cannot see it. Next-line is also the more conservative
         of the two, which is the right direction on a system with no deflection data.

         MEASURED, three rules side by side, control reproducing the known real output first:
           frame                                 now      next-line   any distance
           Patryk 5350 (8 uprights deleted)      5299mm     1792mm       1308mm
           plain 3600x1200, nothing deleted       868mm      868mm        868mm
           wide 4000x600, 2 cols, top rails      1962mm     1962mm       1962mm
           3000x1200, interior uprights out      2949mm      966mm        966mm
         Frames with nothing deleted do not move at all - this only relaxes the warning on the
         frames it was over-warning. */
      var tiedToGround=function(runAx, a, b, li, nOther){
        /* a = index on the run's own axis, b = the line the run sits on. A cross rail at this
           level runs along the OTHER axis, on line a, spanning the bay either side of b. */
        var oax=(runAx==='w')?'d':'w';
        if(b>0 && railAt[oax+'|'+li+'|'+a+'|'+(b-1)]
               && (runAx==='w' ? grounded(a,b-1,li) : grounded(b-1,a,li))) return true;
        if(b<nOther && railAt[oax+'|'+li+'|'+a+'|'+b]
               && (runAx==='w' ? grounded(a,b+1,li) : grounded(b+1,a,li))) return true;
        return false;
      };
      walk('w', rows, cols, g.wSeg, function(xi,zi,li){
        return grounded(xi,zi,li) || tiedToGround('w',xi,zi,li,rows); });
      walk('d', cols, rows, g.dSeg, function(zi,xi,li){
        return grounded(xi,zi,li) || tiedToGround('d',zi,xi,li,cols); });
    }catch(err){}
    return o;
  }
  /* r59: THE PIGEONHOLE SIZE WAS THE SAME LIE AS THE SPAN, IN A DIFFERENT PLACE.
     It read the GRID - cols x levels x rows, each wSeg x hSeg x dSeg - and so it ignored
     "Interior supports: top and bottom only", ignored deleted uprights and ignored deleted
     rails. On Patryk's own link (rails=ends) there are ZERO interior divider rails at the
     middle level, so the interior openings are one space 2349mm high; the page said 1162mm,
     and put 1162mm on the ORDER as "Internal opening".

     An opening is now worked out from the frame itself. Start from the grid cells, then merge
     two neighbours whenever NOTHING stands between them:
       - up/down : no rail of either axis on the plane between them
       - side     : no upright at either end of that line, and no rail crossing it
     Everything is read out of frameParts() - the same geometry the drawing and the cut list
     come from - so there is no second copy of the rules to drift. */
  /* r112, Patryk: "the 2nd and 3rd opening are using the total across? the front and back are
     different then the internal openings... this is what i meant by complexe designs".
     He is right, and it was measurable: his depth boxes read 1182/574/583/1184 and the chain
     drew four "openings", while the engine's own qdOpenings() union-find reported the largest
     real opening as 1792 deep - which is 583 + 25.4 + 1184, the 3rd and 4th with NOTHING
     between them. That 1792 is the figure that travels to the order. The drawing and the order
     disagreed, and the drawing was the one telling the customer a division existed.

     This returns, for each interior grid line on one axis, whether a divider is actually there:
        'all'   present at every level and every cross position  -> a real division
        'some'  present in places                                -> not an opening you can quote
        'none'  nowhere                                          -> the two bays are ONE space

     The tests are lifted from qdOpenings()'s own merge conditions on purpose. If those two ever
     disagree the drawing goes back to contradicting the order, which is the whole fault. */
  function qdDividers(axk){
    var out=[];
    try{
      var cols=Math.max(1,state.cols||1), rows=Math.max(1,state.rows||1);
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,cols,rows,openShares);
      var fp=frameParts(state.type,state.W,state.D,state.H,state.tiers,cols,rows,openShares,railLvArr(),qdNoPosts,qdNoRails);
      var L=g.hSeg.length; if(!L) return out;
      var legAt={}, railAt={}, i, e, q;
      for(i=0;i<fp.beams.length;i++){
        e=fp.beams[i];
        if(e.ax==='y'){ if(e.pxi!=null){
          var a0=(e.pl0!=null?e.pl0:0), b0=(e.pl1!=null?e.pl1:0);
          for(q=a0;q<=b0;q++) legAt[e.pxi+'|'+e.pzi+'|'+q]=true; } }
        else if(e.rail && e.rail.bays){ for(q=0;q<e.rail.bays.length;q++) railAt[e.rail.ax+'|'+e.rail.li+'|'+e.rail.line+'|'+e.rail.bays[q]]=true; }
      }
      var W_=function(li,line,bay){ return !!railAt['w|'+li+'|'+line+'|'+bay]; };
      var D_=function(li,line,bay){ return !!railAt['d|'+li+'|'+line+'|'+bay]; };
      var P_=function(xi,zi,lv){ return !!legAt[xi+'|'+zi+'|'+lv]; };
      var n = (axk==='w') ? cols : ((axk==='d') ? rows : L);
      var lv,i2,j2,yes,no;
      for(var k=1;k<n;k++){
        yes=0; no=0;
        for(lv=0; lv<L; lv++){
          if(axk==='w'){
            for(j2=0;j2<rows;j2++){
              if(P_(k,j2,lv)||P_(k,j2+1,lv)||D_(lv,k,j2)||D_(lv+1,k,j2)) yes++; else no++;
            }
          } else if(axk==='d'){
            for(i2=0;i2<cols;i2++){
              if(P_(i2,k,lv)||P_(i2+1,k,lv)||W_(lv,k,i2)||W_(lv+1,k,i2)) yes++; else no++;
            }
          }
        }
        if(axk==='h'){
          yes=0; no=0;
          for(i2=0;i2<cols;i2++) for(j2=0;j2<rows;j2++){
            if(W_(k,j2,i2)||W_(k,j2+1,i2)||D_(k,i2,j2)||D_(k,i2+1,j2)) yes++; else no++;
          }
        }
        out.push(no===0 ? 'all' : (yes===0 ? 'none' : 'some'));
      }
    }catch(e2){}
    return out;
  }
  /* r113, Patryk: "all those blue teal notes should be minimised and only avaiable as a hint...
     there is too much on this page". Sixteen of them exist. He ticked the split: FIVE are pure
     explanation and fold away; EIGHT are warnings about what arrives in the box or what the
     frame does under load and are NOT touched; the X hint stays (it is the only place that
     button is ever explained, and there are no tooltips on a phone) and the saved-designs note
     folds under the Save button.

     TWO of the five are CONDITIONAL. The same element carries help in one state and a warning
     in another, so folding by element id alone would hide a caution:
        Interior supports  'every level' = help          'Top only' = "think twice for a heavy bench"
        Panels held by     lip           = help          angle      = "screws are not included"
     `when` decides per state, every time the note is rewritten. Get this wrong and the page
     silently stops warning people. */
  var QD_FOLD=[
    {id:'qd-lip-geom',   label:'How the lipped rail works'},
    {id:'qd-cols-note',  label:'What this does'},
    {id:'qd-del-help',   label:'What this does'},
    {id:'qd-rail-note',  label:'What this does', when:function(){ return railLevels==='all'; }},
    {id:'qd-fix-note',   label:'What this does', when:function(){ return panelFix!=='angle'; }},
    {id:'qd-save-scope', label:'Where saved designs live'}
  ];
  /* SECOND, INDEPENDENT GUARD. The `when` tests above read module state, and while building
     this I got contradictory results between test runs about whether they had fired - which is
     not a thing to ship on a property that decides whether a customer is warned. So the text
     itself is checked too: if a note contains any of these, it is never folded, whatever the
     state says. Two independent conditions; either one saying "warning" is enough to keep it
     on the page. Checked against all six foldable notes - none of them contains any of these. */
  var QD_WARN_WORDS = ['think twice', 'not included', 'floor-touching leg open-ended',
                       'cut 3mm shorter', 'moulded nylon', 'cannot carry a panel',
                       'always mill finish', 'Cut your panels to'];
  function qdIsWarning(t){
    t = t || '';
    for(var i=0;i<QD_WARN_WORDS.length;i++) if(t.indexOf(QD_WARN_WORDS[i])>=0) return true;
    return false;
  }
  function qdSyncFolds(){
    try{
      for(var i=0;i<QD_FOLD.length;i++){
        var F=QD_FOLD[i], n=document.getElementById(F.id);
        if(!n) continue;
        var btn=document.getElementById(F.id+'-q');
        var txt=(n.textContent||'').trim();
        var hasText=!!txt;
        /* a note that is empty, or is currently carrying its WARNING text, is left exactly
           as the rest of the page left it - shown, unfolded, with no button. */
        if(!hasText || qdIsWarning(txt) || (F.when && !F.when())){
          if(btn) btn.style.display='none';
          n.removeAttribute('data-fold');
          if(hasText && n.style.display==='none') n.style.display='block';
          continue;
        }
        if(!btn){
          btn=document.createElement('button');
          btn.type='button'; btn.id=F.id+'-q';
          btn.style.cssText='display:inline-flex;align-items:center;gap:5px;margin-top:8px;'
            +'background:none;border:0;padding:2px 0;font:inherit;font-size:11.5px;'
            +'font-weight:600;color:#0e8fb8;cursor:pointer;text-align:left';
          btn.appendChild(document.createTextNode('? '));
          btn.appendChild(document.createElement('span')).textContent=F.label;
          (function(el,b){
            b.addEventListener('click', function(ev){
              ev.preventDefault();
              var open = el.getAttribute('data-fold')==='open';
              el.setAttribute('data-fold', open?'shut':'open');
              el.style.display = open ? 'none' : 'block';
              b.firstChild.nodeValue = open ? '? ' : '\u2715 ';
              b.lastChild.textContent = open ? b.getAttribute('data-lab') : 'Hide';
            });
          })(n,btn);
          btn.setAttribute('data-lab', F.label);
          n.parentNode.insertBefore(btn, n);
        }
        btn.style.display='inline-flex';
        /* whatever rewrote the note may have shown it again; only re-hide if it is not
           currently open, so a note the customer opened does not shut under them. */
        if(n.getAttribute('data-fold')!=='open'){
          n.setAttribute('data-fold','shut');
          n.style.display='none';
        }
      }
    }catch(e){}
  }
  function qdOpenings(){
    var out={ n:0, uniform:true, min:null, max:null, boxy:true };
    try{
      var cols=Math.max(1,state.cols||1), rows=Math.max(1,state.rows||1);
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,cols,rows,openShares);
      var fp=frameParts(state.type,state.W,state.D,state.H,state.tiers,cols,rows,openShares,railLvArr(),qdNoPosts,qdNoRails);
      var L=g.hSeg.length; if(!L||!cols||!rows) return out;
      var postAt={}, legAt3={}, railAt={}, i, e, q;
      for(i=0;i<fp.beams.length;i++){
        e=fp.beams[i];
        if(e.ax==='y'){ if(e.pxi!=null){ postAt[e.pxi+'|'+e.pzi]=true;
          var _a3=(e.pl0!=null?e.pl0:0), _b3=(e.pl1!=null?e.pl1:0);
          for(q=_a3;q<=_b3;q++) legAt3[e.pxi+'|'+e.pzi+'|'+q]=true; } }
        else if(e.rail && e.rail.bays){ for(q=0;q<e.rail.bays.length;q++) railAt[e.rail.ax+'|'+e.rail.li+'|'+e.rail.line+'|'+e.rail.bays[q]]=true; }
      }
      var W_=function(li,line,bay){ return !!railAt['w|'+li+'|'+line+'|'+bay]; };
      var D_=function(li,line,bay){ return !!railAt['d|'+li+'|'+line+'|'+bay]; };
      /* r66: two cells at level lv merge sideways when no leg PIECE stands between them AT
         THAT LEVEL - the column existing somewhere else no longer blocks the opening. */
      var P_=function(xi,zi,lv){ return !!legAt3[xi+'|'+zi+'|'+lv]; };
      var id=function(lv,i2,j2){ return (lv*cols+i2)*rows+j2; };
      var N=L*cols*rows, par=new Array(N);
      for(i=0;i<N;i++) par[i]=i;
      var find=function(a){ while(par[a]!==a){ par[a]=par[par[a]]; a=par[a]; } return a; };
      var join=function(a,b){ a=find(a); b=find(b); if(a!==b) par[b]=a; };
      for(var lv=0; lv<L; lv++) for(var i2=0; i2<cols; i2++) for(var j2=0; j2<rows; j2++){
        // up: the shelf plane at level lv+1 over this footprint
        if(lv+1<L && !(W_(lv+1,j2,i2)||W_(lv+1,j2+1,i2)||D_(lv+1,i2,j2)||D_(lv+1,i2+1,j2))) join(id(lv,i2,j2), id(lv+1,i2,j2));
        // sideways along the width: the line at x = i2+1
        if(i2+1<cols && !(P_(i2+1,j2,lv)||P_(i2+1,j2+1,lv)||D_(lv,i2+1,j2)||D_(lv+1,i2+1,j2))) join(id(lv,i2,j2), id(lv,i2+1,j2));
        // sideways along the depth: the line at z = j2+1
        if(j2+1<rows && !(P_(i2,j2+1,lv)||P_(i2+1,j2+1,lv)||W_(lv,j2+1,i2)||W_(lv+1,j2+1,i2))) join(id(lv,i2,j2), id(lv,i2,j2+1));
      }
      var grp={};
      for(var lv2=0; lv2<L; lv2++) for(var i3=0; i3<cols; i3++) for(var j3=0; j3<rows; j3++){
        var k=find(id(lv2,i3,j3)), o=grp[k];
        if(!o) o=grp[k]={l0:lv2,l1:lv2,i0:i3,i1:i3,j0:j3,j1:j3,cells:0};
        if(lv2<o.l0)o.l0=lv2; if(lv2>o.l1)o.l1=lv2;
        if(i3<o.i0)o.i0=i3; if(i3>o.i1)o.i1=i3;
        if(j3<o.j0)o.j0=j3; if(j3>o.j1)o.j1=j3;
        o.cells++;
      }
      var span=function(seg,a,b){ var t=0; for(var z=a;z<=b;z++) t+=seg[z]; return Math.round(t+QD_A*(b-a)); };
      var list=[], key0=null;
      for(var kk in grp){
        var o2=grp[kk];
        if(o2.cells !== (o2.l1-o2.l0+1)*(o2.i1-o2.i0+1)*(o2.j1-o2.j0+1)) out.boxy=false;
        var it={ w:span(g.wSeg,o2.i0,o2.i1), h:span(g.hSeg,o2.l0,o2.l1), d:span(g.dSeg,o2.j0,o2.j1) };
        it.vol=it.w*it.h*it.d;
        list.push(it);
        var kx=it.w+'x'+it.h+'x'+it.d;
        if(key0===null) key0=kx; else if(kx!==key0) out.uniform=false;
      }
      list.sort(function(a,b){ return a.vol-b.vol; });
      out.n=list.length; out.min=list[0]||null; out.max=list[list.length-1]||null;
    }catch(err){}
    return out;
  }
  function money(c){return '$'+(c/100).toFixed(2);}
  var hlAxis=null;   // 'x' width | 'z' depth | 'y' height - the size field being edited
  var QD_FIT=null;   // r56: the frame size the camera was last fitted to
  var state={}, T=null, group=null, renderer=null, camera=null, scene=null, rotX=0.34, rotY=0.72, dist=3, dragging=false, lx=0, ly=0, spin=false;   // r173: home 3/4 view looking slightly DOWN. It opened looking UP from under the shelves, which is why anything sitting on top of the frame read as detached (Patryk, 30 Aug). Only the opening angle moved - fit, pan, zoom and the view buttons are untouched.
  function init3D(){
    T=window.THREE; if(!T){return;}
    var cv=$('qd-canvas');
    renderer=new T.WebGLRenderer({canvas:cv,antialias:true,alpha:true,preserveDrawingBuffer:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    scene=new T.Scene();
    camera=new T.PerspectiveCamera(38,1,0.01,100);
    var a=new T.AmbientLight(0xffffff,0.78); scene.add(a);
    var d=new T.DirectionalLight(0xffffff,0.7); d.position.set(2,4,3); scene.add(d);
    var d2=new T.DirectionalLight(0xffffff,0.3); d2.position.set(-2,1,-2); scene.add(d2);
    group=new T.Group(); scene.add(group);
    resize();
    /* r53: TAP AN UPRIGHT TO DELETE IT. A tap is a press and release in nearly the same place -
       anything that moved is a rotate, not a click, or nobody could spin the frame any more. */
    var _dx0=0,_dy0=0,_moved=0;
    /* r99: right button, middle button or shift+drag pans; plain left drag still rotates. */
    var _panning=false, _multi=false;
    cv.addEventListener('contextmenu',function(e){ e.preventDefault(); });
    cv.addEventListener('mousedown',function(e){dragging=true;_panning=(e.button===1||e.button===2||e.shiftKey===true);lx=e.clientX;ly=e.clientY;_dx0=e.clientX;_dy0=e.clientY;_moved=0;if(_panning)e.preventDefault();});
    window.addEventListener('mouseup',function(e){
      /* a pan is never a tap, however still the mouse ended up - otherwise a right-click with
         no movement would delete an upright. */
      if(dragging && !_panning && _moved<6 && Math.abs(e.clientX-_dx0)<6 && Math.abs(e.clientY-_dy0)<6) pickPost(e.clientX,e.clientY);
      dragging=false; _panning=false;
    });
    window.addEventListener('mousemove',function(e){if(!dragging)return;var dx=e.clientX-lx,dy=e.clientY-ly;_moved+=Math.abs(dx)+Math.abs(dy);
      if(_panning){ qdPan(dx,dy); }
      else { rotY+=dx*0.01;rotX+=dy*0.01;rotX=Math.max(-1.4,Math.min(1.4,rotX)); }
      lx=e.clientX;ly=e.clientY;});
    cv.addEventListener('wheel',function(e){e.preventDefault();dist*=(e.deltaY>0?1.08:0.92);dist=Math.max(qdFitDist*0.4,Math.min(qdFitDist*3,dist));},{passive:false});
    /* r99 ON A PHONE THERE WAS NO ZOOM AT ALL. touchstart only ever looked at one finger, so
       pinch did nothing and the only way to zoom was a mouse wheel nobody has on a phone.
       Two fingers now pan AND pinch together, which is what every map and photo app does.
       One finger still rotates, and still taps, exactly as before. */
    var _pd0=0, _pdist0=3;
    function _mid(t){ return { x:(t[0].clientX+t[1].clientX)/2, y:(t[0].clientY+t[1].clientY)/2 }; }
    function _spread(t){ var dx=t[0].clientX-t[1].clientX, dy=t[0].clientY-t[1].clientY; return Math.sqrt(dx*dx+dy*dy); }
    cv.addEventListener('touchstart',function(e){
      if(e.touches.length===1 && !_multi){ dragging=true;_panning=false;lx=e.touches[0].clientX;ly=e.touches[0].clientY;_dx0=lx;_dy0=ly;_moved=0; }
      else if(e.touches.length===2){ dragging=true;_multi=true;_panning=true;_moved=999;   // 999: a two-finger gesture can never be a tap
        var m=_mid(e.touches); lx=m.x; ly=m.y; _pd0=_spread(e.touches); _pdist0=dist; }
    },{passive:false});
    cv.addEventListener('touchmove',function(e){
      if(!dragging) return;
      if(e.touches.length===2 && _multi){
        e.preventDefault();                                  // ours, not the browser's page-zoom
        var m=_mid(e.touches); qdPan(m.x-lx, m.y-ly); lx=m.x; ly=m.y;
        var d=_spread(e.touches);
        if(_pd0>4 && d>4){ dist=Math.max(qdFitDist*0.4,Math.min(qdFitDist*3,_pdist0*(_pd0/d))); }
        return;
      }
      if(e.touches.length===1 && !_multi){
        e.preventDefault();                                  /* r161: rotating must not scroll the page */
        _moved+=Math.abs(e.touches[0].clientX-lx)+Math.abs(e.touches[0].clientY-ly);
        rotY+=(e.touches[0].clientX-lx)*0.01;rotX+=(e.touches[0].clientY-ly)*0.01;
        rotX=Math.max(-1.4,Math.min(1.4,rotX));
        lx=e.touches[0].clientX;ly=e.touches[0].clientY;
      }
    },{passive:false});
    cv.addEventListener('touchend',function(e){
      if(dragging && !_multi && _moved<10){ var t0=(e.changedTouches&&e.changedTouches[0]); if(t0) pickPost(t0.clientX,t0.clientY); }
      if(!e.touches || e.touches.length===0){ dragging=false; _multi=false; _panning=false; }
    });
    window.addEventListener('resize',resize);
    animate(); rebuild3D();
  }
  /* r53: turn a tap into "which upright is that", then delete or put it back. Only uprights
     answer - the rails and the joints are not clickable, because a rail is not a thing you can
     remove on its own without changing the size of the frame. */
  var qdRay=null, qdV2=null;
  function pickPost(clientX, clientY){
    try{
      /* r197: this guard is why the pairing was unreachable on its first run - the branch
         went in one level DOWN, in qdActOn, and this caller returns before ever getting
         there. A sweep of 120 canvas points selected nothing and that is what caught it.
         Read the caller before calling a path reachable.
         The pairing is display-only and a second tap clears it, so an idle tap is now
         allowed through. Every edit mode still wins the tap ahead of it. */
      if(!qdBuildView && !qdDelMode && !qdDelRail && !qdDelPanel && !QD_PAIR_ON) return;   // r54/r55/r65: nothing changes unless a tick is on (r222: build view taps always name)
      if(!T || !renderer || !camera || !group) return;
      var cv=$('qd-canvas'), r=cv.getBoundingClientRect();
      if(!qdRay){ qdRay=new T.Raycaster(); qdV2=new T.Vector2(); }
      qdV2.x = ((clientX-r.left)/r.width)*2-1;
      qdV2.y = -((clientY-r.top)/r.height)*2+1;
      qdRay.setFromCamera(qdV2, camera);
      var hits=qdRay.intersectObjects(group.children, false);
      if(qdBuildView){
        var _bm=null, _bi;
        /* r225: joints first, by screen distance - the cube is ~8px and its pill sits on it */
        try{ var _bj=null, _bjd=18, _bv=new T.Vector3(), _px=clientX-r.left, _py=clientY-r.top;
          for(_bi=0;_bi<group.children.length;_bi++){ var _bc=group.children[_bi]; if(_bc.visible===false||!_bc.userData||!_bc.userData.piece||_bc.userData.piece.kind!=='joint') continue;   /* r240: not a hidden step's joint */
            _bc.getWorldPosition(_bv); _bv.project(camera); var _sx=(_bv.x*0.5+0.5)*r.width, _sy=(-_bv.y*0.5+0.5)*r.height, _d=Math.sqrt((_sx-_px)*(_sx-_px)+(_sy-_py)*(_sy-_py));   /* world position: the group is rotated */
            if(_d<_bjd){ _bjd=_d; _bj=_bc; } }
          if(_bj){ qdBuildChip(_bj.userData.piece); return; } }catch(_ej){}
        for(_bi=0;_bi<hits.length;_bi++){ var _bo=hits[_bi].object; if(_bo&&_bo.visible!==false&&_bo.userData&&_bo.userData.piece){ _bm=_bo; break; }   /* r240: hidden steps are not tappable */ }
        if(!_bm){ var _bn=qdNearestPiece(clientX-r.left, clientY-r.top, r); if(_bn&&_bn.userData&&_bn.userData.piece) _bm=_bn; }
        qdBuildChip(_bm?_bm.userData.piece:null);
        return;
      }
      if(qdActOn(hits)) return;
      /* r98 THE NEAREST-PIECE FALLBACK. Measured on the preview: the pickable uprights are
         2.5 to 4 CSS pixels wide - about a fifteenth of the 44px both Apple and Google give as
         the minimum comfortable touch target. A direct hit on a 3px tube is a needle, and on a
         phone it is not hard, it is impossible. Patryk: "why cant i tap which coloum i want to
         work with". Nothing about the LOGIC was wrong; a landed tap always did the right thing.
         So: if the ray hit nothing usable, take the closest piece within QD_TAP_SLOP pixels of
         where the finger actually landed. A 3px tube behaves like a 52px target and no geometry
         changes. The direct hit is still tried FIRST and still wins, so a tap that used to work
         behaves exactly as before. */
      var nr=qdNearestPiece(clientX-r.left, clientY-r.top, r);
      if(nr && qdActOn([nr])) return;
      /* r210: a tap that hit NOTHING clears the pairing. Before this the only exits were a
         second tap on the very same piece and a Clear link written below the fold. */
      if(!qdDelMode && !qdDelRail && !qdDelPanel && qdPairSel){ if(qdPairClear()) rebuild3D(); return; }
      if(qdDelMode) qdOfferAdd();
    }catch(e){}
  }
  /* r210: Esc is what people try when they feel stuck, and it costs nothing to honour. */
  try{ document.addEventListener('keydown', function(ev){
    if(ev.key!=='Escape' && ev.keyCode!==27) return;
    if(!qdPairSel) return;
    if(qdPairClear()){ try{ rebuild3D(); }catch(_e){} }
  }); }catch(_ek){}
  var QD_TAP_SLOP = 26;   // CSS px around the tap that still counts as "that piece"
  /* The decision ladder, unchanged and lifted out whole so the direct hit and the near miss
     are answered by exactly the same rules - two copies would drift, which is the mistake the
     lip-axis code made four times over. */
  function qdActOn(hits){
    /* r199: the idle case is decided over the WHOLE hit list, not hit by hit.
       🔴 WHY: a raycast returns everything under the finger, nearest first, and on a box
       frame a rail or a leg is nearly always nearer than the panel behind it. Taking the
       first match meant a rail won every single tap - a sweep of 85 points selected a face
       panel ZERO times, so the back panel could not be tapped at all. The customer is
       aiming at a SURFACE; a tube only wins when no surface was hit. */
    try{
      if(!qdDelMode && !qdDelRail && !qdDelPanel){
        var pick=null, railHit=null, j;
        for(j=0;j<hits.length;j++){
          var u=hits[j].object && hits[j].object.userData; if(!u) continue;
          if(u.pface){ pick={face:u.pface}; break; }
          if(u.panel){ pick={panel:[u.panel[0],u.panel[1],u.panel[2]]}; break; }
          if(u.rail && !railHit){ var rr=u.rail; railHit={rail:[rr.ax,rr.li,rr.line,(rr.bays&&rr.bays.length)?rr.bays[0]:0]}; }
        }
        if(!pick) pick=railHit;
        if(pick){
          var was=qdPairSel, same=false;
          if(was){
            if(was.face && pick.face) same=(was.face===pick.face);
            else if(was.panel && pick.panel) same=(was.panel[0]===pick.panel[0]&&was.panel[1]===pick.panel[1]&&was.panel[2]===pick.panel[2]);
            else if(was.rail && pick.rail) same=(was.rail[0]===pick.rail[0]&&was.rail[1]===pick.rail[1]&&was.rail[2]===pick.rail[2]&&was.rail[3]===pick.rail[3]);
          }
          qdPairSel = same ? null : pick;
          qdPairNote(); rebuild3D(); return true;
        }
        return false;
      }
      for(var i=0;i<hits.length;i++){
        var ud=hits[i].object && hits[i].object.userData;
        if(!ud) continue;
        if(qdDelMode && ud.post){ togglePost(ud.post[0], ud.post[1], ud.legs||null); return true; }
        if(qdDelRail && ud.rail){ toggleRail(ud.rail); return true; }
        /* r92: in Edit cross bars, tapping a LEG offers a NEW BAR at the tapped height,
           attached to that leg - Patryk: "i want to be able to add in cross bars also". */
        if(qdDelRail && !qdDelMode && ud.post && hits[i].point){ qdOfferBar(ud.post[0], ud.post[1], hits[i].point); return true; }
        /* r91: in Edit Uprights (and not Edit cross bars), tapping a RAIL offers a new support
           right where the finger landed, on that rail's own line - Patryk: "why cant i click
           where i would like it to go... just click on a cross bar and have the option to add".
           A 'w' rail runs across the width, so the support splits the WIDTH at the tapped X on
           that rail's depth line; a 'd' rail splits the DEPTH at the tapped Z on its width line. */
        if(qdDelMode && !qdDelRail && ud.rail && hits[i].point){ qdOfferAddOnRail(ud.rail, hits[i].point); return true; }
        if(qdDelPanel && ud.face){ qdFaceTap(ud.face); return true; }
        if(qdDelPanel && ud.panel){ togglePanel(ud.panel[0], ud.panel[1], ud.panel[2]); return true; }
      }
    }catch(e){}
    return false;
  }
  /* Which pieces this mode can act on at all. Filtering here rather than letting qdActOn
     reject afterwards, so a nearby PANEL can never shadow the upright the customer was
     actually aiming at. Mirrors the ladder above. */
  function qdTapWants(ud){
    if(!ud) return false;
    if(qdDelPanel) return !!ud.panel;
    if(qdDelRail)  return !!(ud.rail || ud.post);
    if(qdDelMode)  return !!(ud.post || ud.rail);
    /* r197: with EDIT off, a tap used to do nothing at all. That is where the pairing
       lives, so it can never fight an edit mode for the same tap.
       r199: vertical face panels answer too. */
    return !!(ud.panel || ud.rail || ud.pface);
  }
  /* Distance from the tap to the piece as DRAWN - point-to-line-segment, not point-to-centre.
     A 466mm rail is long: its centre can be 200px from a tap that landed right on the tube. */
  function qdSegDist(px,py,ax,ay,bx,by){
    var vx=bx-ax, vy=by-ay, L=vx*vx+vy*vy;
    var t = L>0 ? (((px-ax)*vx+(py-ay)*vy)/L) : 0;
    t = t<0?0:(t>1?1:t);
    var cx=ax+t*vx, cy=ay+t*vy;
    return { d:Math.sqrt((px-cx)*(px-cx)+(py-cy)*(py-cy)), t:t };
  }
  function qdNearestPiece(px, py, rect){
    if(!T||!camera||!group) return null;
    var best=null, bestD=QD_TAP_SLOP, v=new T.Vector3();
    var proj=function(p){ v.copy(p).project(camera);
      return { x:(v.x*0.5+0.5)*rect.width, y:(-v.y*0.5+0.5)*rect.height }; };
    for(var i=0;i<group.children.length;i++){
      var m=group.children[i];
      if(!m || m.visible===false || !m.geometry || !qdTapWants(m.userData)) continue;   /* r240: a hidden step's piece is not the nearest anything */
      var g=m.geometry.parameters; if(!g) continue;
      var hx=(g.width||0)/2, hy=(g.height||0)/2, hz=(g.depth||0)/2;
      var a,b;                                   // the two ends of the piece, along its long axis
      if(hy>=hx && hy>=hz){ a=new T.Vector3(0,-hy,0); b=new T.Vector3(0,hy,0); }
      else if(hx>=hz){      a=new T.Vector3(-hx,0,0); b=new T.Vector3(hx,0,0); }
      else {                a=new T.Vector3(0,0,-hz); b=new T.Vector3(0,0,hz); }
      m.updateMatrixWorld();
      a.applyMatrix4(m.matrixWorld); b.applyMatrix4(m.matrixWorld);
      var A=proj(a), B=proj(b), r2=qdSegDist(px,py,A.x,A.y,B.x,B.y);
      if(r2.d<bestD){
        bestD=r2.d;
        /* the point the caller needs (qdOfferBar / qdOfferAddOnRail use it to know WHERE along
           the piece the tap was) - the closest point on the piece, in world space. */
        best={ object:m, point:a.clone().lerp(b, r2.t) };
      }
    }
    return best;
  }
  function postMsg(txt, bad){
    var n=$('qd-post-note'); if(!n) return;
    n.innerHTML=txt||''; n.style.display = txt?'block':'none';
    n.style.color = bad ? '#b42318' : '#475569';
  }
  /* r66: a tap now acts on the PIECE the customer is pointing at - the drawn tube, which is
     one physical piece (it can span levels no rail reaches). `legs` is that tube's piece
     range; null means the caller only knows the column (old ghosts, old links) and the whole
     column is meant. Engine rules mirrored exactly: a corner column can never go whole, and a
     corner's FLOOR piece can never go, but a corner piece higher up can (alucut 1.11.0). */
  function togglePost(xi, zi, legs){
    var cols=Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1);
    var rows=Math.max(1,+($('qd-rows')?$('qd-rows').value:1)||1);
    var N=($('qd-type').value==='box')?2:Math.max(2,+($('qd-tiers')?$('qd-tiers').value:3)||3);
    var corner=(xi===0||xi===cols) && (zi===0||zi===rows);
    var allLegs=[]; for(var li0=0; li0<N-1; li0++) allLegs.push(li0);
    var acts = (legs && legs.length) ? legs : allLegs;
    /* tapping a GHOST puts those pieces back */
    var allGone = acts.every(function(li){ return legDel(xi,zi,li); });
    if(allGone){
      qdSnapPosts('deleting that upright piece');
      /* a whole-column entry has to be EXPANDED before pieces of it can come back */
      var expanded=[];
      qdNoPosts.forEach(function(p){
        if(p[0]===xi&&p[1]===zi&&p.length===2){ allLegs.forEach(function(li){ expanded.push([xi,zi,li]); }); }
        else expanded.push(p);
      });
      qdNoPosts=expanded.filter(function(p){ return !(p[0]===xi&&p[1]===zi&&acts.indexOf(p[2])>=0); });
      postMsg('Upright piece put back.'); syncPostUI(); rebuild3D(); recalc(); return;
    }
    /* tapping a picked tube un-picks it */
    var allSel = acts.every(function(li){ return legSel(xi,zi,li); });
    if(allSel || selPostHas(xi,zi)){
      qdSelPosts=qdSelPosts.filter(function(p){
        if(p[0]!==xi||p[1]!==zi) return true;
        if(p.length===2) return false;
        return acts.indexOf(p[2])<0;
      });
      syncPostUI(); rebuild3D(); return;
    }
    if(corner && acts.indexOf(0)>=0){
      postMsg('The bottom piece of a corner upright cannot go \u2014 the frame has nothing to stand on there. A corner piece higher up can.', true);
      return;
    }
    if(!ENGINE17){
      postMsg('We cannot price a frame with an upright removed just yet \u2014 the pricing engine has not picked it up. Please try again shortly, or email sales@allaluminium.com.au.', true);
      return;
    }
    if(!ENGINE111){
      /* the engine on the other end predates single pieces - fall back to the whole column,
         which is what every tap meant before today */
      if(corner){ postMsg('That is a corner upright \u2014 the frame has nothing to stand on without it. Pick an inner or edge one.', true); return; }
      qdSelPosts=qdSelPosts.concat([[xi,zi]]);
      postMsg(''); syncPostUI(); rebuild3D(); return;
    }
    acts.forEach(function(li){ if(!legSel(xi,zi,li)) qdSelPosts.push([xi,zi,li]); });
    /* r101 (Q3): remove the cross bar between two upright sections and they are cut as ONE
       tube - so a tap takes the whole thing, correctly, and nothing on screen said why.
       Patryk read it as "I can't delete a section, only the whole thing". Say it. */
    postMsg(acts.length>1
      ? ('That upright is <strong>one tube</strong> here \u2014 ' + acts.length + ' sections with no cross bar between them, '
         + 'so it is cut as a single piece and comes out as one. Put a cross bar back at the level you want to '
         + 'cut at and the part below it can go on its own.')
      : '');
    syncPostUI(); rebuild3D();             // no reprice - nothing has left the frame yet
  }
  /* r65: same shape as togglePost. Tapping a ghost puts the panel straight back; tapping a
     picked one un-picks it; otherwise it is picked and nothing changes until Delete. */
  /* r170: one tap = one face panelled (mock 1, instant). Drives the SAME
     qdFaces the tick-boxes drive. When it flips the dropdown to the
     face-picker mode it mirrors the qd-panel change handler's housekeeping
     (r65 removals clear) - if that handler grows a step, add it here too. */
  var QD_FACE_NAME={top:'top',bottom:'bottom',front:'front',back:'back',left:'left side',right:'right side'};
  function qdFaceTap(k){
    if(!window.QD_E125){
      postMsg('Panels on a tapped face are not available just yet \u2014 please try again shortly, or email sales@allaluminium.com.au.', true);
      return;
    }
    var name=QD_FACE_NAME[k]||k;
    qdSnap(qdFaces[k] ? ('removing the '+name+' panel') : ('panelling the '+name));
    if(panelMode!=='custom'){
      var sel=$('qd-panel'); if(sel) sel.value='custom';
      panelMode='custom';
      if(qdNoPanels.length||qdSelPanels.length){ qdNoPanels=[]; qdSelPanels=[]; syncPostUI(); }
    }
    qdFaces[k]=!qdFaces[k];
    try{ if(window.qdSyncL4) window.qdSyncL4(); }catch(e){}
    /* no chatty postMsg here: recalc() writes its "Checking prices" status to
       the same element synchronously, so a confirmation would never render.
       The feedback IS the drawing - the panel and its lips appear - + the price. */
    updatePanelNote();
    rebuild3D();
    recalc();
  }
  function togglePanel(li,bk,dj){
    if(npnHas(li,bk,dj)){
      qdSnapPosts('deleting that panel');
      qdNoPanels=qdNoPanels.filter(function(a){ return !(a[0]===li&&a[1]===bk&&a[2]===dj); });
      postMsg('Panel put back.'); syncPostUI(); rebuild3D(); recalc(); return;
    }
    if(selPanelHas(li,bk,dj)){
      qdSelPanels=qdSelPanels.filter(function(a){ return !(a[0]===li&&a[1]===bk&&a[2]===dj); });
      syncPostUI(); rebuild3D(); return;
    }
    if(!ENGINE113){
      postMsg('We cannot price a frame with a panel removed just yet \u2014 the pricing engine has not picked it up. Please try again shortly, or email sales@allaluminium.com.au.', true);
      return;
    }
    qdSelPanels=qdSelPanels.concat([[li,bk,dj]]);
    postMsg('');
    syncPostUI(); rebuild3D();             // no reprice - nothing has left the design yet
  }
  /* r55: a rail on screen can be ONE tube spanning several bays (they merge through a crossing
     where nothing stands). Tapping it takes out the whole tube - every bay it covers - because
     that is the piece the customer is pointing at. */
  function toggleRail(r){
    if(!r) return;
    var bays=r.bays||[];
    var already=bays.length && bays.every(function(b){ return nrHas([r.ax,r.li,r.line,b]); });
    if(already){
      qdSnapPosts('deleting that cross bar');
      qdNoRails=qdNoRails.filter(function(a){ return !(a[0]===r.ax && a[1]===r.li && a[2]===r.line && bays.indexOf(a[3])>=0); });
      postMsg('Cross bar put back.'); syncPostUI(); rebuild3D(); recalc(); return;
    }
    var picked = bays.length && bays.every(function(b){ return selRailHas([r.ax,r.li,r.line,b]); });
    if(picked){
      qdSelRails=qdSelRails.filter(function(a){ return !(a[0]===r.ax && a[1]===r.li && a[2]===r.line && bays.indexOf(a[3])>=0); });
      syncPostUI(); rebuild3D(); return;
    }
    if(!ENGINE18){
      postMsg('We cannot price a frame with a cross bar removed just yet \u2014 the pricing engine has not picked it up. Please try again shortly, or email sales@allaluminium.com.au.', true);
      return;
    }
    bays.forEach(function(b){ if(!selRailHas([r.ax,r.li,r.line,b])) qdSelRails.push([r.ax,r.li,r.line,b]); });
    postMsg('');
    syncPostUI(); rebuild3D();             // no reprice - nothing has left the frame yet
  }
  function syncPostUI(){
    var w=$('qd-post-wrap'); if(!w) return;
    var nw=qdNoPosts.filter(function(p){return p.length===2;}).length;
    var npc=qdNoPosts.length-nw;
    var n=qdNoPosts.length, nr=qdNoRails.length, npn=qdNoPanels.length, sp=qdSelPosts.length, sr=qdSelRails.length, spn=qdSelPanels.length;
    w.style.display = (n||nr||npn||sp||sr||spn) ? 'flex' : 'none';
    var bits=[];
    if(nw) bits.push(nw + ' upright' + (nw===1?'':'s'));
    if(npc) bits.push(npc + ' upright piece' + (npc===1?'':'s'));
    if(nr) bits.push(nr + ' cross bar' + (nr===1?'':'s'));
    if(npn) bits.push(npn + ' panel' + (npn===1?'':'s'));
    var c=$('qd-post-count'); if(c) c.textContent = bits.length ? (bits.join(' and ') + ' removed') : '';
    var db=$('qd-del-go'), sel=sp+sr+spn;
    if(db){
      db.style.display = sel ? 'inline-flex' : 'none';
      db.textContent = 'Delete ' + sel + ' selected piece' + (sel===1?'':'s');
    }
    var rb=$('qd-post-reset'); if(rb) rb.style.display = (n||nr) ? 'inline-flex' : 'none';
  }
  /* r56: the only place a piece actually leaves the frame. One undo entry for the whole batch,
     one reprice, and the camera does not move because the frame's size has not changed. */
  function commitDelete(){
    if(!qdSelPosts.length && !qdSelRails.length && !qdSelPanels.length) return;
    var npw=qdSelPosts.filter(function(p){return p.length===2;}).length;
    var npp=qdSelPosts.length-npw, nrr=qdSelRails.length, npn=qdSelPanels.length;
    qdSnapPosts('deleting ' + [npw?(npw+' upright'+(npw===1?'':'s')):'', npp?(npp+' upright piece'+(npp===1?'':'s')):'', nrr?(nrr+' cross bar'+(nrr===1?'':'s')):'', npn?(npn+' panel'+(npn===1?'':'s')):''].filter(Boolean).join(' and '));
    qdNoPosts=qdNoPosts.concat(qdSelPosts);
    qdNoRails=qdNoRails.concat(qdSelRails);
    qdNoPanels=qdNoPanels.concat(qdSelPanels);
    qdSelPosts=[]; qdSelRails=[]; qdSelPanels=[];
    postMsg('Deleted. Tap an outline to put a piece back, or use Undo.');
    syncPostUI(); rebuild3D(); recalc();
  }
  function restoreAllPosts(){
    if(!qdNoPosts.length && !qdNoRails.length && !qdNoPanels.length) return;
    qdSnapPosts('putting every piece back');
    qdNoPosts=[]; qdNoRails=[]; qdNoPanels=[]; qdSelPosts=[]; qdSelRails=[]; qdSelPanels=[]; postMsg(''); syncPostUI(); rebuild3D(); recalc();
  }
  /* r230 STAGE ROOM (Patryk, 3 Sep: "when i add in uprights ... the new support page is in the way").
     The edit panel is an overlay at the bottom-left of the stage; with the New support box open it
     covered a third of a 380px drawing. While a box is open the canvas is shortened by the panel's
     height so the frame sits ABOVE it - the label layer is sized to the canvas, so it follows -
     and it is restored the moment the box closes. Full-screen edit keeps its own fixed boxes. */
  function qdStageRoomPx(){
    var st=document.querySelector('.qd-stage'), ep=$('qd-editpanel'); if(!st||!ep) return '';
    var open=!!((qdAddPending&&qdDelMode)||(qdBarPending&&qdDelRail));
    if(!open || document.body.classList.contains('qd-fsmode')) return '';
    var ph=ep.offsetHeight||0, sh=st.clientHeight||0; if(!(ph>0)||!(sh>0)) return '';
    var h=Math.round(sh-ph-42); if(h<170) h=170;
    return h+'px';
  }
  function qdStageRoom(){ try{ resize(); }catch(_e){} }
  function resize(){if(!renderer)return;var cv=$('qd-canvas');try{ var _rm=qdStageRoomPx(); if(cv.style.height!==_rm){ cv.style.height=_rm; } }catch(_e230r){}var w=cv.clientWidth||600,h=cv.clientHeight||360;renderer.setSize(w,h,false);camera.aspect=w/h;camera.updateProjectionMatrix();qdFitCamera();}
  /* r98 FIT THE FRAME TO THE CANVAS. The old rule was dist = maxd*2.1 + 0.4 - a fixed multiple
     of the largest dimension that never looked at the canvas shape. On the real page the canvas
     is about 910 x 378, and a 1500 x 400 x 500 frame came out using roughly a QUARTER of the
     width, which is the other half of why a 25.4mm tube lands on three pixels.
     This measures the frame instead: the furthest corner from the origin (which is what the
     camera orbits), then the distance at which that radius fills FILL of the NARROWER of the
     two half-angles - vertical on a wide canvas, horizontal on a tall phone. Rotation-invariant
     by construction, so the frame cannot swing out of view when it spins. */
  var qdFitDist=3;
  /* r99 PAN. The camera sits on a fixed axis and the GROUP rotates, so panning is a pure
     translation of the camera and its look-at point together - the view direction never
     changes, which is what keeps rotate and pan independent instead of fighting each other. */
  var panX=0, panY=0;
  function qdWorldPerPx(){
    var cv=$('qd-canvas'); var h=(cv&&cv.clientHeight)||360;
    return (2*dist*Math.tan((camera.fov*Math.PI/180)/2))/h;   // scales with zoom, so it always feels the same
  }
  function qdPan(dxPx, dyPx){
    var k=qdWorldPerPx();
    panX -= dxPx*k;          // the frame follows the finger, not the camera
    panY += dyPx*k;
    var lim=Math.max(1, dist*1.5);   // far enough to put any corner mid-canvas, not far enough to lose the frame
    panX=Math.max(-lim,Math.min(lim,panX));
    panY=Math.max(-lim,Math.min(lim,panY));
  }
  function qdResetPan(){ panX=0; panY=0; }
  /* r-bv5: the frame's OWN box, excluding decorations (connector pegs __qdStub, the FRONT
     marker __qdFront) so neither the camera fit nor FRONT placement is thrown off by them.
     Includes hidden real meshes (a build step still frames the whole unit) - visibility is
     not a geometry property. Caller zeroes rotation + updateMatrixWorld first, as before. */
  function qdFrameBox(){
    var box=new T.Box3();
    for(var i=0;i<group.children.length;i++){ var c=group.children[i]; if(c.__qdStub||c.__qdFront) continue; box.expandByObject(c); }
    return box;
  }
  function qdFitCamera(){
    try{
      if(!T||!camera||!group||!group.children.length) return;
      var rx=group.rotation.x, ry=group.rotation.y, rz=group.rotation.z;
      group.rotation.set(0,0,0); group.updateMatrixWorld(true);   // measure it un-rotated
      var box=qdFrameBox();   /* r-bv5: frame only, not pegs/FRONT */
      group.rotation.set(rx,ry,rz); group.updateMatrixWorld(true);
      if(!isFinite(box.min.x)||!isFinite(box.max.x)) return;
      var R=0;
      for(var i=0;i<8;i++){
        var x=(i&1)?box.max.x:box.min.x, y=(i&2)?box.max.y:box.min.y, z=(i&4)?box.max.z:box.min.z;
        var d=Math.sqrt(x*x+y*y+z*z); if(d>R) R=d;
      }
      if(!(R>0)) return;
      var vhalf=(camera.fov*Math.PI/180)/2;
      var hhalf=Math.atan(Math.tan(vhalf)*(camera.aspect||1));
      var half=Math.min(vhalf,hhalf);
      var FILL=0.82;                                  // a little air so nothing touches the edge
      var d2=R/Math.sin(half)/FILL;
      if(!isFinite(d2)||d2<=0) return;
      qdFitDist=d2; dist=d2;
    }catch(e){}
  }
  /* r62: a face view is a FLAT view - the 15% camera lift that makes the 3D look nice would tilt
     a "Front" elevation and it would not read as square-on. Lift goes to zero for a face. */
  var camLift=0.15;
  var QD_VIEWS={
    '3d':   {x:-0.42, y:0.72,  lift:0.15, name:'3D view'},
    'front':{x:0,     y:0,     lift:0,    name:'Looking at the FRONT'},
    'back': {x:0,     y:Math.PI,        lift:0, name:'Looking at the BACK'},
    'left': {x:0,     y:Math.PI/2,      lift:0, name:'Looking at the LEFT side'},
    'right':{x:0,     y:-Math.PI/2,     lift:0, name:'Looking at the RIGHT side'},
    'top':  {x:Math.PI/2, y:0,          lift:0, name:'Looking DOWN from above'}
  };
  function setView(k){
    var v=QD_VIEWS[k]; if(!v) return;
    spin=false;
    var si=$('qd-spin-ic'), st=$('qd-spin-tx');
    if(si) si.innerHTML='&#9658;'; if(st) st.textContent='Spin';
    rotX=v.x; rotY=v.y; camLift=v.lift; qdResetPan(); qdFitCamera();   // r99: a view button also puts the frame back where you can see it
    /* refit the zoom: a square-on elevation of a tall frame needs more room than a 3/4 view,
       and clearing QD_FIT alone does nothing until something else rebuilds. */
    QD_FIT=null; rebuild3D();
    facingNote();
  }
  /* Which face is actually pointing at the camera. Derived from the LIVE rotation rather than
     from whichever button was pressed, so dragging the frame updates it too. */
  function facingNote(){
    try{
      var el=$('qd-facing'); if(!el||!T||!group) return;
      var best=null, bz=-2;
      var axes=[[0,0,1,'FRONT'],[0,0,-1,'BACK'],[1,0,0,'RIGHT side'],[-1,0,0,'LEFT side'],[0,1,0,'TOP'],[0,-1,0,'BOTTOM']];
      for(var i=0;i<axes.length;i++){
        var v=new T.Vector3(axes[i][0],axes[i][1],axes[i][2]).applyEuler(group.rotation);
        if(v.z>bz){ bz=v.z; best=axes[i][3]; }
      }
      el.textContent = (bz>0.985) ? ('Looking at the '+best) : '3D view';
    }catch(e){}
  }
  function animate(){requestAnimationFrame(animate);if(!renderer)return;if(spin&&!dragging)rotY+=0.0035;group.rotation.x=rotX;group.rotation.y=rotY;var r=dist;camera.position.set(panX,r*camLift+panY,r);camera.lookAt(panX,panY,0);renderer.render(scene,camera);gizmo();facingNote();}
  function rebuild3D(){
    if(!T||!group||!state.type)return;
    /* r193: dispose the outline geometries this rebuild is throwing away. Every other
       geometry here is also recreated per rebuild and never disposed, which is existing
       behaviour I am not changing today - but a rebuild fires on every slider tick, and
       I am the one adding these, so I clean up after myself rather than adding to it. */
    while(group.children.length){
      var _old=group.children[0];
      if(_old && _old.userData && _old.userData.glassEdge && _old.geometry){
        try{ _old.geometry.dispose(); }catch(_de){}
      }
      group.remove(_old);
    }
    /* MEASURED 23 Aug 2026. The tube was drawn at 28mm and the joint at 44mm, on a system where
       both are 25.4mm — 8mm of black proud of the tube face at every corner. A Qubelok connector
       is the same outside dimension as the tube and finishes flush; the old numbers made every
       joint read as a lump. Drawing only: no cut list, connector count or price depends on these. */
    var S=1/1000, t=25.4*S;
    var mat=new T.MeshLambertMaterial({color:0x9aa7bd});
    var bs=beams(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares,railLvArr(),qdNoPosts,qdNoRails,qdFloorTrim());   /* r219: the picture trims what the engine trims */
    var maxd=Math.max(state.W,state.D,state.H)*S;
    // Panelled levels (horizontal panels) or side enclosure (vertical panels).
    var sideMode3D=((panelMode==='back'||panelMode==='backfront') && state.type==='box');
    var pLevels=[];
    if(panelMode!=='none' && !sideMode3D){
      /* r45: these were spaced EVENLY off state.H while the rails were drawn from the real
         opening list. Set uneven heights and the shelves floated away from the rails they are
         supposed to be sitting on - exactly what Patryk saw at H 500/600/418/419. Take the
         level positions from the same grid the rails come from, so they cannot drift apart. */
      var _pg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var _ys=_pg.ys||[];
      if(panelMode==='custom'){ if(qdFaces.bottom&&_ys.length) pLevels.push(_ys[0]); if(qdFaces.top&&_ys.length) pLevels.push(_ys[_ys.length-1]); }
      else if(panelMode==='top'){ if(_ys.length) pLevels.push(_ys[_ys.length-1]); }
      else { for(var pi=0;pi<_ys.length;pi++) pLevels.push(_ys[pi]); }
      /* r65: which LEVEL each drawn shelf is, so a tap can name the panel it hit. Parallel
         to pLevels rather than inside it - two other loops compare pLevels entries as bare
         numbers and must keep doing so. */
      var pLis = (panelMode==='custom') ? pLevels.map(function(v){ return _ys.indexOf(v); })
               : (panelMode==='top') ? [ _ys.length-1 ] : _ys.map(function(_,ix){ return ix; });
    }
    var longAx=(state.W>=state.D)?'x':'z';                 // lipped rails are the longer opposite pair
    // frame + lip both tint to the chosen finish (mill grey / clear light / black dark)
    var finMat = (qdFinish==='black') ? new T.MeshLambertMaterial({color:0x2a2f3a})
               : (qdFinish==='clear') ? new T.MeshLambertMaterial({color:0xc7d2e0})
               : mat;
    var anodMat=finMat, frameMat=finMat;   // rails tint to the chosen frame finish
    /* r58: Patryk, 24 Aug - "have a colour on the tubes that are not recommended". A
       horizontal tube longer than QD_SPAN_MAX has nothing under the middle of it, so it is
       drawn AMBER. Legs are never amber - a leg is not a span. */
    var spanMat=new T.MeshLambertMaterial({color:0xf59e0b});
    var qdSF=qdSpanFacts(), qdOverSeen=0, _wbb=null;
    /* r96 (Patryk, 27 Aug): "the highlight the lipped rail and edit cross bars are too simular
       in colour". They were: the lip was 0x12b8e5 and a pickable piece is 0x7dd3fc - two
       cyans on the same frame, and in an edit mode you could not tell a lipped rail from one
       you were about to delete. The lip leaves the blues altogether. Emerald is used by
       nothing else here; the edit palette (sky = pickable, orange = picked, faint pink =
       already gone) is untouched, so the wording that names those colours still holds. */
    var lipMat = lipHL ? new T.MeshLambertMaterial({color:0x059669}) : finMat;   // emerald when "Show where panels sit" is on; blends into the frame when off
    /* r61, 24 Aug. THE DRAWING WAS SHOWING A PRODUCT THAT IS NOT IN THE BOX.
       isLip() never looked at panelFix, so an ANGLE build was painted with teal LIPPED rails.
       Quoted live for shelf 1000x900x1800, 4 tiers, 1 col, 2 depth rows, panels every shelf,
       BYO: lipped bars supplied = 0; what is actually shipped is 32 screw-on angle ledges,
       4 bars and 64 screws we do not stock. Patryk spotted it and named the fix himself -
       "unless we have another colour for angle and to be screwed in".
       The engine is right and already refuses lip + depth supports, because a one-leg lip can
       only face one way. So the angle gets its OWN colour and, on a shared rail, a ledge on
       BOTH sides - which is the whole reason the angle exists. */
    var fixIsAngle = (panelFix==='angle' && panelMode!=='none');
    var angMat = lipHL ? new T.MeshLambertMaterial({color:0x7c3aed}) : finMat;
    /* WHICH PAIR GETS THE LIP - mirrors the Worker's pullLips() exactly.
       The lip belongs on the panel's LONGEST pair so the sheet bridges the SHORTER span (least
       sag) - but only on a single bay, because with cols>1 the depth rails are SHARED between
       two openings and a one-leg lip cannot face both. The preview used to lip the width rails
       unconditionally, so on a deep single-bay frame it drew the lips on the wrong pair while
       the cut list quietly did the right thing. `longAx` above was computed for this and never
       read. Same arithmetic as the Worker so the picture and the cut list cannot drift. */
    var A_=50.8, nColsL=Math.max(1,state.cols||1);
    var _gg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
    var wSegP=Math.max.apply(null,_gg.wSeg);   // the widest bay — uneven openings changed this from one number
    var lipSpanP=Math.max(1,Math.round(state.D-A_));
    var lipAx=(nColsL===1 && lipSpanP>wSegP) ? 'z' : 'x';
    function isLip(e){
      /* r154: back-wall legs first - back walls exist with panels 'none' too */
      if(state.type==='shelf' && qdBackSel.length && e.ax==='y' && e.pl0!=null && e.pl0===e.pl1
         && qdBwLip(e.pxi, e.pzi, e.pl0, qdBackSel)) return true;
      if(panelMode==='none')return false;
      if(panelMode==='custom'){
        /* r144: single box cell only (the gate keeps other shapes off custom, and
           the engine refuses them anyway). Position read off the grid's own outer
           lines, r101's lesson - never assume where a line is. */
        var _cy4=_gg.ys||[], _cz4=_gg.zs||[], _cx4=_gg.xs||[];
        if(_cy4.length<2||_cz4.length<2||_cx4.length<2) return false;
        return qdCustomLip(e.ax,{
          b:Math.abs(e.cy-_cy4[0])<0.5, t:Math.abs(e.cy-_cy4[_cy4.length-1])<0.5,
          k:Math.abs(e.cz-_cz4[0])<0.5, f:Math.abs(e.cz-_cz4[_cz4.length-1])<0.5,
          l:Math.abs(e.cx-_cx4[0])<0.5, r:Math.abs(e.cx-_cx4[_cx4.length-1])<0.5
        }, qdFaces, qdLips4);
      }
      var encl3=(panelMode==='sides'||panelMode==='enclosed'||panelMode==='enclosedfront');
      if(encl3){
        /* r134 - mirrors alucut 1.23.0's fixed assignment (single box cell only; the
           r133 gate keeps every other shape off these modes). floor+top sit in the four
           DEPTH rails, back/front in their own WIDTH rails, the side panels in the four
           LEGS - 12 edges, 6 faces x 2, no member ever lips two ways. Proven by
           tools\enclosure-check\enclosure-check.py; painted counts must equal the
           engine's lipped piece counts: sides 4, enclosed 10, enclosedfront 12. */
        if(e.ax==='y') return true;
        if(e.ax==='z') return panelMode!=='sides';
        if(panelMode==='sides') return false;
        return (panelMode==='enclosedfront') ? true : (e.cz<0);
      }
      if(sideMode3D){                                    // vertical panel(s): back, +front
        /* r134: mirror pullLips. On a single-bay box TALLER than wide the engine buys
           lipped LEGS (lipOnSpan(lipSpanVert) - hSeg beats every wSeg), and the panel
           stands between its two uprights; only otherwise do the top+bottom rails carry
           it. Same arithmetic as the Worker so the picture and the cut list agree. */
        var _hs3=Math.max.apply(null,_gg.hSeg||[0]), _ws3=Math.max.apply(null,_gg.wSeg||[1]);
        if(nColsL===1 && _hs3>_ws3){
          if(e.ax!=='y') return false;
          return (panelMode==='backfront') ? true : (e.cz<0);
        }
        if(e.ax!=='x') return false;
        /* r131 (Patryk's screenshot, 29 Aug): the rail CENTRELINE sits half a connector inside
           the external size, so the old test against state.H/2 matched nothing - no vertical-
           panel build ever showed its lips. Same miss r101 fixed for the shelf path, in the
           branch it did not touch. Compare against the grid's own lines, exactly as below. */
        var _ys3=_gg.ys||[], _oz3=_gg.zs||[];
        if(_ys3.length<2 || _oz3.length<2) return false;
        if(Math.abs(e.cy-_ys3[0])>=0.5 && Math.abs(e.cy-_ys3[_ys3.length-1])>=0.5) return false;
        if(Math.abs(e.cz-_oz3[0])>=0.5 && Math.abs(e.cz-_oz3[_oz3.length-1])>=0.5) return false;
        return (panelMode==='backfront') ? true : (e.cz<0);   // back only, or both faces
      }
      if(e.ax!==lipAx)return false;                      // the longest pair, or the width rails when the depth ones are shared
      /* r101 (Patryk, 27 Aug): THIS was the whole bug. The test above was the only one, so a bar
         running the right way at a shelf level was drawn green wherever it sat - including the
         ones through the MIDDLE of the depth. A middle bar has a panel on each side and the
         ET7200 lip faces one way, so the engine never buys it lipped in any frame it will price:
         his 1500 x 400 frame buys 18 x 466mm width rails with the middle line in and 12 without,
         and all 18 were painted green. The picture said the shelf had ledges; the price said it
         did not. Only a rail on an OUTER line can carry a lip, so ask that too.
         A frame with no depth supports has only outer lines, so nothing about it changes. */
      var _oz=_gg.zs||[], _ox=_gg.xs||[];
      /* Take the outer lines from the SAME grid the rails are drawn from. The first version of
         this compared against +/- D/2 and matched nothing - a rail centreline sits half a
         connector inside the external size, so the test removed EVERY lip from the drawing.
         The pixel count caught it: 4,071 emerald pixels became 0. Never assume where a line is
         when the grid will tell you. */
      if(lipAx==='x'){
        if(_oz.length<2) return false;
        if(Math.abs(e.cz-_oz[0])>=0.5 && Math.abs(e.cz-_oz[_oz.length-1])>=0.5) return false;
      } else {
        if(_ox.length<2) return false;
        if(Math.abs(e.cx-_ox[0])>=0.5 && Math.abs(e.cx-_ox[_ox.length-1])>=0.5) return false;
      }
      for(var i=0;i<pLevels.length;i++){ if(Math.abs(e.cy-pLevels[i])<0.5) return true; }
      return false;
    }
    bs.forEach(function(e){
      var L=e.len*S, sx=t,sy=t,sz=t;
      if(e.ax==='x')sx=L; else if(e.ax==='y')sy=L; else sz=L;
      /* On an angle build EVERY rail at a panelled level carries a ledge, on each side that has
         an opening next to it - not just the "longest pair" the single-sided lip is limited to. */
      var lip=isLip(e), ang=false;
      if(fixIsAngle && e.rail){
        for(var _pl=0;_pl<pLevels.length;_pl++){ if(Math.abs(e.cy-pLevels[_pl])<0.5){ ang=true; break; } }
        if(ang) lip=false;
      }
      /* Option D: light up the rails for the size field the customer is in. hlAxis is 'x'
         (width), 'z' (depth) or 'y' (height); null the rest of the time, so the frame is a
         clean product image unless someone is actually editing a size. */
      var hlMat = (hlAxis && e.ax===hlAxis) ? new T.MeshLambertMaterial({color:0x12b8e5}) : null;
      /* r44: the toggle says "show lipped rails", but only the 2.4mm ledge was tinted - on a
         5350mm frame that is a sub-pixel sliver, so it read as nothing happening. Tint the
         whole lipped RAIL when the toggle is on. The ledge detail stays for close zoom. */
      var railMat = ang ? (lipHL ? angMat : anodMat) : (lip ? (lipHL ? lipMat : anodMat) : frameMat);
      /* r197: with something picked, THIS rail is either one of its holders (amber) or it
         steps back. Applied after the normal choice so every other look is untouched when
         nothing is picked. */
      if(qdPairSel && e.rail){
        /* r210: HIGHLIGHT, DO NOT DIM. Painting every other tube flat 0xe3e9f0 is what made
           Patryk read the frame as wiped - "the other panels disappear and so on". The answer
           to "which rails hold this panel" is the two amber rails; nothing else has to move
           for that to be legible, and a frame that stays a frame is not a trap. */
        if(qdPairIsHolder(e.rail)) railMat = qdPairHotMat();
      }
      /* amber = this tube is part of a run with no upright under the middle of it, longer
         than we recommend. The run is worked out once, above, by qdSpanFacts(). */
      var overSpan=false;
      if(e.rail && e.rail.bays) for(var _ob=0;_ob<e.rail.bays.length;_ob++){ if(qdSF.bad[e.rail.ax+'|'+e.rail.li+'|'+e.rail.line+'|'+e.rail.bays[_ob]]){ overSpan=true; break; } }
      if(overSpan) qdOverSeen++;   /* counted whether or not the amber is being SHOWN, so the tick stays offerable */
      /* r108: grow a box around the tubes that make up the WIDEST run, so its label can be
         anchored to the middle of the run itself rather than guessed from the grid. */
      if(e.rail && e.rail.bays && qdSF.wide) for(var _wb=0;_wb<e.rail.bays.length;_wb++){
        if(qdSF.wide[e.rail.ax+'|'+e.rail.li+'|'+e.rail.line+'|'+e.rail.bays[_wb]]){
          if(!_wbb) _wbb=[e.cx,e.cy,e.cz,e.cx,e.cy,e.cz];
          else { _wbb[0]=Math.min(_wbb[0],e.cx); _wbb[1]=Math.min(_wbb[1],e.cy); _wbb[2]=Math.min(_wbb[2],e.cz);
                 _wbb[3]=Math.max(_wbb[3],e.cx); _wbb[4]=Math.max(_wbb[4],e.cy); _wbb[5]=Math.max(_wbb[5],e.cz); }
          break;
        }
      }
      var m=new T.Mesh(new T.BoxGeometry(sx,sy,sz), hlMat || ((overSpan&&spanHL)?spanMat:railMat));
      m.position.set(e.cx*S,e.cy*S,e.cz*S);
      m.userData.piece={ax:e.ax,len:e.len,cx:e.cx,cy:e.cy,cz:e.cz};   /* r221: for the code pill */
      /* r53: an upright carries the grid crossing it stands on, so a tap can name it.
         r54: while the tick is on, colour the ones that can actually go, so nobody has to
         guess which taps do something. */
      /* r56: THREE states, three colours that cannot be mistaken for each other. The pale red
         used for "you can tap this" was almost the same as the red outline of something already
         gone, so there was no way to tell whether a tap had registered - Patryk's only clue was
         the camera jumping, which was itself a bug. Now: pale BLUE = tappable, strong ORANGE =
         picked, faint RED outline = already deleted. */
      if(e.rail){
        m.userData={ rail:e.rail, piece:m.userData.piece };
        if(qdDelRail){
          var _picked = e.rail.bays && e.rail.bays.length && e.rail.bays.every(function(b){ return selRailHas([e.rail.ax,e.rail.li,e.rail.line,b]); });
          m.material=new T.MeshLambertMaterial({color: _picked ? 0xf97316 : 0x7dd3fc});
        }
      }
      if(e.ax==='y' && e.pxi!=null){
        /* r66: the drawn tube IS the physical piece - it may span several levels where no
           rail arrives. A tap acts on the whole tube, so the mesh carries its piece range. */
        var _legs=[]; for(var _pl=(e.pl0!=null?e.pl0:0); _pl<=(e.pl1!=null?e.pl1:0); _pl++) _legs.push(_pl);
        m.userData={ post:[e.pxi, e.pzi], legs:_legs, piece:m.userData.piece };
        /* r199: a side panel is held by its own two legs, so the legs light up too */
        if(qdPairSel && qdPairSel.face){
          if(qdPairPostIsHolder([e.pxi,e.pzi])) m.material = qdPairHotMat();   /* r210: highlight only */
        }
        if(qdDelMode){
          var _c=Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1), _r=Math.max(1,+($('qd-rows')?$('qd-rows').value:1)||1);
          var _corner=(e.pxi===0||e.pxi===_c)&&(e.pzi===0||e.pzi===_r);
          /* engine rule: only the FLOOR piece of a corner is protected; higher pieces can go */
          var _locked=_corner && _legs.indexOf(0)>=0;
          if(!_locked){
            var _selT=_legs.every(function(li){ return legSel(e.pxi,e.pzi,li); }) || selPostHas(e.pxi,e.pzi);
            m.material=new T.MeshLambertMaterial({color: _selT ? 0xf97316 : 0x7dd3fc});
          }
        }
      }
      group.add(m);
      if(ang){
        /* the ledge is a separate 20 x 20 x 1.6 angle SCREWED to the rail. Draw one on every
           side of this rail that has an opening next to it, so an interior rail shows two,
           back to back - the picture the single-lip extrusion physically cannot give. */
        var ar=6*S, at=1.6*S, adrop=6*S, sides=[];
        if(e.ax==='x'){ if(e.rail.line>0) sides.push(-1); if(e.rail.line<Math.max(1,state.rows||1)) sides.push(1); }
        else {          if(e.rail.line>0) sides.push(-1); if(e.rail.line<Math.max(1,state.cols||1)) sides.push(1); }
        for(var _si=0;_si<sides.length;_si++){
          var sgn=sides[_si];
          var am=new T.Mesh(new T.BoxGeometry(e.ax==='x'?L:ar, at, e.ax==='z'?L:ar), angMat);
          var aX=(e.ax==='z')? sgn*(t/2+ar/2) : 0, aZ=(e.ax==='x')? sgn*(t/2+ar/2) : 0;
          am.position.set(e.cx*S+aX, e.cy*S+t/2-adrop-at/2, e.cz*S+aZ);
          group.add(am);
          var av=new T.Mesh(new T.BoxGeometry(e.ax==='x'?L:at, ar, e.ax==='z'?L:at), angMat);
          var vX=(e.ax==='z')? sgn*(t/2+at/2) : 0, vZ=(e.ax==='x')? sgn*(t/2+at/2) : 0;
          av.position.set(e.cx*S+vX, e.cy*S+t/2-adrop+ar/2-at, e.cz*S+vZ);
          group.add(av);
        }
      }
      if(lip){ // lip ledge drawn exactly where the panel edge sits
        /* ET7200 "One Leg", worked out from Capral's components table 23 Aug: the leg is about
           5mm out and 2.4mm thick, and it sits 6mm BELOW the top face so a 6mm panel finishes
           FLUSH with the rail. The old 12mm x 2mm ON TOP of the rail had no source and showed
           the panel proud - the opposite of the reason to buy the plate. */
        /* r67: drawn to the DIE Patryk supplied 25 Aug - leg 6.35 long x 1.57 thick.
           r68: the drop is the die's 6.35 too, and the panel does NOT finish flush - it
           sits 0.35mm below the top (17mm ply: 0.48mm below on the flipped side). That is
           the point: a panel can never stand proud. Patryk caught the "flush" claim. */
        var lr=6.35*S, lt=1.57*S, drop=6.35*S;
        var _enclVertRail=(panelMode==='enclosed'||panelMode==='enclosedfront') && e.ax==='x';
        /* r144 custom mode: which FACE this member's lip serves decides the detail's
           orientation. The edge budget means a member never serves two faces. */
        var _c4V=false,_c4LegSide=false,_c4ZSide=false;
        if(panelMode==='custom'){
          var _cyD=_gg.ys||[], _czD=_gg.zs||[], _cxD=_gg.xs||[];
          if(_cyD.length>1&&_czD.length>1&&_cxD.length>1){
            var _pB=Math.abs(e.cy-_cyD[0])<0.5, _pT=Math.abs(e.cy-_cyD[_cyD.length-1])<0.5;
            var _pK=Math.abs(e.cz-_czD[0])<0.5, _pF=Math.abs(e.cz-_czD[_czD.length-1])<0.5;
            var _pL=Math.abs(e.cx-_cxD[0])<0.5, _pR=Math.abs(e.cx-_cxD[_cxD.length-1])<0.5;
            _c4V=e.ax==='x' && ((qdFaces.front&&_pF)||(qdFaces.back&&_pK));
            _c4LegSide=e.ax==='y' && ((qdFaces.left&&_pL)||(qdFaces.right&&_pR));
            _c4ZSide=e.ax==='z' && ((qdLips4.left&&_pL)||(qdLips4.right&&_pR));
          }
        }
        /* r141 (Patryk, Front view of an enclosure: "the lip is showing in the wrong spot"):
           on the enclosure modes the front/back panels' WIDTH rails are lipped for a
           VERTICAL panel, but only sideMode3D reached the vertical detail - these rails
           fell through to the horizontal shelf ledge, drawn pointing the wrong way. */
        if((sideMode3D || _enclVertRail || _c4V) && e.ax==='x'){ // VERTICAL panel: mark the top/bottom rail on its inner face (offset toward the opening so the panel doesn't hide it)
          var inZ=(e.cz>0)?-1:1;
          var lm=new T.Mesh(new T.BoxGeometry(L, t*1.1, lt), lipMat);
          lm.position.set(e.cx*S, e.cy*S, e.cz*S - inZ*(t/2-drop-lt/2));
          group.add(lm);
        } else if(e.ax==='y'){
          /* r138 (Patryk, V6.7: "the lipped profile disappeared"): r134 skipped the ledge
             on vertical members; with side panels every lip is on a LEG, so the profile
             vanished from the drawing. Drawn properly now, mirroring the horizontal case:
             the ledge sits `drop` in from the face the panel rests against and protrudes
             into the opening the panel fills. Side panels stand in the x-planes (ledge
             reaches across the depth); a tall box's back/front panels stand in the
             z-planes (ledge reaches across the width). */
          var _enclLeg=(panelMode==='sides'||panelMode==='enclosed'||panelMode==='enclosedfront')||_c4LegSide;
          if(_enclLeg){
            var _oX=(e.cx<0)?-1:1, _iZ=(e.cz>0)?-1:1;
            var lmv=new T.Mesh(new T.BoxGeometry(lt, L, lr), lipMat);
            lmv.position.set(e.cx*S+_oX*(t/2-drop-lt/2), e.cy*S, e.cz*S+_iZ*(t/2+lr/2));
            group.add(lmv);
          } else {
            var _oZ=(e.cz<0)?-1:1, _iX=(e.cx>0)?-1:1;
            /* r154: a back-wall leg's fin points into the ticked bay */
            if(state.type==='shelf' && qdBackSel.length && e.pl0!=null && qdBwLip(e.pxi,e.pzi,e.pl0,qdBackSel)){
              for(var _bi=0;_bi<qdBackSel.length;_bi++){ var _c5=qdBackSel[_bi];
                if(_c5[0]===e.pl0 && (_c5[1]===e.pxi || _c5[1]===e.pxi-1)){ _iX=(_c5[1]===e.pxi)?1:-1; break; } }
            }
            var lmv2=new T.Mesh(new T.BoxGeometry(lr, L, lt), lipMat);
            lmv2.position.set(e.cx*S+_iX*(t/2+lr/2), e.cy*S, e.cz*S+_oZ*(t/2-drop-lt/2));
            group.add(lmv2);
          }
        } else if(_c4ZSide && e.ax==='z'){
          /* r144: a depth rail lipped for a four-edged SIDE panel - the fin sits in
             the side panel's plane (drop in from the outer x face) and reaches into
             the opening vertically. The _enclLeg case with its axes swapped. */
          var _oX4=(e.cx<0)?-1:1, _iY4=(e.cy<0)?1:-1;
          var lmz=new T.Mesh(new T.BoxGeometry(lt, lr, L), lipMat);
          lmz.position.set(e.cx*S+_oX4*(t/2-drop-lt/2), e.cy*S+_iY4*(t/2+lr/2), e.cz*S);
          group.add(lmz);
        } else { // HORIZONTAL shelf panel: ledge on top of the rail protruding inward
          var lm=new T.Mesh(new T.BoxGeometry(e.ax==='x'?L:lr, lt, e.ax==='z'?L:lr), lipMat);
          var inX=(e.ax==='z')?(e.cx>0?-1:1):0, inZ=(e.ax==='x')?(e.cz>0?-1:1):0;
          // top of the leg sits `drop` below the top of the rail; the panel lands on it
          lm.position.set(e.cx*S+inX*(t/2+lr/2), e.cy*S+t/2-drop-lt/2, e.cz*S+inZ*(t/2+lr/2));
          group.add(lm);
        }
      }
    });
    /* r54: a deleted upright leaves nothing on screen, so putting it back meant tapping empty
       air. Draw it as a faint outline while the tick is on - same position, same click target. */
    if(qdDelRail && qdNoRails.length){
      var _gr=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var rmat=new T.MeshLambertMaterial({color:0xb42318, transparent:true, opacity:0.22});
      qdNoRails.forEach(function(a){
        var li=a[1], line=a[2], bay=a[3];
        if(a[0]==='w'){
          var x0=_gr.xs[bay], x1=_gr.xs[bay+1], zz=_gr.zs[line], yy=_gr.ys[li];
          if(x0==null||x1==null||zz==null||yy==null) return;
          var gm=new T.Mesh(new T.BoxGeometry((x1-x0)*S,t,t), rmat);
          gm.position.set(((x0+x1)/2)*S, yy*S, zz*S);
          gm.userData={ rail:{ax:'w',li:li,line:line,bays:[bay]} }; group.add(gm);
        } else {
          var z0=_gr.zs[bay], z1=_gr.zs[bay+1], xx=_gr.xs[line], yy2=_gr.ys[li];
          if(z0==null||z1==null||xx==null||yy2==null) return;
          var gm2=new T.Mesh(new T.BoxGeometry(t,t,(z1-z0)*S), rmat);
          gm2.position.set(xx*S, yy2*S, ((z0+z1)/2)*S);
          gm2.userData={ rail:{ax:'d',li:li,line:line,bays:[bay]} }; group.add(gm2);
        }
      });
    }
    if(qdDelMode && qdNoPosts.length){
      var _gh=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var gmat=new T.MeshLambertMaterial({color:0xb42318, transparent:true, opacity:0.22});
      qdNoPosts.forEach(function(pp){
        var gx=_gh.xs[pp[0]], gz=_gh.zs[pp[1]];
        if(gx==null||gz==null) return;
        /* r66: a deleted PIECE ghosts only its own level span; a whole column ghosts full
           height, as before. The ghost carries its pieces so a tap puts back exactly them. */
        var y0,y1,_legs;
        if(pp.length>=3){
          y0=_gh.ys[pp[2]]; y1=_gh.ys[pp[2]+1];
          if(y0==null||y1==null) return;
          _legs=[pp[2]];
        } else {
          y0=_gh.ys[0]; y1=_gh.ys[_gh.ys.length-1];
          _legs=null;
        }
        var gm=new T.Mesh(new T.BoxGeometry(t,(y1-y0)*S,t), gmat);
        gm.position.set(gx*S,((y0+y1)/2)*S,gz*S);
        gm.userData={ post:[pp[0], pp[1]], legs:_legs };
        group.add(gm);
      });
    }
    /* r57: the opening whose box has focus is lit up in the frame - the replacement for the
       W1/D2/H3 chips, and a much more direct answer to "which one is that?" */
    QD_OPEN_AT=null; QD_OPEN_TXT=''; QD_CHAIN=null;
    /* driven from here, not from the focus handlers, so it is right after ANY rebuild -
       including the ones that throw the boxes away and make new ones. */
    qdMarkOpen();
    if(OPEN_HL){
      var _hk=OPEN_HL.charAt(0), _hi=parseInt(OPEN_HL.slice(1),10);
      var _hg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var hmat=new T.MeshLambertMaterial({color:0x12b8e5, transparent:true, opacity:0.20});
      var sx0,sx1,sy0,sy1,sz0,sz1, okh=true;
      var _xs=_hg.xs,_ys=_hg.ys,_zs=_hg.zs;
      if(_hk==='w' && _xs[_hi]!=null && _xs[_hi+1]!=null){ sx0=_xs[_hi]; sx1=_xs[_hi+1]; sy0=_ys[0]; sy1=_ys[_ys.length-1]; sz0=_zs[0]; sz1=_zs[_zs.length-1]; }
      else if(_hk==='d' && _zs[_hi]!=null && _zs[_hi+1]!=null){ sz0=_zs[_hi]; sz1=_zs[_hi+1]; sx0=_xs[0]; sx1=_xs[_xs.length-1]; sy0=_ys[0]; sy1=_ys[_ys.length-1]; }
      else if(_hk==='h' && _ys[_hi]!=null && _ys[_hi+1]!=null){ sy0=_ys[_hi]; sy1=_ys[_hi+1]; sx0=_xs[0]; sx1=_xs[_xs.length-1]; sz0=_zs[0]; sz1=_zs[_zs.length-1]; }
      else okh=false;
      if(okh){
        var hm=new T.Mesh(new T.BoxGeometry(Math.abs(sx1-sx0)*S, Math.abs(sy1-sy0)*S, Math.abs(sz1-sz0)*S), hmat);
        hm.position.set(((sx0+sx1)/2)*S, ((sy0+sy1)/2)*S, ((sz0+sz1)/2)*S);
        group.add(hm);
        /* r108 ITEM 5: the slab says WHERE; this says WHICH and HOW BIG. The ordinal is read
           off the box's own label in the DOM rather than rebuilt from an array, so the picture
           and the panel can never disagree about whether a bay is the 2nd or the 3rd. */
        /* The grid lines are rail CENTRELINES, so the slab is one connector wider than the
           opening the customer can measure - the first build printed 1330mm beside a box
           saying 1305. Take the connector off: the number on the drawing is the clear
           opening, the same thing the box holds. */
        var _osz=((_hk==='w')?Math.abs(sx1-sx0):((_hk==='d')?Math.abs(sz1-sz0):Math.abs(sy1-sy0)))-QD_A;
        var _oin=document.querySelector('.qd-openf[data-ax="'+_hk+'"][data-i="'+_hi+'"]');
        var _ord='';
        if(_oin){ var _cell=_oin.parentNode&&_oin.parentNode.parentNode;
                  var _osp=_cell&&_cell.querySelector('span span');
                  if(_osp) _ord=(_osp.textContent||'').trim(); }
        if(!_ord) _ord=({w:'Width',d:'Depth',h:'Height'}[_hk]||'')+' '+(_hi+1);
        /* In floor mode the box holds a height ABOVE THE FLOOR, not the size of the band that
           is lit. Say 'gap' there so the two numbers are never read as the same thing. */
        var _gapw=(_hk==='h' && qdHFloor && _ys.length>2) ? ' gap' : '';
        QD_OPEN_AT=[(sx0+sx1)/2,(sy0+sy1)/2,(sz0+sz1)/2];
        QD_OPEN_TXT=_ord+'  '+Math.round(_osz)+'mm'+_gapw;
        QD_OPEN_COL=AX_COL[_hk]||'#0e1a4d';
        /* Build the run this opening belongs to. The points are grid CENTRELINES on the
           outermost edge of the frame for that axis, so the chain hangs off an edge rather
           than cutting through the model. Sizes are centreline gaps less one connector -
           the clear opening, the same number the box holds (the 1330-vs-1305 lesson). */
        /* r110, Patryk: "im not sure if the dim are for opening or from outside to centre,
           centre to centre and so on". He was right to ask - r109 PRINTED the opening but DREW
           the arrow centre to centre, one connector longer at each end than the number beside
           it. A drawn length and a printed length that disagree is the same class of fault as
           a display and a charge that disagree. The chain is now built from the FACES a tape
           measure can touch, so the line spans exactly what the number says:
              bay    = centreline + half a connector  ->  centreline - half a connector
              overall= first centreline - half        ->  last centreline + half   ( = W/D/H )
           Sanity on his own frame: 1305+1305+1305+1308 + 5*25.4 = 5350. */
        try{
          var _cv = (_hk==='w') ? _xs : ((_hk==='d') ? _zs : _ys);
          if(_cv && _cv.length>1){
            var _H2=QD_A/2, _bays=[], _k;
            var _at=function(v){ return (_hk==='w') ? [v, _ys[0], _zs[0]]
                                      : (_hk==='d') ? [_xs[0], _ys[0], v]
                                                    : [_xs[0], v, _zs[0]]; };
            /* one raw entry per BOX, then merged below wherever the frame has no divider */
            var _raw=[];
            for(_k=0;_k+1<_cv.length;_k++){
              var _lo=Math.min(_cv[_k],_cv[_k+1]), _hi2=Math.max(_cv[_k],_cv[_k+1]);
              var _bi=document.querySelector('.qd-openf[data-ax="'+_hk+'"][data-i="'+_k+'"]');
              var _bo='';
              if(_bi){ var _bc=_bi.parentNode&&_bi.parentNode.parentNode;
                       var _bs=_bc&&_bc.querySelector('span span');
                       if(_bs) _bo=(_bs.textContent||'').trim(); }
              _raw.push({ lo:_lo, hi:_hi2, ord:_bo });
            }
            var _dv=qdDividers(_hk);
            /* Walk the boxes and swallow the next one whenever the line between them is 'none'.
               The merged length comes out of the FACES, so the connector the vanished divider
               would have eaten is included automatically - which is the settled rule
               (two 1183 bays with no joint between them are 1183 + 25.4 + 1183). */
            var _ticks=[], _gi=0;
            while(_gi < _raw.length){
              var _gj=_gi;
              while(_gj+1 < _raw.length && _dv[_gj]==='none') _gj++;
              var _ords=[], _hasFocus=false;
              for(_k=_gi;_k<=_gj;_k++){ if(_raw[_k].ord) _ords.push(_raw[_k].ord); if(_k===_hi) _hasFocus=true; }
              var _ordTxt = (_ords.length<=1) ? (_ords[0]||'')
                          : (_ords[0]+'\u2013'+_ords[_ords.length-1]);
              /* a group is a REAL opening only when both the lines that bound it are dividers
                 that exist everywhere - or are the outside of the frame. Anywhere else the
                 number is the spacing the box sets, and saying "opening" would be a claim we
                 cannot stand behind. */
              var _lA = (_gi===0)            ? 'all' : _dv[_gi-1];
              var _lB = (_gj===_raw.length-1)? 'all' : _dv[_gj];
              _bays.push({ a:_at(_raw[_gi].lo+_H2), b:_at(_raw[_gj].hi-_H2),
                           mm:Math.round(_raw[_gj].hi-_raw[_gi].lo-QD_A),
                           ord:_ordTxt, focus:_hasFocus,
                           real:(_lA==='all' && _lB==='all'),
                           merged:(_gj>_gi) });
              if(_gj < _raw.length-1) _ticks.push({ p:_at(_raw[_gj].hi-_H2), kind:_dv[_gj] });
              _gi = _gj+1;
            }
            var _v0=Math.min(_cv[0],_cv[_cv.length-1]), _v1=Math.max(_cv[0],_cv[_cv.length-1]);
            QD_CHAIN={ ax:_hk, i:_hi, bays:_bays, ticks:_ticks,
                       outer:{ a:_at(_v0-_H2), b:_at(_v1+_H2),
                               mm:(_hk==='w'?state.W:(_hk==='d'?state.D:state.H))||0 },
                       col:AX_COL[_hk]||'#0e1a4d', gap:!!_gapw };
          }
        }catch(_e){ QD_CHAIN=null; }
      }
    }
    /* the amber key only appears when there is actually something amber on screen */
    var _sk=$('qd-span-key'); if(_sk) _sk.style.display = (qdOverSeen && !qdBuildView) ? 'inline-flex' : 'none';   /* r240: never in the build view */
    /* r108 ITEM 6: same test as the key - the length is printed only when the amber it belongs
       to is actually being drawn. A clean frame stays clean. */
    QD_SPAN_MM=qdSF.mm||0;
    QD_SPAN_SHOW=!!(qdOverSeen && spanHL);
    QD_SPAN_AT=_wbb ? [(_wbb[0]+_wbb[3])/2,(_wbb[1]+_wbb[4])/2,(_wbb[2]+_wbb[5])/2] : null;
    /* An axis-aligned run's bounding box has the run's two ends at opposite corners. */
    QD_SPAN_A = _wbb ? [_wbb[0],_wbb[1],_wbb[2]] : null;
    QD_SPAN_B = _wbb ? [_wbb[3],_wbb[4],_wbb[5]] : null;
    var cmat=new T.MeshLambertMaterial({color:0x1a1a1a});
    var cs=t*1.01;   // the joint is the same 25.4mm as the tube; the 1% is only to stop the
                     // coplanar faces z-fighting with the rail they sit on (0.25mm, invisible)
    var _jg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);   /* r225: grid indices for the joint pills */
    var _jix=function(arr,v){ var b=-1,bd=0.6; for(var i=0;i<(arr||[]).length;i++){ var d=Math.abs(arr[i]-v); if(d<bd){ bd=d; b=i; } } return b; };
    var _jfp=frameParts(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares,railLvArr(),qdNoPosts,qdNoRails);
    qdNodeDirs=_jfp.dirs; try{ window.__qdNodeDirs=_jfp.dirs; }catch(_ew){}
    _jfp.nodes.forEach(function(p){
      var m=new T.Mesh(new T.BoxGeometry(cs,cs,cs),cmat);
      m.position.set(p[0]*S,p[1]*S,p[2]*S);
      m.userData.piece={kind:'joint',xi:_jix(_jg.xs,p[0]),yi:_jix(_jg.ys,p[1]),zi:_jix(_jg.zs,p[2]),cx:p[0],cy:p[1],cz:p[2]};   /* r225 */
      group.add(m);
    });
    // Panels — one 6mm sheet per bay (compartment): horizontal on panelled levels, or vertical back/front.
    /* r65: BYO normally draws no panels (we supply only the lipped rails; the teal lips show
       where the customer's panel goes) - but with the Remove-panels tick on, the panels ARE
       the thing being pointed at, so they have to be on screen to tap. Same once any panel
       has been removed: the ghost has to stay visible to be tapped back. */
    /* r101 (Q2): BYO used to draw NOTHING and leave the ledges to imply where a panel went.
       Both dropdowns default to their first option - panels none, supply BYO - so turning panels
       on gave you green rails and no shelves, which reads as "the panels disappeared". It caught
       Patryk twice in one evening. The panel is drawn either way now; on BYO it is a faint ghost
       so it can never be mistaken for something we are charging for. */
    if(panelMode!=='none'){
      var _byoGhost = (panelSupply==='byo' && !qdDelPanel && !qdNoPanels.length);
      /* r173: a customer-supplied 17mm panel is timber or ply - draw it as
         timber rather than as grey nothing, so they can picture what they are
         actually going to build. Deliberately still SEE-THROUGH: r101 made the
         BYO panel a ghost so it could never be mistaken for something we are
         charging for, and that reasoning is untouched - this is a timber
         COLOURED ghost, not a solid timber panel. 17mm is only ever offered
         under "I'll supply my own panels", and the thickness has been
         display-only since r150, so nothing here can reach a part or a price. */
      var pmat=qdPanelMat(true);   /* r187: the same three outcomes as r173, now shared */
      var pth=qdPanelTh*S, GAPMM=26;   /* r150: draw the thickness the customer named */
      /* r49: the enclosure modes were drawn as if they were plain shelves. "Fully enclosed - all
         six faces" on a 5350x3650x2400 shelf bills 80 panels - 16 floor, 16 shelf, 16 top, 8 back,
         8 front, 8 left, 8 right, $3,122.33 - and the picture showed NONE of the vertical ones.
         The customer was being shown a different frame from the one being charged for.
         Counts below are derived from the same grid the rails use, and come out equal to the
         engine's own face list on every mode. */
      var _pg2=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var cellsOf=function(a){ var o=[]; for(var q=0;q<a.length-1;q++) o.push({c:(a[q]+a[q+1])/2, len:a[q+1]-a[q]}); return o; };
      var xc=cellsOf(_pg2.xs), zc=cellsOf(_pg2.zs), yc=cellsOf(_pg2.ys);
      var sizeOf=function(mm){ return Math.max(1,(mm-GAPMM))*S; };
      /* r65: three looks. Normal panel; ORANGE = picked for deletion (same orange as posts
         and rails); GHOST = deleted - still faintly there so it can be tapped back, exactly
         like a deleted upright's outline. A panel whose CROSS BARS are gone is not drawn at
         all: the engine does not supply it (1.12.0), so showing it would be showing a part
         that is not in the price. */
      var pselMat=new T.MeshLambertMaterial({color:0xf97316, transparent:true, opacity:0.85});
      var pghostMat=new T.MeshLambertMaterial({color:0x94a3b8, transparent:true, opacity:0.13});
      /* r210: the panel dim is GONE. It was 0xe3e9f0 at opacity 0.16 - a ghost, which read as
         "those panels were deleted", not "those are not the one". And it could never have
         worked anyway: a glass panel is itself transparent at about 0.42, so a 0.45 "step
         back" is invisible on exactly the material most customers pick. Measured, not
         assumed - pairtrap210.mjs caught the collision. Highlight the answer instead. */
      var addPanel=function(sx,sy,sz,px,py,pz,id,fk,mm){
        var mat=pmat;
        if(id){
          if(npnHas(id[0],id[1],id[2])) mat=pghostMat;
          else if(selPanelHas(id[0],id[1],id[2])) mat=pselMat;
        }
        var m=new T.Mesh(new T.BoxGeometry(sx,sy,sz), mat); m.position.set(px,py,pz);
        /* r225: the engine's panel size is cell - 25.4 - 2 on each axis; the drawn slab is cell - 26,
           so the mm size is dim/S - 1.4 unless the call site says otherwise (the H rule differs). */
        var _dims=[sx,sy,sz].filter(function(v){ return v!==pth; }); if(_dims.length<2){ _dims=[sx,sy,sz].sort(function(a,b){return b-a;}).slice(0,2); }
        m.userData.piece={kind:'panel', w:(mm?mm[0]:Math.round(_dims[0]/S-1.4)), h:(mm?mm[1]:Math.round(_dims[1]/S-1.4)), cx:px/S, cy:py/S, cz:pz/S};
        if(id) m.userData.panel=id;
        if(fk) m.userData.pface=fk;   /* r199: so a vertical face can be tapped like a shelf */
        group.add(m);
      };
      /* Mirrors the engine's _held / _shelfHeld: the two width rails of the cell - or, on a
         single-bay frame deeper than it is wide, the two depth rails (the lips flip). Only
         asked when something HAS been deleted, same condition as the engine. */
      var _panelDropped3D=function(li,bk,dj){
        if(!qdNoRails.length && !qdNoPosts.length) return false;
        var flip=(state.cols||1)===1 && (state.rows||1)===1 && state.D>state.W;
        if(flip) return nrHas(['d',li,0,0]) || nrHas(['d',li,1,0]);
        return nrHas(['w',li,dj,bk]) || nrHas(['w',li,dj+1,bk]);
      };
      var encl=(panelMode==='sides'||panelMode==='enclosed'||panelMode==='enclosedfront');
      if(sideMode3D){
        var hd=state.D/2*S, vh=(state.H-GAPMM)*S;
        var zs2=(panelMode==='backfront')?[hd,-hd]:[-hd];
        zs2.forEach(function(z){ xc.forEach(function(bx){ addPanel(sizeOf(bx.len),vh,pth, bx.c*S,0,z+(z>0?-1:1)*pth/2, null, null, [Math.round(bx.len-27.4), Math.round(state.H-52.8)]); }); });
      } else {
        /* horizontals - one sheet per bay CELL, split across the depth too. It used to split by
           column only, so a frame with depth supports drew 4 sheets where 16 are billed. */
        if(panelMode!=='sides'){
          pLevels.forEach(function(y, pidx){
            var li=pLis[pidx];
            xc.forEach(function(bx, bk){ zc.forEach(function(bz, dj){
              if(_panelDropped3D(li,bk,dj)) return;   // its cross bars are gone - not in the price, not in the picture
              addPanel(sizeOf(bx.len), pth, sizeOf(bz.len), bx.c*S, y*S + t/2 - pth/2, bz.c*S, [li,bk,dj]);
            }); });
          });
        }
        if(panelMode==='custom' && (qdFaces.left||qdFaces.right||qdFaces.front||qdFaces.back)){
          yc.forEach(function(by){
            if(qdFaces.left||qdFaces.right){ zc.forEach(function(bz){
              if(qdFaces.left)  addPanel(pth, sizeOf(by.len), sizeOf(bz.len), -state.W/2*S+pth/2, by.c*S, bz.c*S, null, 'left');
              if(qdFaces.right) addPanel(pth, sizeOf(by.len), sizeOf(bz.len),  state.W/2*S-pth/2, by.c*S, bz.c*S, null, 'right');
            }); }
            if(qdFaces.front||qdFaces.back){ xc.forEach(function(bx){
              if(qdFaces.back)  addPanel(sizeOf(bx.len), sizeOf(by.len), pth, bx.c*S, by.c*S, -state.D/2*S+pth/2, null, 'back');
              if(qdFaces.front) addPanel(sizeOf(bx.len), sizeOf(by.len), pth, bx.c*S, by.c*S,  state.D/2*S-pth/2, null, 'front');
            }); }
          });
        }
        if(encl){
          yc.forEach(function(by){ zc.forEach(function(bz){
            addPanel(pth, sizeOf(by.len), sizeOf(bz.len), -state.W/2*S+pth/2, by.c*S, bz.c*S, null, 'left');
            addPanel(pth, sizeOf(by.len), sizeOf(bz.len),  state.W/2*S-pth/2, by.c*S, bz.c*S, null, 'right');
          }); });
          if(panelMode!=='sides'){
            var faces=(panelMode==='enclosedfront')?[-1,1]:[-1];
            yc.forEach(function(by){ xc.forEach(function(bx){
              faces.forEach(function(sz){
                addPanel(sizeOf(bx.len), sizeOf(by.len), pth, bx.c*S, by.c*S, sz*(state.D/2*S-pth/2), null, sz<0?'back':'front');
              });
            }); });
          }
        }
      }
    }
    /* r170 - TAP A FACE (Patryk, 30 Aug, mock 1). With Edit Panels on and a
       BOX frame showing, six pick planes cover the faces. A tap toggles that
       face through the SAME qdFaces state the tick-boxes drive - the engine
       assigns the lipped rails (the fixed 12-edge rule), nothing new is
       priced here. Un-panelled faces get a faint tint as the "tappable"
       affordance; a panelled face gets an invisible plane so tapping its
       panel takes it off. Enclosure modes draw no planes - their Edit Panels
       help still points at the Panels option. */
    if(state.type==='box' && qdDelPanel && (panelMode==='none'||panelMode==='custom')){
      var _fpW=state.W*S, _fpD=state.D*S, _fpH=state.H*S, _fpT=2*S;
      var _fpMk=function(fk,sx,sy,sz,px,py,pz){
        var _on=!!qdFaces[fk];
        var m6=new T.Mesh(new T.BoxGeometry(sx,sy,sz),
          new T.MeshLambertMaterial({color:0x5f8fd0, transparent:true, opacity:(_on?0.0:0.07), depthWrite:false}));
        m6.position.set(px,py,pz); m6.userData.face=fk; group.add(m6);
      };
      /* every axis is CENTRED (qdAxis starts at -span/2) - the planes sit on
         the outer extents, never at 0..H (that put "bottom" mid-frame). */
      _fpMk('top',    _fpW,_fpT,_fpD, 0, _fpH/2,0);
      _fpMk('bottom', _fpW,_fpT,_fpD, 0,-_fpH/2,0);
      _fpMk('front',  _fpW,_fpH,_fpT, 0,0, _fpD/2);
      _fpMk('back',   _fpW,_fpH,_fpT, 0,0,-_fpD/2);
      _fpMk('left',   _fpT,_fpH,_fpD, -_fpW/2,0,0);
      _fpMk('right',  _fpT,_fpH,_fpD,  _fpW/2,0,0);
    }
    /* r154: back walls - one solid 6mm panel per ticked opening on the back
       plane, drawn whether or not shelf panels are on. Same grid the rails use. */
    if(state.type==='shelf' && qdBackSel.length){
      var _bg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var _bxs=_bg.xs||[], _bys=_bg.ys||[];
      var _bpm=qdPanelMat(false,'walls');   /* r191 */   /* r187: the back wall is the customer's timber too */
      for(var _bwi=0;_bwi<qdBackSel.length;_bwi++){
        var _bc=qdBackSel[_bwi], _bli=_bc[0], _bbk=_bc[1];
        if(_bxs[_bbk]==null||_bxs[_bbk+1]==null||_bys[_bli]==null||_bys[_bli+1]==null) continue;
        var _bw2=(_bxs[_bbk+1]-_bxs[_bbk]-26), _bh2=(_bys[_bli+1]-_bys[_bli]-26);
        var _bm=new T.Mesh(new T.BoxGeometry(Math.max(1,_bw2)*S, Math.max(1,_bh2)*S, 6*S), _bpm);
        _bm.position.set(((_bxs[_bbk]+_bxs[_bbk+1])/2)*S, ((_bys[_bli]+_bys[_bli+1])/2)*S, -state.D/2*S+3*S);
        group.add(_bm);
      }
    }
    /* r176 - THE SPLASHBACK, drawn from the SAME arithmetic alucut 1.28.0
       bills: a 25mm riser off every column line, a lipped bottom rail per bay,
       the uprights, a lipped tie rail per bay, and one panel per bay between
       them. The UPRIGHTS ARE PLAIN - drawing them lipped is exactly what made
       1.27.0 look right when it was not. Which face the panel finishes flush
       with is the same rail turned round, so it moves the panel in z and
       nothing else. */
    if(qdUpstand>0){
      var _ug=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var _uxs=_ug.xs||[], _uys=_ug.ys||[];
      var _utop=_uys.length?_uys[_uys.length-1]:0;
      /* r181: THE OFFSET. -state.D/2 is the frame's OUTER SKIN. Putting a 25.4 tube's
         CENTRE there stands the whole back board half a tube (12.8mm) proud behind the
         frame - which is exactly the step Patryk kept seeing and I twice looked for in Y.
         The rear uprights stand on the grid's own first depth line, so read it; do not
         recompute it from D, because qdAxis owns that arithmetic and 12.7 is not 12.8. */
      var _uzb=(_ug.zs&&_ug.zs.length)?_ug.zs[0]:-state.D/2;
      var _upost=qdUpstand-qdUpRiser()-50.8;
      var _uy0=_utop+25.4/2+qdUpRiser()/2;                 // riser centre
      var _uyA=_utop+25.4/2+qdUpRiser()+25.4/2;            // bottom rail centre
      var _uyB=_uyA+25.4/2+_upost+25.4/2;   /* r180: stacked off the parts, not guessed from the customer's number. The old line was _utop+qdUpstand-25.4/2, 12.7mm low, which squeezed the post into both connectors. */                     // tie rail centre
      var _upm=qdPanelMat(false,'board');   /* r191 */   /* r187: the one he reported - grey while the shelves were timber */
      var _ufOut=(qdUpFlush!=='in');
      /* flush OUT puts the panel's outer face level with the frame's back;
         flush IN puts it on the room side of the rails. */
      var _upz=_ufOut ? (_uzb-25.4/2+3) : (_uzb+25.4/2-3);
      /* r208 - THE BOARD AS IT WAS PRICED. Until now this drew ONE band whatever the
         customer chose, so a split board looked like a single panel and an open cell was
         drawn as if it were there. The shape comes from the engine's OWN echo, splashOut,
         and is never re-derived here: if the echo does not describe what is on screen
         right now - same row count, same board height, one height per row - it is not
         used at all and the single band is drawn, because a shape nobody quoted is worse
         than a plain one. The rail lines are stacked off the PIECES the engine billed,
         so the picture cannot drift from the cut list. */
      var _sfEcho=(function(){
        var o=null; try{ o=window.QD_SP_OUT; }catch(_e1){ return null; }
        if(!o||!o.rowH||!o.rowH.length) return null;
        if((+o.rows)!==qdSpRows) return null;
        if(o.rowH.length!==qdSpRows) return null;
        if(Math.abs((+o.height||0)-qdUpstand)>0.5) return null;
        return o;
      })();
      var _sfSegs=_sfEcho ? _sfEcho.rowH.map(function(_h){ return _h+2; }) : [_upost];
      var _sfOff =(_sfEcho ? (_sfEcho.noPanels||[]) : qdSpOff)||[];
      var _sfN=_sfSegs.length;
      var _sfCs=[_uyA];
      for(var _sfQi=0;_sfQi<_sfN;_sfQi++) _sfCs.push(_sfCs[_sfQi]+_sfSegs[_sfQi]+25.4);
      var _sfHas=function(_r,_b){ for(var _i2=0;_i2<_sfOff.length;_i2++)
        if(_sfOff[_i2] && +_sfOff[_i2][0]===_r && +_sfOff[_i2][1]===_b) return true; return false; };
      for(var _ui=0;_ui<_uxs.length;_ui++){
        var _ux=_uxs[_ui];
        var _ur=new T.Mesh(new T.BoxGeometry(t, qdUpRiser()*S, t), frameMat);
        _ur.position.set(_ux*S, _uy0*S, _uzb*S); _ur.userData.piece={ax:'y',len:qdUpRiser(),sp:'riser',cx:_ux,cy:_uy0,cz:_uzb}; group.add(_ur);   /* r225 */
        for(var _sfQj=0;_sfQj<_sfN;_sfQj++){
          var _up=new T.Mesh(new T.BoxGeometry(t, _sfSegs[_sfQj]*S, t), frameMat);
          _up.position.set(_ux*S, ((_sfCs[_sfQj]+_sfCs[_sfQj+1])/2)*S, _uzb*S); _up.userData.piece={ax:'y',len:_sfSegs[_sfQj],sp:'post',cx:_ux,cy:(_sfCs[_sfQj]+_sfCs[_sfQj+1])/2,cz:_uzb}; group.add(_up);   /* r225 */
        }
        for(var _sfQk=0;_sfQk<_sfCs.length;_sfQk++){
          var _uc=new T.Mesh(new T.BoxGeometry(t*1.01,t*1.01,t*1.01), cmat);
          _uc.position.set(_ux*S, _sfCs[_sfQk]*S, _uzb*S); _uc.userData.piece={kind:'joint',xi:_ui,yi:_uys.length+_sfQk,zi:0,cx:_ux,cy:_sfCs[_sfQk],cz:_uzb}; group.add(_uc);   /* r225: yi >= N = board line */
        }
      }
      for(var _ub=0;_ub+1<_uxs.length;_ub++){
        var _uw=_uxs[_ub+1]-_uxs[_ub]-25.4, _ucx=(_uxs[_ub]+_uxs[_ub+1])/2;
        for(var _sfQr=0;_sfQr<_sfCs.length;_sfQr++){
          var _url=new T.Mesh(new T.BoxGeometry(Math.max(1,_uw)*S, t, t), lipMat);
          _url.position.set(_ucx*S, _sfCs[_sfQr]*S, _uzb*S); _url.userData.piece={ax:'x',len:Math.round(_uw),sp:'rail',cx:_ucx,cy:_sfCs[_sfQr],cz:_uzb}; group.add(_url);   /* r225 */
        }
        for(var _sfQb=0;_sfQb<_sfN;_sfQb++){
          /* an OPEN cell: nothing was billed for it, so nothing is drawn in it */
          if(_sfHas(_sfQb,_ub)) continue;
          var _upn=new T.Mesh(new T.BoxGeometry(Math.max(1,_uw-2)*S, Math.max(1,_sfSegs[_sfQb]-2)*S, 6*S), _upm);
          _upn.position.set(_ucx*S, ((_sfCs[_sfQb]+_sfCs[_sfQb+1])/2)*S, _upz*S); _upn.userData.piece={kind:'panel',w:Math.round(_uw-2),h:Math.round(_sfSegs[_sfQb]-2),cx:_ucx,cy:(_sfCs[_sfQb]+_sfCs[_sfQb+1])/2,cz:_upz}; group.add(_upn);   /* r225 */
        }
      }
    }
    /* r56: this used to run on EVERY rebuild, so every tap threw away the customer's zoom and
       snapped the camera back - which Patryk noticed as the only feedback that a tap had
       registered. Only refit when the frame's SIZE actually changed. Selecting or deleting a
       piece does not change the size, so the view stays exactly where it was put. */
    /* r78: feet on standing legs. r84 (alucut 1.17.0 world): only on OPEN-ENDED legs - a leg
       whose floor node still has rails ends in a connector and can take nothing, and the engine
       bills it nothing, so the picture must not put a foot there either. The cap is drawn as
       Patryk described the part: an insert whose plug hides in the tube, only a ~3mm lip
       showing at the very end - not the floating block he reported. */
    if(qdFeet!=='none'){
      var _fg2=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var _fp2=frameParts(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares,railLvArr(),qdNoPosts,qdNoRails);
      var footMat=new T.MeshLambertMaterial({color:0x111827});
      var footHLMat=new T.MeshLambertMaterial({color:0xeab308});   // r96: gold - never sky, orange or pink
      var wheelMat=new T.MeshLambertMaterial({color:0x475569});
      for(var _ffx=0;_ffx<_fg2.xs.length;_ffx++) for(var _ffz=0;_ffz<_fg2.zs.length;_ffz++){
        if(npHas(_ffx,_ffz)||legDel(_ffx,_ffz,0)) continue;
        if(_fp2.railDeg[_fg2.xs[_ffx]+','+_fg2.ys[0]+','+_fg2.zs[_ffz]]) continue;   // ends in a connector - no foot fits, none is billed, none is drawn
        /* r219: _qy is where the TUBE ENDS - the floor plane (ys[0] is the vanished floor
           connector's CENTRE, half a connector above it) plus whatever the engine trims off
           this leg for the foot. The foot is drawn from that end downwards, so on 'keep my
           height' the wheel stack fills the trim back to the floor plane, and on 'wheels
           underneath' it hangs below the plane: the two options finally LOOK different. */
        var _qx=_fg2.xs[_ffx]*S, _qz=_fg2.zs[_ffz]*S, _qy=(_fg2.ys[0]-QD_A/2+qdFloorTrim())*S;
        if(qdFeet==='caps'){
          /* r96 (Patryk, 27 Aug): "the feet are the same dimentions as the tube so it doesnt
             become fatter". This was drawn 31mm square against a 25.4mm tube - it showed a
             product with a flange it does not have. The FOOTPRINT is now the tube's own
             section, always, so the leg never looks like it thickens at the floor.
             Only the HEIGHT is still stylised, and only while the Highlight the feet tick is
             on: at frame zoom a true 3.18mm lip is under a pixel and reads as "caps did
             nothing" (that was the r84 complaint). Untick it and you are looking at the real
             part, 3.18mm as he measured it. */
          /* r102 (Patryk, 27 Aug): 9mm was chosen on a small frame. On his 5350 x 3650 the three
             caps came to TWO PIXELS on the whole canvas - billed, included, drawn, invisible.
             The highlight now scales with the frame so it is always worth looking at, while the
             REAL part stays 3.18mm the moment the tick is off. Roughly the largest dimension
             over 70: 5350 -> 76mm, 900 -> 13mm, and never below 9. */
          /* r102, measured not guessed. On his 5350 frame the caps were TWO gold pixels. Making
             them taller barely helped (9 px at 76mm, 6 px at the first camera-sized try) because
             the cap is drawn at the tube's own 25.4mm section - and at that zoom a 25.4mm tube is
             about ONE PIXEL WIDE. Nothing tube-width can be seen on a frame this size.
             So while the tick is ON it is a MARKER, sized in screen pixels in both directions,
             and it is allowed to be wider than the tube because that is the whole job of a
             marker. The moment the tick is OFF it goes back to the real part - 25.4mm section,
             3.18mm lip, exactly as Patryk measured it - so r96's rule still holds where it
             matters: what you look at to judge the PRODUCT is never fattened. */
          /* r117: the strength note answers the question a customer is actually asking - will it sag,
   and what do I do - in metres and one sentence, instead of four numbers. */
/* r116: the settings summary describes the FRAME, not the dropdowns - and the span number says
   what it actually measures: no upright DIRECTLY UNDER the run. */
/* r115: THE widest run gets a bar drawn along it in the label layer, in its label's own
   colour, so the number and the run it measures are one object, not a dot in a field of amber. */
/* r114: the long notes are cut to what a customer can act on. The 3mm cap explanation is gone
   entirely - and with it a contradiction that showed for a second on every page load. */
/* r113: the five notes that only explain a control fold behind a '?'. The eight that warn -
   what is in the box, what the frame does under load - are untouched and always visible. */
/* r112: where a support has been removed the chain no longer draws a division that is not
   there - the bays merge into the one space the engine already puts on the order. */
/* r111: pan and camera lift are in the label cache key at last; a bay you can see is drawn
   even when its neighbours are off the stage; and the box you are typing in is marked. */
/* r110: the chain measures FACE TO FACE and says so; it stays up until you pick another
   opening or press Escape; and it offers the view rather than taking it. */
/* r109: the selected axis is dimensioned as a CHAIN outside the frame - a tick at each
   opening, arrows between, numbers above, overall underneath. Fusion 360, not a dot. */
/* r108: selected opening and widest span carry their own number on the drawing. */
/* r107: THE REAL PART, ALWAYS. 25.4mm section, 3.18mm proud, black - as measured.
             No highlight, no marker, no scaling with the frame. r96 (gold cap), r102 (cube) and
             r106 (sleeve + floor square) all drew something that is not a part, on a picture whose
             job is to show the customer what they are buying; each one made it easier to see and
             easier to misread. It is small on a 5m frame because it IS small. Where it is included
             is said in words beside the drawing, on the cart line and on the production sheet. */
          var _cap=new T.Mesh(new T.BoxGeometry(t,3.18*S,t), footMat);
          _cap.position.set(_qx,_qy-(3.18/2)*S,_qz); group.add(_cap);   /* r219: the lip stands PROUD of the end, below it */
        } else {
          /* socket wraps the tube end; wheel hangs below the floor plane */
          /* r219: the stack is the measured rise tall, tube end to floor: a collar half in the
             tube and half proud, then the wheel under it. Rise from the engine when known. */
          var _rz=qdRiseMm(), _collar=Math.min(24,_rz/2), _wr=Math.max(6,(_rz-_collar/2)/2);
          var _sock=new T.Mesh(new T.BoxGeometry(29*S,_collar*S,29*S),footMat); _sock.position.set(_qx,_qy,_qz); group.add(_sock);
          var _wheel=new T.Mesh(new T.SphereGeometry(_wr*S,12,10),wheelMat); _wheel.position.set(_qx,_qy-(_collar/2+_wr)*S,_qz); group.add(_wheel);
        }
      }
    }
    /* r79: the pending new support - an amber ghost, full height, on the tapped line.
       r91: on EITHER axis - 'w' splits the width (X = mm from the left, zi = depth line),
       'd' splits the depth (X = mm from the front, zi = width line). */
    if(qdAddPending && qdDelMode){
      var _ag=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var _agm=new T.MeshLambertMaterial({color:0xf59e0b,transparent:true,opacity:0.55});
      var _agh=(_ag.ys[_ag.ys.length-1]-_ag.ys[0])*S;
      var _agmesh=new T.Mesh(new T.BoxGeometry(27*S,_agh,27*S),_agm);
      if(qdAddPending.axis==='d'){
        _agmesh.position.set(_ag.xs[qdAddPending.zi]*S,(_ag.ys[0]+_ag.ys[_ag.ys.length-1])/2*S,(qdAddPending.X-state.D/2)*S);
      } else {
        _agmesh.position.set((qdAddPending.X-state.W/2)*S,(_ag.ys[0]+_ag.ys[_ag.ys.length-1])/2*S,_ag.zs[qdAddPending.zi]*S);
      }
      group.add(_agmesh);
    }
    /* r92: the pending new cross bar - an amber ghost lying at the asked height */
    if(qdBarPending && qdDelRail){
      var _bg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var _bgm=new T.MeshLambertMaterial({color:0xf59e0b,transparent:true,opacity:0.55});
      var _by=(qdBarPending.h-state.H/2)*S, _bax=qdBarPending.axis||'w';
      var _blines=_bax==='w'?_bg.zs:_bg.xs, _bpts=_bax==='w'?_bg.xs:_bg.zs;
      var _bl=Math.min(qdBarPending.line,_blines.length-1), _bb=Math.min(qdBarPending.bay,_bpts.length-2);
      var _len=(_bpts[_bb+1]-_bpts[_bb])*S;
      var _bmesh=new T.Mesh(new T.BoxGeometry(_bax==='w'?_len:27*S, 27*S, _bax==='w'?27*S:_len),_bgm);
      var _bmid=(_bpts[_bb]+_bpts[_bb+1])/2*S;
      if(_bax==='w') _bmesh.position.set(_bmid,_by,_blines[_bl]*S);
      else _bmesh.position.set(_blines[_bl]*S,_by,_bmid);
      group.add(_bmesh);
    }
    /* r193: last thing before the camera - every glass panel on the frame is now drawn,
       whichever block drew it, so one pass catches them all. */
    try{ qdGlassEdges(group); }catch(_gee){}
    /* r197: the pairing is keyed by [level, bay, depth] indices. A shape change renumbers
       them, so a selection made before it would light a DIFFERENT rail afterwards and look
       like a wrong answer rather than a stale one. Drop it when the shape moves. */
    var _pairKey=[state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows].join('|');
    if(qdPairSel && QD_PAIR_KEY!==null && _pairKey!==QD_PAIR_KEY){ qdPairSel=null; qdPairNote(); }
    QD_PAIR_KEY=_pairKey;
    var _fitKey=[state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows].join('|');
    if(_fitKey!==QD_FIT){ QD_FIT=_fitKey; qdResetPan(); qdFitCamera(); }
    try{ qdStepApply(); }catch(_es240){}   /* r240: the meshes were just recreated - re-apply the step */
    try{ bvFrontMarker(); }catch(_ebf){}   /* r-bv2-D: AFTER the step filter, so FRONT is never dimmed or hidden */
  }
  function qdKey(t,W,D,H,tiers,cols,finish,panels,supply,rows){ return t+'|'+W+'|'+D+'|'+H+'|'+tiers+'|'+(cols||1)+'|'+(finish||'mill')+'|'+(panels||'none')+'|'+(supply||'us')+'|'+(rows||1)+'|'+panelFix+'|'+(openShares?JSON.stringify(openShares):'even')+'|'+railLevels+'|'+(qdNoPosts.length?JSON.stringify(qdNoPosts):'allposts')+'|'+(qdNoRails.length?JSON.stringify(qdNoRails):'allrails')+'|'+(qdNoPanels.length?JSON.stringify(qdNoPanels):'allpanels')+'|'+(qdFeet||'none'); }
  /* Did the Worker actually apply the openings we asked for? It echoes the resolved sizes;
     if we sent shares and the echo comes back even, it ignored them. */
  function _sharesEcho(res){
    if(!openShares) return true;
    var o = res.input && res.input.openings; if(!o) return false;
    var ax = {w:o.w, d:o.d, h:o.h};
    for (var k in openShares){
      var want = openShares[k], got = ax[k];
      if(!want || want.length < 2) continue;
      if(!got || got.length !== want.length) return false;
      var uneven = got.some(function(v){ return v !== got[0]; });
      var askedUneven = want.some(function(v){ return v !== want[0]; });
      if (askedUneven && !uneven) return false;
    }
    return true;
  }
  /* Reveal the 1.4.0 controls the first time a Worker admits to being 1.4.0 or later. Until
     then they stay hidden, so the page can never offer something the engine cannot price. */
  function engineSeen(res){
    /* r178: if the engine ever reports its own riser, that is the one we draw. */
    try{ var _sr=(res&&(res.spRiser!=null?res.spRiser:(res.splashOut&&res.splashOut.riser)));
         if(typeof _sr==='number'&&_sr>0) window.QD_LAST_RISER=_sr; }catch(e){}
    /* r208: the board's PRICED shape, kept for the drawing. Same idea as QD_LAST_RISER -
       the picture mirrors what the engine billed, it does not re-derive it. Cleared when a
       response carries no board, so a stale shape can never outlive the design it came from. */
    try{
      var _so=(res&&res.splashOut), _new=(_so&&_so.rows)?_so:null;
      var _kOf=function(o){ return o ? JSON.stringify([o.rows,o.rowH,o.noPanels,o.height]) : 'none'; };
      var _wasK=_kOf(window.QD_SP_OUT);
      window.QD_SP_OUT=_new;
      /* r208: THE PICTURE MUST NOT LAG THE PRICE BY ONE REBUILD. rebuild3D() runs the moment
         a control changes - synchronously - while the echo it draws from only arrives with
         the quote. Without this the board kept the shape of the PREVIOUS quote until some
         unrelated change forced another rebuild: rows moved, the price moved, the drawing
         did not. Measured, not guessed: boarddraw208.mjs caught it as 2 panels drawn against
         6 billed. One rebuild per genuine change - the key only moves when the design does,
         so this cannot loop. */
      if(_kOf(_new)!==_wasK && qdUpstand>0){ try{ rebuild3D(); }catch(_e2){} }
    }catch(e){}
    try{
      var e = String((res && res.engine) || '');
      var m = e.match(/alucut-alucube\/(\d+)\.(\d+)/);
      if(!m) return;
      var maj = +m[1], min = +m[2];
      if(maj > 1 || (maj === 1 && min >= 11)) ENGINE111 = true;
      if(maj > 1 || (maj === 1 && min >= 17)){
        if(!QD_E117){ QD_E117 = true; try{ if(qdFeetNoteFn) qdFeetNoteFn(); }catch(e117){} }
      }
      if(maj > 1 || (maj === 1 && min >= 25)){
        if(!window.QD_E125){ window.QD_E125 = true; try{ if(window.qdSyncL4) window.qdSyncL4(); }catch(e125){} }
      }
      if(maj > 1 || (maj === 1 && min >= 26)){
        if(!window.QD_E126){ window.QD_E126 = true; try{ if(window.qdBwEngineReady) window.qdBwEngineReady(); }catch(e126){} }
      }
      if(maj > 1 || (maj === 1 && min >= 28)){
        if(!window.QD_E128){ window.QD_E128 = true; try{ if(window.qdUpEngineReady) window.qdUpEngineReady(); }catch(e128){} }
      }
      if(maj > 1 || (maj === 1 && min >= 32)){
        if(!window.QD_E132){ window.QD_E132 = true; try{ if(window.qdSfSync) window.qdSfSync(); }catch(e132){} }
      }
      /* r207: 1.33 is the engine that builds the board to the height the customer ASKED for.
         1.32.0 divides (H - riser) by the row count and then takes a FULL connector off every
         segment, though the rails are SHARED between rows - so a 450mm board is built 424.2mm
         at 2 rows and 398.6mm at 3, and a 600mm board at 4 rows comes out 525mm. Measured off
         the live worker's own cut list, not derived. Same shape as the AluCube leg bug.
         Until the fix is live the page must not be able to ask for rows at all. */
      if(maj > 1 || (maj === 1 && min >= 33)){
        if(!window.QD_E133){ window.QD_E133 = true; try{ if(window.qdSfSync) window.qdSfSync(); }catch(e133){} }
      }
      if(maj > 1 || (maj === 1 && min >= 13)){
        if(!ENGINE113){ ENGINE113 = true;
          Array.prototype.forEach.call(document.querySelectorAll('.qd-v113'), function(el){ el.hidden=false; });
        }
      }
      if(maj > 1 || (maj === 1 && min >= 8)){
        if(!ENGINE18){ ENGINE18 = true;
          Array.prototype.forEach.call(document.querySelectorAll('.qd-v18'), function(el){ el.hidden=false; });
        }
      }
      if(maj > 1 || (maj === 1 && min >= 7)){
        if(!ENGINE17){ ENGINE17 = true;
          Array.prototype.forEach.call(document.querySelectorAll('.qd-v17'), function(el){ el.hidden=false; });
        }
      }
      if(maj > 1 || (maj === 1 && min >= 5)){
        if(!ENGINE15){ ENGINE15 = true;
          Array.prototype.forEach.call(document.querySelectorAll('.qd-v15'), function(el){ el.hidden=false; });
          syncRail();
        }
      }
      if(!(maj > 1 || (maj === 1 && min >= 4))) return;
      if(ENGINE14) return;
      ENGINE14 = true;
      Array.prototype.forEach.call(document.querySelectorAll('.qd-v14'), function(el){ el.hidden=false; });
      /* the depth-support note was written when the combination was impossible; it isn't now */
      var rn=document.getElementById('qd-rows-note');
      if(rn) rn.innerHTML='Splits the <strong>depth</strong> the way columns split the width \u2014 the only way to brace a deep frame. <strong>With panels:</strong> set "How the panels are held" to the angle ledge. A lipped rail has one lip, so it cannot carry a panel on both sides of a depth support.';
      openFields();
      applyPending();
    }catch(e){}
  }
  /* r41: one mirror instead of touching all seven places that can set a refusal. Anything that
     writes to #qd-msg now also appears at the top of the summary, next to the dash. Using an
     observer rather than editing each site means a refusal added later cannot forget to do it. */
  (function(){
    try{
      var src=document.getElementById('qd-msg'), top=document.getElementById('qd-msg-top');
      if(!src||!top||!window.MutationObserver) return;
      var sync=function(){ var t=(src.textContent||'').trim(); top.innerHTML=src.innerHTML; top.style.display=t?'block':'none'; };   /* r-bv7: innerHTML so the fix-it button is real here, not dead text */
      new MutationObserver(sync).observe(src,{childList:true,characterData:true,subtree:true});
      sync();
    }catch(e){}
  })();
  /* r41: the engine refuses an enclosure, side panels or panels-with-depth-supports on the
     lipped rail, and it is right to - one lip faces one way, so it cannot carry a panel on all
     four edges. That refusal used to arrive only AFTER pricing, as a dash. Say it here instead,
     the moment the combination is chosen. This only WARNS: it never silently changes the
     fixing, because the price on screen must always be the frame the customer actually asked
     for. The engine's own gate is still what stops a bad price. */
  function syncFixNeed(){
    try{
      var w=document.getElementById('qd-fix-warn'); if(!w) return;
      /* r135. THE WHOLE WARNING IS RETIRED. It dated from r63, when the angle
         ledge went off sale and these shapes could not be priced. alucut 1.22.0
         (deep-bay shelves) and 1.23.0 (enclosures) price every shape the page
         now lets you select - the r130/r133 gates keep every other shape off
         the dropdowns - so this box only ever appeared ON TOP OF A LIVE PRICE,
         telling the customer to phone about a problem that no longer exists.
         Patryk caught it on V6.4 within MINUTES of publishing ("why call us?
         what the hell is going on?"). The engine's own refusal path (renderFrame) still says
         the right thing on the rare shapes that genuinely refuse. */
      if(true){ w.hidden=true; w.innerHTML=''; }
      else { w.hidden=true; w.innerHTML=''; }

    }catch(e){}
  }
  /* r41: sticky alone is not enough - a 380px drawing pinned to a laptop screen leaves too
     little room to type in. Shrink it the moment it actually sticks, and re-fit the canvas
     afterwards or three.js letterboxes the frame inside a box that changed size under it. */
  (function(){
    try{
      var st=document.querySelector('.qd-stage'); if(!st) return;
      /* r42: measure a zero-height marker ABOVE the stage, never the stage itself. Measuring
         the sticky box while also changing its height is a feedback loop - it pinned, shrank,
         un-pinned, grew, and juddered. The marker cannot move, so the test is stable. The
         height no longer changes at all, which also stops the canvas being resized mid-scroll
         (that is what blew the model up out of its box). */
      var mark=document.createElement('div');
      mark.setAttribute('aria-hidden','true');
      mark.style.cssText='height:0;margin:0;padding:0;';
      st.parentNode.insertBefore(mark, st);
      var top=parseFloat(getComputedStyle(st).top)||0, was=false;
      var check=function(){
        var stuck = mark.getBoundingClientRect().top < top;
        if(stuck===was) return;
        was=stuck; st.classList.toggle('qd-stuck', stuck);
      };
      window.addEventListener('scroll', check, {passive:true});
      window.addEventListener('resize', check);
      check();
    }catch(e){}
  })();
  /* r41: which advanced settings are actually doing something right now. Quick mode hides the
     controls, never the consequences - if one of these is on, it is named where you can see it. */
  var QD_MODE='quick', _fixAuto=false;
  /* r116, Patryk: "i dont see 4 supports?" - TWO faults in one sentence.
     ONE: it took the dropdown's VALUE and appended the word "supports". The dropdown itself
     says "4 columns (3 EXTRA SUPPORTS)" - four columns is three uprights - so on a frame nobody
     had touched, both counts were already one too many. Fixed by taking the option's own TEXT
     (trimmed at the bracket) rather than its value: it now cannot disagree with the control it
     came from, because it IS that control's words.
     TWO: it read the settings and never looked at the frame. On his design eight uprights are
     deleted outright and the line still claimed them. The PRICE was never wrong - that comes
     from the engine, which knows every deletion - but a sentence that says "included in the
     price" must not name parts that are not there. */
  function qdPostSummary(){
    var gone=0, part=0;
    try{
      if(!qdNoPosts || !qdNoPosts.length) return {gone:0, part:0};
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,
                   Math.max(1,state.cols||1),Math.max(1,state.rows||1),openShares);
      var L=Math.max(1,((g&&g.ys)?g.ys.length:2)-1);   // leg pieces in one full-height upright
      var whole={}, lvl={}, k;
      qdNoPosts.forEach(function(a){
        if(!a || a.length<2) return;
        k=a[0]+'|'+a[1];
        if(a.length<3) whole[k]=true; else (lvl[k]=lvl[k]||{})[a[2]]=true;
      });
      /* every piece of an upright gone IS the upright gone - counting those as "shortened"
         would under-report what was actually removed. */
      Object.keys(lvl).forEach(function(k2){
        if(whole[k2]) return;
        if(Object.keys(lvl[k2]).length>=L) whole[k2]=true; else part++;
      });
      gone=Object.keys(whole).length;
    }catch(e){}
    return {gone:gone, part:part};
  }
  function qdAdvActive(){
    var out=[];
    try{
      var _lab=function(el){
        var o=el.options[el.selectedIndex];
        var t=(o&&o.text)||'';
        var i=t.indexOf(' (');
        return (i>0?t.slice(0,i):t) || el.value;
      };
      var _cs=$('qd-cols'), _rs=$('qd-rows');
      if(_cs && (+_cs.value||1)>1) out.push(_lab(_cs));
      if(_rs && (+_rs.value||1)>1) out.push(_lab(_rs));
      var _ps=qdPostSummary();
      if(_ps.gone) out.push(_ps.gone+' upright'+(_ps.gone===1?'':'s')+' removed');
      if(_ps.part) out.push(_ps.part+' upright'+(_ps.part===1?'':'s')+' shortened');
      if(railLevels && railLevels!=='all') out.push('interior supports: '+railLevels);
      if(openShares) out.push('opening sizes set by hand');
      /* r-quick-supply: the panel-material control is in Quick mode now, so naming it
          here would point at a control already on the same screen. */
    }catch(e){}
    return out;
  }
  function syncMode(){
    try{
      var wrap=document.getElementById('qd'), quick=(QD_MODE==='quick');
      if(wrap) wrap.classList.toggle('qd-quick', quick);
      var q=$('qd-mode-quick'), f=$('qd-mode-full');
      if(q) q.classList.toggle('qd-on', quick);
      if(f) f.classList.toggle('qd-on', !quick);
      var n=$('qd-adv-active');
      if(n){
        var a=quick? qdAdvActive() : [];
        /* r60, Patryk: "you made this as a quick start, why show issues if build them in this
           way?" A preset that CHOOSES depth supports and BYO panels should say so as part of
           what it is, not warn the customer about a setting it just made for them. The warning
           wording comes back the moment they change something themselves. */
        n.innerHTML = a.length
          ? (qdPresetName
              ? ('<strong>'+qdPresetName+'</strong> includes: <strong>'+a.join(' &middot; ')+'</strong>. Open <strong>Full designer</strong> to change them.')
              : ('Also applied, and included in the price: <strong>'+a.join(' &middot; ')+'</strong>. Open <strong>Full designer</strong> to change them.'))
          : '';
        n.style.display = a.length ? 'block' : 'none';
      }
      try{ if(window.qdGuidedSync) window.qdGuidedSync(); }catch(_eg){}
      setTimeout(function(){ try{ resize(); }catch(e){} },80);
    }catch(e){}
  }
  (function(){
    var q=$('qd-mode-quick'), f=$('qd-mode-full');
    if(q) q.addEventListener('click',function(){ QD_MODE='quick'; syncMode(); });
    if(f) f.addEventListener('click',function(){ QD_MODE='full';  syncMode(); });
  })();
  /* r60: which preset (if any) put the current advanced settings there. Cleared the moment the
     customer changes any control themselves, so the note goes back to being a warning. */
  var qdPresetName=null, qdApplyingPreset=false;
  (function(){
    try{
      var box=document.querySelector('.qd-controls');
      if(box) box.addEventListener('change', function(){ if(!qdApplyingPreset) qdPresetName=null; }, true);
    }catch(e){}
  })();
  function qdCatalog(){ var fv=qdFeeVariant(QD_CUT.fee); return { finish:FINISH, lipped:LIPPED, sheet6:SHEET6, plate:QD_PLATE, angle:ANGLE, conn:CONN, cut:QD_CUT, feeVarId:fv.id, feePrice:fv.price, feet:QD_FEET, weights:qdWeights() }; }

  /* r-qd-honest: a real retry - clear the session fail-fast, drop cached refusals,
     ask again. Wired once; the button only shows in session-failure states. */
  (function(){
    var b=document.getElementById('qd-retry');
    if(b) b.addEventListener('click', function(){
      if (window.aaCutSessionReset) { try { window.aaCutSessionReset(); } catch(e) {} }
      for (var k in QD_CACHE) { if (QD_CACHE[k] && QD_CACHE[k].done !== true) delete QD_CACHE[k]; }
      QD_CACHE = {};
      if (typeof recalc === 'function') recalc();
    });
  })();

  /* r101 (Q1b): every cross bar on an INTERIOR depth line at a level that carries a shelf.
     Those are the ones with a panel on each side, and the only ones alucut 1.19.0 refuses over.
     Counted from the live controls, never from a stored number. */
  function qdMidBars(){
    try{
      var rows=Math.max(1,+($('qd-rows')?$('qd-rows').value:1)||1);
      if(rows<2) return null;
      var cols=Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1);
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var N=(g.ys||[]).length;
      var lvls=[]; if(panelMode==='top'){ if(N) lvls=[N-1]; } else { for(var i=0;i<N;i++) lvls.push(i); }
      var total=0, left=0, list=[];
      for(var li=0; li<lvls.length; li++) for(var dj=1; dj<rows; dj++) for(var bk=0; bk<cols; bk++){
        total++;
        var gone=false;
        for(var q=0;q<qdNoRails.length;q++){ var a=qdNoRails[q];
          if(a[0]==='w' && a[1]===lvls[li] && a[2]===dj && a[3]===bk){ gone=true; break; } }
        if(!gone){ left++; list.push(['w',lvls[li],dj,bk]); }
      }
      return { total:total, left:left, list:list };
    }catch(e){ return null; }
  }
  /* delegated, because the button is written into the message box every time it renders */
  document.addEventListener('click', function(ev){
    var b=ev.target && ev.target.closest && ev.target.closest('[data-aa-cf="floor"]');
    if(!b) return;
    ev.preventDefault();
    var fr=qdFloorRailsFn ? qdFloorRailsFn() : []; if(!fr.length) return;
    qdSnap('removing the floor-level cross bars for the castors');
    for(var i=0;i<fr.length;i++) qdNoRails.push(fr[i]);
    syncPostUI(); rebuild3D(); recalc();
    if(qdCastorUIFn) try{ qdCastorUIFn(); }catch(e218c){}
  });
  document.addEventListener('click', function(ev){
    var b=ev.target && ev.target.closest && ev.target.closest('[data-aa-cf="mid"]');
    if(!b) return;
    ev.preventDefault();
    var mb=qdMidBars(); if(!mb || !mb.left) return;
    qdSnap('removing the cross bars through the middle');
    for(var i=0;i<mb.list.length;i++) qdNoRails.push(mb.list[i]);
    syncPostUI(); rebuild3D(); recalc();
  });

  function renderFrame(res){
    if(!res || res.ok !== true){
      /* r-qd-honest: a refusal from the session gate is NOT a sizing problem - do not
         blame the frame or print jargon like "Session required." Friendly words, a
         real retry, and a dash instead of a $0.00 that is the price of nothing. */
      var _e0=(res&&res.errors&&res.errors[0])?String(res.errors[0]):'';
      /* r218c: say OUT LOUD that the design on screen did not price. aaLastQuote keeps the
         last GOOD quote, which is right for the price panel - but the staff production
         sheet reads it too, and on a refused design it was printing the previous frame,
         with no feet, as if it were this one. r215 was this same fault one step earlier. */
      try{ window.aaQuoteRefused = { error:_e0, at:Date.now() }; }catch(_eq3){}
      try{ qdStaffPaint(null); }catch(_e227r){}   /* r227: no quote, no freight, no guide - never the previous frame's */
      QD_FLOORCLEAR=null; try{ qdFloorClearPaint(); }catch(_e219b){}   /* r219: no quote, no clearance number */
      /* r63: the engine's own refusals for these two cases end with 'switch "How the panels are
         held" to Angle ledge'. That control came OFF the page today, so the customer would be
         hunting for something that no longer exists. Rewritten here rather than in the Worker -
         a theme revision needs no deploy, and the Worker is still right about WHY it refused.
         Matched on the ledge wording, so if the Worker text changes this falls back to it. */
      /* r218c, Patryk 2 Sep: "these warnings with no price are annoying? it should have a
         place where it'll take them to the error? or have a way to clear the error there?"
         He is right, and r101 already set the pattern for the mid-depth bars: the error
         carries its own fix. The castor refusal names the problem - every floor-touching
         leg ends in a connector - and the button that clears those bars lives on the
         Finish step, which a customer on the Review step cannot see. So put the button in
         the message. Same click path as the Feet-step button, one shared counter. */
      if(/Castor sockets push into an open tube end/i.test(_e0)){
        var _fr = qdFloorRailsFn ? qdFloorRailsFn() : [];
        var _fb = qdFloorBarsFn ? qdFloorBarsFn() : _fr.length;   /* r-cf6: TUBES shown, BAYS removed */
        if(_fr.length){
          _e0 = '<strong>Castor wheels need every floor-touching leg open at the bottom</strong>, and '
              + 'right now <strong>' + _fb + ' floor-level cross bar' + (_fb===1?'':'s') + '</strong> '
              + 'run' + (_fb===1?'s':'') + ' into ' + (_fb===1?'a leg':'the legs') + '. '
              + 'Take ' + (_fb===1?'it':'them') + ' out and this frame prices straight away. '
              + '<button type="button" data-aa-cf="floor" style="margin-top:8px;border:0;border-radius:8px;background:#0e1a4d;'
              + 'color:#fff;padding:8px 13px;font:inherit;font-size:13px;font-weight:600;cursor:pointer">'
              + 'Take ' + (_fb===1?'it':'them') + ' out for me</button>';
        }
      } else if(/angle ledge/i.test(_e0)){
        /* r101 (Q1b): the old wording said "take the depth supports back to 1", which is not what
           anyone who just added one wants to hear, and it never said WHICH bars were the problem.
           Count them and name them. alucut 1.19.0 prices the frame the moment every mid-depth bar
           at a shelf level is gone, so that number is the whole answer. */
        var _mb=qdMidBars();
        if(_mb && _mb.left>0){
          _e0 = '<strong>' + _mb.left + ' of the ' + _mb.total + ' cross bars through the middle of the depth</strong> '
              + 'still ' + (_mb.left===1?'has a shelf':'have a shelf') + ' on both sides of ' + (_mb.left===1?'it':'them') + '. '
              + 'A lipped rail has its ledge on one face only, so it can hold the shelf on one side or the other, never both. '
              + 'Take ' + (_mb.left===1?'that one':'those ' + _mb.left) + ' out and this frame prices straight away \u2014 '
              + 'the uprights and the outer rails all stay. '
              + '<button type="button" data-aa-cf="mid" style="margin-top:8px;border:0;border-radius:8px;background:#0e1a4d;'
              + 'color:#fff;padding:8px 13px;font:inherit;font-size:13px;font-weight:600;cursor:pointer">'
              + 'Remove ' + (_mb.left===1?'it':'them') + ' for me</button>';
        } else {
          /* r135: no "off sale", no phone. Patryk: "i dont want anyone to call, its
             better if they email." Say what to change; the contact page is the route
             for anything the designer cannot do. */
          _e0 = 'We cannot price that exact combination online. '
              + 'The frame itself is the same either way \u2014 same tube, same cuts, same connectors \u2014 so set '
              + '<strong>Panels</strong> to <strong>No panels \u2014 frame only</strong> and fix your own panels to it, '
              + 'or send us the design from the <a href="/pages/contact">contact page</a> and we will quote it by email.';
        }
      }
      var _sess=/session|origin|not permitted/i.test(_e0);
      /* r-bv-refused (8 Sep 2026): in the build view #qd-msg is hidden (body.qd-build .qd-summary), so a
         refusal left "Loading your frame..." on screen for ever (#261051). Paint the panel instead - the
         engine's RAW words (never the castor/ledge rewrites above: their buttons edit a design, and a
         built frame is not being designed). A session or network failure gets a Try again. */
      if(qdBuildView){ try{ qdBuildRefused(_sess ? 'the secure pricing check did not load on this device (a VPN or content blocker can cause this).' : ((res&&res.errors&&res.errors[0])?String(res.errors[0]):''), _sess); }catch(_ebv){} }
      $('qd-msg').style.color='#b42318';
      $('qd-msg')[/<strong>/.test(_e0)?'innerHTML':'textContent'] = _sess
        ? 'We could not price this online just now \u2014 the secure pricing check did not load on this device. Tap "Try pricing again", or email sales@allaluminium.com.au and we will price it for you. (A VPN or content blocker can cause this.)'
        : ((_e0 || 'Could not work out a price for that size.') + (/too (big|long|wide|tall|large)|oversize|maximum|exceed|no bar long enough/i.test(_e0) || !_e0 ? ' For long units, add vertical supports; oversized frames are pickup or custom freight \u2014 contact us for a quote.' : ''));
      var _rb=$('qd-retry'); if(_rb) _rb.hidden = !_sess;
      $('qd-price').textContent='\u2014';
      $('qd-price-gst').textContent='';
      $('qd-cuts').textContent='';
      $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})();
      $('qd-tube').textContent='';
      var _sw=$('qd-support-wrap'); if(_sw)_sw.style.display='none';
      $('qd-add').disabled=true;
      state.lineItems=null; state.total=null;
      return;
    }
    engineSeen(res);   // a good answer tells us what the engine can do; reveal 1.4.0 controls if so
    /* THE GATE, 23 Aug 2026. Only alucut-alucube/1.3.0 and later understand `rows`. An older
       Worker ignores the key completely and returns ok:true with a confident price for a
       DIFFERENT frame - one with no depth supports in it at all - and nothing else in the
       response gives it away. Never paint that number. Fail closed and say why. */
    /* SAME GATE, 1.4.0 features. A 1.3.0 Worker does not know `panelFix` or `shares`: it
       ignores both keys and returns ok:true with a confident price for a frame with even
       openings and a lipped rail. Never paint that number. The echo is the only proof. */
    /* A 1.4.0 Worker does not know railLevels and would ignore it — a DIFFERENT frame at a
       confident price. The control is hidden below 1.5.0, but the gate is what actually stops it. */
    /* r53: a 1.6.0 Worker does not know `noPosts`. It ignores the key and returns ok:true with a
       confident price for a frame that still has every upright in it - a DIFFERENT frame, more
       expensive, under the same number. Never paint that. The echo is the only proof. */
    if (qdNoRails.length && (!ENGINE18 || !res.input || !res.input.noRails || res.input.noRails.length !== qdNoRails.length)) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price that frame online just now \u2014 the pricing engine has not picked up the removed cross bars yet. Put them back, or email sales@allaluminium.com.au.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    if (qdNoPosts.length && (!ENGINE17 || !res.input || !res.input.noPosts || res.input.noPosts.length !== qdNoPosts.length)) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price that frame online just now \u2014 the pricing engine has not picked up the removed uprights yet. Put them back, or email sales@allaluminium.com.au.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    if (railLevels !== 'all' && !ENGINE15) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price that support layout online just now \u2014 the pricing engine has not picked it up yet. Set "Interior supports" back to every level, or email sales@allaluminium.com.au.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    var _v14Want = (panelFix === 'angle') || !!openShares;
    if (_v14Want && !(res.input && res.input.panelFix === panelFix && _sharesEcho(res))) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price that combination online just now \u2014 the pricing engine has not picked up the new options yet. Set "How the panels are held" back to the lipped rail and even openings, or email sales@allaluminium.com.au and we will price it for you.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    var _rowsWant = Math.max(1, state.rows || 1);
    if (_rowsWant > 1 && !(res.input && Number(res.input.rows) === _rowsWant)) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price depth supports online just now \u2014 the pricing engine has not picked them up yet. Set "Supports along the depth" back to 1, or email sales@allaluminium.com.au and we will price it for you.';
      $('qd-price').textContent='\u2014';
      $('qd-price-gst').textContent='';
      $('qd-cuts').textContent='';
      $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})();
      $('qd-tube').textContent='';
      $('qd-add').disabled=true;
      state.lineItems=null; state.total=null;
      return;
    }
    var _fcWant=(panelMode==='custom' && qdFacesAny());
    if (_fcWant && !(res.input && res.input.panels && res.input.panels!=='none')) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price face-by-face panels online just now \u2014 the pricing engine has not picked them up yet. Choose one of the preset panel options, or send the design through the Enquiry Desk.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    var _l4Want=(panelMode==='custom' && qdLips4Any());
    if (_l4Want && !(res.input && res.input.lips4)) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price four-edge support online just now \u2014 the pricing engine has not picked it up yet. Untick \u201call four edges\u201d, or send the design through the Enquiry Desk.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    var _bwWant=(state.type==='shelf' && qdBackSel.length);
    if (_bwWant && !(res.input && res.input.backSel && res.input.backSel.length===qdBackSel.length)) {
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='We cannot price back walls online just now \u2014 the pricing engine has not picked them up yet. Untick the back walls, or send the design through the Enquiry Desk.';
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    showOpenResult(res);
    $('qd-price').textContent=money(res.priceExGst);
    $('qd-price-gst').textContent=money(res.priceIncGst)+' inc GST';
    $('qd-cuts').textContent=(res.cuts?res.cuts+' cuts':'')+((res.charged==null)?'':(' · first '+(res.included||0)+' free · cutting '+(res.charged>0?money(res.feeExGst):'free')));
    /* r-conncount: the counts were being STRIPPED right here - the old line ran a replace that
       ate the digits in front of every x. A customer saw WHICH joiners they were getting and
       never HOW MANY, then opened a bag of fifty-odd with no count to check it against. Show
       the numbers.
       r64 NOTE: the version of this comment shipped to V4.2 quoted that replace as a regex
       LITERAL. A regex ending in \s followed by a star and a slash closes a block comment, so
       the comment ended in the middle of itself and the rest of the file was parsed as code.
       Hard SyntaxError, whole designer dead. Never put a regex literal in a block comment. */
    $('qd-conns').textContent=(res.connText||'').replace(/\s+x\s+/g,' \u00d7 ').replace(/,\s*/g,'  \u00b7  ')+((res.connText)?'  \u2014 all included':'');
    (function(){ var fw=$('qd-feet-wrap'); if(fw && res.feet!==undefined) fw.style.display=''; })();
    (function(){ var fb=$('qd-feet-block'); if(!fb) return;
      if(res.feetText){ fb.style.display=''; $('qd-feet-line').textContent=String(res.feetText).replace(/\s+x\s+/g,' \u00d7 ')+'  \u2014 included'; }
      /* r218 SAY WHAT THE HEIGHT CHOICE DID. Caught by testing the real page, not by
         reading the code: picking "keep my height" against "wheels underneath" changed
         NOTHING a customer could see. The price is identical either way - the parts are
         the same and the tube comes out of the same billed metres - so the note is the
         ONLY visible difference, and the note was the static sentence written for the
         days when castors were coming soon. A control whose two settings look the same
         is a control nobody can trust.
         alucut 1.35.0 already sends the right sentence for whichever option was used;
         it was simply never read. Rendered here, after the quote lands, so it replaces
         the placeholder feetNote() wrote before the answer came back. */
      if(res.feetHeightNote){
        var _fn=$('qd-feet-note');
        if(_fn){ _fn.textContent=res.feetHeightNote; _fn.style.display='block'; }
      }
      /* r218b: and repaint the castor controls here, on EVERY answer, not just on a Feet
         change. Caught on the page: add a tier and the floor rails come back, but the
         bracing warning stayed up - it was still telling the customer the legs were
         untied on a frame that now had four cross bars holding them. A warning that
         fires when nothing is wrong is the fastest way to teach everyone to ignore it,
         which is the whole reason it must be driven by the CURRENT frame and not by
         whatever was true when Feet was last touched. */
      if(qdCastorUIFn) try{ qdCastorUIFn(); }catch(e218b){}
      else fb.style.display='none';
    })();
    /* r199: remember whether THIS design is on the enclosure branch, from the engine's own
       echo. The face pairing refuses to highlight anything when it is not true. */
    try{ QD_LIP_DEPTH = !!(res.input && res.input.lipOnDepthRails===true); }catch(_ld){ QD_LIP_DEPTH=null; }
    var t=res.tube||{}, tubeTxt=(t.desc||'')+' tube';
    if(t.panelCount){
      var _rails='  ·  lipped '+(t.sideMode?'panel':'shelf')+' rails';
      /* r191: on a MIXED frame t.byo is false and t.plate is true, so the old
         two-branch line printed "6mm 5083 marine plate panels" over a design
         whose back walls are the customer's own timber. Name the groups from
         the engine's OWN echo, never from what the page asked for. */
      if(t.mixed && t.byoBy && t.panelsBy){
        var _nm={panels:(t.sideMode?'side panels':'shelf panels'),walls:'back walls',board:'back board'};
        var _mine=[], _yours=[];
        ['panels','walls','board'].forEach(function(g){
          if(!t.panelsBy[g]) return;
          ((t.byoBy[g]==='byo')?_yours:_mine).push(_nm[g]);
        });
        tubeTxt+=_rails;
        if(_mine.length) tubeTxt+='  ·  6mm 5083 marine plate: '+_mine.join(' + ');
        if(_yours.length) tubeTxt+='  ·  your own: '+_yours.join(' + ');
      }
      else if(t.byo){ tubeTxt+=_rails+' (for your own panels)'; }
      else { tubeTxt+=_rails+'  ·  6mm 5083 marine plate '+(t.sideMode?'side panels':'panels'); }
    }
    $('qd-tube').textContent=tubeTxt;
    try{ if(window.qdMatCounts) window.qdMatCounts(t); }catch(e){}
    /* r154 Q4: the bowing sentence only when this quote includes plate/sheet we
       cut (the ruling: bowing text only when buying plate). Same label, same
       tick, same gate - only the span's visibility moves. */
    (function(){ var _bw3=$('qd-consent-bow'); if(_bw3){ var _t3=res.tube||{}; _bw3.style.display=(_t3.plate || (_t3.sheets||0)>0)?'inline':'none'; } })();
    (function(){ var _bn=$('qd-bw-note'); if(_bn && res.bwNote){ _bn.textContent=res.bwNote+' Two openings side by side can\u2019t both have one.'; } })();
    (function(){ var _un=$('qd-up-note'); if(_un && res.spNote){ _un.textContent=res.spNote; } })();
    var supN=$('qd-supply-note');
    /* r191: this was gated on res.supply, the TOP-LEVEL card. On a mixed frame
       (shelves from us, back walls your own) supply is "us", so the customer was
       told nothing at all about the panels they have to bring. Gate on what the
       engine says is byo. byoPanels already lists only the byo groups. */
    if(supN){ var _bp=res.byoPanels;
      if(_bp && _bp.count){
        var _brk=(_bp.list&&_bp.list.length>1)
          ? _bp.list.map(function(g){ return g.count+' '+g.face+(g.count===1?'':'s'); }).join(' and ')
          : null;
        supN.innerHTML='You\u2019ll supply <strong>'+_bp.count+' panel'+(_bp.count===1?'':'s')+'</strong> for this design'+(_brk?(' — '+_brk):'')+'.';
        supN.style.display='block';
      } else { supN.style.display='none'; } }
    var sup=$('qd-support'), supW=$('qd-support-wrap');
    /* r66: the engine counts leg pieces hanging above a gap (legFloat, 1.11.0) and says so
       on the order; the page now says it BEFORE the order. Shares the support-note box. */
    var _supTxt = res.supportNote || '';
    if(res.lips4Note){ _supTxt = (_supTxt?_supTxt+' ':'') + res.lips4Note; }
    if(res.legFloat){ _supTxt = (_supTxt?_supTxt+' ':'') + res.legFloat + ' upright piece' + (res.legFloat===1?' is':'s are') + ' above a gap \u2014 carried by the cross bars into the next upright, not standing on the floor. Fine for a light shelf; think twice for a bench.'; }
    if(_supTxt){ sup.textContent=_supTxt; supW.style.display='block'; } else { supW.style.display='none'; }
    $('qd-msg').textContent='';
    var _rok=$('qd-retry'); if(_rok) _rok.hidden=true;
    $('qd-add').disabled=false;
    // Structural hints + pigeonhole are computed client-side in qdGeoNotes() (called from recalc), so they
    // still show when the price call errors — e.g. a wide frame whose plate panel needs columns to fit.
    state.lineItems=res.lineItems; state.total=res.priceExGst; state.finish=res.finish;
    /* r148: hand the staff production sheet the quote DIRECTLY. Its fetch-wrapper
       capture loses a timing race with aaFetch, and its r82 nudge can never
       recover: firing events on qd-w without changing the value re-prices from
       QD_CACHE, so no network request ever happens for it to catch. Publishing
       the last good quote here covers fresh AND cached paths, race-free. */
    try{ window.aaLastQuote = res; }catch(_eq){}
    QD_LAST_KEY=QD_WANT_KEY; QD_QSER++;   /* r230: renderFrame only ever paints a quote whose key matches the screen (see recalc) */
    try{ window.aaQuoteRefused = null; }catch(_eq2){}   /* r218c: the design on screen priced */
    try{ qdStaffPaint(res); }catch(_e227){}   /* r227: staff freight line + load guide, from this quote */
    if(qdBuildView){ try{ qdBuildPanel(res); }catch(_e222){} }
    try{ window.aaShareURL = qdShareURL(); }catch(_e222b){}   /* r222: the staff sheet prints this link (+build=1) on the customer's assembly sheet */
    /* r219: the castor numbers, from the engine. castorRiseMm / floorClearMm are 1.35.1;
       an older engine still carries the rise inside its own sentence, and the trimmed floor
       leg it reports plus that rise is the floor clearance on 'keep my height'. */
    try{
      var _rz=null, _rzPrev=QD_RISE;
      if(typeof res.castorRiseMm==='number' && res.castorRiseMm>0) _rz=res.castorRiseMm;
      else { var _m=String(res.feetHeightNote||'').match(/(\d+)mm (?:taller|shorter)/); if(_m) _rz=+_m[1]; }
      if(_rz) QD_RISE=_rz;
      var _fc=null;
      if(typeof res.floorClearMm==='number' && res.floorClearMm>0) _fc=res.floorClearMm;
      else if(res.feet==='castors' && res.castorFit==='trim' && _rz && res.feetTrimmedLens && res.feetTrimmedLens.length){
        _fc=Math.round(Math.min.apply(null,res.feetTrimmedLens)+_rz);
      }
      QD_FLOORCLEAR=_fc;
      qdSizeBar(); qdFloorClearPaint();
      /* the wheel stack reads the engine's rise - redraw once, when it first becomes known
         or changes; not on every quote (a rebuild per keystroke is the r147 flicker) */
      if(res.feet==='castors' && _rz && _rz!==_rzPrev){ try{ rebuild3D(); }catch(_e3){} }
    }catch(_e219){}
    qdSyncAddressBar();
  }
  // Geometry-only notes (column/strength recommendation + pigeonhole size). Runs on every recalc from the
  // current dimensions, independent of the price response, so recommendations never disappear on an error.
  function qdGeoNotes(){
    var sEl=$('qd-strength'), parts=[];
    var colN=Math.max(1,state.cols||1), dRowN=Math.max(1,state.rows||1);
    var sf=qdSpanFacts(), spanMm=sf.mm;
    var moreCtl=(sf.ax==='x') ? '"Vertical supports (columns)"' : '"Supports along the depth"';
    /* r117, Patryk: "need to be easy to understand, remember these customers are lickly not
       engenners". A millimetre figure next to a 1200mm threshold and a count of 24-of-36 is
       four numbers answering a one-sentence question: will it sag, and what do I do?
       METRES in the headline, because 5.3 metres is a length you can picture and 5299mm reads
       like a rating. The exact millimetres stay - one bracket at the end, on the drawing's bar,
       and in the cart property - so nothing is lost for the workshop. */
    var spanM=(Math.round(spanMm/100)/10).toFixed(1);
    if(spanMm>QD_SPAN_MAX){
      var axisTx=(sf.ax==='x')?'across the width':'along the depth';
      if(sf.postGone){
        /* r114: the paragraph explaining WHY the run is long is gone - the drawing shows it,
           in amber with its length written on it since r109. Every number, the guide and the
           fix all stay. */
        parts.push('<strong>Long open stretch.</strong> About <strong>'+spanM+' metres</strong> of rail with nothing standing under the middle of it — the bar on the drawing shows which one. Uprights on other rows only help where a cross rail reaches across to one, and none does along here.');
      } else {
        var tot=(sf.ax==='x')?(state.W||0):(state.D||0);
        var rec=Math.min(6,Math.max(2,Math.ceil(tot/QD_SPAN_MAX)));
        parts.push('<strong>Long open stretch.</strong> About <strong>'+spanM+' metres</strong> of rail with nothing standing under the middle of it — the bar on the drawing shows which one. Uprights on other rows only help where a cross rail reaches across to one, and none does along here. Setting '+moreCtl+' to '+rec+' would break it up.');
        /* r150 (tick sheet Q6): the warning already names the fix - let one tap take it.
           Guarded: no button when the recommended option is gate-locked (enclosures/custom). */
        var _asCtl=(sf.ax==='x')?'qd-cols':'qd-rows', _asEl=$(_asCtl), _asOk=false, _ai;
        if(_asEl) for(_ai=0;_ai<_asEl.options.length;_ai++) if(+_asEl.options[_ai].value===rec && !_asEl.options[_ai].disabled){ _asOk=true; break; }
        if(_asOk) parts.push('<button type="button" class="qd-addsup" data-ctl="'+_asCtl+'" data-n="'+rec+'" style="border:1px solid #0e1a4d;background:#fff;color:#0e1a4d;border-radius:8px;padding:5px 12px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;margin-top:2px">+ Add a support</button>');
      }
      /* r119: "uprights on other rows do not hold it up" now fires in BOTH branches. r117 had
         it only where an upright had been deleted, so a customer who never deleted one lost the
         sentence that answers "but there are three uprights right there". It is a clause on the
         sentence they are already reading, not a third paragraph - the box stays shorter than
         the version Patryk called too much. */
      /* r117: the count of how many runs are over is noise - a customer cannot act on "24 of
         36", and it makes the one that matters harder to find. What they can act on is what
         it will DO and what to do about it. The exact millimetres go in the bracket. */
      parts.push('It will flex under weight: fine for light storage, add an upright if you are going to load it up. ('+spanMm+'mm exactly, '+axisTx+'.)');
    }
    /* r58: THE KILOGRAM FIGURE IS GONE, at Patryk's request 24 Aug. It was a deflection sum on
       the aluminium TUBE alone and it ignored the joints entirely - and the joints are nylon,
       which is the part that gives first. A kilogram printed next to a price reads as a rating
       however carefully it is hedged. What stays is what we can stand behind: the real span in
       millimetres, what to do about it, and who to ask if you need a number. */
    var loadHtml='';
    if(spanMm>0){
      /* Don't say the span twice. When it is over the guide the paragraph above has already
         named it and said what to do; all that is left to add is the joint tip and the caveat. */
      /* r139: on an enclosure the tip below would point at the very control the
         enclosure gate locks, and the engine's supportNote already covers the
         panel spans - so the tip stands aside there. The safety sentence stays
         on every frame; it is the wording that replaced the kg rating (r58). */
      var _enclNote=(panelMode==='sides'||panelMode==='enclosed'||panelMode==='enclosedfront'||panelMode==='custom');
      loadHtml = ((spanMm>QD_SPAN_MAX || _enclNote) ? '' :
          ('The longest run with nothing under the middle of it is <strong>'+spanMm+'mm</strong>.' +
           ' <strong>Tip:</strong> adding a support halves the span, and a shorter span sags far less — try '+moreCtl+'.')) +
        ((spanMm>QD_SPAN_MAX || _enclNote) ? '' : ' ') +
        '<strong>Glue and rivet every joint</strong> — that is what makes it rigid.' +
        ' Domestic, office and retail use only. For anything load-bearing, have it checked by an engineer.';
    }
    /* r219: the box is painted by qdStrengthPaint() from these facts, so the castor bracing
       fact (which arrives on its own timetable) can share the one box. loadHtml is retired:
       its two sentences are now the grey span line and the Why? text. */
    QD_STRENGTH = { over:(spanMm>QD_SPAN_MAX), spanMm:spanMm, parts:parts,
                    enclNote:(panelMode==='sides'||panelMode==='enclosed'||panelMode==='enclosedfront'||panelMode==='custom'),
                    ctl:(sf.ax==='x')?'qd-cols':'qd-rows',
                    next:((sf.ax==='x')?colN:dRowN)+1 };
    /* r58: WARN AND ALLOW. Patryk, 24 Aug: "give them a warning but allow it, also maybe have a
       disclaimer that they understand the risk as its a custom build". Nothing is refused. The
       tick only exists while the frame is actually over the guide, and it resets whenever the
       number changes, so a tick can never be inherited by a different frame. */
    /* r59: ONE tick, not two. Patryk saw the second amber box stacked under the measurements
       box and said "this seems too much?" - he was right, it was two walls of small print at
       the moment of paying. The sentence now lives INSIDE the existing tick, so there is one
       box and one gate. It is nested inside that label's own span rather than added beside it,
       because sections/aa-cut-consent.liquid rewrites consent copy globally every 400ms and
       only skips labels carrying data-aa-shortened - which this one does. Do not remove that
       attribute. The tick is NOT auto-cleared here (that would un-tick them on every keystroke);
       instead the Add handler checks the span has not moved since they ticked. */
    var cx=$('qd-consent-extra');
    if(cx){
      if(spanMm>QD_SPAN_MAX){
        cx.textContent='I also understand this is a custom build: my widest opening is '+spanMm+'mm with no support in the middle, which is wider than we recommend, and I accept responsibility for that.';
        /* r76: amber callout look, still the SAME span inside the SAME label - one tick, one
           gate (r59), consent-rewriter still skips this label, qdTickedAtSpan check untouched. */
        cx.style.cssText='display:block;margin-top:8px;background:#fef3c7;border:1px solid #f59e0b;color:#92400e;border-radius:8px;padding:8px 10px;font-weight:600;';
      } else { cx.textContent=''; cx.style.cssText='display:none;'; }
    }
    /* r59: the real openings, not the grid. See qdOpenings(). This string travels to the ORDER
       as the "Internal opening" property, so it must be the space the customer will actually
       measure - which is why it is worth the union-find rather than a division. */
    var op=qdOpenings();
    var sz=function(o){ return o ? (o.w+' wide × '+o.h+' high × '+o.d+' deep (mm)') : ''; };
    var openTxt;
    if(!op.n){ openTxt=''; }
    else if(op.n===1){ openTxt='One opening, about '+sz(op.max); }
    else if(op.uniform){ openTxt=op.n+' openings, each about '+sz(op.max); }
    else { openTxt=op.n+' openings — the smallest about '+sz(op.min)+', the largest about '+sz(op.max); }
    /* a merge can leave an L-shaped space; then the figures are the box it fits in, not a wall
       measurement, and we say so rather than quoting a size nobody can lay a tape on. */
    if(openTxt && !op.boxy) openTxt += '. Some of them are L-shaped, so those sizes are the box they fit inside.';
    state.spaceText = openTxt;
    if($('qd-space')){ $('qd-space').textContent = openTxt + (op.n && !op.uniform ? ' The drawing shows them.' : ''); $('qd-space').setAttribute('data-base', $('qd-space').textContent); }   /* r219: base text kept for qdFloorClearPaint */
    if($('qd-space-wrap')) $('qd-space-wrap').style.display = openTxt ? 'block' : 'none';
    /* r62: the overall size, once, under the drawing - not three pills floating over it. */
    /* r183 (Patryk, 31 Aug, tick sheet Q1): with a back board fitted the strip said
       HEIGHT 750mm while the thing standing in the room was 1200mm, and nothing on the
       page said so. The frame height STAYS the frame height - it is what the openings,
       the cut lengths and the price are all built from, and changing its meaning would
       be worse than the gap. So when a board is on, the label says FRAME height and an
       OVERALL follows it. Overall = frame + the number the customer typed: measured on
       the real drawing, the board finishes 450.2mm above a 750 frame's top rail for a
       450 board, so the two numbers add with nothing in between. */
    qdSizeBar();
    qdFloorClearPaint();
    qdStrengthPaint();
  }
  /* r219: the strip under the drawing, repainted when the quote lands as well as on every
     recalc, because the wheel numbers arrive WITH the quote. Same r183 rule as the back
     board: Height stays the frame height; what stands in the room is said beside it. */
  function qdSizeBar(){
    var sb=$('qd-sizebar'); if(!sb) return;
    var _upOn=(qdUpstand>0), _ovh=(state.H||0)+(_upOn?qdUpstand:0);
    var _cs=(qdFeet==='castors'), _rise=(typeof QD_RISE==='number'&&QD_RISE>0)?QD_RISE:null;
    var _wh='';
    if(_cs && qdCastorFit==='trim') _wh='<span>On wheels</span> <b>about '+(state.H||0)+'mm</b>';
    else if(_cs && _rise) _wh='<span>On wheels</span> <b>about '+((state.H||0)+_rise)+'mm</b>';
    sb.innerHTML = '<span>Width</span> <b>'+(state.W||0)+'mm</b>'
                 + '<span>Depth</span> <b>'+(state.D||0)+'mm</b>'
                 + '<span>'+(_upOn?'Frame height':'Height')+'</span> <b>'+(state.H||0)+'mm</b>'
                 + (_upOn ? '<span>Overall with back board</span> <b>'+_ovh+'mm</b>' : '')
                 + _wh;
  }
  /* r219 (tick sheet Q2): the clear height under the bottom rail, floor included, on a castor
     frame - the number a customer lays a tape on. From the engine (floorClearMm, 1.35.1);
     before that only where the response lets it be derived: 'trim' = the trimmed floor leg
     the engine reports + its rise. 'under' prints nothing until 1.35.1 - unknown is not zero.
     Painted on the Review pigeonhole line and beside the Advanced openings. NOT added to
     state.spaceText: that string travels to the order as "Internal opening". */
  function qdFloorClearText(){
    if(qdFeet!=='castors') return '';
    if(window.aaQuoteRefused) return '';
    var v=(typeof QD_FLOORCLEAR==='number'&&QD_FLOORCLEAR>0)?QD_FLOORCLEAR:null;
    var r=(typeof QD_RISE==='number'&&QD_RISE>0)?QD_RISE:null;
    if(v==null) return '';
    if(qdCastorFit==='trim') return 'Under the bottom shelf: about '+v+'mm clear from the floor, wheels included'+(r?(' \u2014 the legs are cut '+r+'mm shorter, so that is the same as without wheels.'):'.');
    return 'Under the bottom shelf: about '+v+'mm clear from the floor, wheels included'+(r?(' \u2014 '+r+'mm more than the frame alone.'):'.');
  }
  function qdFloorClearPaint(){
    var t=qdFloorClearText();
    var a=$('qd-floorclear'); if(a){ a.textContent=t; a.style.display=t?'block':'none'; }
    var sp=$('qd-space');
    if(sp){
      var base=sp.getAttribute('data-base'); if(base==null){ base=sp.textContent; }
      sp.textContent = t ? (base+(base?' ':'')+t) : base;
    }
  }
  /* r219 (tick sheet Q3 + Q4 + Q5): ONE Strength box. Grey when nothing is wrong - under the
     guide the span is a fact with a button beside it, not a warning - and amber only when a
     run is over the guide. The two-tier castor bracing fact lives here too (it used to be a
     second box on the Feet control), and the glue / rivet / engineer sentence is said ONCE,
     behind Why?. The fix is IN the box: "+ Add a support" (columns or depth supports, one
     more than now; r150's button, now on every frame and on the Easy Designer where the
     control itself is hidden) and "+ Add a shelf level" (tiers + 1, floor bars kept out for
     the wheels). Both change the price and both are one Undo. */
  var QD_STRENGTH=null;   /* what qdGeoNotes worked out; the painter reads it */
  function qdStrengthPaint(){
    var sEl=$('qd-strength'); if(!sEl) return;
    var st=QD_STRENGTH||{};
    var over=!!st.over, html='', btns='';
    if(over){
      html='For strength: '+(st.parts||[]).join(' ');
    } else if(st.spanMm>0 && !st.enclNote){
      html='<strong>Strength.</strong> Longest run with nothing under the middle of it: <strong>'+st.spanMm+'mm</strong> \u2014 under our '+QD_SPAN_MAX+'mm guide.';
    }
    if(qdBraceWeak){
      html+=(html?' ':'')+'<strong>Two-tier frame on wheels:</strong> with the floor cross bars out there is nothing tying the legs together below the top rails \u2014 it can lean sideways as you push it. A shelf level puts a rail back at mid height and still leaves the leg ends open for the wheels.';
    }
    /* the buttons: a real control value on a real control, never a synthetic nudge (r80) */
    if(!over && st.ctl && st.next){
      var _el=$(st.ctl), _ok=false, _i;
      if(_el) for(_i=0;_i<_el.options.length;_i++) if(+_el.options[_i].value===st.next && !_el.options[_i].disabled){ _ok=true; break; }
      if(_ok) btns+='<button type="button" class="qd-addsup" data-ctl="'+st.ctl+'" data-n="'+st.next+'" style="border:1px solid #0e1a4d;background:#fff;color:#0e1a4d;border-radius:8px;padding:5px 12px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;margin:6px 6px 0 0">+ Add a support</button>';
    }
    if(qdBraceWeak){
      var _te=$('qd-tiers'), _tn=Math.max(2,state.tiers||2)+1, _tok=false, _ti;
      if(_te) for(_ti=0;_ti<_te.options.length;_ti++) if(+_te.options[_ti].value===_tn && !_te.options[_ti].disabled){ _tok=true; break; }
      if(_tok) btns+='<button type="button" class="qd-addlevel" data-n="'+_tn+'" style="border:0;background:#0e1a4d;color:#fff;border-radius:8px;padding:6px 12px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;margin:6px 6px 0 0">+ Add a shelf level</button>';
    }
    var why='Adding a support halves the span, and a shorter span sags far less. A shelf level adds a ring of rails at mid height. <strong>Glue and rivet every joint</strong> \u2014 that is what makes it rigid. Domestic, office and retail use only. For anything load-bearing, have it checked by an engineer.';
    if(html){
      btns+='<button type="button" class="qd-why" aria-expanded="false" style="border:1px solid #94a3b8;background:#fff;color:#475569;border-radius:8px;padding:5px 10px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;margin:6px 0 0 0">Why?</button>';
      html+='<div>'+btns+'</div><div class="qd-whytext" style="display:none;margin-top:7px">'+why+'</div>';
    } else if(st.spanMm>0){
      /* r139: an enclosure under the guide - the tip would point at a locked control, so
         the safety sentence stands alone, exactly as before. */
      html=why;
    }
    if(over){ sEl.style.color='#92400e'; sEl.style.background='#fdf4e3'; sEl.style.borderColor='#f0d9a8'; }
    else { sEl.style.color='#0e1a4d'; sEl.style.background='#f8fafc'; sEl.style.borderColor='#cbd5e1'; }
    if(html){ sEl.innerHTML=html; sEl.style.display='block'; } else { sEl.style.display='none'; }
  }
  // Build a shareable URL that encodes the current design; opening it rebuilds the exact frame.
  function qdShareURL(){
    try{
      var p=new URLSearchParams();
      p.set('type',state.type||'shelf'); p.set('w',state.W||''); p.set('d',state.D||''); p.set('h',state.H||'');
      p.set('tiers',state.tiers||3); p.set('cols',Math.max(1,state.cols||1)); p.set('rows',Math.max(1,state.rows||1)); p.set('finish',state.finish||qdFinish||'mill'); p.set('panels',panelMode||'none'); p.set('supply',(panelMode==='none'?'us':panelSupply)||'us');
      /* r40: the new 1.5 settings have to travel with the link. Before this, sending someone a
         design with uneven bays silently handed them EVEN bays at the same overall size - a
         different frame, a different cut list and a different price, under the same URL. */
      if(openShares){
        ['w','d','h'].forEach(function(k){
          var v=openShares[k];
          if(v && v.length) p.set('o'+k, v.join('-'));
        });
      }
      if(panelSupply==='byo' && panelMode!=='none' && qdPanelTh===17) p.set('pt','17');
      if(panelMode==='custom'){
        var _fs4=qdF6Str(qdFaces); if(_fs4) p.set('fc',_fs4);
        var _ls4=qdF6Str(qdLips4); if(_ls4) p.set('l4',_ls4);
      }
      /* r203: the board's own shape MUST travel with the design. Without this a customer
         who splits the board into rows shares a link that rebuilds a SINGLE-BAND board -
         a different frame at a different price under the same URL, which is the exact
         fault this project has already been bitten by once. */
      if(qdUpstand && qdSpRows>1) p.set('sr',String(qdSpRows));
      if(qdUpstand && qdSpOff.length)
        p.set('sn', qdSpOff.map(function(a){ return a[0]+'.'+a[1]; }).join('-'));
      if(qdMatWalls) p.set('mw',qdMatWalls);
      if(qdMatBoard) p.set('mb',qdMatBoard);   /* r191: the material has to travel with the design or a shared link rebuilds a different frame at a different price */
      if(panelFix==='angle') p.set('fix','angle');
      if(qdFeet && qdFeet!=='none') p.set('feet', qdFeet);
      if(qdFeet==='castors') p.set('cfit', qdCastorFit);   /* r218 */
      if(railLevels && railLevels!=='all') p.set('rails', (typeof railLevels==='string')?railLevels:[].concat(railLevels).join('-'));
      if(qdNoPosts.length) p.set('nop', qdNoPosts.map(function(q){ return q.join('.'); }).join('-'));
      if(qdNoRails.length) p.set('nor', qdNoRails.map(function(q){ return q[0]+'.'+q[1]+'.'+q[2]+'.'+q[3]; }).join('-'));
      if(qdNoPanels.length) p.set('nopan', qdNoPanels.map(function(q){ return q[0]+'.'+q[1]+'.'+q[2]; }).join('-'));
      if(state.type==='shelf' && qdBackSel.length) p.set('bw', qdBackSel.map(function(q){ return q[0]+'.'+q[1]; }).join('-'));
      if(qdUpstand){ p.set('us', String(qdUpstand)); if(qdUpFlush==='in') p.set('uf','in'); }
      return location.origin+location.pathname+'?'+p.toString();
    }catch(e){ return location.href; }
  }
  /* r-addressbar: keep the address bar on the design the customer is looking at.
     Until now it kept whatever they arrived with, so someone who changed the width
     and then copied the web address sent us the frame they STARTED from, at the
     price they started from, with nothing on screen to warn either of us.
     This MERGES onto the existing query instead of replacing it. qdShareURL()
     builds its params from scratch, so writing it in raw would silently drop
     edit_bundle / edit_key - and a customer who arrived from "Edit frame in cart"
     and then reloaded would press a button that adds a SECOND frame and leaves the
     original in the cart. It also keeps utm tags, ?variant= and any app param. */
  /* r154: pt/fc/l4 (r144/r150 keys) + bw added - they are OURS, so a mode
     switch must drop the stale copies from the address bar instead of merging
     them back in forever. */
  var QD_URL_OURS = ['type','w','d','h','tiers','cols','rows','finish','panels','supply','ow','od','oh','fix','rails','nop','nor','nopan','feet','cfit','pt','fc','l4','bw','us','uf'];
  function qdSyncAddressBar(){
    try{
      if(!window.history || !history.replaceState) return;
      var mine=qdShareURL(), qs=mine.indexOf('?');
      if(qs<0) return;
      var next=new URLSearchParams(mine.slice(qs+1));
      var cur=new URLSearchParams(location.search);
      cur.forEach(function(v,k){ if(QD_URL_OURS.indexOf(k)<0 && !next.has(k)) next.set(k,v); });
      if(qdEditBundle && !next.has('edit_bundle')) next.set('edit_bundle', qdEditBundle);
      if(qdEditKey && !next.has('edit_key')) next.set('edit_key', qdEditKey);
      var url=location.origin+location.pathname+'?'+next.toString();
      if(url!==location.href) history.replaceState(null,'',url);
    }catch(e){}
  }
  var qdEditBundle=null;   // set from ?edit_bundle= when reopening a cart design to REPLACE it
  var qdEditKey=null;      // r39: set from ?edit_key= (the cart line key) - same replace flow
  function qdLoadFromURL(){
    try{
      var p=new URLSearchParams(location.search); if(!p.get('w'))return;
      if(p.get('edit_bundle')) qdEditBundle=p.get('edit_bundle');
      if(p.get('edit_key')) qdEditKey=p.get('edit_key');
      // r39: opening from a cart Edit link means the button now UPDATES the cart
      if(qdEditBundle||qdEditKey){ var ab=$('qd-add'); if(ab) ab.textContent='Update frame in cart'; }
      var set=function(id,v){ var el=$(id); if(el && v!=null && v!==''){ el.value=v; } };
      if(p.get('type')) set('qd-type',p.get('type'));
      set('qd-w',p.get('w')); set('qd-d',p.get('d')); set('qd-h',p.get('h'));
      if(p.get('tiers')) set('qd-tiers',p.get('tiers'));
      if(p.get('cols')) set('qd-cols',p.get('cols'));
      if(p.get('rows')) set('qd-rows',p.get('rows'));
      if(p.get('finish')){ set('qd-finish',p.get('finish')); qdFinish=p.get('finish'); }
      if(p.get('panels')){ set('qd-panel',p.get('panels')); panelMode=p.get('panels'); }
      if(p.get('supply')){ set('qd-supply',p.get('supply')); panelSupply=p.get('supply'); }
      if(p.get('pt')==='17'){ qdPanelTh=17; var _t17=$('qd-thick-17'); if(_t17) _t17.checked=true; }
      if(p.get('panels')==='custom'){
        var _fcR=(p.get('fc')||'').split('.'), _l4R=(p.get('l4')||'').split('.');
        ['top','bottom','front','back','left','right'].forEach(function(k4){
          qdFaces[k4]=_fcR.indexOf(k4)>=0; qdLips4[k4]=_l4R.indexOf(k4)>=0;
        });
        try{ if(window.qdSyncL4) window.qdSyncL4(); }catch(_er4){}
      }
      /* r85: feet is NOT applied here any more. It used to be, and a share link carrying
         feet=caps PLUS deleted floor rails deadlocked: the first quote went out as caps-on-a-
         full-frame (rails still pending), the engine refused, engineSeen never runs on a
         refusal, so the ENGINE flags never flipped and applyPending never applied the rails -
         the page sat on the refusal forever. Measured on the V4.9 preview, 26 Aug 2026.
         Feet now rides qdPending with the rails, applied after the first GOOD quote. */
      /* r40: order matters. Changing type/tiers/cols/rows CLEARS the openings (that listener is
         deliberate - a shape change invalidates them). So the fixing, the rail levels and the
         openings are applied LAST, after every shape control has already settled. */
      /* r40: these three cannot be applied yet. The openings panel and the rail selector stay
         hidden until a Worker has answered 1.4.0/1.5.0, and syncRail() actively resets the rail
         setting back to 'all' while its wrapper is hidden. So park them and let engineSeen()
         apply them the moment the engine has identified itself. */
      var _got={}, _any=false;
      ['w','d','h'].forEach(function(k){
        var raw=p.get('o'+k); if(!raw) return;
        var arr=raw.split('-').map(function(x){ return Math.round(Number(x)||0); });
        if(arr.length && arr.every(function(n){ return n>0 && isFinite(n); })){ _got[k]=arr; _any=true; }
      });
      var _nop=p.get('nop'), _nor=p.get('nor'), _nopan=p.get('nopan'), _bwp=p.get('bw');
      /* r60, 24 Aug. THIS OBJECT HAD THE KEY `rails` TWICE. JavaScript takes the last one and
         says nothing, so `rails=ends` from a share link was overwritten by the DELETED-rails
         list on every link ever sent - and then applyPending did `select.value = [an array]`,
         which matches no option, so the Interior-supports box was left BLANK.
         Measured on Patryk's own link 24 Aug: the URL said rails=ends and the quote went out
         with railLevels:"all". A shared design rebuilt as a DIFFERENT frame, with a different
         cut list and a different price, under the same URL. Two distinct names now. */
      qdPending = { open: _any?_got:null, fix: p.get('fix')||null, feet: p.get('feet')||null, cfit: p.get('cfit')||null,
                    railLv: p.get('rails')||null,
                    posts: _nop ? _nop.split('-').map(function(q){ var a=q.split('.').map(Number); return (a.length>=3)?[a[0],a[1],a[2]]:[a[0],a[1]]; })
                                        .filter(function(a){ return a.every(isFinite); }) : null,
                    norails: _nor ? _nor.split('-').map(function(q){ var a=q.split('.'); return [ a[0], +a[1], +a[2], +a[3] ]; })
                                        .filter(function(a){ return (a[0]==='w'||a[0]==='d')&&isFinite(a[1])&&isFinite(a[2])&&isFinite(a[3]); }) : null,
                    nopanels: _nopan ? _nopan.split('-').map(function(q){ var a=q.split('.'); return [ +a[0], +a[1], +a[2] ]; })
                                        .filter(function(a){ return isFinite(a[0])&&isFinite(a[1])&&isFinite(a[2]); }) : null,
                    bw: _bwp ? _bwp.split('-').map(function(q2){ var a=q2.split('.'); return [ +a[0], +a[1] ]; })
                                        .filter(function(a){ return isFinite(a[0])&&isFinite(a[1]); }) : null,
                    up: (function(){ var v=Math.round(Number(p.get('us'))); return (isFinite(v)&&v>0)?v:null; })(),
                    upf: (p.get('uf')==='in')?'in':null,
                    /* r203: read back the board's shape. Each is validated here rather
                       than trusted - a hand-edited URL must not be able to build a design
                       the engine will refuse. */
                    sfRows: (function(){ var v=Math.round(Number(p.get('sr')));
                      return (isFinite(v)&&v>=2&&v<=4)?v:null; })(),
                    sfOff: (function(){ var v=p.get('sn'); if(!v) return null;
                      var out=v.split('-').map(function(q){ var a=q.split('.'); return [+a[0],+a[1]]; })
                               .filter(function(a){ return isFinite(a[0])&&isFinite(a[1])&&a[0]>=0&&a[1]>=0; });
                      return out.length?out:null; })(),
                    mw: (p.get('mw')==='byo'||p.get('mw')==='us')?p.get('mw'):null,
                    mb: (p.get('mb')==='byo'||p.get('mb')==='us')?p.get('mb'):null };
      if(ENGINE14) applyPending();
    }catch(e){}
  }
  /* r40: restore the 1.4/1.5 settings a share link carried, once the engine is known. Applying
     the openings LAST matters - setting the fixing or the rails calls recalc(), and a shape
     change would wipe the openings if they went first. */
  var qdPending=null;
  function applyPending(){
    if(!qdPending) return;
    var q=qdPending; qdPending=null;
    try{
      qdPendMatW=q.mw||''; qdPendMatB=q.mb||'';
      /* r203: staged, not applied here. The board arrives via qdSetPendingUp and only
         exists once the engine has admitted to 1.28+; applying its shape before that would
         be pruned away by the board's own sync. qdSfLand() puts it on once it is real. */
      qdPendSf = (q.sfRows||q.sfOff) ? {rows:q.sfRows, off:q.sfOff} : null;
      if(q.bw && q.bw.length && window.qdSetPendingBw) window.qdSetPendingBw(q.bw);
      if(q.upf==='in'){ var _fi=$('qd-up-flush-in'); if(_fi){ _fi.checked=true; qdUpFlush='in'; } }
      if(q.up && window.qdSetPendingUp) window.qdSetPendingUp(q.up);
      /* r63: the angle is off sale. An older share link carrying fix=angle must not quietly
         rebuild as a lipped frame at a different price - it says so, in words, and the price it
         then shows is the lipped one it is actually offering. Fail loud, never substitute in
         silence. */
      if(q.fix){
        var wanted=(q.fix==='angle')?'angle':'lip';
        panelFix='lip';
        var fx=$('qd-fix'); if(fx){ fx.value='lip'; fx.dispatchEvent(new Event('change')); }
        if(wanted==='angle'){
          var wf=$('qd-fix-warn');
          if(wf){ wf.className='qd-fixwarn';
            wf.innerHTML='This saved design used the <strong>screw-on angle ledge</strong>, which is off sale while we sort the fixing. It is showing with the <strong>lipped rail</strong> instead, so the price below is for that. Email sales@allaluminium.com.au if you need the ledge.';
            wf.hidden=false; }
        }
      }
      if(q.railLv){
        var rl=$('qd-rail');
        /* whitelist, because this value came out of a URL a stranger can edit */
        var okLv = (q.railLv==='all'||q.railLv==='ends'||q.railLv==='top'||q.railLv==='bottom');
        if(!ENGINE15){ qdPending=q; return; }   /* engine not identified yet - park it, never drop it */
        if(rl && okLv){ rl.value=q.railLv; rl.dispatchEvent(new Event('change')); }
      }
      if(q.feet && (q.feet==='none'||q.feet==='caps'||q.feet==='castors')){
        /* r218 (Patryk, tick sheet 2 Sep Q4: yes). The r94 COMING-SOON gate is GONE.
           It rewrote a castor design to 'none' and told the customer the wheels were on
           order. Both wheel and socket are ACTIVE products with live prices, and alucut
           1.35.0 prices, trims and describes castors, so the gate was the only thing left
           between a castor design and a sale. A shared link now rebuilds what it says.
           castorFit travels with it - without that a shared castor design would silently
           come back at the OTHER height, which is the same class of fault r40 fixed for
           uneven bays. */
        var _fs=$('qd-feet');
        if(_fs){ _fs.value=q.feet; _fs.dispatchEvent(new Event('change')); }   // sets qdFeet, note, redraw, requote via its own listener
        if(q.feet==='castors' && q.cfit && (q.cfit==='trim'||q.cfit==='under')){
          qdCastorFit=q.cfit;
          var _cf=$('qd-castor-fit'); if(_cf){ _cf.value=q.cfit; }
        }
      }
      if(q.posts && q.posts.length){ qdNoPosts=q.posts; syncPostUI(); rebuild3D(); }
      if(q.norails && q.norails.length){ qdNoRails=q.norails; syncPostUI(); rebuild3D(); }
      /* r218b: repaint the castor UI AFTER the link's deleted rails have landed.
         Found by opening a share link rather than clicking through: the button and the
         bracing warning are both driven by how many floor rails are left, and this
         restore runs after the Feet control has already painted. Without this a shared
         castor design showed no warning at all - the one case where the customer did
         not press the button themselves and so never saw what it costs. */
      if(qdCastorUIFn) try{ qdCastorUIFn(); }catch(e218){}
      /* r65: parked until the engine says 1.13 - applying panel deletions the Worker would
         refuse rebuilds a shared design as a different (pricier) frame in silence. */
      if(q.nopanels && q.nopanels.length){
        if(!ENGINE113){ qdPending=q; return; }
        qdNoPanels=q.nopanels; syncPostUI(); rebuild3D();
      }
      if(q.open){
        openShares=q.open;
        var on=$('qd-open-on'); if(on) on.checked=true;
        openFields();            // rebuilds the boxes, seeded from openShares
        readOpenFields();        // recomputes W/D/H from them and reprices
      }
      /* r82: the undo baseline used to be captured at page init, BEFORE this function applied
         a share link's removed pieces. One change + one Undo then silently rebuilt the
         customer's design as the FULL frame at a different price ($944.57 -> $1246.43,
         measured on Patryk's own link, 26 Aug 2026). The loaded design is where this
         session's story starts - the undo history starts from it, not from the blank the
         page woke up as. (The re-park returns above skip this until the apply completes.) */
      qdPast.length=0; qdFuture.length=0; qdHistLabel='';
      qdLast=null; qdCommit('');
    }catch(e){}
  }
  function qdDownloadImg(){
    try{
      if(renderer&&scene&&camera)renderer.render(scene,camera);
      var url=$('qd-canvas').toDataURL('image/png');
      var a=document.createElement('a'); a.href=url;
      a.download='allaluminium-design-'+(state.W||'')+'x'+(state.D||'')+'x'+(state.H||'')+'.png';
      document.body.appendChild(a); a.click(); a.remove();
    }catch(e){ alert('Could not save the image on this browser — try a screenshot.'); }
  }

  /* r87: the thumbnails. Painted on every recalc, because recalc runs after every path that
     can change these selects - typing, undo (qdApplyState sets values without events), a share
     link, applyPending. Tiny innerHTML writes, skipped when unchanged. */
  var _qdThumbLast={};
  function qdSyncThumbs(){
    try{
      var draw=function(id,val,svg){ if(_qdThumbLast[id]===val) return; var el=document.getElementById(id); if(!el) return; el.innerHTML=svg; _qdThumbLast[id]=val; };
      var tv=($('qd-type')||{}).value||'box';
      draw('qd-thumb-type',tv, tv==='shelf'
        ? '<svg width="38" height="28" viewBox="0 0 64 44"><g stroke="#0e1a4d" stroke-width="3.2" fill="none"><rect x="8" y="6" width="48" height="32"/><line x1="8" y1="22" x2="56" y2="22"/><line x1="32" y1="6" x2="32" y2="38"/></g></svg>'
        : '<svg width="38" height="28" viewBox="0 0 64 44"><g stroke="#0e1a4d" stroke-width="3.2" fill="none"><rect x="10" y="12" width="40" height="26"/><path d="M10 12 l9 -6 h40 l-9 6 M50 12 l9 -6 v26 l-9 6"/></g></svg>');
      var fv=($('qd-finish')||{}).value||'mill';
      var fc = fv==='black' ? '#242a35' : (fv==='clear' ? '#e8edf4' : '#c7ced9');
      draw('qd-thumb-finish',fv,'<svg width="32" height="22"><rect x="1" y="1" width="30" height="20" rx="3" fill="'+fc+'" stroke="#94a3b8" stroke-width="1.5"/></svg>');
      var pv=($('qd-panel')||{}).value||'none';
      /* r88: one isometric box per panels option; the panelled faces fill cyan-grey.
         Geometry shared by every case: top face T, front face F, back face B, floor face G,
         side faces via the same points. */
      (function(){
        var P={ // face polygons on a 44x36 canvas
          T:'M8,12 L20,5 L40,5 L28,12 Z',           // top
          G:'M8,30 L20,23 L40,23 L28,30 Z',         // floor
          F:'M8,12 L28,12 L28,30 L8,30 Z',          // front
          B:'M20,5 L40,5 L40,23 L20,23 Z',          // back
          S:'M28,12 L40,5 L40,23 L28,30 Z'          // right side
        };
        var fill=function(f){ return '<path d="'+P[f]+'" fill="#4fb5d8" stroke="#0e1a4d" stroke-width="1.6"/>'; };
        var frame='<path d="'+P.F+'" fill="none" stroke="#0e1a4d" stroke-width="2"/><path d="'+P.T+'" fill="none" stroke="#0e1a4d" stroke-width="2"/><path d="'+P.S+'" fill="none" stroke="#0e1a4d" stroke-width="2"/>';
        var faces={ none:[], all:['G','T'], top:['T'], back:['B'], backfront:['B','F'],
                    sides:['S'], enclosed:['G','T','B','S'], enclosedfront:['G','T','B','S','F'] }[pv]||[];
        var svg='<svg width="40" height="32" viewBox="0 0 46 36">';
        for(var fi=0;fi<faces.length;fi++) svg+=fill(faces[fi]);
        svg+=frame+'</svg>';
        var el=document.getElementById('qd-thumb-panel');
        if(el && _qdThumbLast['qd-thumb-panel']!==pv){ el.innerHTML=svg; _qdThumbLast['qd-thumb-panel']=pv; }
      })();
      /* r152, Patryk: "could we have them for the rest?" - the structure controls
         get pictures too, drawn from their own current value. */
      var cv=Math.max(1,+((($('qd-cols')||{}).value)||1));
      draw('qd-thumb-cols','c'+cv,(function(){
        var g='<svg width="38" height="28" viewBox="0 0 64 44"><g stroke="#0e1a4d" stroke-width="3" fill="none"><rect x="8" y="6" width="48" height="32"/>';
        for(var i=1;i<cv;i++){ var x=(8+48*i/cv).toFixed(1); g+='<line x1="'+x+'" y1="6" x2="'+x+'" y2="38"/>'; }
        return g+'</g></svg>'; })());
      var rv=Math.max(1,+((($('qd-rows')||{}).value)||1));
      draw('qd-thumb-rows','r'+rv,(function(){
        /* top face of the same isometric box the panels thumb draws, divided front-to-back */
        var g='<svg width="40" height="20" viewBox="0 0 48 20"><g stroke="#0e1a4d" stroke-width="2" fill="none"><path d="M4,17 L18,3 L44,3 L30,17 Z"/>';
        for(var i=1;i<rv;i++){ var f=i/rv, x1=(4+14*f).toFixed(1), x2=(30+14*f).toFixed(1), y=(17-14*f).toFixed(1);
          g+='<line x1="'+x1+'" y1="'+y+'" x2="'+x2+'" y2="'+y+'"/>'; }
        return g+'</g></svg>'; })());
      var tv2=Math.max(2,+((($('qd-tiers')||{}).value)||3));
      draw('qd-thumb-tiers','t'+tv2,(function(){
        var g='<svg width="38" height="28" viewBox="0 0 64 44"><g stroke="#0e1a4d" stroke-width="3" fill="none"><rect x="8" y="6" width="48" height="32"/>';
        for(var i=1;i<tv2-1;i++){ var y=(6+32*i/(tv2-1)).toFixed(1); g+='<line x1="8" y1="'+y+'" x2="56" y2="'+y+'"/>'; }
        return g+'</g></svg>'; })());
      var ft=qdFeet||'none';
      draw('qd-thumb-feet',ft, ft==='caps'
        ? '<svg width="30" height="32" viewBox="0 0 44 40"><rect x="16" y="2" width="12" height="31" stroke="#0e1a4d" stroke-width="2.6" fill="none"/><rect x="13" y="33" width="18" height="4" fill="#0e1a4d"/><line x1="6" y1="38" x2="38" y2="38" stroke="#94a3b8" stroke-width="2"/></svg>'
        : (ft==='castors'
        ? '<svg width="30" height="32" viewBox="0 0 44 40"><rect x="16" y="0" width="12" height="22" stroke="#0e1a4d" stroke-width="2.6" fill="none"/><rect x="13" y="22" width="18" height="6" rx="1.5" fill="#0e1a4d"/><circle cx="22" cy="33" r="5.5" fill="#475569"/><line x1="6" y1="39" x2="38" y2="39" stroke="#94a3b8" stroke-width="2"/></svg>'
        : '<svg width="30" height="32" viewBox="0 0 44 40"><rect x="16" y="2" width="12" height="34" stroke="#0e1a4d" stroke-width="2.6" fill="none"/><line x1="6" y1="38" x2="38" y2="38" stroke="#94a3b8" stroke-width="2"/></svg>'));
    }catch(e){}
  }
  function qdKeySfx(){
    /* r154: the cache key's custom/bw suffix, built from LIVE state in one
       place. The request key and the post-fetch paint guard both call it, so
       they can never disagree again (the r152 guard omitted the custom suffix
       and a fresh custom-mode answer never painted on arrival). */
    return (panelMode==='custom'?('|'+qdF6Str(qdFaces)+'|'+qdF6Str(qdLips4)):'')
         + ((state.type==='shelf'&&qdBackSel.length)?('|bw'+qdBackSel.map(function(c){ return c[0]+'.'+c[1]; }).join('-')):'')
         + (qdUpstand?('|us'+qdUpstand+qdUpFlush):'')
         + ((qdMatWalls||qdMatBoard)?('|m'+(qdMatWalls||'-')+(qdMatBoard||'-')):'')   /* r191: a material change MUST bust the cache, or the old price paints over the new one */
         /* r218 - AND SO MUST THE CASTOR HEIGHT, for exactly the reason r191 and r202
            are already here. Found by driving the real page: switching between "keep my
            height" and "wheels underneath" changed the URL and the payload but the cache
            answered from the previous key, so the request was never sent and the note
            never moved. Two options that look identical are worse than one option.
            Third time this trap has been hit in this function; adding a payload field
            without adding it here is the whole failure mode. */
         + ((qdFeet==='castors')?('|cf'+qdCastorFit):'')
         /* r202: and so must the board's own shape. Without this the rows, the rails
            and the open cells all changed the PAYLOAD while the cache answered from
            the previous key - so the request was never sent, the price never moved,
            and the controls looked dead. Same trap as r191's, one feature later. */
         + ((qdUpstand && (qdSpRows>1 || qdSpRails || qdSpOff.length))
             ? ('|sf'+qdSpRows+(qdSpRails?qdSpRails.join(''):'')+(qdSpOff.length?('o'+qdSpOff.map(function(a){return a[0]+'.'+a[1];}).sort().join('-')):''))
             : '');
  }
  /* ---- r183, tick sheet Q2 (Patryk, 31 Aug) --------------------------------------
     "We cut 6mm aluminium plate — select to see the price". Measured over 540 designs,
     choosing it adds an average of $263.77 and as much as $1,251.36, so the only way to
     learn a four-figure number was to commit to it. r140 deliberately avoided a second
     quote call; that was the right call then and the wrong one now.

     So: after a good quote lands, ask the engine ONCE for the same frame with the other
     panel supply, and publish the pair on window.QD_SUPPLY_MEM. The card markup in the
     section reads it and falls back to its own remembered prices if it is not there, so
     a failed or slow shadow quote leaves the page exactly as it is today - that is the
     fire-and-forget requirement, not a nicety.

     It is CACHED under the other supply's own QD_CACHE key, so flipping between the two
     cards costs nothing after the first look, and an in-flight entry is never re-fired.
     It is skipped entirely when there are no panels, when the supply block is hidden, and
     when plateGate has disabled the plate option (the card says "see below" there and a
     price would contradict it).

     QD_SUP_MEM is stamped with the design key IGNORING supply and cleared the moment that
     changes, so a price from the previous frame can never be shown against this one - the
     stale-number shape this project keeps getting caught by. */
  var QD_SUP_MEM=null, QD_SUP_KEY=null;
  function qdSupplyPub(){ try{ window.QD_SUPPLY_MEM=QD_SUP_MEM; }catch(e){} }
  function qdSupplyPending(on){
    if(!QD_SUP_MEM) QD_SUP_MEM={byo:null,us:null};
    QD_SUP_MEM.pending=!!on; qdSupplyPub();
  }
  function qdSupplyNote(sup,j){
    if(!QD_SUP_MEM) QD_SUP_MEM={byo:null,us:null};
    if(j && j.ok===true && typeof j.priceExGst==='number') QD_SUP_MEM[sup]=j.priceExGst/100;
    qdSupplyPub();
  }
  function qdSupplyShadow(base,sup){
    try{
      if(panelMode==='none') return;
      var w=$('qd-supply-wrap'); if(!w || w.style.display==='none') return;
      var st=$('qd-supply'), i;
      if(st) for(i=0;i<st.options.length;i++) if(st.options[i].value==='us' && st.options[i].disabled) return;
      var other=(sup==='byo')?'us':'byo';
      if(QD_SUP_MEM && QD_SUP_MEM[other]!=null) return;
      var okey=qdKey(base.frameType,base.W,base.D,base.H,base.tiers,base.cols,base.finish,
                     panelMode+qdKeySfx(),other,base.rows);
      var oh=QD_CACHE[okey];
      if(oh && oh.done){ qdSupplyNote(other,oh.res); return; }
      if(oh) return;                                  /* already in flight - never fire twice */
      QD_CACHE[okey]={done:false};
      var body={}, k; for(k in base) if(Object.prototype.hasOwnProperty.call(base,k)) body[k]=base[k];
      body.panelSupply=other; body.savedName=null;    /* a shadow must never record a save */
      /* MEASURED before this flag existed: when the shadow was refused the card sat on
         "working out the price..." forever - a sentence that was no longer true and that
         the customer could not act on. The old wording at least told them what to do. So
         the card is only allowed to say "working out" while one is actually in flight. */
      qdSupplyPending(true);
      qdPriceFetch(QD_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
        .then(function(r){return r.json();})
        .then(function(j){
          if(j && j.ok===true){ QD_CACHE[okey]={done:true,res:j}; qdSupplyNote(other,j); }
          else { delete QD_CACHE[okey]; }
          qdSupplyPending(false);
        })
        .catch(function(){ delete QD_CACHE[okey]; qdSupplyPending(false); });
    }catch(e){}
  }

  function recalc(){
    qdSyncThumbs();
    try{ syncMode(); }catch(e){}
    try{ if(window.qdBwSync) window.qdBwSync(); }catch(e){}
    var type=$('qd-type').value, W=+$('qd-w').value||0, D=+$('qd-d').value||0, H=+$('qd-h').value||0, tiers=+$('qd-tiers').value||3, cols=+($('qd-cols')?$('qd-cols').value:1)||1, rows=+($('qd-rows')?$('qd-rows').value:1)||1;
    $('qd-tierwrap').hidden = (type!=='shelf');

    // the 3D preview only needs the dimensions - draw it straight away
    state.type=type; state.W=W; state.D=D; state.H=H; state.tiers=tiers; state.cols=cols; state.rows=rows;

    if(!W||!H||(type==='box'&&!D)){
      $('qd-price').textContent='\u2014'; $('qd-price-gst').textContent='';
      $('qd-cuts').textContent=''; $('qd-conns').textContent=''; (function(){var _fb=$('qd-feet-block'); if(_fb)_fb.style.display='none';})(); $('qd-tube').textContent='';
      var _s=$('qd-strength'); if(_s)_s.style.display='none'; var _sp=$('qd-space-wrap'); if(_sp)_sp.style.display='none'; var _sb227=$('qd-staffbox'); if(_sb227)_sb227.style.display='none';
      $('qd-add').disabled=true; state.lineItems=null; state.total=null;
      return;
    }
    rebuild3D();
    dimStrip();
    qdGeoNotes();   // column/strength recommendation + pigeonhole — always shown, even if the price call errors

    var finish=qdFinish, panels=panelMode, supply=(panelMode==='none'?'us':panelSupply);
    var key=qdKey(type,W,D,H,tiers,cols,finish,panels+qdKeySfx(),supply,rows);
    QD_WANT_KEY=key;   /* r230: the design on screen - a quote is only "this frame's" while its key matches */
    if(qdSavedFlag) delete QD_CACHE[key];   // r70: a save must reach the engine, not the cache
    var hit=QD_CACHE[key];
    /* r183 Q2: one request object, used by the real quote and by the shadow. Built here,
       after the cache delete above, so consuming qdSavedFlag is exactly as it was: when
       that flag is set the cache entry has just been removed, so `hit` is always undefined
       and the real fetch always runs. */
    var _qb={mode:'alucube-basket',frameType:type,W:W,D:D,H:H,tiers:tiers,cols:cols,rows:rows,finish:finish,panels:(panelMode==='custom'?'none':panels),faces:(panelMode==='custom'?qdFaces:null),lips4:(panelMode==='custom'&&qdLips4Any()?qdLips4:null),panelSupply:supply,panelFix:panelFix,feet:qdFeet,castorFit:qdCastorFit,shares:openShares,railLevels:railLevels,noPosts:(qdNoPosts.length?qdNoPosts:null),noRails:(qdNoRails.length?qdNoRails:null),noPanels:(qdNoPanels.length?qdNoPanels:null),backSel:(state.type==='shelf'&&qdBackSel.length?qdBackSel:null),splash:(qdUpstand||null),splashFlush:(qdUpstand?qdUpFlush:null),
      /* r202: send NOTHING while the board is a plain single lipped band. A design that
         does not use this must put identical bytes on the wire, or every frame already out
         there is repriced by a feature nobody asked for. */
      splashRows:((qdUpstand && qdSpRows>1) ? qdSpRows : null),
      splashRails:((qdUpstand && qdSpRails && qdSpRails.some(function(v){return v==='plain';})) ? qdSpRails.slice() : null),
      splashNoPanels:((qdUpstand && qdSpOff.length) ? qdSpOff.map(function(a){return a.slice();}) : null),panelSupplyBy:qdSupplyBy(),share:qdShareURL(),savedName:(function(){var v=qdSavedFlag;qdSavedFlag=null;return v;})(),cat:qdCatalog()};
    /* r191: send NOTHING rather than an explicit null. A design where the two new
       selects were never touched then puts the identical bytes on the wire that r189
       did - which is the property the control test asserts, and the reason a customer
       who ignores the feature cannot be repriced by it. */
    if(_qb.panelSupplyBy==null) delete _qb.panelSupplyBy;
    var _supKey=qdKey(type,W,D,H,tiers,cols,finish,panels+qdKeySfx(),'*',rows);
    if(_supKey!==QD_SUP_KEY){ QD_SUP_KEY=_supKey; QD_SUP_MEM=null; qdSupplyPub(); }
    if(hit && hit.done){ renderFrame(hit.res); qdSupplyNote(supply,hit.res); qdSupplyShadow(_qb,supply); return; }

    if(!hit){
      QD_CACHE[key]={done:false};
      /* r-qd-honest 22 Aug 2026: while the engine is being asked, say so - and never
         paint $0.00 over a price nothing has read yet. On a VPN the secure check can
         take a while; the customer must see progress, not a silent zero. */
      $('qd-price').textContent='\u2014';
      $('qd-price-gst').textContent='';
      var _m=$('qd-msg'); _m.style.color='#64748b'; _m.textContent='Checking prices\u2026 the secure pricing check can take a moment on some connections.';
      var _r=$('qd-retry'); if(_r) _r.hidden=true;
      qdPriceFetch(QD_ENDPOINT,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(_qb)   /* r183 Q2: built above so the shadow quote sends the identical frame */
      })
      .then(function(r){
        /* r152 14 Sep 2026: THIS WAS .then(function(r){return r.json();}) WITH NO STATUS CHECK,
           AND THE .catch BELOW SITS AFTER THE RENDER STEP. So three completely different things
           all printed the same sentence, "Could not reach the frame designer":
             - a real network failure, where nothing arrived;
             - a 429 from the engine telling the customer to slow down (the rate limit still
               applies to alucube-basket; only the Turnstile session was lifted for it);
             - an exception thrown while DRAWING an answer that had arrived perfectly well.
           Patryk photographed the third shape on 14 Sep: the 3D had drawn, the pigeonhole sizes
           had rendered, "Working out your cut list..." was still spinning, and that sentence was
           underneath it. A half-rendered card reported as an unreachable server.
           Every failure now carries a CODE. If it happens again the photo says which one. */
        return r.text().then(function(t){
          var j=null; try{ j=JSON.parse(t); }catch(_pe){}
          if(!r.ok){
            var e1=new Error('aa-http-'+r.status); e1.aaCode='AC-H'+r.status;
            e1.aaSay=(j&&j.errors&&j.errors.length)?String(j.errors[0])
                     :('The frame designer answered with an error ('+r.status+').');
            if(r.status===429) e1.aaSay='Too many price checks in a row. Wait a few seconds, then try again.';
            e1.aaBody=String(t||'').slice(0,300);
            throw e1;
          }
          if(j===null){
            var e2=new Error('aa-body'); e2.aaCode='AC-BODY';
            e2.aaSay='The frame designer sent an answer we could not read.';
            e2.aaBody=String(t||'').slice(0,300);
            throw e2;
          }
          return j;
        });
      })
      .then(function(j){
        /* r152: the DRAWING is fenced off from the TRANSPORT. Anything that throws in here is
           a fault in our own rendering, not a fault in reaching the engine, and it must not be
           reported as one - the price DID arrive. */
        try {
          // Only cache a GOOD answer. Caching a failure used to freeze the page on $0.00 forever.
          if(j && j.ok===true){ QD_CACHE[key]={done:true,res:j}; qdSupplyNote(supply,j); qdSupplyShadow(_qb,supply); }
          else { delete QD_CACHE[key]; }
          if(qdKey($('qd-type').value,+$('qd-w').value||0,+$('qd-d').value||0,+$('qd-h').value||0,+$('qd-tiers').value||3,+($('qd-cols')?$('qd-cols').value:1)||1,qdFinish,panelMode+qdKeySfx(),(panelMode==='none'?'us':panelSupply),+($('qd-rows')?$('qd-rows').value:1)||1)===key) renderFrame(j);
        } catch(_drw){
          var e3=new Error('aa-draw'); e3.aaCode='AC-DRAW';
          e3.aaSay='We worked out your price but could not draw it on the page.';
          e3.aaReal=_drw;
          throw e3;
        }
      })
      .catch(function(_err){
        delete QD_CACHE[key];   /* let it try again */
        var _code=(_err&&_err.aaCode)||'AC-NET';
        var _say=(_err&&_err.aaSay)||'Could not reach the frame designer.';
        $('qd-price').textContent='\u2014';
        $('qd-price-gst').textContent='';
        $('qd-msg').style.color='#b42318';
        /* r152: only add the instruction when the message does not already carry one -
           the 429 wording ends in "try again" and read "...try again. Please try again." */
        $('qd-msg').textContent=_say+(/try again/i.test(_say)?'':' Please try again.')+' ['+_code+']';
        /* r152: this line said "Working out your cut list..." until the page was reloaded - a
           sentence that was no longer true, sitting beside an error. Same fault shape the panel
           supply card had before qdSupplyPending. */
        try{ var _qc=$('qd-cuts'); if(_qc) _qc.textContent=''; }catch(_ec){}
        try{ console.error('[AluCube '+_code+']', (_err&&_err.aaReal)||_err, (_err&&_err.aaBody)||''); }catch(_lg){}
        var _rc=$('qd-retry'); if(_rc) _rc.hidden=false;
        if(qdBuildView){ try{ qdBuildRefused(_say.charAt(0).toLowerCase()+_say.slice(1), true); }catch(_ebv2){} }   /* r-bv-refused */
      });
    }
    $('qd-add').disabled=true;
    $('qd-price').textContent='Pricing…'; $('qd-price-gst').textContent='';
    $('qd-cuts').textContent='Working out your cut list…';
  }

  function syncPanelOptions(){
    var isBox = $('qd-type').value==='box';
    var sel=$('qd-panel');
    ['back','backfront'].forEach(function(v){ var o=sel.querySelector('option[value="'+v+'"]'); if(o) o.disabled=!isBox; });
    if(!isBox && (sel.value==='back'||sel.value==='backfront')){ sel.value='none'; sel.dispatchEvent(new Event('change')); }   // shelf can't take a back panel — reset
  }
  function syncCols(){
    var multi = (+($('qd-cols')?$('qd-cols').value:1)||1) > 1;
    $('qd-cols-note').style.display = multi ? 'block' : 'none';
    qdSyncFolds();
    // Panels now work per-bay with columns — one 6mm sheet per compartment.
  }
  /* Option C: the three measurements in a strip under the drawing. Built in JS and inserted
     after the canvas so it does not depend on the section markup, and it doubles as the legend
     for option D - clicking a cell lights up those rails. */
  /* ---- AXIS GIZMO ------------------------------------------------------------------
     A Fusion-style corner marker: three arrows from one origin, turned through the SAME
     rotation as the frame and projected through the SAME camera, so the arrow marked
     DEPTH always points the way depth actually runs — it cannot drift from the picture.
     It replaces the dimension strip, which mounted itself off `document.querySelector
     ('canvas')` and landed above "Quick start", detached from the drawing it existed to
     explain. Chosen by Patryk 24 Aug from three mock-ups. */
  /* ---- EDGE LABELS ------------------------------------------------------------------
     The first build was a corner triad — three arrows from one hub, turning with the model.
     Patryk, 24 Aug: "I don't like legend. It becomes like a clock." He is right; three arms
     sweeping round a centre point is a clock face. So the labels now sit ON THE FRAME'S OWN
     EDGES: one on a width rail, one on a depth rail, one on a leg. Nothing radiates from a hub,
     nothing sweeps. They are projected through the live camera, so they stay stuck to their edge
     however you spin it, and the tag IS the answer to "which one is depth". */
  /* Turn the storefront's keyword into the same level list the engine will resolve it to, so the
     drawing shows exactly the frame that is being priced. Kept deliberately identical in shape to
     normRailLevels() in the Worker; if the two ever disagree the picture is the one that lies. */
  function railLvArr(){
    if(!railLevels || railLevels==='all') return null;
    var N=(state.type==='box')?2:Math.max(2,+(state.tiers||3));
    var lv = (railLevels==='ends') ? (N===2?[0,1]:[0,N-1])
           : (railLevels==='top')  ? [N-1]
           : (railLevels==='bottom') ? [0] : null;
    if(!lv || lv.length>=N) return null;
    if((state.cols||1)<=1 && (state.rows||1)<=1) return null;   // no interior rails exist to skip
    return lv;
  }
  var GZ={svg:null,rx:null,ry:null,dz:null,px:null,py:null,lf:null,W:null,D:null,H:null,hl:null,cw:0,ch:0};
  /* r108: rebuild3D already knows where the selected opening and the widest run are; it just
     never told anyone. These four are written there and read by gizmo(), so the number on the
     picture comes from the SAME geometry the picture is drawn from and cannot drift from it. */
  var QD_OPEN_AT=null, QD_OPEN_TXT='', QD_OPEN_COL='#0e1a4d';
  /* r109: the CHAIN. Patryk, on the r108 single callout: "still not showing which side of
     opening your working on, maybe consider a line with arrows like in fusion 360? and what
     if the design becomes a little more complex". A dot in the middle of a bay says where
     roughly; a dimension line with a tick at each end says exactly, and a CHAIN of them says
     it for every opening on the axis at once without the picture turning into spaghetti -
     because the whole run sits OUTSIDE the frame on one line, the way a CAD drawing does. */
  var QD_CHAIN=null;
  /* r111, Patryk: "i'll need the part that im adjusting to highlight or let the customer know
     what they are working on, as this gets confusing with so many rows". MEASURED: the box
     being typed in and every other box had the SAME computed border, background and shadow -
     rgba(14,26,77,.267) / white / none. There was no marker at all; the browser's own focus
     ring is overridden by the panel's styling.
     The mark is deliberately the SAME filled pill in the SAME axis colour that the drawing
     puts on the chain, so the panel and the picture are visibly the same object. */
  function qdMarkOpen(){
    try{
      Array.prototype.forEach.call(document.querySelectorAll('.qd-openf'), function(el){
        var was=el.getAttribute('data-bc0');
        if(was!=null){ el.style.borderColor=was; el.style.borderWidth=''; el.style.boxShadow=''; }
        var cell=el.parentNode&&el.parentNode.parentNode;
        var sp=cell&&cell.querySelector('span span');
        if(sp && sp.getAttribute('data-mk')==='1'){
          sp.style.cssText=sp.getAttribute('data-st0')||'';
          sp.removeAttribute('data-mk');
        }
      });
      if(!OPEN_HL) return;
      var k=OPEN_HL.charAt(0), i=OPEN_HL.slice(1);
      var el2=document.querySelector('.qd-openf[data-ax="'+k+'"][data-i="'+i+'"]');
      if(!el2) return;
      var c=AX_COL[k]||'#0e1a4d';
      if(el2.getAttribute('data-bc0')==null) el2.setAttribute('data-bc0', el2.style.borderColor||'');
      el2.style.borderColor=c; el2.style.borderWidth='2px';
      el2.style.boxShadow='0 0 0 3px '+c+'26';
      var cell2=el2.parentNode&&el2.parentNode.parentNode;
      var sp2=cell2&&cell2.querySelector('span span');
      if(sp2){
        if(sp2.getAttribute('data-st0')==null) sp2.setAttribute('data-st0', sp2.style.cssText||'');
        sp2.setAttribute('data-mk','1');
        sp2.style.cssText='background:'+c+';color:#fff;border-radius:9px;padding:1px 8px;font-weight:700;';
      }
    }catch(e){}
  }
  var QD_SPAN_AT=null, QD_SPAN_MM=0, QD_SPAN_SHOW=false;
  /* r115: the two ENDS of the widest run, so it can be drawn as a bar rather than pointed at. */
  var QD_SPAN_A=null, QD_SPAN_B=null;
  var OPEN_HL=null;   // the opening whose input box has focus, e.g. 'w1'
  /* One label per axis, each anchored to the MIDDLE of an edge that actually runs that way, and
     each pushed out in a different direction so they start apart. They are then separated again
     in screen space below, because at some rotations "different directions in the model" still
     land on top of each other on screen. */
  var GZ_AX=[
    {k:'x', name:'WIDTH',  col:'#0e1a4d', get:function(){return state.W;},
     at:function(){return [0, -state.H/2, state.D/2];},   out:[-0.15,-1.15,0.35]},
    {k:'z', name:'DEPTH',  col:'#0e8fb8', get:function(){return state.D;},
     at:function(){return [state.W/2, -state.H/2, 0];},   out:[1.15,-0.25,0]},
    {k:'y', name:'HEIGHT', col:'#5b9bd5', get:function(){return state.H;},
     at:function(){return [-state.W/2, 0, state.D/2];},   out:[-1.15,0.15,0.3],
     /* r219: on 'keep my height' the typed height IS the finished height, wheels in */
     sfx:function(){ return (qdFeet==='castors' && qdCastorFit==='trim') ? ' incl. wheels' : ''; }}
  ];
  function gizmo(){
    try{
      if(!T||!camera||!group||!renderer) return;
      var stage=document.querySelector('.qd-stage'); if(!stage) return;
      var cv=$('qd-canvas'); if(!cv) return;
      /* r62: the host is built lazily on the first frame, so turning the tick off at start-up
         could not hide something that did not exist yet - it appeared anyway. Asked here, every
         frame, so the tick is the only thing that decides. */
      var _dt=$('qd-dimhl');
      var _dimsOn=!(_dt && !_dt.checked);
      /* r108: the W/D/H labels are a tick the customer can turn off. The selected-opening and
         widest-span callouts are not - they appear only while a box has focus or a run is over
         the guide, and they are the answer to a question that was just asked. The tick must not
         take those away, so the host is only hidden when there is nothing at all to show. */
      var _extra=(QD_OPEN_AT!=null)||QD_CHAIN||(QD_SPAN_SHOW&&QD_SPAN_AT!=null)||qdCodesOn||qdConnsOn||qdGuideOn;   /* r228 */   /* r221, r225 */
      if(!_dimsOn && !_extra){ if(GZ.svg&&GZ.svg.parentNode) GZ.svg.parentNode.style.display='none'; return; }
      if(GZ.svg&&GZ.svg.parentNode) GZ.svg.parentNode.style.display='';
      var cw=cv.clientWidth, ch=cv.clientHeight;
      if(!GZ.svg){
        var host=document.createElement('div'); host.className='qd-gizmo'; host.id='qd-gizmo';
        host.innerHTML='<svg role="img" aria-label="Width, depth and height marked on the frame"></svg>';
        stage.appendChild(host); GZ.svg=host.querySelector('svg');
      }
      /* r47: ZOOM WAS MISSING FROM THIS KEY. Scrolling changes `dist` and nothing else, so this
         test passed and the label layer returned without redrawing - the model zoomed and the
         labels sat exactly where they were, pointing at nothing. That is the "legends are stuck"
         Patryk reported, and no amount of clamping or filtering could have fixed it, because the
         code never ran. */
      /* r108: the two new callouts change with cols/tiers/rows and with which box has focus,
         and NONE of those were in this key. Without them the label layer returns early and the
         number sits there stale - exactly the r47 'legends are stuck' failure, one rev later.
         Everything the callouts depend on goes into one string, so it cannot be half-updated. */
      var _r108=(_dimsOn?'1':'0')+'|'+QD_OPEN_TXT+'|'+(QD_OPEN_AT?QD_OPEN_AT.join(','):'')
               +'|'+(QD_SPAN_SHOW?QD_SPAN_MM:'')+'|'+(QD_SPAN_AT?QD_SPAN_AT.join(','):'')
               +'|'+(QD_SPAN_A?QD_SPAN_A.join(','):'')+'|'+(QD_SPAN_B?QD_SPAN_B.join(','):'')
               +'|'+(QD_CHAIN?(QD_CHAIN.ax+QD_CHAIN.i+':'+QD_CHAIN.bays.map(function(B){return B.mm+(B.focus?'*':'')+(B.real?'o':'-');}).join('-')+':'+QD_CHAIN.outer.mm):'')
               +'|'+qdFeet+'|'+qdCastorFit+'|'+(QD_RISE||'')   /* r219: the r47 lesson - anything a label reads goes in the key */
               +'|'+(qdCodesOn?('codes:'+((window.aaLastQuote&&window.aaLastQuote.labels)?window.aaLastQuote.labels.map(function(l){return l.code+(l.kind==='panel'?l.size:l.len);}).join(','):'none')+':'+group.children.length):'')
               +'|'+(qdConnsOn?('conns:'+((window.aaLastQuote&&window.aaLastQuote.joints)?window.aaLastQuote.joints.length:'none')+':'+group.children.length):'')   /* r221, r225 */
               +'|'+(qdGuideOn?('guide:'+qdGuideKey()+':'+(qdPairSel&&qdPairSel.panel?qdPairSel.panel.join(','):'')):'')
               +'|q'+QD_QSER+(qdQuoteFresh()?'F':'S')
               +'|st'+QD_STEP;   /* r240: the step is something the pills read, so it is in the key (the r47 lesson) */   /* r230: fresh-or-stale in the key, so the pills repaint the moment THIS design's quote lands */   /* r228: the r47 lesson again - the pills read the quote's rows and the picked shelf */
      /* r111, Patryk: "if i pan the design it goes off, but if i reclick on it it snaps back".
         PAN WAS NOT IN THIS KEY. Nor was the camera lift. Both move the camera, so both move
         where every label belongs - but neither was tested, so the layer returned early and the
         labels stayed exactly where they were while the frame slid out from under them.
         MEASURED: after one shift-drag the frame occupied x 153-435 and the chain was still
         drawn at x 313-483. Re-clicking a box nulls GZ.rx by hand, which forced the repaint -
         that is the "snaps back".
         This is the r47 fault for the THIRD time (zoom, then cols/rows, now pan). It predates
         the chain: the W/D/H labels have drifted on pan since r46. The lesson is not "add pan":
         it is that ANY value the projection reads must be in this key, and the way to know is
         to list what toPx() depends on - rotX, rotY, dist, panX, panY, camLift - not to think
         of them one at a time after each bug report. */
      if(GZ.rx===rotX&&GZ.ry===rotY&&GZ.dz===dist&&GZ.px===panX&&GZ.py===panY&&GZ.lf===camLift&&GZ.W===state.W&&GZ.D===state.D&&GZ.H===state.H&&GZ.hl===hlAxis&&GZ.cw===cw&&GZ.ch===ch&&GZ.dm===qdDelMode&&GZ.dr===qdDelRail&&GZ.r108===_r108&&GZ.up===qdUpstand) return;
      GZ.rx=rotX; GZ.ry=rotY; GZ.dz=dist; GZ.px=panX; GZ.py=panY; GZ.lf=camLift; GZ.W=state.W; GZ.D=state.D; GZ.H=state.H; GZ.hl=hlAxis; GZ.cw=cw; GZ.ch=ch; GZ.dm=qdDelMode; GZ.dr=qdDelRail; GZ.r108=_r108; GZ.up=qdUpstand;   /* r183: see the note by GZ_UP */
      GZ.svg.setAttribute('viewBox','0 0 '+cw+' '+ch);
      GZ.svg.setAttribute('width',cw); GZ.svg.setAttribute('height',ch);
      /* r239: the svg's CSS box must be the CANVAS's box, not the stage's. On a phone the canvas is shorter
         than the stage, the css rule sized the svg to the stage, and the browser letterboxed the viewBox -
         every pill 23 px below its piece (Patryk 3 Sep: "the labels have shifted?"). Same numbers toPx uses. */
      GZ.svg.style.width=cw+'px'; GZ.svg.style.height=ch+'px'; GZ.svg.setAttribute('preserveAspectRatio','xMinYMin meet');
      var S=1/1000, parts=[];
      function toPx(p){
        var v=new T.Vector3(p[0]*S,p[1]*S,p[2]*S).applyEuler(group.rotation).project(camera);
        return [(v.x*0.5+0.5)*cw, (-v.y*0.5+0.5)*ch, v.z];   // r46: z tells us if the point is behind the camera
      }
      /* r48: how far a label sits off the frame used to be measured in MILLIMETRES - 15% of the
         largest dimension. On a 5350mm frame that is 800mm, which throws the label right off the
         stage, where it clamps into a corner and trails a long leader line back. Three of them
         land in the same corner and the separation pass cannot help. Keep the model-space vector
         for its DIRECTION only, and set the distance in PIXELS, so it behaves the same whether
         the frame is 300mm or 5m. */
      function pxOut(anchor, far, px){
        var dx=far[0]-anchor[0], dy=far[1]-anchor[1];
        var len=Math.sqrt(dx*dx+dy*dy);
        if(!isFinite(len) || len<0.001) return [anchor[0], anchor[1]-px];
        return [anchor[0]+dx/len*px, anchor[1]+dy/len*px];
      }
      var reach=Math.max(state.W,state.D,state.H)*0.15, HP=21, lab=[];
      var PADT=8, PADB=28, PADX=8;   // bottom pad keeps a label clear of the "drag to rotate" hint
      /* r183 Q1: two more labels, and ONLY while a back board is fitted. They go into the
         SAME lab[] as the three size labels so the one separation pass keeps them apart -
         built as their own list they would sit on top of HEIGHT at half the rotations
         (the r46 lesson, learned the hard way, and again at r108).
         qdUpstand IS IN THE CACHE KEY BELOW. It has to be: this layer returns early unless
         something it reads has changed, and that has now caused the same stale-label bug
         three times (r47 zoom, r108 cols/rows, r111 pan). Anything these labels read goes
         in the key, or they freeze pointing at nothing. */
      var GZ_UP=[];
      if(qdUpstand>0){
        var _uz=-state.D/2, _ux=-state.W/2;
        try{ var _gg=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
             if(_gg.zs&&_gg.zs.length) _uz=_gg.zs[0];
             if(_gg.xs&&_gg.xs.length) _ux=_gg.xs[0]; }catch(e){}
        GZ_UP = [
          {k:'up', name:'BACK BOARD', col:'#334155', get:function(){return qdUpstand;},
           at:function(){return [_ux, state.H/2+qdUpstand/2, _uz];}, out:[-1.30,-0.10,0.25]}   /* aimed LEFT and slightly DOWN, never up: pushed up it lands under the
                     Show-on-the-drawing toolbar, which the separation pass knows nothing
                     about. Seen in a screenshot before this line changed. */,
          {k:'ov', name:'OVERALL',    col:'#5b9bd5', get:function(){return (state.H||0)+qdUpstand;},
           at:function(){return [state.W/2, qdUpstand/2, state.D/2];}, out:[1.15,0.9,0.3]}
        ];
      }
      /* r219: 'wheels underneath' - the thing standing in the room is taller than HEIGHT
         says, by the engine's rise. Same shape as the back board's OVERALL label (r183):
         the frame height stays the frame height, and the taller number is said beside it.
         Only when the engine has given the number - never from a local copy. */
      var GZ_FT=[];
      if(qdFeet==='castors' && qdCastorFit==='under' && typeof QD_RISE==='number' && QD_RISE>0){
        GZ_FT=[{k:'ft', name:'ON WHEELS', col:'#0e8fb8', get:function(){return (state.H||0)+QD_RISE;},
                at:function(){return [state.W/2, -QD_RISE/2, state.D/2];}, out:[1.15,-0.9,0.3]}];
      }
      if(_dimsOn) GZ_AX.concat(GZ_UP).concat(GZ_FT).forEach(function(a){
        var p=a.at(), o=a.out;
        var anchor=toPx(p);
        var far=toPx([p[0]+o[0]*reach, p[1]+o[1]*reach, p[2]+o[2]*reach]);
        if(_chainOn && a.k===_chainAx) return;
        var txt=a.name+'  '+(a.get()||0)+'mm'+(a.sfx?a.sfx():'');
        var fp=pxOut(anchor, far, 54);
        lab.push({a:a, anchor:anchor, x:fp[0], y:fp[1], w:txt.length*6.1+16, h:HP, txt:txt, chip:false});
      });
      /* r108: both callouts go into the SAME lab[] as the size labels, so the one separation
         pass below keeps them off each other. Built as their own list they would overlap the
         WIDTH label at half the rotations - the r46 lesson, which was learned by doing it. */
      /* r109 THE CHAIN. Drawn straight into parts[] at a fixed PIXEL offset outside the
         frame, so it behaves the same on a 300mm cube and a 5m shelf (the r48 lesson - a
         millimetre offset throws the label off the stage on a big frame). */
      var _chainOn=false, _chainAx=null;
      if(QD_CHAIN && QD_CHAIN.bays && QD_CHAIN.bays.length){
        var BA=QD_CHAIN.bays.map(function(B){ return toPx(B.a); });
        var BB=QD_CHAIN.bays.map(function(B){ return toPx(B.b); });
        var OA0=toPx(QD_CHAIN.outer.a), OB0=toPx(QD_CHAIN.outer.b);
        var CP=BA.concat(BB); CP.push(OA0); CP.push(OB0);
        var _behind=false, _ci;
        for(_ci=0;_ci<CP.length;_ci++) if(CP[_ci][2]>1) _behind=true;
        var _rdx=OB0[0]-OA0[0], _rdy=OB0[1]-OA0[1];
        var _rlen=Math.sqrt(_rdx*_rdx+_rdy*_rdy);
        /* A run that has collapsed to almost nothing on screen (edge pointing at the camera)
           cannot carry arrows or numbers. Refuse it rather than draw a pile of chips on one
           spot - a dimension you cannot read is worse than none. */
        if(!_behind && _rlen>40){
          var _ux=_rdx/_rlen, _uy=_rdy/_rlen, _nx=-_uy, _ny=_ux;
          /* push the chain AWAY from the middle of the frame, whichever way that is */
          var _mid=toPx([0,state.H/2,0]);
          var _c0x=(OA0[0]+OB0[0])/2, _c0y=(OA0[1]+OB0[1])/2;
          if((_c0x-_mid[0])*_nx+(_c0y-_mid[1])*_ny < 0){ _nx=-_nx; _ny=-_ny; }
          /* At 26/52 the bay chip and the OVERALL chip sat 26px apart and touched - and
             neither can be moved aside, because both are pinned to their own dimension line.
             The gap has to be right at build time, not repaired by the collision pass. */
          var O1=30, O2=68, col=QD_CHAIN.col;
          var MG=4;
          var offs=function(p,d,sx,sy){ return [p[0]+sx*d, p[1]+sy*d]; };
          var inside=function(p){ return p[0]>=MG && p[0]<=cw-MG && p[1]>=MG && p[1]<=ch-MG; };
          /* r111, Patryk: "if i zoom in too much it disapeers". The r110 fit test was
             ALL OR NOTHING - one endpoint off the stage and the whole chain went, which on a
             zoomed-in frame is every time. It is the right instinct (never draw half a
             dimension) applied at the wrong grain. Judge EACH bay on its own: a bay whose
             two ends are both on the stage is a complete, honest measurement whether or not
             its neighbours are. Zoomed in you now keep the bays you can see. */
          var fitCount=function(sx,sy){
            var n=0, k;
            for(k=0;k<BA.length;k++)
              if(inside(offs(BA[k],O1,sx,sy)) && inside(offs(BB[k],O1,sx,sy))) n++;
            return n;
          };
          var nPos=fitCount(_nx,_ny), nNeg=fitCount(-_nx,-_ny);
          if(nNeg>nPos){ _nx=-_nx; _ny=-_ny; }
          var off=function(p,d){ return [p[0]+_nx*d, p[1]+_ny*d]; };
          var seg=function(a,b,c2,w2){ return '<line x1="'+a[0].toFixed(1)+'" y1="'+a[1].toFixed(1)+'" x2="'+b[0].toFixed(1)+'" y2="'+b[1].toFixed(1)+'" stroke="'+c2+'" stroke-width="'+w2+'"/>'; };
          /* arrowheads drawn as explicit triangles, not SVG markers: markers need a <defs>
             with a unique id and this layer is rebuilt by innerHTML every frame. */
          var head=function(p,sx,c2){ var hx=_ux*sx, hy=_uy*sx;
            var bx=p[0]+hx*6.5, by=p[1]+hy*6.5;
            return '<polygon points="'+p[0].toFixed(1)+','+p[1].toFixed(1)+' '
                 + (bx+_nx*2.6).toFixed(1)+','+(by+_ny*2.6).toFixed(1)+' '
                 + (bx-_nx*2.6).toFixed(1)+','+(by-_ny*2.6).toFixed(1)+'" fill="'+c2+'"/>'; };
          /* the overall bar is its own decision: on a zoomed-in frame its two outside corners
             are usually off the stage even when several bays are perfectly visible. */
          var OA=off(OA0,O2), OB=off(OB0,O2);
          var overOK = inside(OA) && inside(OB);
          var TICK = overOK ? (O2+7) : (O1+7);
          var chips=[], drawn=0, ticks=[];
          for(_ci=0;_ci<BA.length;_ci++){
            var A2=off(BA[_ci],O1), B2=off(BB[_ci],O1);
            if(!inside(A2) || !inside(B2)) continue;
            drawn++;
            ticks.push(BA[_ci]); ticks.push(BB[_ci]);
            parts.push(seg(A2,B2,col,'1.3'));
            parts.push(head(A2,1,col)); parts.push(head(B2,-1,col));
            /* r110: the one being edited says WHAT IT IS MEASURING, in a word. Nobody should
               have to work out from the picture whether a number is the hole or the pitch.
               r112: and the word has to be TRUE. Where a support has been taken out, the space
               is not the opening the box describes, so it says what it really is instead. */
            var _B=QD_CHAIN.bays[_ci], _isF=!!_B.focus;
            var _word = QD_CHAIN.gap ? 'gap' : (_B.real ? 'opening' : 'to next support');
            var t2 = _isF ? ((_B.ord? _B.ord+'  ':'')+_B.mm+'mm '+_word) : String(_B.mm);
            chips.push({x:(A2[0]+B2[0])/2, y:(A2[1]+B2[1])/2, w:t2.length*6.1+14, t:t2, on:_isF});
          }
          if(drawn){
            if(overOK){ ticks.push(OA0); ticks.push(OB0); }
            /* an extension line off every face that carried a dimension */
            for(_ci=0;_ci<ticks.length;_ci++){
              parts.push(seg(ticks[_ci], off(ticks[_ci], TICK), col, '0.9'));
            }
            /* r112: a divider that is there at SOME levels and not others gets a broken tick.
               It is a real thing on the frame, so it is not silently dropped; it is not a
               division you could quote a size against either, so it is not drawn as one. */
            if(QD_CHAIN.ticks) QD_CHAIN.ticks.forEach(function(TK){
              if(TK.kind!=='some') return;
              var tp=toPx(TK.p); if(tp[2]>1) return;
              var t1=off(tp,O1-9), t2b=off(tp,TICK);
              if(!inside(t1)||!inside(t2b)) return;
              parts.push('<line x1="'+t1[0].toFixed(1)+'" y1="'+t1[1].toFixed(1)+'" x2="'+t2b[0].toFixed(1)+'" y2="'+t2b[1].toFixed(1)+'" stroke="'+col+'" stroke-width="1" stroke-dasharray="3 3" opacity="0.75"/>');
            });
            /* WHEN IT GETS COMPLEX. Not all-or-nothing: the first build dropped every number
               the moment ONE pair was tight, so a four-bay frame with room for three numbers
               showed one. Reserve the one being edited, then keep every other number that still
               clears everything already kept. Numbers thin out as the frame gets busier instead
               of vanishing, and the arrows always show every division either way. */
            var kept=[], _kj, _clash;
            for(_ci=0;_ci<chips.length;_ci++) if(chips[_ci].on) kept.push(chips[_ci]);
            for(_ci=0;_ci<chips.length;_ci++){
              if(chips[_ci].on) continue;
              _clash=false;
              for(_kj=0;_kj<kept.length;_kj++){
                if(Math.abs(chips[_ci].x-kept[_kj].x) < (chips[_ci].w+kept[_kj].w)/2 + 5 &&
                   Math.abs(chips[_ci].y-kept[_kj].y) < HP + 3){ _clash=true; break; }
              }
              if(!_clash) kept.push(chips[_ci]);
            }
            kept.forEach(function(C){
              lab.push({a:{col:col,k:'__chain'}, anchor:[C.x,C.y], x:C.x, y:C.y,
                        w:C.w, h:HP, txt:C.t, chip:false, on:C.on, plain:true, fixed:true});
            });
            if(overOK){
              parts.push(seg(OA,OB,'#64748b','1.1'));
              parts.push(head(OA,1,'#64748b')); parts.push(head(OB,-1,'#64748b'));
              var ot='OVERALL  '+QD_CHAIN.outer.mm+'mm outside';
              lab.push({a:{col:'#64748b',k:'__chainall'}, anchor:[(OA[0]+OB[0])/2,(OA[1]+OB[1])/2],
                        x:(OA[0]+OB[0])/2, y:(OA[1]+OB[1])/2, w:ot.length*6.1+14, h:HP,
                        txt:ot, chip:false, on:false, plain:true, fixed:true});
            }
            _chainOn=true; _chainAx=(QD_CHAIN.ax==='w'?'x':(QD_CHAIN.ax==='d'?'z':'y'));
          }
        }
      }
      var _lift=Math.max(state.H,300)*0.5;
      /* the chain's filled chip IS the callout, and its OVERALL bar IS the size label for that
         axis - so neither is drawn twice. */
      if(QD_OPEN_AT && !_chainOn){
        var _oa=toPx(QD_OPEN_AT);
        var _ofp=pxOut(_oa, toPx([QD_OPEN_AT[0], QD_OPEN_AT[1]+_lift, QD_OPEN_AT[2]]), 46);
        lab.push({a:{col:QD_OPEN_COL,k:'__open'}, anchor:_oa, x:_ofp[0], y:_ofp[1],
                  w:QD_OPEN_TXT.length*6.1+16, h:HP, txt:QD_OPEN_TXT, chip:false, on:true});
      }
      /* r115, Patryk: "it is widest span, but there is a support leg near it, does that make
         sense?" The NUMBER was right - three interior uprights on that depth line are gone
         outright (the engine reports legFloat 0, so nothing is even left hanging), and
         1305+1305+1305+1308 plus the three joints it reclaims is 5299. What was wrong is that
         the label pointed into a FOREST of amber: 24 of his 36 runs are over the guide and all
         of them were the same colour, so the dot read as "no support HERE" while unrelated legs
         stood beside it.
         THE FIRST FIX WAS A DARKER AMBER ON THE TUBE ITSELF, AND IT WAS THROWN AWAY. A Lambert
         material is lit, so one amber already spreads across a range of shades - the r114
         CONTROL scored 512 pixels of the supposedly-new 'darker' colour before anything had
         changed. If a pixel test cannot separate two ambers on a 3px tube, an eye will not
         either. Drawn in the LABEL LAYER instead: flat 2D, exact colour, immune to lighting and
         to how thin the tube is, as a bar along the run in the chip's own colour with the chip
         sitting on it. The number and the run it measures become one object. */
      if(QD_SPAN_SHOW && QD_SPAN_A && QD_SPAN_B){
        var _sA=toPx(QD_SPAN_A), _sB=toPx(QD_SPAN_B);
        if(_sA[2]<=1 && _sB[2]<=1){
          var _sdx=_sB[0]-_sA[0], _sdy=_sB[1]-_sA[1];
          var _slen=Math.sqrt(_sdx*_sdx+_sdy*_sdy);
          /* a run pointing at the camera collapses to a dot; a bar drawn on it would be a
             smudge claiming to be 5 metres. Refuse it, exactly as the chain does. */
          if(_slen>18){
            var _snx=-_sdy/_slen, _sny=_sdx/_slen;
            parts.push('<line x1="'+_sA[0].toFixed(1)+'" y1="'+_sA[1].toFixed(1)+'" x2="'+_sB[0].toFixed(1)+'" y2="'+_sB[1].toFixed(1)+'" stroke="#b45309" stroke-width="4.5" stroke-linecap="round" opacity="0.95"/>');
            [_sA,_sB].forEach(function(P){
              parts.push('<line x1="'+(P[0]+_snx*6).toFixed(1)+'" y1="'+(P[1]+_sny*6).toFixed(1)+'" x2="'+(P[0]-_snx*6).toFixed(1)+'" y2="'+(P[1]-_sny*6).toFixed(1)+'" stroke="#b45309" stroke-width="2.4" stroke-linecap="round"/>');
            });
          }
        }
      }
      if(QD_SPAN_SHOW && QD_SPAN_AT){
        var _stx='WIDEST SPAN  '+QD_SPAN_MM+'mm';
        var _sa=toPx(QD_SPAN_AT);
        var _sfp=pxOut(_sa, toPx([QD_SPAN_AT[0], QD_SPAN_AT[1]+_lift, QD_SPAN_AT[2]]), 46);
        lab.push({a:{col:'#b45309',k:'__span'}, anchor:_sa, x:_sfp[0], y:_sfp[1],
                  w:_stx.length*6.1+16, h:HP, txt:_stx, chip:false, on:true});
      }
      /* The opening ID chips go into the SAME list, so ONE collision pass separates labels and
         chips together. Kept apart, the first build buried W3 behind the depth label. */
      /* r57: THE CHIPS ARE GONE. Nine of them plus three size labels turned the drawing into a
         pile of stickers - Patryk: "i really dont like how all those w1,w2,w3 and the rest look,
         unprofessional". They existed to tie a box to a bay; putting focus on a box and lighting
         the bay itself up does that better and leaves the picture clean. */
      /* SEPARATE THEM. Fixed model-space offsets are not enough — at some rotations two labels
         still land on the same spot (the first build put WIDTH straight through DEPTH). Push any
         overlapping pair apart vertically, then clamp back inside the stage. */
      var clamp=function(L){
        L.x=Math.max(L.w/2+PADX, Math.min(cw-L.w/2-PADX, L.x));
        L.y=Math.max(L.h/2+PADT, Math.min(ch-L.h/2-PADB, L.y));
      };
      /* r46: a label whose anchor has left the stage - zoomed in, or rotated behind the camera -
         used to be CLAMPED back inside, so on zoom every label piled up along the edges and sat
         there pointing at nothing. Drop those instead, and clamp only the ones still attached to
         something you can see. */
      lab=lab.filter(function(L){
        var a=L.anchor;
        if(a[2]>1) return false;                                  // behind the camera
        return a[0]>-40 && a[0]<cw+40 && a[1]>-40 && a[1]<ch+40;  // anchor still on the stage
      });
      lab.forEach(function(L){ if(!L.fixed) clamp(L); });
      for(var pass=0; pass<14; pass++){
        var moved=false;
        for(var i=0;i<lab.length;i++) for(var j=i+1;j<lab.length;j++){
          var A=lab[i], B=lab[j];
          var needX=(A.w+B.w)/2 + 6, needY=(A.h+B.h)/2 + 5;
          var dx=B.x-A.x, dy=B.y-A.y;
          if(Math.abs(dx) < needX && Math.abs(dy) < needY){
            /* r109: a chain chip sits ON its own dimension line. Moving it would point the
               number at the wrong bay, which is the exact confusion this was built to end.
               Fixed labels never move; the free one gets out of the way instead. */
            if(A.fixed && B.fixed) continue;
            /* push apart along whichever axis needs the least travel, so a label is not driven
               into the floor of the stage just because two happened to line up. */
            var gapX=needX-Math.abs(dx), gapY=needY-Math.abs(dy);
            if(gapY<=gapX){ var s2=(dy>=0?1:-1)*(gapY/2+0.5);
                            if(A.fixed){ B.y+=s2*2; } else if(B.fixed){ A.y-=s2*2; } else { A.y-=s2; B.y+=s2; } }
            else          { var s3=(dx>=0?1:-1)*(gapX/2+0.5);
                            if(A.fixed){ B.x+=s3*2; } else if(B.fixed){ A.x-=s3*2; } else { A.x-=s3; B.x+=s3; } }
            if(!A.fixed) clamp(A); if(!B.fixed) clamp(B); moved=true;
          }
        }
        if(!moved) break;
      }
      lab.forEach(function(L){
        var on = (L.on!=null) ? L.on : (L.chip ? (OPEN_HL===L.key) : (hlAxis===L.a.k));
        var c=L.a.col, fs=L.chip?10:11;
        if(!L.plain){
          parts.push('<line x1="'+L.anchor[0].toFixed(1)+'" y1="'+L.anchor[1].toFixed(1)+'" x2="'+L.x.toFixed(1)+'" y2="'+L.y.toFixed(1)+'" stroke="'+c+'" stroke-width="'+(on?1.8:1.1)+'" opacity="'+(on?1:0.45)+'"/>');
          parts.push('<circle cx="'+L.anchor[0].toFixed(1)+'" cy="'+L.anchor[1].toFixed(1)+'" r="'+(on?3.4:2.4)+'" fill="'+c+'"/>');
        }
        parts.push('<rect x="'+(L.x-L.w/2).toFixed(1)+'" y="'+(L.y-L.h/2).toFixed(1)+'" width="'+L.w.toFixed(1)+'" height="'+L.h+'" rx="'+(L.h/2)+'" fill="'+(on?c:'#ffffff')+'" fill-opacity="'+(on?1:0.95)+'" stroke="'+c+'" stroke-width="'+(on?0:1.1)+'"/>');
        parts.push('<text x="'+L.x.toFixed(1)+'" y="'+(L.y+fs/2-0.7).toFixed(1)+'" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="'+fs+'" font-weight="700" letter-spacing="0.3" fill="'+(on?'#ffffff':c)+'">'+L.txt+'</text>');
      });
      /* r221: one pill per drawn tube, at its centre, no separation pass - a code has to sit
         ON its piece or it says nothing. Behind-camera points are skipped (z>1). */
      if((qdCodesOn||qdConnsOn) && qdQuoteNow()){   /* r230: no quote for THIS design = no pills, never another frame's */
        for(var _ci=0;_ci<group.children.length;_ci++){
          var _pc=group.children[_ci].userData&&group.children[_ci].userData.piece; if(!_pc) continue;
          if(qdBuildView && QD_STEP>=0 && group.children[_ci].userData.qstep!==QD_STEP) continue;   /* r240: this step's pieces only */
          var _isJ=(_pc.kind==='joint');
          if(_isJ && !qdConnsOn) continue;
          if(!_isJ && !qdCodesOn) continue;
          var _pp=toPx([_pc.cx,_pc.cy,_pc.cz]); if(_pp[2]>1) continue;
          var _code, _fill='#ea580c', _fs=10.5, _hh=16;
          if(_isJ){ var _jt=qdJointType(_pc.xi,_pc.yi,_pc.zi); _code=_jt?(QD_CONN_TAG[_jt]||'?'):'?'; _fill='#0e1a4d'; _fs=8.5; _hh=13; }
          else if(_pc.kind==='panel'){ var _pl=qdPanelLabel(_pc.w,_pc.h); _code=_pl?_pl.code:'?'; _fill='#0f766e'; }
          else _code=qdCodeFor(_pc.ax,_pc.len,_pc.sp)||'?';
          var _cw=_code.length*(_isJ?5.6:7)+10;
          parts.push('<rect x="'+(_pp[0]-_cw/2).toFixed(1)+'" y="'+(_pp[1]-_hh/2).toFixed(1)+'" width="'+_cw+'" height="'+_hh+'" rx="'+(_hh/2)+'" fill="'+_fill+'" stroke="#ffffff" stroke-width="1.2"/>');
          parts.push('<text x="'+_pp[0].toFixed(1)+'" y="'+(_pp[1]+(_isJ?3.1:3.8)).toFixed(1)+'" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="'+_fs+'" font-weight="700" fill="#ffffff">'+_code+'</text>');
        }
      }
      /* r228: LOAD GUIDE PILLS. One per shelf / top panel (userData.panel = [li,bk,dj]; back
         walls and the back board are vertical and carry nothing, so they get none). The text is
         the engine's row for that bay - never computed here. Staff only by construction. */
      if(qdGuideOn && qdQuoteNow()){   /* r230: same guard - the kg pills never come from another frame */
        var _lg=qdQuoteNow().loadGuide||null;
        for(var _gi=0;_gi<group.children.length;_gi++){
          var _gm=group.children[_gi], _gp=_gm.userData&&_gm.userData.piece;
          if(!_gp||_gp.kind!=='panel'||!_gm.userData.panel) continue;
          var _gpx=toPx([_gp.cx,_gp.cy,_gp.cz]); if(_gpx[2]>1) continue;
          var _gr=qdGuideRowFor(_gp,_lg), _gt=_gr?qdGuidePillText(_gr,_lg):(_lg?'?':'needs 1.38.0');
          var _gsel=!!(qdPairSel&&qdPairSel.panel&&qdPairSel.panel[0]===_gm.userData.panel[0]&&qdPairSel.panel[1]===_gm.userData.panel[1]&&qdPairSel.panel[2]===_gm.userData.panel[2]);
          var _gfs=_gsel?12:10.5, _gh=_gsel?21:17, _gw=_gt.length*(_gsel?7.2:6.4)+16;
          parts.push('<rect x="'+(_gpx[0]-_gw/2).toFixed(1)+'" y="'+(_gpx[1]-_gh/2).toFixed(1)+'" width="'+_gw.toFixed(1)+'" height="'+_gh+'" rx="'+(_gh/2)+'" fill="#ea580c" stroke="#ffffff" stroke-width="'+(_gsel?2.4:1.2)+'"/>');
          parts.push('<text x="'+_gpx[0].toFixed(1)+'" y="'+(_gpx[1]+(_gsel?4.2:3.8)).toFixed(1)+'" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="'+_gfs+'" font-weight="700" fill="#ffffff">'+_gt+'</text>');
        }
      }
      GZ.svg.innerHTML=parts.join('');
      /* r110 SHOW ME. Patryk asked for auto zoom-and-rotate to the best view. I did not do it
         automatically: a camera that swings on its own every time you tab between boxes is the
         same complaint as "the camera jumping", which was a real bug once. This offers the move
         instead, and ONLY when the measurement genuinely cannot be drawn where you are - the
         run is edge-on to the camera, or it will not fit inside the stage. Nothing moves
         unless it is pressed. */
      try{
        var _sb=$('qd-showme');
        if(!_sb){
          _sb=document.createElement('button');
          _sb.type='button'; _sb.id='qd-showme';
          _sb.style.cssText='position:absolute;left:12px;top:86px;z-index:6;pointer-events:auto;'
            +'background:#0e1a4d;color:#fff;border:0;border-radius:6px;padding:6px 11px;'
            +'font:inherit;font-size:12px;font-weight:600;cursor:pointer;'
            +'box-shadow:0 1px 3px rgba(0,0,0,.2);display:none';
          _sb.addEventListener('click', function(ev){
            ev.preventDefault();
            if(!QD_CHAIN) return;
            setView(QD_CHAIN.ax==='d' ? 'right' : 'front');
          });
          stage.appendChild(_sb);
        }
        var _want = !!(QD_CHAIN && !_chainOn);
        _sb.textContent = _want ? ('Show me this measurement') : '';
        _sb.style.display = _want ? 'block' : 'none';
      }catch(_e2){}
    }catch(e){}
  }
  /* RETIRED 24 Aug. The strip is replaced by the corner axis gizmo above. Kept as a
     no-op that removes any strip a cached page may have already inserted, so no call
     site needs to change and nothing is left orphaned on screen. */
  function dimStrip(){ try{ var h=document.getElementById('qd-dimstrip'); if(h&&h.parentNode) h.parentNode.removeChild(h); }catch(e){} }
  (function(){
    var map={'qd-w':'x','qd-d':'z','qd-h':'y'};
    Object.keys(map).forEach(function(id){
      var el=document.getElementById(id); if(!el) return;
      el.addEventListener('focus', function(){ hlAxis=map[id]; rebuild3D(); dimStrip(); });
      el.addEventListener('blur',  function(){ hlAxis=null;    rebuild3D(); dimStrip(); });
    });
  })();

  function syncRows(){
    var el=$('qd-rows'); if(!el) return;
    var multi=(+el.value||1)>1, n=$('qd-rows-note');
    if(n) n.style.display = multi ? 'block' : 'none';
  }
  ['qd-type','qd-w','qd-d','qd-h','qd-tiers','qd-cols','qd-rows'].forEach(function(id){var el=$(id);if(el){el.addEventListener('input',recalc);el.addEventListener('change',recalc);}});
  /* r57: the overall size is the master now, so when it changes the openings inside have to be
     re-fitted to the new size rather than the other way round. */
  ['qd-w','qd-d','qd-h'].forEach(function(id){
    var el=$(id); if(!el) return;
    var refit=function(){ var on=$('qd-open-on'); if(on&&on.checked) readOpenFields(true); };
    el.addEventListener('input',refit); el.addEventListener('change',refit);
  });
  ['qd-type','qd-tiers','qd-cols','qd-rows'].forEach(function(id){var el=$(id);if(el)el.addEventListener('change',function(){ if(qdRmGuard) return;   /* r50: removeSupport() drives this control deliberately and has already written the merged openings. Wiping them here would throw away the sizes the customer just asked us to keep - which is the whole point of the button. */ /* r120: MEASURED 28 Aug - this listener silently discards work the customer has already
     done. On the 5350 shelf: 12 removed uprights, 12 removed rails and the hand-set opening
     sizes all vanish the moment "Vertical supports (columns)" or "Supports along the depth"
     moves, and NOTHING on the page says so - the "Also applied" line just stops mentioning
     them. Undo restores all of it (measured), so the fault is the silence, not the clearing:
     the indices really are invalid once the grid renumbers. So: say what went, and point at
     the button that brings it back. Counted BEFORE the wipe, printed after. */
  var qdLost=(function(){ var n=[];
    try{
      var np=(qdNoPosts&&qdNoPosts.length)||0, nr=(qdNoRails&&qdNoRails.length)||0,
          nl=(qdNoPanels&&qdNoPanels.length)||0, hs=(openShares!=null);
      if(np) n.push(np+(np===1?' removed upright':' removed uprights'));
      if(nr) n.push(nr+(nr===1?' removed rail':' removed rails'));
      if(nl) n.push(nl+(nl===1?' removed panel':' removed panels'));
      if(hs) n.push('the opening sizes you set by hand');
    }catch(e){}
    return n; })();
  openShares=null; qdNoPosts=[]; qdNoRails=[]; qdNoPanels=[]; qdSelPosts=[]; qdSelRails=[]; qdSelPanels=[]; clearPins(); syncPostUI();
  postMsg(qdLost.length
    ? ('Changing this rebuilt the frame, so '+qdLost.join(', ').replace(/, ([^,]*)$/,' and $1')+' could not be carried over. Press <strong>Undo</strong> to put them back.')
    : '');  /* r52/r53: a real shape change invalidates every snapshot AND every crossing index */ var on=$('qd-open-on'); if(on) on.checked=false; openFields(); syncFixNeed(); });});
  $('qd-type').addEventListener('change',syncPanelOptions);
  (function(){ var b=$('qd-post-reset'); if(b) b.addEventListener('click', function(ev){ ev.preventDefault(); restoreAllPosts(); }); })();
  (function(){ var b=$('qd-del-go'); if(b) b.addEventListener('click', function(ev){ ev.preventDefault(); commitDelete(); }); })();
  function syncDelHelp(){
    var w=$('qd-del-wrap'), w2=$('qd-delr-wrap'), w3=$('qd-delp-wrap'), hp=$('qd-del-help');
    var paint=function(el,on){ if(!el) return; el.style.borderColor=on?'#b42318':'#cbd5e1'; el.style.background=on?'#fef2f2':'#fff'; el.style.color=on?'#b42318':'#0e1a4d'; };
    qdSelPosts=[]; qdSelRails=[]; qdSelPanels=[];   // r56: leaving a mode drops anything picked but not deleted
    qdPairClear();   /* r197: an edit mode owns the tap - the pairing steps out of its way */
    qdAddPending=null; qdSyncAddUI();                 // r79: and withdraws a pending add-support offer
    paint(w,qdDelMode); paint(w2,qdDelRail); paint(w3,qdDelPanel);
    qdSyncFolds();
    var aw=$('qd-add-open-wrap'); if(aw) aw.style.display = qdDelMode ? 'block' : 'none';
    var bw2=$('qd-bar-open-wrap'); if(bw2) bw2.style.display = qdDelRail ? 'block' : 'none';
    qdBarPending=null; qdSyncBarUI();
    /* r93 MOBILE FULL-SCREEN EDIT: on a narrow screen, any edit mode hands the display to the
       frame. The stage goes fixed (CSS class on body), the chip bar floats, and the renderer
       is re-measured. Leaving the last mode (or Done) restores the page exactly where it was. */
    try{
      var _fsWant=(qdDelMode||qdDelRail||qdDelPanel) && window.innerWidth<=768;
      var _fsHad=document.body.classList.contains('qd-fsmode');
      if(_fsWant!==_fsHad){
        document.body.classList.toggle('qd-fsmode',_fsWant);
        if(!_fsWant) window.scrollTo(0, qdFsScroll||0); else qdFsScroll=window.scrollY;
        setTimeout(function(){ try{ resize(); rebuild3D(); }catch(e){} }, 60);
      }
      var _c1=$('qd-fs-up'),_c2=$('qd-fs-rail'),_c3=$('qd-fs-pan');
      if(_c1) _c1.classList.toggle('qd-fson', qdDelMode);
      if(_c2) _c2.classList.toggle('qd-fson', qdDelRail);
      if(_c3) _c3.classList.toggle('qd-fson', qdDelPanel);
    }catch(eFS){}
    syncPostUI();
    if(hp && qdDelPanel && ($('qd-type')||{}).value==='box' && (panelMode==='none'||panelMode==='custom')){
      /* r170: on a box frame the faces themselves are the controls. */
      hp.innerHTML='<strong>Tap a face</strong> of the frame to panel it \u2014 the lipped rails that hold the panel come with it automatically. Tap a panelled face again to take the panel off. Spin the frame to reach the other faces.';
      GZ.rx=null; rebuild3D(); postMsg(''); return;
    }
    if(hp && qdDelPanel && panelMode!=='top' && panelMode!=='all'){
      hp.innerHTML='Panels can be removed one at a time on <strong>shelf and top</strong> panels. This frame\u2019s Panels setting is different \u2014 change the Panels option instead.';
      GZ.rx=null; rebuild3D(); postMsg(''); return;
    }
    if(hp) hp.innerHTML = (qdDelMode||qdDelRail||qdDelPanel)
      ? ('The pieces you can pick turn <strong style="color:#0284c7">blue</strong>. <strong>Tap one</strong> and it turns <strong style="color:#f97316">orange</strong> &mdash; tap it again to change your mind. Nothing leaves the frame until you press <strong>Delete</strong>. Anything already gone shows as a faint outline; tap that to put it back.'
         + (qdDelMode ? ' A corner upright cannot lose its bottom piece \u2014 higher pieces can go. Want another support? Press <strong>+ Add a support</strong> below, or tap an empty spot along the frame.' : '')
         + (qdDelPanel ? ' The lipped rails stay when a panel goes, so a panel can be dropped in later.' : ''))
      : '';   /* r168: idle default blanked - on the canvas it would sit over the drawing; the chips carry the affordance */
    postMsg('');
    GZ.rx=null;
    rebuild3D();
  }
  (function(){
    var c2=$('qd-delr-on');
    if(c2) c2.addEventListener('change', function(){
      qdDelRail=!!c2.checked;
      if(qdDelRail){ qdDelMode=false; qdDelPanel=false; var o=$('qd-del-on'); if(o) o.checked=false; var o3=$('qd-delp-on'); if(o3) o3.checked=false; }
      syncDelHelp();
    });
  })();
  (function(){
    var c=$('qd-del-on'); if(!c) return;
    c.addEventListener('change', function(){
      qdDelMode=!!c.checked;
      if(qdDelMode){ qdDelRail=false; qdDelPanel=false; var o2=$('qd-delr-on'); if(o2) o2.checked=false; var o3=$('qd-delp-on'); if(o3) o3.checked=false; }
      syncDelHelp();
    });
  })();
  (function(){
    var c3=$('qd-delp-on'); if(!c3) return;
    c3.addEventListener('change', function(){
      qdDelPanel=!!c3.checked;
      if(qdDelPanel){ qdDelMode=false; qdDelRail=false; var o=$('qd-del-on'); if(o) o.checked=false; var o2=$('qd-delr-on'); if(o2) o2.checked=false; }
      syncDelHelp();
    });
  })();
  /* r57: one padlock unlocks ALL three - a customer who wants to change the size wants to
     change the size, not fight three separate switches. */
  ['qd-w','qd-d','qd-h'].forEach(function(id){
    var b=$(id+'-lock');
    if(b) b.addEventListener('click', function(ev){
      ev.preventDefault();
      qdDimLock=!qdDimLock;
      lockSizes(true);
      var n=$('qd-open-note');
      if(n) n.innerHTML = qdDimLock
        ? 'The outside sizes are locked. Change an opening and the other openings on that same side take up the difference, so the overall size stays exactly where you set it.'
        : '<strong>Sizes unlocked.</strong> You can type over the outside sizes now. The overall size still decides the openings, not the other way round: change a width, depth or height and the openings inside it are re-fitted to suit. Tap the padlock again to lock them.';
    });
  });
  $('qd-cols').addEventListener('change',syncCols);
  (function(){ var r=$('qd-rows'); if(r) r.addEventListener('change',syncRows); })();
  syncPanelOptions(); syncCols(); syncRows(); updatePanelNote();
  $('qd-finish').addEventListener('change',function(){ qdFinish=this.value; recalc(); });
  /* r61/r62: say which part is being shown. Teal lip and violet angle are DIFFERENT PRODUCTS and
     only one of them is ever in the box. r62: this lived inline in the panel sync, so changing
     "How the panels are held" repainted the frame but left the key still saying "lipped rails".
     Its own function now, called from both places. */
  function syncFixKey(){
    try{
      var lw=$('qd-liphl-wrap'); if(!lw) return;
      var isA=(panelFix==='angle'), c=isA?'#7c3aed':'#059669';   // r96: emerald, matching lipMat
      var sw=lw.querySelector('span'), inp=lw.querySelector('input');
      if(sw) sw.style.background=c;
      if(inp) inp.style.accentColor=c;
      var last=lw.lastChild;
      if(last && last.nodeType===3) last.nodeValue = isA
        ? 'Show angle ledges \u2014 we supply and cut them, you screw them on'
        : 'Highlight the lipped rails (display only)';
    }catch(e){}
  }
  /* r67/r68b: the Rail/tube type cards are a VISUAL GUIDE only - the highlight mirrors the
     Panels choice (the lip follows the panels), and nothing here changes the frame. */
  function qdSyncRailType(){
    try{
      var std=$('qd-rt-std'), lip=$('qd-rt-lip'); if(!std||!lip) return;
      var lipOn = panelMode!=='none';
      var paint=function(el,on){ el.style.borderColor=on?'#0e1a4d':'#cbd5e1'; el.style.background=on?'#eef2ff':'#fff'; };
      paint(std,!lipOn); paint(lip,lipOn);
      var now=$('qd-rail-now'); if(now) now.textContent = lipOn ? 'Lipped rail \u2014 \u201cOne Leg\u201d' : 'Standard square tube';
      /* r95 Q1: name the way out. Saying the Panels choice picks the profile is no help to
         someone who wants plain tube and cannot see which setting gives it to them. */
      var how=$('qd-rail-how'); if(how) how.textContent = lipOn ? '(picked by your Panels choice \u2014 \u201cNo panels\u201d gives plain square tube)' : '(no panels \u2014 frame only)';
    }catch(e){}
  }
  /* r73: the sticky bar. A MutationObserver MIRRORS #qd-price (same element the quote
     writes, so the bar can never show a different number), an IntersectionObserver shows
     the bar only while that price is off screen, and the button scrolls to the summary.
     Everything is wrapped - a browser without observers just never shows the bar. */
  (function(){
    try{
      var bar=$('qd-stickybar'), sp=$('qd-sticky-price'), price=$('qd-price'), go=$('qd-sticky-go');
      if(!bar||!sp||!price||!go) return;
      var priced=false, offscreen=false, errored=false;
      function paint(){ bar.style.display=((priced||errored)&&offscreen)?'block':'none'; }
      var atc=$('qd-price-atc'), atcv=$('qd-price-atc-v');
      function mirror(){
        var t=price.textContent||'';
        sp.textContent=t;
        /* r154 Q9: one-line recap beside the mirrored price - built from the
           same controls the quote reads, never a second copy of the design */
        (function(){ var ss=$('qd-sticky-sum'); if(!ss) return;
          try{
            var fin=($('qd-finish')&&$('qd-finish').selectedIndex>=0)?$('qd-finish').options[$('qd-finish').selectedIndex].text.split('\u2014')[0].trim():'';
            ss.textContent=qdDesignLabel()+(fin?(' \u00b7 '+fin):'');
          }catch(e){ ss.textContent=''; }
        })();
        /* r74, Patryk 25 Aug: the summary is taller than the screen, so at the Add button
           the big price is cut off above. This recap mirrors the SAME element - it can
           never show a different number - and hides whenever the design is unpriced. */
        if(atc&&atcv){ atcv.textContent=t; atc.style.display=(t.indexOf('$')===0)?'block':'none'; }
        /* '$...' = priced; '\u2014'/empty = unpriced (hide); anything else ("Pricing\u2026")
           keeps the previous state so the bar doesn't flicker on every edit. */
        if(t.indexOf('$')===0) priced=true;
        else if(t==='\u2014'||t==='') priced=false;
        paint();
      }
      new MutationObserver(mirror).observe(price,{childList:true,characterData:true,subtree:true});
      /* r156: the desktop guided flow hides the summary, so anything written to
         #qd-msg (refusals, "Checking prices...") must reach the bar too - the
         SAME element mirrored, never a second copy of the message. */
      var sm=$('qd-sticky-msg'), srcMsg=$('qd-msg');
      if(sm && srcMsg){
        var msync=function(){ var t2=(srcMsg.textContent||'').trim();
          sm.innerHTML=srcMsg.innerHTML; sm.style.display=t2?'block':'none'; errored=!!t2; paint(); };   /* r-bv7: innerHTML, real button */
        new MutationObserver(msync).observe(srcMsg,{childList:true,characterData:true,subtree:true});
        msync();
      }
      new IntersectionObserver(function(en){ offscreen = !en[0].isIntersecting; paint(); },{threshold:0}).observe(price);
      go.addEventListener('click', function(){
        /* r156: in the guided flow the summary IS step 4 - jump there rather
           than scrolling to a price box that may be display:none. */
        if(QD_MODE==='quick' && window.qdGoReview){ window.qdGoReview(); return; }
        try{ price.scrollIntoView({behavior:'smooth',block:'start'}); }catch(e){ price.scrollIntoView(); }
      });
      mirror();
    }catch(e){}
  })();
  /* r71: the What's-this toggle folds the profile cards open and shut. Wired once here;
     the cards inside stay exactly as r68b left them - passive pictures. */
  (function(){
    var btn=$('qd-rail-toggle'), fold=$('qd-railfold'); if(!btn||!fold) return;
    btn.addEventListener('click', function(){
      var open = fold.style.display !== 'none';
      fold.style.display = open ? 'none' : 'block';
      btn.textContent = open ? "What's this?" : 'Hide';
    });
  })();
  /* r68b, Patryk: the cards are a VISUAL GUIDE, not a control. Clicking a picture to learn
     what it means must never change the frame; the Panels dropdown is the one place the
     choice is made, and qdSyncRailType keeps the highlight honest about which profile the
     current design uses. The click handlers this comment replaces lasted one day. */
  function updatePanelNote(){
    qdSyncRailType();
    var note=$('qd-panel-note');
    /* r41: this note used to be written from the panel MODE alone, so it said "panels sit in
       lipped rails (supplied)... 6mm sheet always mill finish" even when the customer was
       supplying their own panels on a screw-on angle. It described a frame nobody had asked
       for. It is built from the actual state now - who supplies, and how it is held. */
    var who = (panelSupply==='byo')
      ? '<strong>You supply the panels</strong> \u2014 anything <strong>6mm or 17mm</strong> thick: timber, ply, glass, acrylic, mesh, even a whiteboard. They are drawn faint on the picture so you can see where they land, and the exact cut sizes are printed on your invoice once your order is placed.'
      : 'We cut the panels from <strong>6mm aluminium</strong> \u2014 always mill finish, not anodised.';
    var held = (panelFix==='angle')
      ? 'They sit on a <strong>screw-on 20 \u00d7 20 angle ledge</strong>, supplied cut to suit in your frame finish. You screw it on \u2014 screws are not included.'
      : 'They drop into a <strong>lipped rail</strong>, supplied in your frame finish. Nothing to fix. '
        /* r95 Q1: a customer looking at the highlighted rails asked what the lip was and how to
           turn it off. Only the pair carrying each panel is lipped, and the way out is the
           Panels dropdown a few pixels below this sentence. */
        + '<strong>Only the two rails that carry each panel are lipped</strong> \u2014 every other rail and every leg stays plain 25.4mm square tube. For plain tube right through, choose <strong>No panels \u2014 frame only</strong>.';
    var lab=$('qd-panel-lab');
    if(lab) lab.innerHTML = (panelMode==='none') ? 'Panels'
      : (panelSupply==='byo' ? 'Panels \u2014 you supply them' : 'Panels \u2014 6mm aluminium (mill-finish sheet)');
    if(panelMode==='none'){
      note.innerHTML='Plain square tube, <strong>no shelf lip</strong>. Add panels if you want a shelf to sit in something.';
    } else if(panelMode==='custom'){
      note.innerHTML = who + ' ' + held + ' Tick the faces you want panelled \u2014 each panel sits in two lipped rails. <strong>All four edges</strong> lips the other two rails as well; where two lips meet at a corner the lip needs a small notch (7\u201310mm, hacksaw) \u2014 the exact instruction prints with your order.';
    } else if(panelMode==='back' || panelMode==='backfront'){
      note.innerHTML = who + ' ' + held + ' Because these panels stand vertical they do not just rest in place \u2014 <strong>fix them to the rails</strong>. Box frames only.';
    } else {
      note.innerHTML = who + ' ' + held;
    }
    note.style.display='block';
    var sw=$('qd-supply-wrap');
    if(sw) sw.style.display=(panelMode==='none' && !qdBackSel.length && !qdUpstand)?'none':'block';
    var fcw=$('qd-faces-wrap'); if(fcw) fcw.style.display=(panelMode==='custom')?'block':'none';
    /* r191: the 6mm-glass / 17mm-timber choice used to appear only when the TOP
       card said "I'll supply my own". On the design Patryk actually asked for -
       aluminium shelves, a timber back wall - the top card says "we cut plate",
       so the control was hidden and his timber wall drew as grey glass. Offer it
       whenever ANY group on this frame is the customer's own. */
    var _anyOwn = (panelMode!=='none' && qdSupplyOf('panels')==='byo')
               || (qdBackSel.length>0 && qdSupplyOf('walls')==='byo')
               || (qdUpstand>0 && qdSupplyOf('board')==='byo');
    var tkw=$('qd-thick-wrap'); if(tkw) tkw.style.display=_anyOwn?'block':'none';
    if(panelMode==='custom' && window.qdSyncL4) try{ window.qdSyncL4(); }catch(_e4){}
    /* r43: "How the panels are held" was staying on screen with Panels set to frame only,
       announcing "Lipped rail - the panel drops in, nothing to fix" when there is no panel and
       no rail. The supply control already hid itself in that case; this one never got the same
       treatment. Empty string rather than 'block' so the 1.4.0 gate and Quick mode still win. */
    var fw=$('qd-fix-wrap'); if(fw) fw.style.display=(panelMode==='none')?'none':'';
    var lw=$('qd-liphl-wrap'); if(lw) lw.style.display=(panelMode==='none')?'none':'flex';
    syncFixKey();
     syncFixNeed();
  }
  (function(){
    var K4=['top','bottom','front','back','left','right'];
    function syncL4(){
      K4.forEach(function(k){
        var f=$('qd-face-'+k), l=$('qd-l4-'+k);
        if(f) f.checked=qdFaces[k];
        if(!l) return;
        var blocked=qdL4Blocked(k,qdFaces);
        var d=(!window.QD_E125)||!qdFaces[k]||blocked;
        if(d && qdLips4[k]) qdLips4[k]=false;
        l.disabled=d; l.checked=qdLips4[k];
        l.title = !window.QD_E125 ? 'Available shortly' : (!qdFaces[k] ? 'Tick the panel first' : (blocked ? 'The neighbouring panels already use these rails' : ''));
        var lw=l.parentNode; if(lw&&lw.style) lw.style.opacity=d?0.45:1;
      });
    }
    K4.forEach(function(k){
      var f=$('qd-face-'+k), l=$('qd-l4-'+k);
      if(f) f.addEventListener('change',function(){ qdSnap(this.checked?'panelling a face':'removing a face panel'); qdFaces[k]=this.checked; syncL4(); recalc(); });
      if(l) l.addEventListener('change',function(){ if(this.disabled) return; qdSnap('the four-edge support'); qdLips4[k]=this.checked; syncL4(); recalc(); });
    });
    window.qdSyncL4=syncL4;
    syncL4();
  })();
  /* r172 - BACK BOARD ABOVE THE TOP. One tick, one height. The fold shows on
     every frame type once the fixing is the lipped rail; the CONTROLS stay
     disabled until the engine answers 1.27+, exactly as the back-wall ticks
     do - the page never offers what the live engine cannot price. Mutations
     here never call recalc() from sync() itself; only a real change does. */
  (function(){
    var wrap=$('qd-up-wrap'), tick=$('qd-up-on'), num=$('qd-upstand'), row=$('qd-up-row');
    if(!wrap||!tick||!num) return;
    function clamp(v){ v=Math.round(Number(v)); if(!isFinite(v)) v=150; return Math.max(QD_UP_MIN, Math.min(QD_UP_MAX, v)); }
    function sync(){
      var lip=(panelFix!=='angle') && QD_UP_OFFER;
      wrap.style.display = lip ? 'block' : 'none';
      var ready=!!window.QD_E128;
      tick.disabled=!ready; num.disabled=!ready||!tick.checked;
      tick.title = ready ? '' : 'Available shortly';
      wrap.style.opacity = ready ? 1 : 0.55;
      if(!lip && tick.checked){ tick.checked=false; }
      if(row) row.style.display = tick.checked ? 'flex' : 'none';
      /* r191: the material row only exists once the board does. A "Made of"
         select hanging over a board that is not on the frame is exactly the
         shape that made the first picker mockup unpickable. */
      var _mrow=$('qd-up-matrow');
      if(_mrow) _mrow.style.display = tick.checked ? 'block' : 'none';
      if(!tick.checked && qdMatBoard){ qdMatBoard=''; var _mb0=$('qd-up-mat'); if(_mb0) _mb0.value=''; }
      /* r202: the board's shape goes with the board. Rows or open cells left behind on an
         unticked board would come straight back on the next tick, on a design the customer
         thought they had cleared. */
      if(!tick.checked && (qdSpRows!==1 || qdSpRails || qdSpOff.length)){ qdSpRows=1; qdSpRails=null; qdSpOff=[]; }
      var frow=$('qd-up-flushrow'); if(frow) frow.style.display = tick.checked ? 'flex' : 'none';
      var want = (lip && ready && tick.checked) ? clamp(num.value) : 0;
      if(want && String(num.value)!==String(want)) num.value=String(want);
      var changed = (want!==qdUpstand);
      qdUpstand = want;
      /* r202: AFTER qdUpstand is set, never before. Called from the middle of this function
         it read the OLD height, so ticking the board on left the controls hidden and
         ticking it off left them on screen - wrong in both directions from one line in the
         wrong place. */
      try{ if(window.qdSfSync) window.qdSfSync(); }catch(_sf){}
      return changed;
    }
    tick.addEventListener('change', function(){
      qdSnap(tick.checked ? 'adding the back board' : 'removing the back board');
      sync(); try{ rebuild3D(); }catch(e){} recalc();
    });
    num.addEventListener('change', function(){
      sync(); try{ rebuild3D(); }catch(e){} recalc();
    });
    ['out','in'].forEach(function(k){ var el=$('qd-up-flush-'+k); if(el) el.addEventListener('change', function(){
      if(!this.checked) return;
      qdSnap('which face the splashback sits flush with');
      qdUpFlush=k; try{ rebuild3D(); }catch(e){} recalc();
    }); });
    window.qdUpSync=sync;
    window.qdSetPendingUp=function(v){ if(!QD_UP_OFFER) return; qdPendingUp=v; if(window.QD_E128) window.qdUpEngineReady(); };
    window.qdUpEngineReady=function(){
      sync();
      if(qdPendingUp){
        var v=qdPendingUp; qdPendingUp=null;
        tick.checked=true; num.value=String(clamp(v));
        var _chg=sync(), _mlx=false, _sfx=false;
        try{ if(window.qdMatLand) _mlx=window.qdMatLand(); }catch(e){}
        try{ if(window.qdSfLand) _sfx=window.qdSfLand(); }catch(e){}   /* r203: the shared board shape */
        if(_chg||_mlx||_sfx){ try{ rebuild3D(); }catch(e){} recalc(); }
      }
    };
    sync();
  })();
  /* r154 - BACK WALLS UI. Ticks per opening; the gate mirrors alucut 1.26.0
     exactly (shelf, lip fixing, panels none/top/all, clean frame; adjacency and
     feet-on-the-bottom-opening refusals per tick, with the reason in the title).
     Locked until the engine identifies as 1.26+ - same pattern as the l4 ticks.
     Mutations here never call recalc() from sync() itself: sync runs inside
     recalc (before the payload is built), so a pruned selection is already what
     the in-flight quote asks for. Only the tick handler starts a new quote. */
  (function(){
    var wrap=$('qd-bw-wrap'), grid=$('qd-bw-grid'); if(!wrap||!grid) return;
    function openings(){ var t=Math.max(2,+($('qd-tiers')?$('qd-tiers').value:3)||3); return ($('qd-type')&&$('qd-type').value==='shelf') ? (t-1) : 0; }
    function colsN(){ return Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1); }
    function cleanFrame(){ return !qdNoPosts.length && !qdNoRails.length && !qdNoPanels.length && railLevels==='all' && !openShares; }
    function modeOk(){ return (panelMode==='none'||panelMode==='top'||panelMode==='all') && panelFix!=='angle'; }
    function bwHas(li,bk){ for(var i=0;i<qdBackSel.length;i++) if(qdBackSel[i][0]===li&&qdBackSel[i][1]===bk) return true; return false; }
    function prune(){
      var n=openings(), c=colsN(), out=[], ch=false, i;
      for(i=0;i<qdBackSel.length;i++){ var a=qdBackSel[i];
        if(a[0]<0||a[0]>=n||a[1]<0||a[1]>=c){ ch=true; continue; }
        if(qdFeet!=='none'&&a[0]===0){ ch=true; continue; }
        out.push(a);
      }
      for(i=out.length-1;i>=0;i--){ for(var k2=0;k2<i;k2++){
        if(out[k2][0]===out[i][0]&&Math.abs(out[k2][1]-out[i][1])===1){ out.splice(i,1); ch=true; break; } } }
      if(ch) qdBackSel=out;
      return ch;
    }
    function sync(){
      var n=openings();
      var show=n>0 && modeOk() && cleanFrame();
      if(!show){
        wrap.style.display='none';
        if(qdBackSel.length){ qdBackSel=[]; try{ rebuild3D(); }catch(e){} }
        if(qdMatWalls){ qdMatWalls=''; var _mw0=$('qd-bw-mat'); if(_mw0) _mw0.value=''; }
        return;
      }
      wrap.style.display='block';
      if(prune()){ try{ rebuild3D(); }catch(e){} }
      var c=colsN(), ready=!!window.QD_E126, html='';
      for(var li=n-1; li>=0; li--){
        for(var bk=0; bk<c; bk++){
          var lab=(li===n-1?'Top opening':(li===0?'Bottom opening':('Opening '+(li+1)+' of '+n)))+(c>1?(' \u00b7 bay '+(bk+1)):'');
          var dis=!ready, why=!ready?'Available shortly':'';
          if(!dis && qdFeet!=='none' && li===0){ dis=true; why='Not with feet \u2014 the wall would lip the leg a foot fits into'; }
          if(!dis && !bwHas(li,bk) && (bwHas(li,bk-1)||bwHas(li,bk+1))){ dis=true; why='The opening beside it already has a wall \u2014 they would share an upright'; }
          html+='<label style="display:flex;align-items:center;gap:7px;font-size:12.5px;color:#334155;cursor:pointer'+(dis?';opacity:.45':'')+'"'+(why?(' title="'+why+'"'):'')+'><input type="checkbox" data-bw="'+li+'.'+bk+'"'+(bwHas(li,bk)?' checked':'')+(dis?' disabled':'')+' style="accent-color:#0e1a4d;margin:0">'+lab+'</label>';
        }
      }
      if(grid.getAttribute('data-bw-html')!==html){ grid.innerHTML=html; grid.setAttribute('data-bw-html',html); }
      try{ if(window.qdSfSync) window.qdSfSync(); }catch(_sf2){}   /* r202: the cells follow the bays */
      var _bmr=wrap.querySelector('.qd-matrow');
      if(_bmr) _bmr.style.display = qdBackSel.length ? 'flex' : 'none';
      if(!qdBackSel.length && qdMatWalls){ qdMatWalls=''; var _mw1=$('qd-bw-mat'); if(_mw1) _mw1.value=''; }
    }
    grid.addEventListener('change', function(ev){
      var el=ev.target; if(!el||!el.getAttribute||!el.getAttribute('data-bw')) return;
      var a=el.getAttribute('data-bw').split('.'), li=+a[0], bk=+a[1];
      qdSnap('the back walls');
      if(el.checked){ if(!bwHas(li,bk)) qdBackSel.push([li,bk]); }
      else { for(var i=qdBackSel.length-1;i>=0;i--) if(qdBackSel[i][0]===li&&qdBackSel[i][1]===bk) qdBackSel.splice(i,1); }
      sync(); try{ rebuild3D(); }catch(e){} recalc();
    });
    window.qdBwSync=sync;
    window.qdSetPendingBw=function(v){ qdPendingBw=v; if(window.QD_E126 && window.qdBwEngineReady) window.qdBwEngineReady(); };
    window.qdBwEngineReady=function(){
      sync();
      if(qdPendingBw && qdPendingBw.length){
        var v=qdPendingBw; qdPendingBw=null;
        var n=openings(), c=colsN(), ok=[];
        for(var i=0;i<v.length;i++){ var x=v[i]; if(x[0]>=0&&x[0]<n&&x[1]>=0&&x[1]<c) ok.push([x[0],x[1]]); }
        if(ok.length){ qdBackSel=ok; prune(); sync();
          try{ if(window.qdMatLand) window.qdMatLand(); }catch(e){}
          try{ rebuild3D(); }catch(e){} recalc(); }
      }
    };
    sync();
  })();
  /* r191 - MIXED PANEL MATERIALS. Two selects, one per group, default "" which
     means "whatever the two supply cards above say". A customer who never
     touches them sends no panelSupplyBy at all, so the request, the price and
     the cart payload are identical to r189 - that is the property the whole
     change is built around and differential-131 is what proves it. */
  (function(){
    function wire(id, get, set, label){
      var el=$(id); if(!el) return;
      el.addEventListener('change', function(){
        var v=(el.value==='byo'||el.value==='us') ? el.value : '';
        if(v===get()) return;
        qdSnap(label);
        set(v);
        try{ rebuild3D(); }catch(e){}
        recalc();
      });
    }
    wire('qd-bw-mat', function(){ return qdMatWalls; }, function(v){ qdMatWalls=v; }, 'what the back walls are made of');
    wire('qd-up-mat', function(){ return qdMatBoard; }, function(v){ qdMatBoard=v; }, 'what the back board is made of');
    window.qdMatSync=function(){
      var a=$('qd-bw-mat'); if(a && a.value!==qdMatWalls) a.value=qdMatWalls;
      var b=$('qd-up-mat'); if(b && b.value!==qdMatBoard) b.value=qdMatBoard;
    };
    /* A share link carries the material, but the GROUP it belongs to arrives
       later (the walls and the board both wait on the engine version). Hold it
       until the group is really on the frame, or the sync that prunes an empty
       group would throw the material away before it was ever used. */
    window.qdMatLand=function(){
      var ch=false;
      if(qdPendMatW && qdBackSel.length){ qdMatWalls=qdPendMatW; qdPendMatW=''; ch=true; }
      if(qdPendMatB && qdUpstand){ qdMatBoard=qdPendMatB; qdPendMatB=''; ch=true; }
      try{ window.qdMatSync(); }catch(e){}
      return ch;
    };
    /* The label beside each select is the PIECE COUNT the engine actually
       priced for that group - not a price. A per-group price would mean a
       second copy of the plate rule living in the page, and two copies drift
       until the label and the charge disagree. The count comes straight off
       the quote echo, so it cannot say something the cart did not do. */
    window.qdMatCounts=function(t){
      var by=(t && t.panelsBy) || null;
      [['qd-bw-mat-p','walls'],['qd-up-mat-p','board']].forEach(function(pair){
        var sp=$(pair[0]); if(!sp) return;
        var n=by ? by[pair[1]] : null;
        sp.textContent=(typeof n==='number' && n>0) ? (n+(n===1?' panel':' panels')) : '';
      });
    };
  })();
  /* r202 - THE BOARD'S OWN CONTROLS. Rows, lip-or-plain per rail, a tick per cell. Hidden
     until the engine reports 1.32+, the same gate the back walls and four-edge ticks use,
     so the page can never offer what the live worker cannot price.
     Rebuilt from state on every sync rather than mutated: the number of rails and cells
     moves with the row and column counts, and a stale checkbox is how someone ticks a cell
     that no longer exists.
     r204: the four lipped/plain rail SELECTS are gone from the customer page. Measured on
     108 designs (plainrail.mjs): plain costs MORE on 54 of them - +$23.77 at W=1800 - because
     the remaining lipped rail still needs a whole lipped bar and the plain one needs its own
     stock. A question whose answer is usually worse, and which took a paragraph to explain,
     is not one to put to a customer. qdSpRails stays in the state and in the payload guard
     (it is always null now), so the engine capability is untouched. */
  (function(){
    function railsOf(){
      var n=qdSpRows+1, out=[];
      for(var i=0;i<n;i++) out.push(qdSpRails && qdSpRails[i]==='plain' ? 'plain' : 'lip');
      return out;
    }
    function sfCols(){ return Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1); }
    function offHas(r,b){ for(var i=0;i<qdSpOff.length;i++) if(qdSpOff[i][0]===r&&qdSpOff[i][1]===b) return true; return false; }
    function sfPrune(){
      var c=sfCols(), out=[], ch=false;
      for(var i=0;i<qdSpOff.length;i++){ var a=qdSpOff[i];
        if(a[0]<0||a[0]>=qdSpRows||a[1]<0||a[1]>=c){ ch=true; continue; }
        out.push(a); }
      if(ch) qdSpOff=out;
      return ch;
    }
    /* A row whose rails are not BOTH lipped cannot hold a panel - the engine refuses such a
       design outright, so the page must not be able to build one. Those cells are forced
       off and their ticks disabled, with the reason in the title. */
    function sfForceOpen(){
      var rl=railsOf(), c=sfCols();
      for(var r=0;r<qdSpRows;r++){
        if(rl[r]==='lip' && rl[r+1]==='lip') continue;
        for(var b=0;b<c;b++) if(!offHas(r,b)) qdSpOff.push([r,b]);
      }
    }
    function sfSync(){
      var wrap=$('qd-sf-wrap'); if(!wrap) return;
      var on = !!qdUpstand && !!window.QD_E132;
      wrap.style.display = on ? 'block' : 'none';
      if(!on) return;
      /* r207: rows are gated SEPARATELY, on 1.33. The panel ticks are not - leaving a bay
         open is correct on 1.32. Forcing qdSpRows back to 1 here is belt and braces: with the
         control hidden nothing can set it, and a share link is clamped in qdSfLand. */
      var _r133=!!window.QD_E133;
      var _rr=$('qd-sf-rowsrow'); if(_rr) _rr.style.display=_r133?'flex':'none';
      var _rn=$('qd-sf-note-rows'); if(_rn) _rn.style.display=_r133?'inline':'none';
      if(!_r133 && qdSpRows!==1){ qdSpRows=1; qdSpOff=[]; }
      var rsel=$('qd-sf-rows'); if(rsel && String(rsel.value)!==String(qdSpRows)) rsel.value=String(qdSpRows);
      sfPrune(); sfForceOpen();
      var rl=railsOf(), c=sfCols(), r, b;
      var ch2='<div class="qd-lab" style="font-weight:600;margin:0 0 5px">Panels</div>';
      for(r=qdSpRows-1;r>=0;r--){
        var held = rl[r]==='lip' && rl[r+1]==='lip';
        var why = held ? '' : ' title="This row has a plain rail, so nothing holds a panel here"';
        ch2 += '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:3px">';
        for(b=0;b<c;b++){
          var lab = (qdSpRows>1 ? ('row '+(r+1)) : 'panel') + (c>1 ? (' · bay '+(b+1)) : '');
          ch2 += '<label style="display:flex;align-items:center;gap:6px;font-size:12.5px;color:#334155'
               + (held?'':';opacity:.45') + '"'+why+'>'
               + '<input type="checkbox" data-sfcell="'+r+'.'+b+'"'+((!offHas(r,b)&&held)?' checked':'')
               + (held?'':' disabled')+' style="accent-color:#0e1a4d;margin:0">'+lab+'</label>';
        }
        ch2 += '</div>';
      }
      var cw=$('qd-sf-cells'); if(cw && cw.getAttribute('data-h')!==ch2){ cw.innerHTML=ch2; cw.setAttribute('data-h',ch2); }
    }
    var rsel0=$('qd-sf-rows');
    if(rsel0) rsel0.addEventListener('change', function(){
      var v=Math.max(1,Math.min(4,+this.value||1));
      if(v===qdSpRows) return;
      qdSnap('the back board rows');
      qdSpRows=v;
      if(qdSpRails && qdSpRails.length!==v+1) qdSpRails=null;   /* a stale rail list is a different design */
      qdSpOff=[];
      sfSync(); try{ rebuild3D(); }catch(e){} recalc();
    });
    var cw0=$('qd-sf-cells');
    if(cw0) cw0.addEventListener('change', function(ev){
      var el=ev.target, k=el&&el.getAttribute&&el.getAttribute('data-sfcell');
      if(k==null) return;
      var a=k.split('.'), r=+a[0], b=+a[1];
      qdSnap('a back board panel');
      if(el.checked){ for(var i=qdSpOff.length-1;i>=0;i--) if(qdSpOff[i][0]===r&&qdSpOff[i][1]===b) qdSpOff.splice(i,1); }
      else if(!offHas(r,b)) qdSpOff.push([r,b]);
      sfSync(); try{ rebuild3D(); }catch(e){} recalc();
    });
    /* r204: the panel is CLOSED by default. A board that arrives already split - from a
       share link, or from Undo - must open it, or the customer meets a board they cannot
       see a reason for and cannot find the control that made it. */
    function sfOpen(){ var d=$('qd-sf-more'); if(d && (qdSpRows>1 || qdSpOff.length)) d.open=true; }
    window.qdSfSync=sfSync; window.qdSfOpen=sfOpen;
    /* r203: a share link's board shape lands HERE, once the board is really on the frame.
       Applied any earlier, the board's own sync prunes it away and the link rebuilds a
       single band - the exact "different frame at the same URL" fault. Returns whether it
       changed anything, so the caller knows whether to re-quote. */
    window.qdSfLand=function(){
      if(!qdPendSf || !qdUpstand) return false;
      var q=qdPendSf; qdPendSf=null;
      /* r207: a link made on a fixed engine must not rebuild a short board on this one */
      if(q.rows && window.QD_E133) qdSpRows=Math.max(1,Math.min(4,q.rows));
      if(q.off) qdSpOff=q.off.map(function(a){ return a.slice(); });
      sfSync(); sfOpen();
      return true;
    };
    sfSync();
  })();
  /* r154 Q8 - the guided Easy flow. Presentation only: the same controls, paged.
     Everything rides two classes JS puts on; with no JS, or in Advanced mode,
     nothing is ever hidden. A link that carries a design opens at Review. */
  (function(){
    var wrap=document.getElementById('qd'), steps=$('qd-steps'), nav=$('qd-stepnav');
    if(!wrap||!steps||!nav) return;
    var back=$('qd-step-back'), next=$('qd-step-next');
    var cur=1;
    try{ if(new URLSearchParams(location.search).get('w')) cur=4; }catch(e){}
    var chips=steps.querySelectorAll('.qd-stepchip');
    function show(){
      var quick=(QD_MODE==='quick');
      wrap.classList.toggle('qd-guided', quick);
      wrap.classList.toggle('qd-onstep4', quick && cur===4);
      steps.hidden=!quick; nav.hidden=!quick;
      if(!quick) return;
      var gs=wrap.querySelectorAll('.qd-stepgrp');
      for(var i=0;i<gs.length;i++) gs[i].classList.toggle('qd-stepon', gs[i].getAttribute('data-qdstep')===String(cur));
      for(var j=0;j<chips.length;j++){ var n2=+chips[j].getAttribute('data-step');
        chips[j].classList.toggle('qd-on', n2===cur);
        chips[j].classList.toggle('qd-done', n2<cur); }
      if(back) back.disabled=(cur===1);
      if(next){ next.style.display=(cur===4)?'none':'block'; next.textContent=(cur===3)?'Review & add \u2192':'Next \u2192'; }
    }
    function go(n3, scroll){
      cur=Math.max(1,Math.min(4,n3)); show();
      try{
        if(!scroll) return;
        var app=document.getElementById('qd-app');
        if(window.innerWidth>980 && app){
          /* r159: desktop app mode - park the whole designer at the top of the
             viewport, once, and only when it is actually out of place. */
          var r=app.getBoundingClientRect();
          if(r.top<-4 || r.top>60) window.scrollTo({top:window.pageYOffset+r.top-8, behavior:'smooth'});
          return;
        }
        if(cur===4){ var pb=$('qd-price-box'); if(pb) pb.scrollIntoView({behavior:'smooth',block:'start'}); }
        else { steps.scrollIntoView({behavior:'smooth',block:'start'}); }
      }catch(e){}
    }
    for(var k3=0;k3<chips.length;k3++)(function(b3){ b3.addEventListener('click',function(){ go(+b3.getAttribute('data-step'), true); }); })(chips[k3]);
    if(next) next.addEventListener('click',function(){ go(cur+1, true); });
    if(back) back.addEventListener('click',function(){ go(cur-1, true); });
    window.qdGuidedSync=show;
    window.qdGoReview=function(){ go(4,true); };
    show();
  })();
  /* r156 - the shrunken drawing (phone/tablet <=980px): the expand chip and a
     canvas resize on the height transition, so the 3D never renders squashed. */
  (function(){
    var st=document.querySelector('.qd-stage'), b=$('qd-stage-expand');
    if(!st) return;
    if(b) b.addEventListener('click', function(){
      st.classList.toggle('qd-stage-big');
      /* r-bv2-B, Patryk's phone 10:27: expanding made the box bigger but left the CAMERA where
         it was, so the frame sat tiny in the middle of a full screen. resize() only re-sizes the
         canvas and the renderer - the fit distance is qdFitCamera's job, and QD_FIT has to be
         cleared or the next rebuild decides nothing has changed and skips it. */
      bvRefit();
      setTimeout(bvRefit, 300);
    });
    st.addEventListener('transitionend', function(ev){ if(ev && ev.propertyName==='height'){ try{ resize(); }catch(e){} } });
  })();
  /* r-bv2-B: refit after the stage changes size, and put the step controls back on screen.
     Both are called from the Expand button and from qdStepGo. */
  function bvRefit(){
    try{ resize(); }catch(_e1){}
    try{ qdResetPan(); qdFitCamera(); QD_FIT=null; rebuild3D(); }catch(_e2){}
    try{ bvStageNav(); }catch(_e3){}
  }
  /* r-bv2-C, Patryk: "we should have options on there for next also?" - in full-page mode the
     stage covers the panel the step bar lives in, so there was no way to move on without
     collapsing it again. This is the same bar, floated inside the stage, and ONLY while the
     stage is expanded AND a step is showing. It reads the same QD_STEP and calls the same
     qdStepGo, so there is one step machine, not two. */
  function bvStageNav(){
    try{
      var st=document.querySelector('.qd-stage'); if(!st) return;
      var el=document.getElementById('qd-bv-stepnav');
      var want = qdBuildView && st.classList.contains('qd-stage-big') && QD_STEP>=0;
      if(!want){ if(el) el.style.display='none'; return; }
      var P=QD_STEP_PLAN||qdStepStamp(), n=P.steps.length, s=P.steps[QD_STEP];
      if(!el){
        el=document.createElement('div'); el.id='qd-bv-stepnav';
        el.style.cssText='position:absolute;left:8px;right:8px;top:56px;z-index:32;display:flex;'
          +'align-items:center;gap:8px;background:#0e1a4d;color:#fff;border-radius:12px;'
          +'padding:7px 7px 7px 12px;font-family:inherit;box-shadow:0 6px 18px -8px rgba(15,23,42,.6)';
        st.appendChild(el);
      }
      el.style.display='flex';
      var A='flex:0 0 auto;width:38px;height:38px;border:0;border-radius:10px;background:#12b8e5;color:#fff;cursor:pointer;font-family:inherit;';
      var CL='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="15 5 7 12 15 19"></polyline></svg>';
      var CR='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="9 5 17 12 9 19"></polyline></svg>';
      var nm=String((s&&s.name)||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      el.innerHTML='<button type="button" id="qd-bv-prev" aria-label="Previous step"'+(QD_STEP===0?' disabled':'')+' style="'+A+'opacity:'+(QD_STEP===0?'.35':'1')+'">'+CL+'</button>'
        +'<div style="flex:1;min-width:0"><div style="font-size:11px;opacity:.85">Step '+(QD_STEP+1)+' of '+n+'</div>'
        +'<div style="font-size:15px;font-weight:800;line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+nm+'</div></div>'
        +'<button type="button" id="qd-bv-next" aria-label="Next step"'+(QD_STEP===n-1?' disabled':'')+' style="'+A+'opacity:'+(QD_STEP===n-1?'.35':'1')+'">'+CR+'</button>';
      var p=document.getElementById('qd-bv-prev'), x=document.getElementById('qd-bv-next');
      if(p) p.onclick=function(ev){ ev.preventDefault(); qdStepGo(QD_STEP-1); };
      if(x) x.onclick=function(ev){ ev.preventDefault(); qdStepGo(QD_STEP+1); };
    }catch(_e){}
  }
  /* r-bv2-D, Patryk: "we've had a mockup of a front thing so the customer doesn't get lost when
     it rotates? Like which is the front". The chip top-right says which face you are LOOKING at;
     this is the other half - a label lying on the floor at the front edge that TURNS WITH THE
     FRAME, so when you spin it you can still see where the front went.
     It is a child of the model group, so it rotates with everything else. It carries no userData.qstep,
     which qdStepApply reads as -1 = always visible, and no userData.piece, so it never appears
     in the parts list. raycast is stubbed out so it can never swallow a tap meant for a piece. */
  var BV_FRONT_TEX=null;
  function bvFrontTex(){
    if(BV_FRONT_TEX) return BV_FRONT_TEX;
    var c=document.createElement('canvas'); c.width=512; c.height=128;
    var g=c.getContext('2d');
    g.fillStyle='rgba(234,88,18,0.92)'; g.fillRect(0,0,512,128);
    g.fillStyle='#ffffff';
    g.font='bold 72px -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial,sans-serif';
    g.textAlign='center'; g.textBaseline='middle';
    g.fillText('FRONT',256,68);
    BV_FRONT_TEX=new T.CanvasTexture(c);
    return BV_FRONT_TEX;
  }
  function bvFrontMarker(){
    try{
      if(!T || !group) return;   /* r-bv5: FRONT now shows in the normal designer too, not only ?build=1 */
      for(var _fi=group.children.length-1;_fi>=0;_fi--){ var _om=group.children[_fi]; if(_om.__qdFront){ group.remove(_om); try{_om.geometry.dispose();}catch(_e){} } }
      /* the local extents - zero the rotation first, or Box3 returns the ROTATED world box and
         the label lands in the wrong place the moment anyone spins the frame. */
      var rx=group.rotation.x, ry=group.rotation.y, rz=group.rotation.z;
      group.rotation.set(0,0,0); group.updateMatrixWorld(true);
      var box=qdFrameBox();
      group.rotation.set(rx,ry,rz); group.updateMatrixWorld(true);
      if(!isFinite(box.min.x) || !(box.max.x>box.min.x)) return;
      var w=box.max.x-box.min.x, lw=Math.max(0.30, w*0.30), lh=lw/4;
      var m=new T.Mesh(new T.PlaneGeometry(lw,lh),
            new T.MeshBasicMaterial({map:bvFrontTex(), transparent:true, depthWrite:false, side:T.DoubleSide}));
      m.rotation.x=-Math.PI/2;
      m.position.set((box.min.x+box.max.x)/2, box.min.y+0.003, box.max.z+lh*0.8);
      m.renderOrder=6;
      m.raycast=function(){};
      m.__qdFront=true; m.userData={qstep:-1};   /* r-bv5: excluded from fit; always-on across steps */
      group.add(m);
    }catch(_e){}
  }
  /* r154 Q12 - printable Build Summary. It mirrors the page's OWN summary
     blocks, so it can never print something the page would not show - and the
     page never shows panel cut sizes (the sizes ruling: invoice only). The doc
     is appended to <body> so the print CSS can show it alone. A4 at 100%:
     190mm fixed width, proven by the pdf harness. */
  (function(){
    var btn=$('qd-print'); if(!btn) return;
    function esc(x){ return String(x==null?'':x).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
    btn.addEventListener('click', function(){
      var res=window.aaLastQuote;
      if(!res || res.ok!==true || $('qd-add').disabled){
        var m=$('qd-share-msg'); if(m){ m.textContent='Price the design first \u2014 the summary prints what is on screen.'; m.style.display='block'; setTimeout(function(){ m.style.display='none'; },3500); }
        return;
      }
      var pd=$('qd-printdoc'); if(!pd) return;
      var img='';
      try{ if(renderer&&scene&&camera){ renderer.render(scene,camera); img='<img src="'+$('qd-canvas').toDataURL('image/png')+'" alt="Frame drawing">'; } }catch(e){}
      var blocks='';
      var add=function(t2,b2){ b2=(b2||'').replace(/\s+/g,' ').trim(); if(b2) blocks+='<div class="qd-pd-blk"><div class="qd-pd-bt">'+t2+'</div><div>'+esc(b2)+'</div></div>'; };
      add('Design', res.recipe||qdDesignLabel());
      add('Cutting', ($('qd-cuts')||{}).textContent);
      add('Openings', ($('qd-space')||{}).textContent);
      add('Connectors', ($('qd-conns')||{}).textContent);
      add('Feet', ((($('qd-feet-block')||{}).style||{}).display!=='none') ? ($('qd-feet-line')||{}).textContent : '');
      add('Made from', ($('qd-tube')||{}).textContent);
      if(res.bwNote) add('Back walls', res.bwNote);
      if(res.spNote) add('Splashback', res.spNote);
      add('Notes', ($('qd-support')||{}).textContent);
      /* r164: assembly + fitting guidance - the manufacturer's method (Capral
         Qubelok brochure: mallet; joints glued with polyurethane adhesive as a
         thin continuous ribbon inside the tube ends; panels drop into the lips;
         glass/perspex cushioned with bumpons; no screws, no drilling). Static
         text, no sizes, no capacity claims; weight line anchored to the
         catalogue's own 6mm sheet weights. */
      add('Assembly', 'Tap the joints together with a rubber mallet. Left dry, the frame stays reconfigurable. For a permanent or heavier build, run a thin continuous bead of polyurethane adhesive inside each tube end before assembly, or rivet the joints. Castors and adjustable feet thread into their plastic insert - wind them in carefully by hand, never force them.');
      if((res.tube && res.tube.panelCount) || res.byoPanels || res.bwNote || res.spNote)
        add('Fitting your panels', 'No screws, no drilling. Shelf panels drop onto the lips. Glass or acrylic: stick a few soft rubber pads (bumpons) on the lips first. Vertical panels (sides, front/back, back walls): turn those lipped rails so the channel faces the OUTSIDE - the panel then finishes just shy of flush with the outer face, as drawn. Slide it in from outside; its weight rests on the rail below. Run a bead of neutral-cure silicone in the channel first so it cannot come back out (avoid acetic, vinegar-smelling silicone on metal). 6mm aluminium panels are heavy - a large side panel can be over 20 kg; place big ones with two people, bottom edge first.');
      var share=''; try{ share=qdShareURL(); }catch(e){}
      pd.innerHTML='<h2>AluCube build summary</h2>'
        +'<div class="qd-pd-sub">All Aluminium \u2014 allaluminium.com.au \u2014 printed '+esc(new Date().toLocaleDateString('en-AU'))+'</div>'
        +'<div class="qd-pd-price">'+esc(($('qd-price')||{}).textContent)+' <span style="font-size:12px;font-weight:400">ex GST</span></div>'
        +'<div class="qd-pd-sub">'+esc(($('qd-price-gst')||{}).textContent)+'</div>'
        +img+blocks
        +(share?('<div class="qd-pd-blk"><div class="qd-pd-bt">Reopen this design</div><div><a href="'+esc(share)+'">'+esc(share)+'</a></div></div>'):'')
        +'<div class="qd-pd-fine">Estimate only \u2014 the exact total is confirmed in the cart. Prices ex GST unless marked. This is a design aid, not an engineering document: it carries no load rating. Where panels are included, their cut sizes are printed on your invoice once the order is placed.</div>';
      if(pd.parentNode!==document.body) document.body.appendChild(pd);
      pd.hidden=false;
      document.body.classList.add('qd-printing');
      var done=function(){ document.body.classList.remove('qd-printing'); pd.hidden=true; window.removeEventListener('afterprint',done); };
      window.addEventListener('afterprint',done);
      setTimeout(function(){ try{ window.print(); }catch(e){ done(); } },60);
    });
  })();
  /* r154 Q5 - send the design for a free check, into the EXISTING enquiry
     path. The link is rebuilt by qdShareURL(), which never carries
     edit_bundle / edit_key (S-DL1's strip rule), and the message states the
     scope: buildability, no load ratings. It rides aa-contact's EXISTING
     ?prefill=wishlist branch (sessionStorage handoff) - deliberately, so the
     enquiry section itself is untouched; the key name is the wishlist's, and
     any future wishlist refactor must keep this rider in mind. ?dlink= is a
     breadcrumb only (nothing reads it; a human can recover the link from the
     URL if sessionStorage was blocked). */
  (function(){
    var btn=$('qd-sendcheck'); if(!btn) return;
    btn.addEventListener('click', function(){
      var link=''; try{ link=qdShareURL(); }catch(e){}
      var res=window.aaLastQuote;
      var msg='Please check my AluCube design before I order.\n'
        +'Design: '+((res&&res.ok===true&&res.recipe)?res.recipe:qdDesignLabel())+'\n'
        +(link?('Design link: '+link+'\n'):'')
        +'Please confirm it is buildable as drawn and flag anything you would change. I understand you cannot provide load ratings.';
      try{ sessionStorage.setItem('aa_wl_prefill', msg); }catch(e){}
      location.href='/pages/contact?enquiry=quote&prefill=wishlist&dlink='+encodeURIComponent(link);
    });
  })();
  /* r150 Q6: delegation, bound once - the warning re-renders every recalc. A real
     customer click on a REAL control value; the r80 ban is on synthetic events. */
  /* r219: "+ Add a shelf level". Tiers + 1 through the REAL control, so the r80/r120 handler
     does its honest work (rebuilds the frame, says what could not be carried over, offers
     Undo) - and then, on a castor frame, the floor cross bars go straight back out, because
     the customer already chose wheels and the engine refuses a castor frame with them in.
     One undo step for the whole thing, the way the add-a-bar code does it (qdHistBusy). */
  document.addEventListener('click', function(ev){
    var b=ev.target && ev.target.closest ? ev.target.closest('.qd-addlevel') : null;
    if(!b) return;
    ev.preventDefault();
    var el=$('qd-tiers'); if(!el) return;
    var v=b.getAttribute('data-n'), ok=false, i;
    for(i=0;i<el.options.length;i++) if(el.options[i].value===v && !el.options[i].disabled) ok=true;
    if(!ok) return;
    qdDriveControl(el, v, 'adding a shelf level', 'Added a shelf level.');
  }, false);
  /* r219: one way to drive a real control from a button, shared by "+ Add a support" and
     "+ Add a shelf level". The control's own r80/r120 handler rebuilds the frame and names
     what could not be carried over; then, on a castor frame, the floor cross bars go
     straight back out - the customer already chose wheels and the engine refuses a castor
     frame with them in (measured: "+ Add a support" on a 2-column castor frame brought all
     7 back and the next quote was a refusal). One undo step for the whole thing, the way
     the add-a-bar code does it (qdHistBusy). */
  function qdDriveControl(el, v, label, said){
    var other=0, i;
    try{ other=qdNoPosts.length+qdNoPanels.length+(openShares?1:0)+qdNoRails.filter(function(r){ return r[1]!==0; }).length; }catch(_e){}
    qdHistBusy=true;
    el.value=v;
    try{ el.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
    if(qdFeet==='castors' && qdFloorRailsFn){
      var fr=qdFloorRailsFn();
      if(fr.length){
        for(i=0;i<fr.length;i++) qdNoRails.push(fr[i]);
        syncPostUI(); rebuild3D(); recalc();
        if(qdCastorUIFn) try{ qdCastorUIFn(); }catch(_e2){}
        if(!other) postMsg(said+' The floor cross bars stay out for the wheels.');
        else { var pm=$('qd-post-note'); if(pm && pm.innerHTML) pm.innerHTML+=' The floor cross bars are back out for the wheels.'; }
      }
    }
    qdHistBusy=false;
    qdCommit(label);
  }
  /* r222: the build-view panel replaces the controls column. Read-only by construction -
     it is a list, not a form. Painted from the quote that carries the labels. */
  /* r240 STEP-BY-STEP BUILD (Patryk 3 Sep, tick sheet Q11/Q12: yes; open on the whole frame with a button).
     The build view walks the frame in the order it goes together: floor frame, uprights, next level's rails,
     uprights, ... top rails, and the splashback last when the drawing has one. Only that step's pieces carry
     pills and appear in the list under the drawing; earlier steps stay drawn as faint grey, later steps are
     not drawn yet. Every count is read off the DRAWN pieces (one mesh = one physical piece, r219 geo-parity)
     with the same code lookup the pills use - never a second copy of the engine's numbers. Whole frame is the
     resting state (QD_STEP = -1); nothing here runs outside ?build=1. */
  function qdStepPlan(){
    var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
    var ys=(g&&g.ys&&g.ys.length)?g.ys:[0], N=ys.length, steps=[{name:'Floor frame',kind:'rails',lv:0}];
    for(var l=1;l<N;l++){
      var top=(l===N-1), mid=(N===3&&l===1);
      steps.push({name: top?'Uprights to the top':(mid?'Uprights to the middle':'Uprights to level '+l), kind:'posts', lv:l-1});
      steps.push({name: top?'Top rails':(mid?'Middle level rails':'Level '+l+' rails'), kind:'rails', lv:l});
    }
    return {ys:ys, steps:steps};
  }
  /* Stamp every drawn object with its step (userData.qstep): rails and joints by their level, posts by the
     lowest level they stand on, panels by the level they sit at (a vertical panel: the level above it), a
     tube the grid does not know (splashback riser, board rail) by height, and an untagged object - a lip
     ledge or angle (it follows the tube drawn just before it), feet and castor stacks (with the first
     uprights), a glass outline or the customer's back wall (by height). -1 = always drawn, never listed. */
  function qdStepStamp(){
    var P=qdStepPlan(); QD_STEP_PLAN=P;
    if(!group) return P;
    var ys=P.ys, N=ys.length, S=1/1000, above=false, prevTube=null, i, o, u, p, s;
    var idx=function(kind,lv){ for(var k=0;k<P.steps.length;k++) if(P.steps[k].kind===kind&&P.steps[k].lv===lv) return k; return -1; };
    var lvAt=function(y){ for(var k=0;k<N;k++) if(ys[k]>=y-30) return k; return -1; };
    var byLevel=function(y){ var k=lvAt(y); return (k<0)?-2:idx('rails',k); };
    for(i=0;i<group.children.length;i++){
      o=group.children[i]; u=o.userData||{}; p=u.piece; s=-1;
      if(o.__qdFront){ u.qstep=-1; o.userData=u; continue; }   /* r-bv5: FRONT is not a step piece */
      if(u.rail&&u.rail.li!=null){ s=idx('rails',u.rail.li); }
      else if(u.post){ var lo=(u.legs&&u.legs.length)?Math.min.apply(null,u.legs):0; s=idx('posts',lo); if(s<0) s=idx('rails',0); }
      else if(p&&p.kind==='joint'){ s=(p.yi>=N)?-2:idx('rails',p.yi); }
      else if(p){ s=byLevel(p.cy); }
      else {
        /* untagged: a lip ledge or angle (long and thin - by its level, or the tube drawn just before it), a
           foot, cap, castor socket or wheel (small, at or under the floor level - with the first uprights;
           a castor collar sits up to ~50 mm above the trimmed floor plane), a glass outline or the customer's
           back wall (by height) */
        var y=o.position.y/S, gp=(o.geometry&&o.geometry.parameters)||{};
        var small=!!o.isMesh && ((gp.radius!=null) || ((gp.width||0)<=60*S && (gp.height||0)<=60*S && (gp.depth||0)<=60*S));
        if(prevTube && (Math.abs(o.position.x-prevTube.position.x)+Math.abs(o.position.y-prevTube.position.y)+Math.abs(o.position.z-prevTube.position.z))<60*S) s=prevTube.userData.qstep;
        else if(small && y<=ys[0]+120){ s=idx('posts',0); if(s<0) s=0; }
        else s=byLevel(y);
      }
      if(s===-2) above=true;
      u.qstep=s; o.userData=u;
      if(p&&p.kind!=='joint'&&p.kind!=='panel') prevTube=o;
    }
    if(above){
      var ai=P.steps.length; P.steps.push({name:'Splashback',kind:'above',lv:N});
      for(i=0;i<group.children.length;i++){ if(group.children[i].userData.qstep===-2) group.children[i].userData.qstep=ai; }
    }
    /* a step with no piece in it (a castor trolley has no floor rails at all) is not a step: drop it and
       renumber, sending any furniture that pointed at it to the next step that exists */
    var used={}, k;
    for(i=0;i<group.children.length;i++){ var uu=group.children[i].userData; if(uu&&uu.piece&&uu.qstep>=0) used[uu.qstep]=true; }
    var ns=[], map={};
    for(k=0;k<P.steps.length;k++){ if(used[k]){ map[k]=ns.length; ns.push(P.steps[k]); } }
    if(ns.length && ns.length<P.steps.length){
      for(i=0;i<group.children.length;i++){ var u2=group.children[i].userData, q=u2?u2.qstep:-1; if(q==null||q<0) continue;
        if(map[q]==null){ var k2=q; while(k2<P.steps.length && map[k2]==null) k2++; map[q]=(k2<P.steps.length)?map[k2]:ns.length-1; }
        u2.qstep=map[q]; }
      P.steps=ns;
    }
    if(QD_STEP>=P.steps.length) QD_STEP=P.steps.length-1;
    return P;
  }
  /* Show, dim or hide every drawn object for the current step; restore everything on the whole frame. The
     dimmed material is one clone per material, cached on the material itself (materials are recreated on
     every rebuild, so the cache never outlives them). */
  /* r-bv4: connector socket pegs. A real connector has a spigot in every socket; the drawing was
     a plain cube, so in a build step an empty socket (upright not fitted yet) made a 3-way read as
     a 2-way elbow - Patryk, 3 Sep, floor-frame step. Pegs appear ONLY inside a build step; the
     whole-frame view is untouched and by the last step every socket has its tube, so none draw.
     Directions come from qdNodeDirs (the SAME frameParts the cut list uses) - never a 2nd copy. */
  function bvClearStubs(){
    if(!group) return;
    for(var i=group.children.length-1;i>=0;i--){ var o=group.children[i]; if(o&&o.__qdStub){ group.remove(o); try{ o.geometry.dispose(); }catch(_e){} } }
  }
  function bvConnStubs(){
    if(!group||!T||!qdBuildView||QD_STEP<0||!qdNodeDirs) return 0;
    var S=1/1000, cs=25.4*S*1.01, sLen=cs*1.1, sW=cs*0.6, off=cs/2+sLen/2;
    if(!qdStubMat) qdStubMat=new T.MeshLambertMaterial({color:0x1a1a1a});
    var P=QD_STEP_PLAN||qdStepPlan();
    var idx=function(kind,lv){ for(var k=0;k<P.steps.length;k++) if(P.steps[k].kind===kind&&P.steps[k].lv===lv) return k; return -1; };
    var fill=function(d,yi){ if(d==='+y') return idx('posts',yi); if(d==='-y') return idx('posts',yi-1); return idx('rails',yi); };
    var made=0, n=group.children.length;
    for(var c=0;c<n;c++){
      var o=group.children[c], u=o.userData, p=u&&u.piece;
      if(!p||p.kind!=='joint'||o.__qdHid||u.qstep!==QD_STEP) continue;   /* only THIS step's lit connectors */
      var key=p.cx+','+p.cy+','+p.cz;   /* r-bv4: EXACT raw coords - frameParts keys dirs by K(x,y,z) floats; rounding never matches */
      var ds=qdNodeDirs[key]; if(!ds) continue;
      for(var di=0;di<ds.length;di++){
        var d=ds[di], fs=fill(d,p.yi);
        if(fs<=QD_STEP) continue;                 /* the tube for this socket is already placed */
        var g;
        if(d==='+x'||d==='-x') g=new T.BoxGeometry(sLen,sW,sW);
        else if(d==='+z'||d==='-z') g=new T.BoxGeometry(sW,sW,sLen);
        else g=new T.BoxGeometry(sW,sLen,sW);
        var sm=new T.Mesh(g,qdStubMat);
        sm.position.set(o.position.x+(d==='+x'?off:d==='-x'?-off:0),
                        o.position.y+(d==='+y'?off:d==='-y'?-off:0),
                        o.position.z+(d==='+z'?off:d==='-z'?-off:0));
        sm.__qdStub=true; sm.userData={qstep:QD_STEP}; sm.raycast=function(){};
        group.add(sm); made++;
      }
    }
    return made;
  }
  function qdStepApply(){
    if(!group) return;
    var i, o;
    try{ bvClearStubs(); }catch(_ecs){}
    if(!qdBuildView || QD_STEP<0){
      for(i=0;i<group.children.length;i++){ o=group.children[i]; if(o.__qdHid){ o.visible=true; o.__qdHid=false; } if(o.__qdOrig){ o.material=o.__qdOrig; o.__qdOrig=null; } }
      return;
    }
    qdStepStamp();
    for(i=0;i<group.children.length;i++){
      o=group.children[i]; var s=(o.userData&&o.userData.qstep!=null)?o.userData.qstep:-1;
      var want=(s<0)?'on':(s<QD_STEP?'dim':(s===QD_STEP?'on':'off'));
      if(want==='off'){ if(!o.__qdHid){ o.visible=false; o.__qdHid=true; } }
      else if(o.__qdHid){ o.visible=true; o.__qdHid=false; }
      if(want==='dim'){
        if(!o.__qdOrig) o.__qdOrig=o.material;
        var m=o.__qdOrig;
        if(m&&!m.length){ if(!m.__qdDim){ m.__qdDim=m.clone(); m.__qdDim.transparent=true; m.__qdDim.opacity=0.22; } o.material=m.__qdDim; }
      } else if(o.__qdOrig){ o.material=o.__qdOrig; o.__qdOrig=null; }
    }
    try{ bvConnStubs(); }catch(_ecs2){}
  }
  /* The current step's parts, counted off the drawing with the pills' own code lookup. */
  function qdStepParts(){
    var rows={}, order=[], out=[], i, o, u, p, key, row;
    if(!group) return out;
    for(i=0;i<group.children.length;i++){
      o=group.children[i]; u=o.userData||{}; p=u.piece;
      if(!p || u.qstep!==QD_STEP) continue;
      if(p.kind==='joint'){ var JL=qdJointLabel(p.xi,p.yi,p.zi), jt=qdJointType(p.xi,p.yi,p.zi), tag=jt?(QD_CONN_TAG[jt]||'?'):'?';
        key='3'+tag; row={code:tag, what:(JL&&JL.role)?JL.role:(QD_CONN_NAME[tag]?QD_CONN_NAME[tag]+' connector':'connector'), len:'', kind:'conn', sort:tag}; }
      else if(p.kind==='panel'){ var PL=qdPanelLabel(p.w,p.h);
        key='2'+(PL?PL.code:('?'+p.w+'x'+p.h)); row={code:PL?PL.code:'?', what:PL?PL.role:'panel', len:PL?PL.size:(Math.round(p.w)+' x '+Math.round(p.h)+' mm'), kind:'panel', sort:PL?PL.code:'zz'}; }
      else { var L=qdLabelFor(p.ax,p.len,p.sp);
        key='1'+(L?L.code:('?'+p.ax+Math.round(p.len))); row={code:L?L.code:'?', what:L?L.role:(p.sp?'back board piece':(p.ax==='y'?'upright':(p.ax==='x'?'cross rail':'depth rail'))), len:Math.round(p.len)+' mm', kind:'tube', sort:L?L.code:'zz', longPost:!!(u.legs&&u.legs.length>1)}; }
      if(!rows[key]){ rows[key]=row; row.n=0; order.push(key); }
      rows[key].n++; if(row.longPost) rows[key].longPost=true;
    }
    order.sort(function(a,b){ var ra=rows[a], rb=rows[b]; if(a.charAt(0)!==b.charAt(0)) return a.charAt(0)<b.charAt(0)?-1:1;
      var oa='PWDB'.indexOf(ra.sort.charAt(0)), ob='PWDB'.indexOf(rb.sort.charAt(0)); if(oa<0) oa=9; if(ob<0) ob=9; if(oa!==ob) return oa-ob;
      return ra.sort<rb.sort?-1:(ra.sort>rb.sort?1:0); });
    for(i=0;i<order.length;i++) out.push(rows[order[i]]);
    return out;
  }
  function qdStepWords(st, rows, res, esc){
    var hasPanel=false, longPost=false, i;
    for(i=0;i<rows.length;i++){ if(rows[i].kind==='panel') hasPanel=true; if(rows[i].longPost) longPost=true; }
    var w;
    if(st.kind==='rails'&&st.lv===0) w='Lay the floor rails out flat and push a connector onto every end.'+(hasPanel?' Drop the floor panels in as you go.':'');
    /* r-bv3-B, Patryk: "the connectors on each level seem to be missing the top part if it's a
       3way". They are not missing - the connector that caps an upright is fitted in the NEXT
       step, with the rails, which is what the next step's own words already say. The uprights
       step never said it, so a bare upright reads as a mistake. One clause fixes that. */
    else if(st.kind==='posts') w='Stand an upright in every upward socket of the connectors below.'+(longPost?' A long upright that runs straight through the next level goes in now.':'')+' The connector that caps each upright is NOT missing - it goes on in the next step, with the rails.'+((st.lv===0&&res&&res.feetText)?' Fit the feet ('+esc(res.feetText)+') to the bottom of the standing legs.':'');
    else if(st.kind==='rails') w='Push a connector onto the top of every upright, then fit the rails between them.'+(hasPanel?' Drop the panels in as you go.':'');
    else w='The splashback goes on last: risers into the top connectors, then its rails and panels.';
    return w+' <strong>Tap any piece</strong> to see what it is. Grey pieces are already built.';
  }
  function qdStepGo(i){
    var P=QD_STEP_PLAN||qdStepStamp(), n=P.steps.length;
    /* r-bv1, Patryk 3 Sep: "The default view I think for design step by step should be top view."
       Set it ONCE, on the way IN from the resting state - not on every step. If the customer has
       turned the frame to look at something, stepping on must not snatch it back. */
    var _bvWasRest = (QD_STEP < 0);
    QD_STEP=(i<0)?-1:Math.max(0,Math.min(n-1,i));
    if(_bvWasRest && QD_STEP>=0){ try{ setView('top'); }catch(_ebv){} }
    try{ bvStageNav(); }catch(_ebn){}
    qdStepApply(); try{ qdBuildChip(null); }catch(_ec){}
    qdBuildPanel(qdQuoteNow()||window.aaLastQuote||{});
    /* Bring the right thing into view. Stacked (phone): the drawing's top, 12 px down - past the 8 px
       sticky line, so the stage is at its full height with the step bar right under it. Side by side
       (desktop): the stage is sticky on the left, so only the step bar needs to be on screen. */
    try{
      var stacked=!!(window.matchMedia&&window.matchMedia('(max-width: 980px)').matches), st=document.querySelector('.qd-stage');
      if(stacked && st){
        /* the stage is sticky, so its own rect lies once it is pinned; the r42 marker just before it never moves */
        var mk=st.previousElementSibling, mr=(mk&&mk.getAttribute('aria-hidden')==='true'&&mk.offsetHeight===0)?mk.getBoundingClientRect():st.getBoundingClientRect();
        if(Math.abs(mr.top-12)>2) window.scrollBy({top:mr.top-12, left:0, behavior:'smooth'});
      }
      else { var bar=$('qd-stepbar')||$('qd-build'); if(bar){ var r=bar.getBoundingClientRect(); if(r.top<8 || r.top>window.innerHeight-80) window.scrollBy({top:r.top-8, left:0, behavior:'smooth'}); } }
    }catch(_esc){}
  }
  function qdStepWire(host){
    var on=function(id,fn){ var e=host.querySelector('#'+id); if(e) e.addEventListener('click',function(ev){ ev.preventDefault(); fn(); }); };
    on('qd-step-start',function(){ qdStepGo(0); });
    on('qd-step-all',function(){ qdStepGo(-1); }); on('qd-step-all2',function(){ qdStepGo(-1); });
    on('qd-step-prev',function(){ qdStepGo(QD_STEP-1); }); on('qd-step-prev2',function(){ qdStepGo(QD_STEP-1); });
    on('qd-step-next',function(){ qdStepGo(QD_STEP+1); }); on('qd-step-next2',function(){ qdStepGo(QD_STEP+1); });
  }
  var QD_STEP_BTN='border:0;border-radius:10px;padding:11px 12px;font-weight:800;font-size:14px;cursor:pointer;font-family:inherit;';
  function qdStepHTML(res, esc){
    var P=QD_STEP_PLAN||qdStepStamp(), n=P.steps.length, st=P.steps[QD_STEP], rows=qdStepParts(), h=[], i;
    var arrow='flex:0 0 auto;width:38px;height:38px;border:0;border-radius:10px;background:#12b8e5;color:#fff;font-size:15px;cursor:pointer;font-family:inherit;';
    h.push('<div id="qd-stepbar" style="display:flex;align-items:center;gap:8px;background:#0e1a4d;color:#fff;border-radius:12px;padding:7px 7px 7px 12px;margin:2px 0 6px">'
      +'<button type="button" id="qd-step-prev" aria-label="Previous step"'+(QD_STEP===0?' disabled':'')+' style="'+arrow+'opacity:'+(QD_STEP===0?'.35':'1')+'"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="15 5 7 12 15 19"></polyline></svg></button>'
      +'<div style="flex:1;min-width:0"><div style="font-size:11px;opacity:.85">Step '+(QD_STEP+1)+' of '+n+'</div><div style="font-size:16px;font-weight:800;line-height:1.2">'+esc(st.name)+'</div></div>'
      +'<button type="button" id="qd-step-next" aria-label="Next step"'+(QD_STEP===n-1?' disabled':'')+' style="'+arrow+'opacity:'+(QD_STEP===n-1?'.35':'1')+'"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="9 5 17 12 9 19"></polyline></svg></button></div>');
    h.push('<div style="display:flex;gap:4px;margin:0 0 8px">'); for(i=0;i<n;i++) h.push('<span style="flex:1;height:4px;border-radius:2px;background:'+(i<=QD_STEP?'#12b8e5':'#e2e8f0')+'"></span>'); h.push('</div>');
    h.push('<div style="font-size:12.5px;color:#0e1a4d;margin-bottom:10px">'+qdStepWords(st,rows,res,esc)+' <a href="#" id="qd-step-all" style="color:#0e8fb8;font-weight:700;white-space:nowrap">Show whole frame</a></div>');
    if(rows.length){
      var TH='text-align:left;padding:4px 6px;border-bottom:1.5px solid #0e1a4d;font-size:10px;letter-spacing:.06em;color:#64748b';
      h.push('<table style="border-collapse:collapse;width:100%;font-size:12px"><tr><th style="'+TH+'">CODE</th><th style="'+TH+'">WHAT</th><th style="'+TH+';text-align:right">QTY</th></tr>');
      for(i=0;i<rows.length;i++){ var r=rows[i], bg=(r.kind==='conn'?'#0e1a4d':(r.kind==='panel'?'#0f766e':'#ea580c'));
        h.push('<tr><td style="padding:6px;border-bottom:1px solid #e2e8f0"><span style="display:inline-block;background:'+bg+';color:#fff;border-radius:8px;padding:1px 7px;font-weight:800">'+esc(r.code)+'</span></td><td style="padding:6px;border-bottom:1px solid #e2e8f0">'+(r.len?'<strong>'+esc(r.len)+'</strong> ':'')+esc(r.what)+'</td><td style="padding:6px;border-bottom:1px solid #e2e8f0;text-align:right;white-space:nowrap"><strong>&times; '+r.n+'</strong></td></tr>');
      }
      h.push('</table>');
    } else {
      h.push('<div style="font-size:12.5px;color:#92400e;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:8px 10px">Nothing to add at this step.</div>');
    }
    h.push('<div style="display:flex;gap:8px;margin-top:12px">'
      +'<button type="button" id="qd-step-prev2" style="'+QD_STEP_BTN+'flex:1;background:#fff;color:#0e1a4d;border:1px solid #cbd5e1;visibility:'+(QD_STEP===0?'hidden':'visible')+'"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="15 5 7 12 15 19"></polyline></svg> Previous</button>'
      +(QD_STEP===n-1
        ? '<button type="button" id="qd-step-all2" style="'+QD_STEP_BTN+'flex:1.4;background:#0e1a4d;color:#fff">Done &#10003; show whole frame</button>'
        : '<button type="button" id="qd-step-next2" style="'+QD_STEP_BTN+'flex:1.4;background:#0e1a4d;color:#fff">Next step <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="9 5 17 12 9 19"></polyline></svg></button>')
      +'</div>');
    return h.join('');
  }
  /* r-bv-refused (8 Sep 2026, Patryk: "it seems to be frozen?"). The build view painted its list ONLY from a
     good quote, and a refusal's words went to #qd-msg - which body.qd-build hides. So a frame the engine will
     no longer price (order #261051: a 100mm-deep shelf sold 3 Aug with 49mm depth rails, refused since the
     short-piece rule) sat on "Loading your frame..." for good. This is the panel's failure state: what
     happened, what the customer can still do (the drawing still names every piece on a tap - qdBuildChip
     needs no quote for the length and the role), the sheet in the box, and email. canRetry = a session or
     network failure: the button clicks the designer's own hidden #qd-retry (session reset + cache clear +
     recalc), so one retry path exists, not two. */
  function qdBuildRefused(words, canRetry){
    var host=$('qd-build'); if(!host) return;
    var esc=function(v){ return String(v==null?'':v).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
    var w=String(words||'').trim(), h=[];
    h.push('<div style="font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#ea580c">Build view</div>');
    h.push('<h3 style="margin:2px 0 6px;font-size:17px;color:#0e1a4d">Your frame, piece by piece</h3>');
    if(canRetry){
      h.push('<div id="qd-build-fail" data-kind="retry" style="font-size:12.5px;color:#0e1a4d;background:#fff7ed;border:1px solid #fb923c;border-radius:8px;padding:10px 12px"><strong>We could not load the part list just now</strong> — '+esc(w||'the frame designer did not answer.')
        +'<button type="button" id="qd-build-retry" style="'+QD_STEP_BTN+'display:block;width:100%;background:#0e1a4d;color:#fff;margin:10px 0 0">Try again</button></div>');
    } else {
      h.push('<div id="qd-build-fail" data-kind="refused" style="font-size:12.5px;color:#0e1a4d;background:#fff7ed;border:1px solid #fb923c;border-radius:8px;padding:10px 12px"><strong>The part codes for this frame can’t be listed online.</strong> The designer’s current rules don’t price this exact frame'
        +(w?', so there is no list to show. The designer said: <span style="color:#475569">“'+esc(w)+'”</span>':'.')+'</div>');
    }
    h.push('<div style="font-size:12.5px;color:#0e1a4d;margin-top:10px">The parts sheet in the box lists every piece and its code. <strong>Tap any piece on the drawing</strong> to see its length and where it goes. Spin the drawing with a finger; pinch to zoom.</div>');
    h.push('<div style="margin-top:12px;display:flex;flex-direction:column;gap:8px">'
      +'<a href="/pages/alucube-assembly" style="display:block;text-align:center;background:#0e1a4d;color:#fff;border-radius:8px;padding:10px;font-weight:700;text-decoration:none">How AluCube goes together</a>'
      +'<a href="'+qdAskURL('')+'" style="display:block;text-align:center;border:1px solid #fb923c;background:#fff7ed;color:#9a3412;border-radius:8px;padding:9px;font-weight:700;text-decoration:none">Stuck? Ask us about this frame</a></div>');
    h.push('<div style="font-size:11px;color:#64748b;margin-top:8px">Your order number'+(qdBuildOrder?' (#'+qdBuildOrder+')':'')+' and this design go with the message, so we can open your exact frame and send the part list again. Or email <strong>sales@allaluminium.com.au</strong> with your order number.</div>');
    host.innerHTML=h.join('');
    var rb=host.querySelector('#qd-build-retry');
    if(rb) rb.addEventListener('click', function(ev){ ev.preventDefault(); host.innerHTML='<div style="font-size:12.5px;color:#475569">Loading your frame…</div>'; var r=$('qd-retry'); if(r) r.click(); });
  }
  function qdBuildPanel(res){
    var host=$('qd-build'); if(!host) return;
    var L=(res&&res.labels)||[], h=[];
    var esc=function(v){ return String(v==null?'':v).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
    /* r-qv: THE QUOTE PANEL. Returns before a single part, length or step is written.
       The sizes come from the URL the quote linked to, not from the engine - there is
       no engine answer in qv mode. */
    if(qdQuoteView){
      var qp=function(k){ try{ var m=new RegExp('[?&]'+k+'=([^&]*)').exec(location.search); return m?decodeURIComponent(m[1]):''; }catch(_e){ return ''; } };
      var W=qp('w'), D=qp('d'), H=qp('h'), TI=qp('tiers'), CO=qp('cols'), TY=qp('type');
      var size=(W&&D&&H)?(esc(W)+' \u00d7 '+esc(D)+' \u00d7 '+esc(H)+' mm'):'';
      var extra=[];
      /* r-qv2/qv3: the frame in the store's OWN words, from the same tokens the designer's
         dropdowns use. tiers is printed ONLY for a shelving unit - measured on live V13.3,
         a box frame returns the identical cut list at tiers 2, 3 and 4 (4 x 1749 posts,
         8 x 1149 rails, rails top and bottom), so "3 levels" described nothing. An unknown
         token prints nothing rather than guessing. */
      var TYPES={ box:'Box frame', shelf:'Shelving unit' };
      var PANELS={ none:'frame only', all:'panels on every shelf', top:'top panel',
                   back:'back panel', backfront:'front and back panels', sides:'side panels',
                   enclosed:'enclosed, open front', enclosedfront:'fully enclosed',
                   custom:'panels on chosen faces', byo:'you supply the panels' };
      if(TYPES[TY]) extra.push(TYPES[TY]);
      if(TY === 'shelf'){
        if(TI && TI!=='1') extra.push(esc(TI)+' levels');
        if(CO && CO!=='1') extra.push(esc(CO)+' bays wide');
      }
      var PN=qp('panels');
      if(PANELS[PN]) extra.push(PANELS[PN]);
      h.push('<div style="font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#ea580c">Your quote</div>');
      h.push('<h3 style="margin:2px 0 8px;font-size:17px;color:#0e1a4d">The frame we have priced</h3>');
      if(size) h.push('<div style="font-size:15px;font-weight:700;color:#0e1a4d;margin:0 0 2px">'+size+'</div>');
      if(extra.length) h.push('<div style="font-size:12.5px;color:#64748b;margin:0 0 10px">'+extra.join(' \u00b7 ')+'</div>');
      h.push('<div style="font-size:12.5px;color:#0e1a4d;line-height:1.5;margin:10px 0 0">Spin it with a finger or drag it with the mouse, and check the size is the frame you asked for. Tell us if anything is not right and we will re-quote it.</div>');
      h.push('<div style="font-size:12px;color:#64748b;line-height:1.5;margin:10px 0 0">The cut sizes and the piece-by-piece build come with the order once it goes ahead, with a sticker on every tube.</div>');
      host.innerHTML=h.join('');
      return;
    }
    if(QD_STEP>=0){   /* r240: one step at a time - the step bar first, so it sits right under the drawing on a phone */
      try{ h.push(qdStepHTML(res,esc)); }catch(_e240){ h.push('<div style="font-size:12.5px;color:#92400e">The step-by-step view could not be drawn for this frame. <a href="#" id="qd-step-all">Show whole frame</a></div>'); }
      h.push('<div style="font-size:11px;color:#64748b;margin:12px 0 10px">'+esc(res.recipe||'')+'</div>');
    } else {
    h.push('<div style="font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#ea580c">Build view</div>');
    h.push('<h3 style="margin:2px 0 6px;font-size:17px;color:#0e1a4d">Your frame, piece by piece</h3>');
    h.push('<div style="font-size:12.5px;color:#475569;margin-bottom:10px">'+esc(res.recipe||'')+'</div>');
    h.push('<div style="font-size:12.5px;color:#0e1a4d;margin-bottom:10px">Every tube in the box has a sticker with its code. <strong>Tap any piece on the drawing</strong> to see what it is and where it goes. Spin the drawing with a finger; pinch to zoom.</div>');
      /* r240: the whole frame is the resting state; the walk-through is one press away */
      var _sn=0; try{ _sn=qdStepStamp().steps.length; }catch(_esn){}
      if(_sn>1 && L.length) h.push('<button type="button" id="qd-step-start" style="'+QD_STEP_BTN+'display:block;width:100%;background:#0e1a4d;color:#fff;margin:0 0 4px">Build it step by step <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="9 5 17 12 9 19"></polyline></svg></button><div style="font-size:11.5px;color:#64748b;margin:0 0 12px">'+_sn+' steps: the floor frame first, then the uprights, then each level. Only that step\'s pieces are shown and listed.</div>');
    }
    if(QD_STEP<0 && L.length){
      h.push('<table style="border-collapse:collapse;width:100%;font-size:12px"><tr><th style="text-align:left;padding:4px 6px;border-bottom:1.5px solid #0e1a4d;font-size:10px;letter-spacing:.06em;color:#64748b">CODE</th><th style="text-align:left;padding:4px 6px;border-bottom:1.5px solid #0e1a4d;font-size:10px;letter-spacing:.06em;color:#64748b">WHAT</th><th style="text-align:left;padding:4px 6px;border-bottom:1.5px solid #0e1a4d;font-size:10px;letter-spacing:.06em;color:#64748b">LENGTH</th><th style="text-align:left;padding:4px 6px;border-bottom:1.5px solid #0e1a4d;font-size:10px;letter-spacing:.06em;color:#64748b">QTY</th></tr>');
      for(var i=0;i<L.length;i++){ var l=L[i], _k=l.kind||'tube', _bg=(_k==='conn'?'#0e1a4d':(_k==='panel'?'#0f766e':'#ea580c'));
        h.push('<tr><td style="padding:6px;border-bottom:1px solid #e2e8f0"><span style="display:inline-block;background:'+_bg+';color:#fff;border-radius:8px;padding:1px 7px;font-weight:800">'+esc(l.code)+'</span></td><td style="padding:6px;border-bottom:1px solid #e2e8f0">'+esc(l.role)+'<div style="font-size:11px;color:#64748b">'+esc(l.where)+'</div></td><td style="padding:6px;border-bottom:1px solid #e2e8f0;white-space:nowrap"><strong>'+(_k==='conn'?'\u2014':(_k==='panel'?esc(l.size):esc(l.len)+' mm'))+'</strong></td><td style="padding:6px;border-bottom:1px solid #e2e8f0">'+esc(l.qty)+'</td></tr>');
      }
      h.push('</table>');
    } else if(QD_STEP<0){   /* r240: on a step the step block above has already said what there is */
      h.push('<div style="font-size:12.5px;color:#92400e;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:8px 10px">The part codes for this frame are not available yet. The sheet in the box has them.</div>');
    }
    if(QD_STEP<0 && res.connText) h.push('<div style="font-size:12.5px;margin-top:10px"><strong>Connectors:</strong> '+esc(res.connText)+'<div style="font-size:11px;color:#64748b;margin-top:2px">The small dark pills on the drawing are the connector at each joint: 3C / 4C corner, 3F / 4F flat, 5W five-way, 2W elbow. A Corner turns; a Flat runs straight through.</div></div>');
    if(QD_STEP<0 && res.feetText) h.push('<div style="font-size:12.5px;margin-top:4px"><strong>Feet:</strong> '+esc(res.feetText)+'</div>');
    h.push('<div style="margin-top:12px;display:flex;flex-direction:column;gap:8px">'
      +'<a href="/pages/alucube-assembly" style="display:block;text-align:center;background:#0e1a4d;color:#fff;border-radius:8px;padding:10px;font-weight:700;text-decoration:none">How AluCube goes together</a>'
      +'<button type="button" onclick="window.print()" style="border:1px solid #cbd5e1;background:#fff;color:#0e1a4d;border-radius:8px;padding:9px;font-weight:600;cursor:pointer;font-family:inherit">Print this list</button></div>');
    /* r-bv8: the finished-build "what next" card. Only in the resting whole-frame state,
       never mid-step. Two routes: design another, or order spares (the connectors collection
       holds connectors, feet, caps and End Cap at 56c - the fix for "I wanted end caps for a
       few of these"). No castor CTA: castor pricing is parked. */
    if(QD_STEP<0){
      h.push('<div style="margin-top:14px;padding-top:12px;border-top:1px solid #e2e8f0">'
        +'<div style="font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#64748b;margin-bottom:8px">All built? What next</div>'
        +'<div style="display:flex;flex-direction:column;gap:8px">'
        +'<a href="/pages/alucube-designer" style="display:block;text-align:center;background:#0e1a4d;color:#fff;border-radius:8px;padding:10px;font-weight:700;text-decoration:none">Design another frame</a>'
        +'<a href="/collections/alucube-connectors" style="display:block;text-align:center;border:1px solid #cbd5e1;background:#fff;color:#0e1a4d;border-radius:8px;padding:9px;font-weight:600;text-decoration:none">Spare parts &amp; extras</a>'
        +'</div>'
        +'<div style="font-size:11px;color:#64748b;margin-top:6px">Need a few more connectors, end caps or feet? They\u2019re all here, from 56c each.</div>'
        +'</div>');
    }
    h.push('<a href="'+qdAskURL('')+'" style="display:block;margin-top:10px;text-align:center;border:1px solid #fb923c;background:#fff7ed;color:#9a3412;border-radius:8px;padding:9px;font-weight:700;text-decoration:none">Stuck? Ask us about this frame</a>');
    h.push('<div style="font-size:11px;color:#64748b;margin-top:8px">Your order number'+(qdBuildOrder?' (#'+qdBuildOrder+')':'')+' and this design go with the message, so we can open your exact frame. Or email <strong>sales@allaluminium.com.au</strong> with a photo.</div>');
    h.push('<div style="font-size:11px;color:#64748b;margin-top:8px">Domestic, office and retail use. We do not publish a weight rating for made-to-measure frames.</div>');
    host.innerHTML=h.join('');
    try{ qdStepWire(host); }catch(_ew240){}   /* r240 */
  }
  (function(){
    if(!qdBuildView) return;
    try{ document.body.classList.add('qd-build'); }catch(_e){}
    /* r-qv4: ARMED for the real build view only. In the quote view there is no quote and
       no joints[], so neither pill can draw - and an armed flag there is how part codes
       would quietly return to a pre-purchase drawing if the quote guard ever loosened. */
    qdCodesOn=!qdQuoteView; qdConnsOn=!qdQuoteView;   /* r225: joints pilled too in build view */
    /* r240 (Patryk 3 Sep: "show wide opening ... needs to be hidden when the order goes ahead"): the amber
       overlay and its WIDEST SPAN badge are a designer-time warning. In the build view the order is done
       and the page is an assembly guide, so the paint is off and the tick box is never shown. The designer
       keeps both, and the order still carries 'Wide span accepted' (r58) - nothing about the risk is hidden
       before the sale. */
    spanHL=false; try{ var _sp240=$('qd-spanhl'); if(_sp240) _sp240.checked=false; }catch(_esp240){}
    try{ var _ct=$('qd-connhl'); if(_ct) _ct.checked=!qdQuoteView; }catch(_ect){}   /* r-qv4 */
    var host=$('qd-build'); if(host) host.innerHTML='<div style="font-size:12.5px;color:#475569">Loading your frame\u2026</div>';
    /* the hint under the drawing talks about deleting rails - not in build view */
    try{ var _hint=document.querySelector('.qd-stage .qd-hint'); if(_hint) _hint.textContent='tap any piece to see what it is \u00b7 drag to rotate \u00b7 scroll or pinch to zoom'; }catch(_eh){}
  })();
  /* r227 STAFF BOX - Patryk 2 Sep 2026: "having the kg rating in the designer, so we can toggle
     it on and off, change or add supports and see it update ... the total kg's and longest
     length so we can quote for delivery ... add the offcuts". Both come from the ENGINE
     (alucut 1.38.0 freight and loadGuide), so this box, the production sheet and the order
     stamp (_Freight) can never disagree. Staff only: #qd-staffbox exists only inside the
     section's is_staff branch, so for a customer this function returns on its first line.
     The guide is CALCULATED and UNVERIFIED - the wording says so on every paint, the engine
     caps it, and it is never a rating (the customer-facing kg rating was removed in r58 for
     exactly that reason and stays removed). */
  /* r228: which engine row is this shelf? A shelf panel is opening - 2 on each axis, so its
     bay is (w+2) x (h+2); the nearest row within a couple of mm, either way round. */
  function qdGuideRowFor(pc, lg){
    if(!lg||!lg.rows||!lg.rows.length) return null;
    var w=pc.w+2, d=pc.h+2, best=null, bd=6;
    lg.rows.forEach(function(r){ var e=Math.min(Math.abs(r.w-w)+Math.abs(r.d-d), Math.abs(r.w-d)+Math.abs(r.d-w)); if(e<bd){ bd=e; best=r; } });
    return best;
  }
  function qdGuidePillText(r, lg){
    var kgTx=function(v){ return v<20?Math.round(v):Math.round(v/5)*5; };
    if(r.capped) return 'cap '+lg.capKg+' kg';          /* the guide's cap - the tube is not the limit under it; nothing is checked above it */
    var t='\u2248'+kgTx(r.spreadKg)+' kg';
    if(r.governs==='panel') t+=' \u00b7 panel';          /* the 6mm plate sags before the rails */
    else if(r.panel==='byo') t+=' \u00b7 own panel';      /* rails only - the customer's panel is not assessed */
    return t;
  }
  function qdGuideKey(){
    var q=qdQuoteNow(), g=q&&q.loadGuide;
    if(!g||!g.rows) return 'none';
    return g.capKg+':'+g.rows.map(function(r){ return r.w+'x'+r.d+'='+r.spreadKg+(r.capped?'c':'')+r.governs.charAt(0)+r.panel.charAt(0); }).join(',');
  }
  /* r228: tap a shelf (the r197 pairing) -> its row in the staff box lights up. */
  function qdGuideRowHL(){
    var box=$('qd-staffbox'); if(!box) return;
    var rows=box.querySelectorAll('tr[data-bay]'), i, want=null;
    if(qdPairSel&&qdPairSel.panel&&group){
      for(i=0;i<group.children.length;i++){ var m=group.children[i], id=m.userData&&m.userData.panel, pc=m.userData&&m.userData.piece;
        if(id&&pc&&pc.kind==='panel'&&id[0]===qdPairSel.panel[0]&&id[1]===qdPairSel.panel[1]&&id[2]===qdPairSel.panel[2]){
          var r=qdGuideRowFor(pc,(qdQuoteNow()&&qdQuoteNow().loadGuide)||null); if(r) want=r.w+'x'+r.d; break; } }
    }
    for(i=0;i<rows.length;i++){ var on=(want!==null&&rows[i].getAttribute('data-bay')===want); rows[i].style.outline=on?'2px solid #ea580c':''; rows[i].style.background=on?'#ffedd5':''; }
  }
  function qdStaffPaint(res){
    var box=$('qd-staffbox'); if(!box) return;
    if(!res || !res.ok || (typeof qdBuildView!=='undefined' && qdBuildView)){ box.style.display='none'; box.innerHTML=''; return; }
    var E=function(v){ return String(v==null?'':v).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
    var f=res.freight, g=res.loadGuide, h='';
    var keep=!!($('qd-keepoffcuts')&&$('qd-keepoffcuts').checked);
    h+='<div style="font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#ea580c;font-weight:800">Staff only \u2014 not shown to customers</div>';
    if(f){
      h+='<div style="margin-top:4px"><strong>Freight:</strong> kit <strong>'+E(f.kitKg)+' kg</strong> (tube '+E(f.tubeKg)+' \u00b7 connectors '+E(f.connKg)+' \u00b7 feet '+E(f.feetKg)+' \u00b7 panels '+E(f.panelKg)+'), longest piece <strong>'+E(f.longestMm)+' mm</strong> ('+E(f.longestWhat)+'), '+E(f.pieces)+' pieces + '+E(f.connectors)+' connectors'+(f.panels?' + '+E(f.panels)+' panel'+(f.panels===1?'':'s'):'')+'.'
        +' Offcuts: <strong>'+E(f.offcutKg)+' kg</strong>, longest <strong>'+E(f.longestOffcutMm)+' mm</strong> \u2014 '+(keep?'<strong>ship</strong> (keep offcuts is ticked)':'stay here (keep offcuts not ticked)')+'.'
        +' Bars as billed '+E(f.barsKg)+' kg.'
        +(f.unweighed&&f.unweighed.length?' <span style="color:#9a3412">Not weighed: '+E(f.unweighed.join(', '))+'.</span>':'')
        +' <span style="color:#64748b">Calculated from the shop\u2019s part weights, not weighed on the bench.</span></div>';
    } else {
      h+='<div style="margin-top:4px"><strong>Freight:</strong> not on this quote \u2014 needs alucut 1.38.0 (this one came from '+E(res.engine||'an older engine')+').</div>';
    }
    if(qdGuideOn){
      h+='<div style="margin-top:8px;border-top:1px solid #fdba74;padding-top:6px"><strong>Load guide</strong> \u2014 calculated \u00b7 not verified \u00b7 not a rating.';
      if(g && g.rows && g.rows.length){
        h+='<div style="overflow-x:auto"><table style="border-collapse:collapse;width:100%;margin-top:5px;font-size:12px"><tr>'+['Shelf bay','Panel sits on','Rail span','Spread over the shelf','One item mid-shelf','Sag per 10 kg','What sags first'].map(function(t){ return '<th style="text-align:left;font-size:10px;letter-spacing:.05em;text-transform:uppercase;color:#9a3412;border-bottom:1px solid #fdba74;padding:3px 6px">'+t+'</th>'; }).join('')+'</tr>';
        var kgTx=function(v){ if(v>=g.capKg) return '<span style="color:#64748b">over '+E(g.capKg)+' kg \u2014 the tube is not the limit</span>'; var r=v<20?Math.round(v):Math.round(v/5)*5; return '<strong>about '+r+' kg</strong>'; };
        g.rows.forEach(function(r){
          var sits=r.railPair==='angle'?'ledges on 4 rails (long pair taken)':(r.railPair==='depth'?'the 2 depth rails':'the 2 width rails');
          var pan=r.panel==='6mm'?'6mm plate':(r.panel==='byo'?'customer\u2019s own \u2014 not assessed':(r.panel==='none'?'no panel':'panel not assessed'));
          var lim=r.capped?'nothing checked above '+E(g.capKg)+' kg \u2014 joints have no data':(r.governs==='panel'?'the 6mm panel (bridging '+E(r.bridgeMm)+' mm)':'the rails');
          var sag=E(r.railSagPer10kgMm)+' mm rail'+((r.governs==='panel'&&r.panelSagPer10kgMm!=null)?', '+E(r.panelSagPer10kgMm)+' mm panel':'');
          h+='<tr data-bay="'+E(r.w)+'x'+E(r.d)+'">'+['<strong>'+E(r.w)+' \u00d7 '+E(r.d)+'</strong> mm', sits+'<div style="color:#64748b">'+pan+'</div>', E(r.railSpanMm)+' mm<div style="color:#64748b">sag limit '+E(r.sagLimitMm)+' mm</div>', kgTx(r.spreadKg), kgTx(r.pointKg), sag, lim].map(function(c){ return '<td style="padding:4px 6px;border-bottom:1px solid #fed7aa;vertical-align:top">'+c+'</td>'; }).join('')+'</tr>';
        });
        h+='</table></div>';
        h+='<div style="margin-top:4px;color:#9a3412">On the drawing: one pill per shelf - \u201c\u224830 kg\u201d is the spread figure, \u201ccap 50 kg\u201d means the tube is not the limit under the cap and nothing is checked above it. Tap a shelf to light up its row.</div>';
        h+='<div style="margin-top:5px;color:#7f1d1d;font-weight:700">Never quote these to a customer, and never put a kg figure on the store from this box. Calculated from the tube section ('+E(g.tube)+', I \u2248 '+E(g.I_mm4)+' mm\u2074, sag limit span/'+E(g.sagDiv)+', a rail = a simply supported beam between its two connectors, half the shelf on each); the nylon connectors have no test data and are not assessed; capped at '+E(g.capKg)+' kg per bay until a real frame is measured. Domestic, office and retail use only.</div>';
      } else {
        h+='<div style="margin-top:4px">Not on this quote \u2014 needs alucut 1.38.0 and a frame with openings (this one came from '+E(res.engine||'an older engine')+').</div>';
      }
      h+='</div>';
    }
    box.innerHTML=h; box.style.display='block';
    try{ qdGuideRowHL(); }catch(_e228){}
  }
  /* r221: staff buttons in the Review row. "Part labels" opens the production sheet's Dymo
     page straight away (the sheet exposes window.aaOpenLabels); when the quote carries no
     codes yet (engine before 1.36.0) it opens the sheet itself, which says why. "Codes on
     drawing" toggles the pills. Both buttons only exist inside the is_staff Liquid branch. */
  (function(){
    var b=$('qd-labels');
    if(b) b.addEventListener('click', function(ev){
      ev.preventDefault();
      var ok=false;
      try{ ok = (typeof window.aaOpenLabels==='function') ? window.aaOpenLabels() : false; }catch(e){ ok=false; }
      if(!ok){ var sb=document.getElementById('aa-sfs-btn'); if(sb) sb.click(); }
    });
    var t=$('qd-codes');
    if(t) t.addEventListener('click', function(ev){
      ev.preventDefault();
      qdCodesOn=!qdCodesOn;
      t.setAttribute('aria-pressed', qdCodesOn?'true':'false');
      t.style.background=qdCodesOn?'#ea580c':'#fff7ed'; t.style.color=qdCodesOn?'#fff':'#ea580c';
      try{ if(GZ) GZ.rx=null; }catch(e){}   /* force the label layer to repaint */
    });
    /* r227: the orange Load guide toggle; the freight line is always in the box, the table only while on */
    var lg=$('qd-loadguide');
    if(lg) lg.addEventListener('click', function(ev){
      ev.preventDefault();
      qdGuideOn=!qdGuideOn;
      lg.setAttribute('aria-pressed', qdGuideOn?'true':'false');
      lg.style.background=qdGuideOn?'#ea580c':'#fff7ed'; lg.style.color=qdGuideOn?'#fff':'#ea580c';
      try{ qdStaffPaint(window.aaLastQuote); }catch(e){}
    });
    var ko=$('qd-keepoffcuts');
    if(ko && $('qd-staffbox')) ko.addEventListener('change', function(){ try{ qdStaffPaint(window.aaLastQuote); }catch(e){} });
  })();
  /* r219: Why? folds the long text open and shut. */
  document.addEventListener('click', function(ev){
    var b=ev.target && ev.target.closest ? ev.target.closest('.qd-why') : null;
    if(!b) return;
    ev.preventDefault();
    var box=b.closest('#qd-strength'); var t=box?box.querySelector('.qd-whytext'):null; if(!t) return;
    var open=(t.style.display!=='none'); t.style.display=open?'none':'block'; b.setAttribute('aria-expanded',open?'false':'true'); b.textContent=open?'Why?':'Hide';
  }, false);
  document.addEventListener('click', function(ev){
    var b=ev.target && ev.target.closest ? ev.target.closest('.qd-addsup') : null;
    if(!b) return;
    var el=$(b.getAttribute('data-ctl')); if(!el) return;
    var v=b.getAttribute('data-n'), ok=false, i;
    for(i=0;i<el.options.length;i++) if(el.options[i].value===v && !el.options[i].disabled) ok=true;
    if(!ok) return;
    /* r219: through qdDriveControl, so a castor frame keeps its floor bars out and the
       whole thing is one undo step. Before this the control's own listener committed. */
    qdDriveControl(el, v, 'adding a support', 'Added a support.');
  }, false);
  /* r150 Q7: thickness radios redraw the picture and ride the address bar. */
  (function(){
    function setTh(v){ qdPanelTh=(String(v)==='17')?17:6; try{ rebuild3D(); }catch(e){} try{ qdSyncAddressBar(); }catch(e2){} }
    /* r173: the supply choice decides whether the timber look applies at all,
       so the drawing has to be rebuilt when THAT changes too - not just when
       the thickness does. Without this, switching to BYO left the panels grey
       until something else happened to repaint them. */
    (function(){ var sp=$('qd-supply'); if(sp) sp.addEventListener('change', function(){ try{ rebuild3D(); }catch(e){} }); })();
    ['qd-thick-6','qd-thick-17'].forEach(function(id){ var el=$(id); if(el) el.addEventListener('change',function(){ if(this.checked) setTh(this.value); }); });
  })();
  $('qd-panel').addEventListener('change',function(){
    panelMode=this.value;
    /* r65: a removed panel is named by level/bay under ONE panel mode. Changing the mode
       changes which panels exist, so the removals are cleared rather than misapplied -
       the engine would refuse a stale entry anyway. Undo restores mode and removals
       together, and sets this value without firing 'change', so it is not affected. */
    if(qdNoPanels.length||qdSelPanels.length){ qdNoPanels=[]; qdSelPanels=[]; syncPostUI(); }
    syncDelHelp();
    updatePanelNote();
    recalc();
  });
  (function(){ var s=$('qd-supply'); if(s){ s.addEventListener('change',function(){
    panelSupply=this.value;
    /* r74, Patryk 25 Aug: he removed panels under BYO, switched to the 5083 upgrade, and got
       an unpanelled frame while both dropdowns promised panels - the removals survived the
       material change invisibly (a ghost panel is 13% opacity). Changing what the panels ARE
       re-decides the panels: clear removals here exactly as the Panels dropdown does (r65).
       Undo restores material and removals together, so a deliberate layout is one tap back. */
    if(qdNoPanels.length||qdSelPanels.length){ qdNoPanels=[]; qdSelPanels=[]; syncPostUI(); }
    updatePanelNote(); recalc();
  }); } })();
  (function(){ var s=$('qd-feet'); if(!s) return;
    function feetNote(){
      var n=$('qd-feet-note'); if(!n) return;
      /* r114, Patryk: "I don't think we need to explain the 3mm we will insert them into the
         correct once cut". Right - the workshop handles it, so there is nothing here for a
         customer to know or do, and 627 characters said so.
         DROPPING THE 3mm ALSO FIXES A CONTRADICTION. QD_E117 starts FALSE and only flips once a
         Worker answers 1.17.0+, so for the second or two before the first quote lands the page
         showed the OLD sentence - "the caps add about 3mm to the overall height" - the opposite
         of what now happens (the legs are cut shorter instead). A customer briefly read that
         caps make the frame taller, then watched it change its mind. Both engine versions now
         say the same short thing, so there is nothing left to flicker between. */
      if(qdFeet==='caps'){ n.textContent='Included.'; n.style.display='block'; }
      /* Same trim for castors, but the CONSTRAINT survives word for word: without open-ended
         legs a castor order cannot be built. */
      else if(qdFeet==='castors'){ n.textContent='Included \u2014 one wheel and one socket per leg. Castors need every floor-touching leg open-ended: remove the floor-level cross bars first.'; n.style.display='block'; }
      else n.style.display='none';
      /* r96: the feet key appears with the feet and goes away with them, exactly as the lip
         key follows the Panels choice. Castors get it too - the socket is worth seeing. */
      /* r107: the feet key is gone - there is nothing to key any more, the cap is just the cap.
         Kept hidden rather than deleted from the section, per the settled rule about unused markup. */
      var fw=$('qd-foothl-wrap'); if(fw) fw.style.display='none';
      /* r102: a foot only fits a leg with an OPEN end. A leg whose floor node still has cross
         bars ends in a connector, and the connector's own underside is already the foot -
         nothing pushes into it. That is right, but the page never said so, so Patryk had to ask
         why the middle legs got caps and the outside ones did not. Say it. No count: the number
         is the engine's to give and it does not send one yet. */
      try{
        if(qdFeet==='caps' && n && n.innerHTML){
          /* r114: four sentences became one. What a customer can act on is that it only fits an
             open end and that the price counts what fits; why a connector is already a foot is
             our business, not theirs. Castors are skipped - their own line already says it. */
          n.innerHTML += ' A cap only fits a leg with an <strong>open end</strong> \u2014 the count in the price is what actually fits.';
        }
      }catch(e){}
    }
    /* r218 THE CASTOR HEIGHT CONTROL and THE FLOOR-RAIL OFFER.
       Two things the tick sheet asked for (Q1/Q2 and Q5), wired here because this is
       already the one place that owns the Feet control.

       WHY THE OFFER EXISTS. A castor socket pushes into an OPEN tube end. On an ordinary
       shelf every floor-touching leg runs into a floor-level cross bar, so it ends in a
       connector and there is nowhere for a wheel to go - alucut refuses the whole frame.
       Measured 2 Sep: 1,296 of 1,296 ordinary shelf designs were refused for exactly this,
       and all 1,680 priced fine once the floor rails were gone. So the refusal is correct
       and castors were effectively unreachable without knowing the trick.
       It ASKS, it never does it silently: taking the floor rails out makes a real change
       to the frame - it is less braced down low - and that is the customer's call, not
       ours. One press instead of hunting for every bar. */
    /* r-cf6: the floor rails that ACTUALLY EXIST, from the same frameParts the drawing and
       cut list use - so the count matches what is on screen and the engine's own refusal.
       The old version generated a full (rows+1)x cols + (cols+1)x rows grid (40 on a 4x4) and
       only subtracted rails a customer had hand-deleted. It ignored interior-supports=top (no
       interior floor rails at all) and removed uprights, so it read 40/32 where 14 tubes were
       drawn and the engine said 14 legs. frameParts already applies railLevels, noPosts and
       noRails, so nothing here re-decides those rules. */
    function qdFloorRuns(){
      var out=[];
      try{
        var fp=frameParts(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares,railLvArr(),qdNoPosts,qdNoRails);
        for(var i=0;i<fp.beams.length;i++){ var b=fp.beams[i]; if(b.rail && b.rail.li===0 && b.rail.bays && b.rail.bays.length) out.push(b.rail); }
      }catch(e){}
      return out;
    }
    /* per-BAY entries (what noRails is keyed by) - a merged run through a removed upright is one
       tube but several bays, and ALL its bays must go for the engine to price. */
    function qdFloorRails(){
      var out=[], runs=qdFloorRuns(), i, k;
      for(i=0;i<runs.length;i++){ var r=runs[i]; for(k=0;k<r.bays.length;k++) out.push([r.ax,0,r.line,r.bays[k]]); }
      return out;
    }
    /* TUBES on screen (merged run = 1). This is the number the customer can count and the one
       to show - a bay count would read 2 high on his 5350 frame (16 vs 14 tubes). */
    function qdFloorBars(){ return qdFloorRuns().length; }
    function qdCastorUI(){
      var wrap=$('qd-castor-fit-wrap');
      if(wrap) wrap.style.display=(qdFeet==='castors')?'':'none';
      var off=$('qd-castor-clear');
      if(!off) return;
      var need=(qdFeet==='castors')?qdFloorBars():0;   /* r-cf6: tubes on screen, not bay-segments */
      off.style.display=need?'':'none';
      if(need) off.textContent='Take out the '+need+' floor-level cross bar'+(need===1?'':'s')+' so the wheels fit';
      /* r218b BRACING. Patryk, looking at the drawing: "this looks weak? maybe have
         crossbars put in for strength?" He is right, and it is measurable, not a feeling.
         A castor socket needs an OPEN tube end, so the whole floor perimeter has to go -
         there is no way to keep a rail at floor level. Count the rings of rails that
         survive on a 900 frame with the floor rails cleared:
             2 tiers -> ONE ring, at the very top. Four legs, nothing tying them together.
             3 tiers -> two rings (mid + top)
             4 tiers -> three rings
         So a TWO-TIER castor frame is the weak shape, every time, by necessity. The page
         has to say so before it is ordered, and point at the fix that actually works -
         another tier, which puts a rail back at mid height while leaving the leg ends open.
         Wording is deliberately about the SHAPE, not about load: we do not publish weight
         ratings and a warning that implied one would be a rating by the back door. */
      /* r219: the fact is worked out here (it depends on the feet and the rails) and PAINTED
         by the one Strength box, with the "+ Add a shelf level" button beside it. */
      var rings=Math.max(2,state.tiers||2)-1;   /* rails survive at every level above the floor */
      var weak=(qdFeet==='castors' && qdFloorRails().length===0 && rings<2);
      if(weak!==qdBraceWeak){ qdBraceWeak=weak; try{ qdStrengthPaint(); }catch(_e219c){} }
      var brace=$('qd-castor-brace'); if(brace) brace.style.display='none';
    }
    qdCastorUIFn=qdCastorUI;
    qdFloorRailsFn=qdFloorRails;   /* r218c: the refusal message needs the count too */
    qdFloorBarsFn=qdFloorBars;     /* r-cf6: display count = tubes */
    (function(){
      var cf=$('qd-castor-fit');
      if(cf) cf.addEventListener('change',function(){
        qdCastorFit=(this.value==='under')?'under':'trim'; recalc();
      });
      var off=$('qd-castor-clear');
      if(off) off.addEventListener('click',function(ev){
        ev.preventDefault();
        var add=qdFloorRails();
        if(!add.length) return;
        for(var i=0;i<add.length;i++) qdNoRails.push(add[i]);
        syncPostUI(); rebuild3D(); recalc(); qdCastorUI();
      });
    })();
    qdFeetNoteFn=feetNote;
    s.addEventListener('change',function(){ qdFeet=this.value; feetNote(); qdCastorUI(); rebuild3D(); recalc(); });
    qdCastorUI();
  })();
  (function(){ var e=$('qd-liphl'); if(e){ e.addEventListener('change',function(){ lipHL=this.checked; rebuild3D(); }); } })();
  (function(){ var e=$('qd-foothl'); if(e){ e.addEventListener('change',function(){ footHL=this.checked; rebuild3D(); }); } })();

  /* =======================================================================================
     r97 — THE CLEAN-UP (Patryk's sheet, 27 Aug 2026; all five answered Yes).

     Counted on the real V5.0 preview beforehand: 25 controls in Quick mode, 47 in the full
     designer with feet, panels and the openings panel all in play. These five take that to 38.

     The rule for every one of them: GROUP, never remove. Each underlying control keeps its id,
     its listeners and its behaviour - this block only changes where it sits and what drives it.
     That is deliberate: rebuilding the edit checkboxes as real radio buttons would mean
     re-pointing every listener in this file at new elements, and the cheapest bug to avoid is
     the one you never create.
     ======================================================================================= */
  (function(){
    /* --- 1. Edit modes: one control, four states -------------------------------------
       The three tick boxes were ALREADY mutually exclusive - each one unticks the other two,
       written out in three separate places. So the page looked like "these can all be on" and
       behaved like "pick one". This makes it honest. The boxes stay and are clicked for real,
       so every existing handler fires exactly as it does today. */
    (function(){
      var w1=$('qd-del-wrap'), w2=$('qd-delr-wrap'), w3=$('qd-delp-wrap');
      if(!w1||!w1.parentNode) return;
      var SEG=[{lab:'Off',box:null,wrap:null},
               {lab:'Uprights',box:'qd-del-on',wrap:w1},
               {lab:'Cross bars',box:'qd-delr-on',wrap:w2},
               {lab:'Panels',box:'qd-delp-on',wrap:w3}];
      var seg=document.createElement('div');
      seg.id='qd-editseg';
      seg.style.cssText='display:inline-flex;border:1px solid #cbd5e1;border-radius:9px;overflow:hidden;background:#fff';
      var btns=[];
      SEG.forEach(function(m,i){
        var b=document.createElement('button');
        b.type='button'; b.textContent=m.lab;
        b.style.cssText='border:0;border-left:'+(i?'1px solid #e2e8f0':'0')+';background:transparent;padding:7px 13px;font:inherit;font-size:13px;font-weight:600;color:#475569;cursor:pointer';
        b.addEventListener('click',function(ev){ ev.preventDefault(); pick(i); });
        seg.appendChild(b); btns.push(b);
      });
      w1.parentNode.insertBefore(seg,w1);
      [w1,w2,w3].forEach(function(w){ if(w) w.style.display='none'; });
      function pick(i){
        /* Untick what is on, then tick what is wanted - as real clicks, so nothing in this
           file has to know the segmented control exists. */
        SEG.forEach(function(m){ var b=m.box&&$(m.box); if(b&&b.checked){ b.checked=false; b.dispatchEvent(new Event('change',{bubbles:true})); } });
        var want=SEG[i].box&&$(SEG[i].box);
        if(want){ want.checked=true; want.dispatchEvent(new Event('change',{bubbles:true})); }
        paint();
      }
      function paint(){
        var active=0;
        SEG.forEach(function(m,i){ var b=m.box&&$(m.box); if(b&&b.checked) active=i; });
        btns.forEach(function(b,i){
          var on=(i===active);
          b.style.background = on?'#0e1a4d':'transparent';
          b.style.color      = on?'#fff':'#475569';
          /* A mode the engine has not revealed yet keeps its segment hidden, exactly as its
             own control was hidden. Cross bars and Panels appear when the engine says it can
             do them, and the segmented control has to follow that, not pre-empt it. */
          var hid = SEG[i].wrap ? (SEG[i].wrap.hidden===true) : false;
          b.style.display = hid?'none':'';
        });
      }
      ['qd-del-on','qd-delr-on','qd-delp-on'].forEach(function(id){ var b=$(id); if(b) b.addEventListener('change',paint); });
      if(window.MutationObserver){
        var mo=new MutationObserver(paint);
        [w1,w2,w3].forEach(function(w){ if(w) mo.observe(w,{attributes:true,attributeFilter:['hidden']}); });
      }
      paint();
    })();

    /* --- 2. The drawing gets its picture back ----------------------------------------
       Four display-only pills could sit on the canvas at once - lipped rails, feet, edge
       labels, wide openings. Counted with Undo, Redo, Spin, the view label and six view
       buttons, that was 15 pieces of furniture on the one thing customers came to look at.
       (The feet one was mine, added the same night. Fair cop.)
       They are MOVED into a fold, not re-created, so each keeps the show/hide logic that
       already decides whether it applies to this frame at all. */
    (function(){
      var keys=$('qd-keys'); if(!keys) return;
      /* r107: 'qd-foothl-wrap' removed - the feet tick no longer exists, so it must not be
         offered in the fold either or the menu would list a control that does nothing. */
      /* r-qv4 (Patryk 17 Sep: "we need to take away the connector types and it doesnt do
         anything if selected"). Dropped from the menu in the quote view for the same reason
         r107 dropped the feet tick: the pills need a quote for this design and the quote view
         never asks for one, so the control cannot do anything. Hidden as well as unlisted -
         unlisted alone would leave it loose on the canvas instead of inside the fold. */
      var picks=['qd-liphl-wrap','qd-dimhl-wrap','qd-connhl-wrap','qd-span-key']   /* r225 */
                  .filter(function(id){ return !(qdQuoteView && id==='qd-connhl-wrap'); })
                  .map(function(id){ return $(id); }).filter(Boolean);
      if(qdQuoteView){ try{ var _cw4=$('qd-connhl-wrap'); if(_cw4) _cw4.style.display='none'; }catch(_ecw4){} }
      if(!picks.length) return;
      var fold=document.createElement('div');
      fold.id='qd-keys-fold';
      fold.style.cssText='display:none;flex-direction:column;align-items:flex-start;gap:6px;pointer-events:auto';
      var btn=document.createElement('button');
      btn.type='button'; btn.id='qd-keys-btn';
      btn.style.cssText='position:relative;pointer-events:auto;background:rgba(255,255,255,.92);border:0;box-shadow:0 1px 3px rgba(0,0,0,.15);border-radius:6px;padding:5px 10px;font:inherit;font-size:12px;font-weight:600;color:#374151;cursor:pointer';
      var open=false;
      function sync(){ btn.textContent='Show on the drawing '+(open?'▴':'▾'); fold.style.display=open?'flex':'none'; }
      btn.addEventListener('click',function(ev){ ev.preventDefault(); open=!open; sync(); });
      keys.insertBefore(btn, picks[0]);
      keys.insertBefore(fold, picks[0]);
      picks.forEach(function(p){ fold.appendChild(p); });
      sync();
    })();

    /* --- 3. Save a copy, but Copy share link stays where it is -----------------------
       NOT negotiable, and the reason is in the notes: the designer's address bar never
       updates as a design changes, so Copy share link is the only thing that emits the design
       the customer is actually looking at. Behind a menu, people send the web address instead
       - the frame they started from, at the price they started from. It stays in the open.
       (Cut plan PDF is staff-only Liquid, so a customer sees two buttons become two, and
       staff see three become two.) */
    (function(){
      var row=document.querySelector('.qd-saverow'); if(!row) return;
      var movers=['qd-savebtn','qd-img','qd-cubepdf'].map(function(id){ return $(id); }).filter(Boolean);
      if(movers.length<2) return;
      var fold=document.createElement('div');
      fold.id='qd-savefold';
      fold.style.cssText='display:none;gap:8px;flex-wrap:wrap;margin-top:8px';
      var btn=document.createElement('button');
      btn.type='button'; btn.id='qd-savemore'; btn.className=(movers[0].className||'');
      var open=false;
      function sync(){ btn.textContent='Save a copy '+(open?'▴':'▾'); fold.style.display=open?'flex':'none'; }
      btn.addEventListener('click',function(ev){ ev.preventDefault(); open=!open; sync(); });
      row.appendChild(btn);
      row.parentNode.insertBefore(fold, row.nextSibling);
      movers.forEach(function(m){ fold.appendChild(m); });
      sync();
    })();

    /* --- 4. One size lock, because there was only ever one ---------------------------
       I told Patryk this would cost him per-axis unlocking. It does not: r57 already made a
       single flag (qdDimLock) drive all three, with its own comment saying "one padlock
       unlocks ALL three". So the three padlocks were three buttons for one boolean - pure
       surplus, not a trade-off. Corrected to him.
       One button, in words rather than a bare emoji, and it clicks the original so the r57
       handler and its explanation still do all the work. */
    (function(){
      var w=$('qd-w-lock'), d=$('qd-d-lock'), h=$('qd-h-lock');
      if(!w) return;
      var cell=w.closest('div'), sizeRow=cell&&cell.parentNode;
      if(!sizeRow||!sizeRow.parentNode) return;
      var one=document.createElement('button');
      one.type='button'; one.id='qd-sizelock';
      one.style.cssText='margin-top:7px;border:1px solid #cbd5e1;background:#fff;border-radius:8px;padding:6px 11px;font:inherit;font-size:12px;font-weight:600;color:#475569;cursor:pointer';
      one.addEventListener('click',function(ev){ ev.preventDefault(); w.click(); });
      sizeRow.parentNode.insertBefore(one, sizeRow.nextSibling);
      [w,d,h].forEach(function(b){ if(b) b.style.display='none'; });
      function sync(){
        var on=$('qd-open-on');
        one.style.display=(on&&on.checked)?'inline-block':'none';
        var locked=(w.textContent||'').indexOf('🔒')>=0;
        one.textContent = locked ? '🔒 Sizes locked — tap to change them'
                                 : '🔓 Sizes unlocked — tap to lock them';
      }
      if(window.MutationObserver){
        var mo=new MutationObserver(sync);
        mo.observe(w,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['hidden']});
      }
      var oc=$('qd-open-on'); if(oc) oc.addEventListener('change',function(){ setTimeout(sync,0); });
      sync();
    })();

    /* --- 5. The "3D view" readout goes ------------------------------------------------
       It named the view you were in, directly above a row of view buttons with the current
       one already highlighted. Hidden rather than removed: other code writes to it, and a
       hidden element that still takes a value cannot throw. */
    /* r-bv2, Patryk 3 Sep: "When you rotate it you can loose track on which is front back and so
       on and the customer can get frustrated and connect a wrong part". In the DESIGNER the readout
       is redundant - the view buttons are right under it and the current one is highlighted. In
       BUILD VIEW there are no view buttons in the customer's head, only a frame they are turning
       with a thumb, so it stays. Nothing changes for anyone who is not on ?build=1. */
    (function(){ var f=$('qd-facing'); if(f && !qdBuildView) f.style.display='none'; })();
  })();
  (function(){ var e=$('qd-spanhl'); if(e){ e.addEventListener('change',function(){ spanHL=this.checked; rebuild3D(); }); } })();
  // Live feedback for the keep-offcuts tick so the toggle visibly does something.
  (function(){ var k=$('qd-keepoffcuts'), s=$('qd-offcut-status'); if(k&&s){ var upd=function(){ if(k.checked){ s.textContent='Tube offcuts: kept with your order'; s.style.color='#0f7a3d'; } else { s.innerHTML='Tube offcuts: not kept &#183; drops stay with us'; s.style.color='#6b7280'; } }; k.addEventListener('change',upd); upd(); } })();
  /* ---- OPENING-DRIVEN SIZING -----------------------------------------------------------
     Patryk, 24 Aug: "he can add in the dimensions, from opening to opening, the width will change
     tho, so it'll need to be auto update on width and depth and height."

     So this runs the other way round from the rest of the page. Normally you type an overall size
     and the openings fall out of it. Tick this and you type the OPENINGS — the clear gap between
     one support and the next — and the overall width, depth and height are worked out to suit and
     written into the size boxes for you.

     The arithmetic is the settled connector rule, nothing new:
         overall = sum of the openings + (number of openings + 1) x 25.4
     because a divided edge has one more connector than it has tubes, and each connector eats
     25.4mm in line. Setting the overall size this way makes the engine's own split return the
     typed openings EXACTLY - avail = overall - (n+1)*25.4 = the sum, so each share comes back as
     the number that was typed. No rounding drift, no "you asked for 1215 and got 1202". */
  var A_HALF = 25.4;                       // one connector, measured along the tube
  var AX_COL = { w:'#0e1a4d', d:'#0e8fb8', h:'#5b9bd5' };   // same three colours as the size labels
  function overallOf(list){ var t=0; for(var i=0;i<list.length;i++) t+=(+list[i]||0); return Math.round(t + (list.length+1)*A_HALF); }
  /* r95 (Patryk, 26 Aug, tick sheet Q2+Q3): the height openings can be typed as the GAPS
     BETWEEN levels - how a fabricator thinks, and what this box has always been - or as the
     HEIGHT ABOVE THE FLOOR, which is how a customer thinks ("bottom shelf 200 off the
     ground"). This is a VIEW ONLY. The state stays gaps, the engine still receives gaps, the
     share link is untouched and no price can move: proved by pricing the same frame in both
     modes. Levels are joined by one connector each, so the rail at the top of opening i sits
     at (i+2) x 25.4 plus every gap below it. The bottom level's rail top is one connector,
     25.4mm - it is not zero, and saying zero would put every shelf a connector out. */
  var qdHFloor=false;                       // false = gaps between, exactly as before r95
  function gapsToFloor(gaps){               // gaps -> the rail height above each opening
    var out=[], run=A_HALF;
    for(var i=0;i<gaps.length;i++){ run += (+gaps[i]||0) + A_HALF; out.push(Math.round(run*10)/10); }
    return out;
  }
  function floorToGaps(hts){                // the exact inverse of gapsToFloor
    var out=[], prev=A_HALF;
    for(var i=0;i<hts.length;i++){ var h=+hts[i]||0; out.push(Math.round(h-prev-A_HALF)); prev=h; }
    return out;
  }
  /* Make a typed set of heights legal. THE ROUNDING GOES ON THE POSITIONS, NOT THE GAPS, and
     that is the whole trick. Rounding each gap on its own and then patching the odd
     millimetre onto a neighbour moves a shelf the customer never touched: typing 200/500/750
     that way lands the middle shelf on 499.2, 0.8mm out, because the patched gap sits under
     it. Rounding the running total instead keeps every shelf within half a millimetre of
     what was asked for, and editing one shelf cannot disturb the ones above it - their
     running totals never change. The gaps then fall out as differences and are whole by
     construction. rebalance() is left alone: proportional sharing is still right for gaps. */
  function resolveFloor(hts, avail){
    var n=hts.length, i, S=[], prev, next;
    for(i=0;i<n;i++) S.push(Math.round((+hts[i]||0) - (i+2)*A_HALF));   // tube below each rail
    S[n-1]=avail;                                   // the top box IS the overall height
    prev=0;                                         // nothing closer than MIN_OPEN from below
    for(i=0;i<n-1;i++){ if(S[i]<prev+MIN_OPEN) S[i]=prev+MIN_OPEN; prev=S[i]; }
    next=avail;                                     // ...or from above
    for(i=n-2;i>=0;i--){ if(S[i]>next-MIN_OPEN) S[i]=next-MIN_OPEN; next=S[i]; }
    if(S[0]<MIN_OPEN){ for(i=0;i<n;i++) S[i]=Math.round(avail*(i+1)/n); S[n-1]=avail; }
    var g=[]; prev=0;
    for(i=0;i<n;i++){ g.push(S[i]-prev); prev=S[i]; }
    /* A frame too short to hold this many levels has no legal answer at all. rebalance() ends
       up clamping in exactly the same way, and the engine refuses either version. */
    for(i=0;i<n;i++) if(g[i]<MIN_OPEN) g[i]=MIN_OPEN;
    return g;
  }
  function openAxes(){
    var cols=+($('qd-cols')?$('qd-cols').value:1)||1;
    var rows=+($('qd-rows')?$('qd-rows').value:1)||1;
    var N=($('qd-type').value==='box')?2:Math.max(2,+($('qd-tiers')?$('qd-tiers').value:3)||3);
    return [
      {k:'w', n:cols,  field:'qd-w', label:'Openings across the width', total:+$('qd-w').value||0},
      {k:'d', n:rows,  field:'qd-d', label:'Openings front to back', total:+$('qd-d').value||0},
      {k:'h', n:N-1,   field:'qd-h', label:(qdHFloor && N-1>1) ? 'Shelf heights above the floor' : 'Openings bottom to top', total:+$('qd-h').value||0}
    ];
  }
  /* Seed the boxes from the frame that is on screen right now, WITHOUT losing a millimetre.
     An even split does not always divide: 1800mm over 4 levels leaves 1673mm of tube, and
     418 x 4 is 1672 — tick the box and the height would quietly drop to 1799. So the remainder
     goes onto the last opening. 418/418/418/419 is what the frame actually is. */
  function seedOpenings(total, n){
    var avail=Math.round(total - (n+1)*A_HALF);
    if(!(avail>0)) return new Array(n).fill(60);
    var base=Math.floor(avail/n), rem=avail-base*n, out=[];
    for(var i=0;i<n;i++) out.push(Math.max(1, base + (i===n-1?rem:0)));
    return out;
  }
  function openFields(){
    try{
      var wrap=$('qd-open-wrap'), box=$('qd-open-fields'), on=$('qd-open-on');
      if(!wrap||!box||!on) return;
      if(!ENGINE14){ wrap.hidden=true; lockSizes(false); return; }
      wrap.hidden=false;
      /* r110: the boxes are about to be rebuilt or removed, so any opening still lit belongs
         to a panel that will not exist in a moment. Clear it here rather than leave a chain
         pointing at a bay that has been renumbered underneath it. */
      OPEN_HL=null;
      if(!on.checked){ box.hidden=true; box.innerHTML=''; openShares=null; qdDimLock=true; clearPins(); lockSizes(false); $('qd-open-note').textContent=''; return; }
      box.hidden=false; lockSizes(true);
      var axes=openAxes(), keep=openShares||{};
      /* r64: the Undo button used to be rendered HERE, inside the openings panel, which
         meant it did not exist unless that panel was open. It lives on the frame now and
         is always visible. */
      box.innerHTML = axes.map(function(a){
        var cur=(keep[a.k] && keep[a.k].length===a.n) ? keep[a.k] : seedOpenings(a.total, a.n);
        var col=AX_COL[a.k], f=[];
        /* r95: only the HEIGHT axis, and only when there is more than one opening. With a
           single opening the one box IS the overall height, so the two modes would show the
           same number and the switch would do nothing. */
        var HF=(a.k==='h' && qdHFloor && a.n>1);
        var shown=HF ? gapsToFloor(cur) : cur;
        for(var i=0;i<a.n;i++){
          /* Every opening carries an ID — W1, D2, H3 — printed here AND on the frame in the 3D
             view, in the same colour. Point at a bay in the picture and you know which box
             changes it. Without this the panel is three rows of unlabelled numbers. */
          /* r51: the X sits ON the length, because that is the thing the customer is pointing
             at. Pressing it removes the support beside this opening and joins the two into one.
             The title says the resulting size AND that the overall does not move, so nobody has
             to guess which way the merge goes. Only shown when there is a support to remove. */
          var x='';
          if(a.n>1){
            var jj=(i>0)?(i-1):0, pr=cur[jj]+cur[jj+1], mg=null, ov=overallOf(cur);
            for(var dd=25; dd<=26 && mg===null; dd++){ var tt=cur.slice(); tt.splice(jj,2,pr+dd); if(overallOf(tt)===ov) mg=pr+dd; }
            if(mg!==null){
              x = '<button type="button" class="qd-rmop" data-ax="'+a.k+'" data-i="'+i+'" '
                + 'title="Remove this opening. It joins the one to its '+((i>0)?'left':'right')+' to make a single '+mg+'mm opening. The overall size stays '+ov+'mm." '
                + 'aria-label="Remove opening '+a.k.toUpperCase()+(i+1)+'" '
                + 'style="border:1px solid '+col+'44;background:#fff;color:'+col+';border-radius:6px;width:26px;height:26px;line-height:1;font-size:14px;cursor:pointer;padding:0;margin:-4px 0 0 0;flex:0 0 auto">\u2715</button>';
            }
          }
          /* r51b: flex-start, not space-between. Pushed to the column edge the X looked like it
             belonged to the NEXT opening's label - the same "which one does this act on"
             confusion the button row had. It reads "W1 X". */
          /* r57: "1st, 2nd, 3rd" instead of W1/D2/H3. Nobody should have to learn a code to buy
             a shelf, and the drawing no longer carries the matching chips either. */
          var ORD=['1st','2nd','3rd','4th','5th','6th','7th'];
          /* r95: in floor mode box i is the rail ABOVE opening i, and the bottom rail is the
             1st - so the boxes count from the 2nd up. The top one is the overall height and
             is read-only here: it is changed in the Height field, not in this row. */
          var _ord = HF ? (ORD[i+1]||(i+2)) : (ORD[i]||(i+1));
          var _top = (HF && i===a.n-1);
          var _at  = HF ? ('min="0" step="any"') : ('min="60" step="1"');
          var _ro  = _top ? (' readonly title="This is the overall height. Change it in the Height box above." style="padding:7px 8px;font-size:14px;border-color:'+col+'44;width:100%;box-sizing:border-box;background:#f1f5f9;color:#475569"')
                          : (' style="padding:7px 8px;font-size:14px;border-color:'+col+'44;width:100%;box-sizing:border-box"');
          f.push('<div><span style="display:flex;align-items:center;justify-content:flex-start;gap:6px;font-size:11px;font-weight:700;color:'+col+';margin-bottom:2px;min-height:22px">'
            + '<span>'+_ord+'</span>' + (_top?'':x) + '</span>'
            + '<label style="display:block"><input type="number" '+_at+' data-ax="'+a.k+'" data-i="'+i+'" class="qd-in qd-openf"'+_ro+' value="'+shown[i]+'"></label></div>');
        }
        /* r50: DELETE A SUPPORT. n openings means n-1 interior supports, one between each
           neighbouring pair. Removing support j merges opening j into j+1 and hands back the
           25.4mm the vanished joint was eating, so the OVERALL size does not move by a
           millimetre - only the count of supports and the size of one bay. Named by the two
           bays it stands between, because "support 2" is ambiguous and W2|W3 is not. */
        var rm='';
        /* r57: a bar and a running total, so "why doesn't this add up" never has to be asked. */
        var bar = (a.n>1)
          ? ('<div id="qd-bar-'+a.k+'" style="display:flex;height:9px;border-radius:99px;overflow:hidden;background:#e8edf5;margin-top:9px"></div>'
             + '<div id="qd-bud-'+a.k+'" style="display:flex;justify-content:space-between;font-size:11.5px;color:#64748b;margin-top:5px"></div>')
          : '';
        /* r95: the switch. Two words each, because it sits above four number boxes on a
           phone. Height axis only - across the width and front to back there is no floor to
           measure from. */
        var tog='';
        if(a.k==='h' && a.n>1){
          tog='<div style="display:flex;gap:4px;margin:0 0 7px">' + ['gap','floor'].map(function(m){
            var on=((m==='floor')===qdHFloor);
            return '<button type="button" class="qd-hmode" data-hm="'+m+'" style="flex:1;padding:6px 4px;border:1.5px solid '
              + (on?'#0e1a4d':'#cbd5e1')+';background:'+(on?'#0e1a4d':'#fff')+';color:'+(on?'#fff':'#475569')
              + ';border-radius:8px;font-size:11.5px;font-weight:700;cursor:pointer;font-family:inherit">'
              + (m==='gap'?'Gaps between':'Height off the floor') + '</button>';
          }).join('') + '</div>';
        }
        return '<div style="margin-bottom:14px">'
          + '<span style="display:flex;justify-content:space-between;align-items:baseline;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#64748b;margin-bottom:4px">'
          + '<span>'+a.label+'</span><span id="qd-tot-'+a.k+'" style="font-weight:700;color:#0e1a4d;letter-spacing:0">&nbsp;</span></span>'
          + tog
          + '<div style="display:grid;grid-template-columns:repeat('+Math.min(a.n,4)+',1fr);gap:6px">'+f.join('')+'</div>'
          + bar + rm + '</div>';
      }).join('');
      /* r95: flipping the switch changes NOTHING about the frame, so there is no recalc and
         no undo step - it re-draws the same design with the other set of numbers in it. */
      Array.prototype.forEach.call(box.querySelectorAll('.qd-hmode'), function(b){
        b.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation();
          var want=(b.getAttribute('data-hm')==='floor');
          if(want===qdHFloor) return;
          qdHFloor=want; openFields();
        });
      });
      Array.prototype.forEach.call(box.querySelectorAll('.qd-rmop'), function(b){
        b.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation();
          var i=+b.getAttribute('data-i');
          removeSupport(b.getAttribute('data-ax'), (i>0)?(i-1):0);   // the support beside this opening
        });
      });
      $('qd-open-note').innerHTML='The outside sizes are locked. Change an opening and the other openings on that same side take up the difference, so the overall size stays exactly where you set it. Press <strong>\u2715</strong> to remove the support beside an opening.'
        + (qdHFloor ? '<br><br>Heights are to the <strong>top of the rail</strong> \u2014 a 6mm panel in the lipped rail finishes 0.35mm under that, so this is the height you stand something on. Cuts are whole millimetres and each joint is 25.4mm, so a height can land up to half a millimetre off what you type: <strong>the box always shows what you will actually get</strong>.' : '');
      readOpenFields(true);
    }catch(e){}
  }
  /* While the openings are driving, the overall boxes are an OUTPUT. Making them read-only rather
     than hiding them means the customer still sees the number that will be on the invoice. */
  /* r57: the overall sizes are now the MASTER, so they are locked while the openings are being
     played with - not because they are a computed output (they are not any more) but so a
     customer who has measured a space cannot knock the number out of it by accident. The
     padlock beside each one unlocks it. */
  var qdDimLock=true;
  function lockSizes(lock){
    var on=$('qd-open-on'), active=(on&&on.checked&&qdDimLock&&!!lock);
    ['qd-w','qd-d','qd-h'].forEach(function(id){
      var el=$(id); if(!el) return;
      el.readOnly=active;
      el.style.background = active ? '#f1f5f9' : '';
      el.style.color      = active ? '#475569' : '';
      el.title            = active ? 'Locked so the size you measured cannot move. Tap the padlock to change it.' : '';
      var b=$(id+'-lock');
      if(b){ b.hidden = !(on&&on.checked); b.textContent = active ? '\uD83D\uDD12' : '\uD83D\uDD13';
             b.title = active ? 'Locked \u2014 tap to change this size' : 'Unlocked \u2014 tap to lock it again'; }
    });
  }
  /* r50: remove ONE interior support and keep everything else exactly where it was.
     Changing the Columns dropdown cannot do this - it discards every custom opening and hands
     back even bays, which is a different frame at a different price. Merging is the honest
     operation: two openings become one, the joint that stood between them is gone, and the
     25.4mm that joint was eating goes back into the bay. overallOf() then returns the same
     number it returned before, so the customer's overall size is untouched. */
  var qdRmGuard=false;
  /* r52: UNDO. Deleting a support is destructive - two openings become one and the sizes of
     both are gone. Patryk: "we'll need a go back I guess if we delete the wrong piece". So take
     a snapshot of everything a delete touches BEFORE touching it, and keep a stack so several
     deletes in a row can be walked back one at a time. The checkbox state is part of the
     snapshot: without it, undoing back past the first delete collapses the whole panel. */
  /* ===== r64  UNDO / REDO, the whole design ================================
     Patryk, 25 Aug: "I want the option to undo and redo like what we have in office
     excel or word". What was here before remembered the openings and the deleted
     pieces and nothing else - not the width, not the height, not the finish, not the
     panel choice. It lived inside the openings panel, so it did not exist on screen
     unless that panel was open. It had no redo. And it emptied its own stack the moment
     anyone changed tiers, columns or depth supports.

     This remembers the COMPLETE design: every control, plus the openings and the
     deleted pieces. That is the same set the share link carries, and the share link is
     already proved complete - nothing the price depends on is missing from it.

     THE MODEL. `qdLast` is the design as of the last committed point. A change pushes
     qdLast onto the past and becomes the new qdLast. Nothing has to be snapshotted
     BEFORE a change, so no future caller can forget to ask for one - which is exactly
     how the old one came to miss twelve controls.

     A label travels with each step, so the button says what it will undo. */
  var QD_HIST_MAX = 60;
  var qdPast = [], qdFuture = [], qdLast = null, qdHistBusy = false, qdHistLabel = '';
  var QD_CTL = ['qd-type','qd-w','qd-d','qd-h','qd-tiers','qd-cols','qd-rows',
                'qd-finish','qd-panel','qd-supply','qd-fix','qd-rail','qd-feet','qd-upstand'];
  var QD_CTL_NAME = { 'qd-type':'the frame type', 'qd-w':'the width', 'qd-d':'the depth',
    'qd-h':'the height', 'qd-tiers':'the shelf tiers', 'qd-cols':'the columns',
    'qd-rows':'the depth supports', 'qd-finish':'the finish', 'qd-panel':'the panels',
    'qd-supply':'who supplies the panels', 'qd-fix':'how the panels are held',
    'qd-rail':'the interior supports', 'qd-feet':'the feet', 'qd-upstand':'the back board height' };

  function qdStateNow(){
    var st = { c:{}, on: !!(($('qd-open-on')||{}).checked), open:null,
               posts: qdNoPosts.map(function(p){ return p.slice(); }),
               rails: qdNoRails.map(function(a){ return a.slice(); }),
               panelsOut: qdNoPanels.map(function(a){ return a.slice(); }),
               bw: qdBackSel.map(function(a){ return a.slice(); }),
               fc: qdF6Str(qdFaces), l4: qdF6Str(qdLips4),
               upOn: !!(($('qd-up-on')||{}).checked), upF: qdUpFlush,
               matW: qdMatWalls, matB: qdMatBoard,
               sfRows: qdSpRows, sfRails: (qdSpRails?qdSpRails.slice():null),
               sfOff: qdSpOff.map(function(a){ return a.slice(); }) };
    QD_CTL.forEach(function(id){ var el=$(id); if(el) st.c[id]=el.value; });
    if(openShares){ st.open={}; ['w','d','h'].forEach(function(k){ if(openShares[k]) st.open[k]=openShares[k].slice(); }); }
    return st;
  }
  function qdKeyOf(o){ try{ return JSON.stringify(o); }catch(e){ return 'x'+Math.random(); } }

  /* What moved? Only used for the button's wording - "Undo the width" beats
     "Undo that change" when you are six steps deep and cannot remember. */
  function qdWhatChanged(a, b){
    if(!a) return 'that change';
    var hit=[];
    QD_CTL.forEach(function(id){ if(a.c[id]!==b.c[id] && QD_CTL_NAME[id]) hit.push(QD_CTL_NAME[id]); });
    if(hit.length) return hit.slice(0,2).join(' and ');
    if(qdKeyOf(a.posts)!==qdKeyOf(b.posts)) return 'the uprights';
    if(qdKeyOf(a.rails)!==qdKeyOf(b.rails)) return 'the cross bars';
    if(qdKeyOf(a.panelsOut)!==qdKeyOf(b.panelsOut)) return 'the panels';
    if(qdKeyOf(a.bw)!==qdKeyOf(b.bw)) return 'the back walls';
    if(a.upOn!==b.upOn) return 'the splashback';
    if(a.upF!==b.upF) return 'which face the splashback sits flush with';
    if(a.fc!==b.fc) return 'the panel faces';
    if(a.l4!==b.l4) return 'the four-edge support';
    if(qdKeyOf(a.open)!==qdKeyOf(b.open)) return 'the openings';
    if(a.on!==b.on) return 'the openings panel';
    return 'that change';
  }

  function qdCommit(label){
    if(qdHistBusy) return;
    var now = qdStateNow(), k = qdKeyOf(now);
    if(qdLast && qdLast.k === k) return;                    // nothing actually moved
    if(qdLast){
      qdPast.push({ s:qdLast.s, k:qdLast.k, label: label || qdHistLabel || qdWhatChanged(qdLast.s, now) });
      if(qdPast.length > QD_HIST_MAX) qdPast.shift();
      qdFuture.length = 0;                                  // a fresh action ends the redo branch
    }
    qdHistLabel = '';
    qdLast = { s:now, k:k };
    qdHistUI();
    try{ syncPostUI(); }catch(_e230){}   /* r230: the "N cross bars removed" chip recounts on every commit - it sat stale after add-support / add-bar */
    /* r69: the address bar used to update only after a PRICE came back, so an edit made in
       the seconds before the quote returned was lost on refresh (measured: type a width,
       refresh instantly, the width reverts). Every committed change now syncs the bar and
       autosaves - a refresh, a crash or a closed tab can no longer lose work. */
    try{ qdSyncAddressBar(); }catch(e){}
    try{ qdAutosave(); }catch(e){}
  }

  /* Put a whole design back. qdRmGuard keeps the shape-change listener from clearing the
     openings and the deleted pieces on the way past; qdHistBusy keeps the events this
     fires from being recorded as new steps. */
  function qdApplyState(st){
    qdHistBusy = true; qdRmGuard = true;
    try{
      QD_CTL.forEach(function(id){ var el=$(id); if(el && st.c[id]!=null) el.value = st.c[id]; });
      qdFinish = ($('qd-finish')||{}).value || qdFinish;
      panelMode = ($('qd-panel')||{}).value || 'none';
      var sp=$('qd-supply'); if(sp) panelSupply = sp.value;
      var fx=$('qd-fix'); if(fx) panelFix = (fx.value==='angle') ? 'angle' : 'lip';
      var rl=$('qd-rail'); if(rl) railLevels = rl.value || 'all';
      var ft=$('qd-feet'); if(ft) qdFeet = ft.value || 'none';
      openShares = null;
      if(st.open){ openShares={}; ['w','d','h'].forEach(function(k){ if(st.open[k]) openShares[k]=st.open[k].slice(); }); }
      qdNoPosts = (st.posts||[]).map(function(p){ return p.slice(); });
      qdNoRails = (st.rails||[]).map(function(a){ return a.slice(); });
      qdNoPanels = (st.panelsOut||[]).map(function(a){ return a.slice(); });
      qdBackSel = (st.bw||[]).map(function(a){ return a.slice(); });
      /* Set the materials BEFORE qdBwSync/qdUpSync run: both prune an empty
         group's material, and at this point the group itself is restored, so
         neither will. Set them after and the sync has already wiped them. */
      qdMatWalls = st.matW||''; qdMatBoard = st.matB||'';
      /* r203: and Undo carries the board's shape too - without it, undoing any unrelated
         change silently flattened a split board back to one band. */
      qdSpRows = st.sfRows||1;
      qdSpOff = (st.sfOff||[]).map(function(a){ return a.slice(); });
      try{ if(window.qdSfSync) window.qdSfSync(); }catch(_sfa){}
      try{ if(window.qdSfOpen) window.qdSfOpen(); }catch(_sfb){}
      qdPendMatW=''; qdPendMatB='';
      try{ if(window.qdMatSync) window.qdMatSync(); }catch(e){}
      try{ if(window.qdBwSync) window.qdBwSync(); }catch(e){}
      /* r170: the panel faces ride the history too - they were invisible to
         Undo since r144, and tap-to-panel makes that a customer-visible gap. */
      var _fr=(st.fc||'').split('.'), _lr=(st.l4||'').split('.');
      ['top','bottom','front','back','left','right'].forEach(function(k6){ qdFaces[k6]=_fr.indexOf(k6)>=0; qdLips4[k6]=_lr.indexOf(k6)>=0; });
      try{ if(window.qdSyncL4) window.qdSyncL4(); }catch(e){}
      var _uo=$('qd-up-on'); if(_uo) _uo.checked=!!st.upOn;
      qdUpFlush=(st.upF==='in')?'in':'out';
      var _uf=$('qd-up-flush-'+qdUpFlush); if(_uf) _uf.checked=true;
      try{ if(window.qdUpSync) window.qdUpSync(); }catch(e){}
      qdSelPosts=[]; qdSelRails=[]; qdSelPanels=[];
      try{ clearPins(); }catch(e){}
      var on=$('qd-open-on'); if(on) on.checked = !!st.on;
      try{ syncPanelOptions(); }catch(e){}
      try{ syncCols(); }catch(e){}
      try{ syncRows(); }catch(e){}
      try{ syncRail(); }catch(e){}
      try{ syncFixNeed(); }catch(e){}
      try{ updatePanelNote(); }catch(e){}
      try{ syncPostUI(); postMsg(''); }catch(e){}
      openFields();
      if(st.on) readOpenFields(true);
      /* readOpenFields recomputes the overall sizes FROM the openings. The two were
         captured together and should agree, but the snapshot is the record - put the
         three overalls back exactly as they were rather than trust the arithmetic. */
      ['qd-w','qd-d','qd-h'].forEach(function(id){ var el=$(id); if(el && st.c[id]!=null) el.value = st.c[id]; });
      rebuild3D();
      recalc();
    }catch(e){}
    qdRmGuard = false; qdHistBusy = false;
    qdHistUI();
  }

  function qdUndoStep(){
    qdFlushTyping();
    if(!qdPast.length) return;
    var prev = qdPast.pop();
    if(qdLast) qdFuture.push({ s:qdLast.s, k:qdLast.k, label: prev.label });
    qdLast = { s:prev.s, k:prev.k };
    qdHistLabel = '';
    qdApplyState(prev.s);
  }
  function qdRedoStep(){
    qdFlushTyping();
    if(!qdFuture.length) return;
    var nxt = qdFuture.pop();
    if(qdLast) qdPast.push({ s:qdLast.s, k:qdLast.k, label: nxt.label });
    qdLast = { s:nxt.s, k:nxt.k };
    qdHistLabel = '';
    qdApplyState(nxt.s);
  }

  function qdHistUI(){
    try{
      var u=$('qd-undo-b'), r=$('qd-redo-b');
      if(u){ u.disabled = !qdPast.length;
        u.title = qdPast.length ? ('Undo ' + (qdPast[qdPast.length-1].label||'that change') + '   (Ctrl+Z)')
                                : 'Nothing to undo yet   (Ctrl+Z)'; }
      if(r){ r.disabled = !qdFuture.length;
        r.title = qdFuture.length ? ('Redo ' + (qdFuture[qdFuture.length-1].label||'that change') + '   (Ctrl+Y)')
                                  : 'Nothing to redo   (Ctrl+Y)'; }
    }catch(e){}
  }

  /* ===== r69  SAVE / RESTORE ================================================
     Everything is stored as the SHARE LINK's query - the one format already proved to carry
     the complete priced design (nothing the price depends on is missing from it), already
     versioned, and already loaded by qdLoadFromURL. No second serialiser to drift.
     localStorage can be absent or full (private mode, cleared data): every touch is wrapped,
     and the designer works identically when it fails - saving is a convenience, never
     load-bearing. Browser saves stay on this device; the note in the panel says so. */
  var QD_LS_AUTO='aaQdAutosave1', QD_LS_LIST='aaQdSaves1', QD_LS_MAX=20;
  /* r70: set by the Save button; the NEXT quote carries it once so the OS can badge the
     design as deliberately saved. The engine (1.14.0+) sanitises and logs it; an older
     engine ignores the extra key. */
  var qdSavedFlag=null;
  function qdDesignQuery(){ var u=qdShareURL(), i=u.indexOf('?'); return i<0?'':u.slice(i); }
  function qdDesignLabel(){
    try{
      var t=$('qd-type').value==='box'?'Box':'Shelf';
      return t+' '+($('qd-w').value||'?')+'\u00d7'+($('qd-d').value||'?')+'\u00d7'+($('qd-h').value||'?')+'mm';
    }catch(e){ return 'design'; }
  }
  function qdAutosave(){
    try{
      var q=qdDesignQuery(); if(!q || q.length<10) return;
      localStorage.setItem(QD_LS_AUTO, JSON.stringify({ q:q, label:qdDesignLabel(), ts:Date.now() }));
    }catch(e){}
  }
  function qdLoadSaves(){ try{ var v=JSON.parse(localStorage.getItem(QD_LS_LIST)||'[]'); return Array.isArray(v)?v:[]; }catch(e){ return []; } }
  function qdStoreSaves(l){ try{ localStorage.setItem(QD_LS_LIST, JSON.stringify(l.slice(0,QD_LS_MAX))); }catch(e){} }
  function qdRenderSaves(){
    var box=$('qd-savelist'); if(!box) return;
    var l=qdLoadSaves();
    if(!l.length){ box.innerHTML='<div style="font-size:12px;color:#94a3b8">No saved designs yet.</div>'; return; }
    box.innerHTML=l.map(function(sv,i){
      var d=new Date(sv.ts||0);
      return '<div style="display:flex;align-items:center;gap:8px;padding:6px 0;border-top:1px dashed #e2e8f0">'
        +'<button type="button" class="qd-saveopen" data-i="'+i+'" style="flex:1;text-align:left;border:0;background:none;cursor:pointer;font:inherit;font-size:13px;color:#0e1a4d;font-weight:600;padding:0">'
        +String(sv.name||'design').replace(/[<>&]/g,'')+' <span style="font-weight:400;color:#64748b;font-size:11.5px">'+String(sv.label||'').replace(/[<>&]/g,'')+' \u00b7 '+d.toLocaleDateString()+'</span></button>'
        +'<button type="button" class="qd-savedel" data-i="'+i+'" title="Delete this saved design" style="border:1px solid #e2e8f0;background:#fff;color:#b42318;border-radius:6px;width:24px;height:24px;cursor:pointer;font-size:13px;line-height:1;padding:0">\u2715</button>'
        +'</div>';
    }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.qd-saveopen'), function(b){
      b.addEventListener('click', function(){
        var sv=qdLoadSaves()[+b.getAttribute('data-i')]; if(!sv||!sv.q) return;
        location.href=location.origin+location.pathname+sv.q;   // the proven loader does the rest
      });
    });
    Array.prototype.forEach.call(box.querySelectorAll('.qd-savedel'), function(b){
      b.addEventListener('click', function(){
        var l2=qdLoadSaves(); l2.splice(+b.getAttribute('data-i'),1); qdStoreSaves(l2); qdRenderSaves();
      });
    });
  }
  (function(){
    var btn=$('qd-savebtn'), box=$('qd-savebox'); if(!btn||!box) return;
    btn.addEventListener('click', function(){
      box.hidden=!box.hidden;
      if(!box.hidden){ qdRenderSaves(); var nm=$('qd-savename'); if(nm && !nm.value) nm.value=qdDesignLabel(); syncGoLabel(); }
    });
    var go=$('qd-savego');
    /* r72, Patryk 25 Aug: saving under a name that already exists UPDATES that save instead
       of piling up duplicates. Case-insensitive; the updated design moves to the top as the
       most recent. The button says Update whenever the typed name matches a saved one. */
    var nmEl=$('qd-savename');
    function syncGoLabel(){
      try{
        if(!go) return;
        var name=((nmEl&&nmEl.value.trim())||qdDesignLabel()).toLowerCase();
        var hit=qdLoadSaves().some(function(sv){ return String(sv.name||'').toLowerCase()===name; });
        go.textContent=hit?'Update':'Save';
      }catch(e){}
    }
    if(nmEl) nmEl.addEventListener('input', syncGoLabel);
    if(go) go.addEventListener('click', function(){
      var nm=$('qd-savename'), q=qdDesignQuery();
      if(!q) return;
      var name=(nm&&nm.value.trim())||qdDesignLabel();
      var existed=false;
      var l=qdLoadSaves().filter(function(sv){
        var hit=String(sv.name||'').toLowerCase()===name.toLowerCase();
        if(hit) existed=true; return !hit;
      });
      l.unshift({ name:name, label:qdDesignLabel(), q:q, ts:Date.now() });
      qdStoreSaves(l); qdRenderSaves(); syncGoLabel();
      qdSavedFlag=name;
      recalc();   // r70: one fresh quote carries savedName so the OS sees the save
      var msg=$('qd-share-msg'); if(msg){ msg.style.display='block'; msg.textContent=(existed?'Updated \u201c'+name+'\u201d on this device. ':'Saved on this device. ')+'Use Copy share link to carry it anywhere.'; setTimeout(function(){ msg.style.display='none'; },3500); }
    });
  })();
  /* the offer, only when the page opened BARE - a design in the URL always wins */
  (function(){
    try{
      var p=new URLSearchParams(location.search);
      if(p.get('w')) return;                                   // arrived with a design
      var sv=JSON.parse(localStorage.getItem(QD_LS_AUTO)||'null');
      if(!sv || !sv.q) return;
      if(sessionStorage.getItem('aaQdResumeNo')) return;       // said no this session
      var bar=$('qd-resume'); if(!bar) return;
      var what=$('qd-resume-what');
      if(what){ var d=new Date(sv.ts||0); what.textContent=(sv.label||'your last design')+' \u2014 '+d.toLocaleDateString()+' '+d.toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'}); }
      bar.hidden=false; bar.style.display='flex';
      var go=$('qd-resume-go'); if(go) go.addEventListener('click', function(){ location.href=location.origin+location.pathname+sv.q; });
      var no=$('qd-resume-no'); if(no) no.addEventListener('click', function(){ try{ sessionStorage.setItem('aaQdResumeNo','1'); }catch(e){} bar.style.display='none'; bar.hidden=true; });
    }catch(e){}
  })();

  /* TYPING. One undo step per NUMBER, not per keystroke - otherwise walking back out of
     "1500" takes four presses and Ctrl+Z is useless. A step is committed when the box is
     left, or after a 700ms pause, whichever comes first. Same as a word in Word. */
  var qdTypeT=null, qdTypeEl=null;
  function qdTypePending(el){ qdTypeEl=el||null; if(qdTypeT) clearTimeout(qdTypeT); qdTypeT=setTimeout(function(){ qdTypeT=null; qdTypeEl=null; qdCommit(); }, 700); }
  /* Flushing is per FIELD. A `change` somewhere else - and the engine dispatches its own
     on qd-fix and qd-rail the moment a Worker identifies itself - must not chop a number
     someone is still typing into two undo steps. Called with no argument it flushes
     whatever is pending, which is what Ctrl+Z wants. */
  function qdFlushTyping(el){
    if(!qdTypeT) return;
    if(el && qdTypeEl && el !== qdTypeEl) return;
    clearTimeout(qdTypeT); qdTypeT=null; qdTypeEl=null; qdCommit();
  }

  /* The five delete/restore actions call qdSnap immediately BEFORE they mutate. Rather
     than add a commit to each site - and leave the next one to be forgotten - keep the
     label and commit on the next tick, by which time the mutation has happened. */
  function qdSnap(label){ qdHistLabel = label || ''; setTimeout(function(){ qdCommit(); }, 0); }
  function qdSnapPosts(label){ qdSnap(label); }
  function removeSupport(k, j){
    try{
      var axes=openAxes(), a=null;
      for(var x=0;x<axes.length;x++) if(axes[x].k===k) a=axes[x];
      if(!a || a.n<2) return;
      if(!(j>=0 && j<a.n-1)) return;
      var cur=(openShares && openShares[k] && openShares[k].length===a.n)
                ? openShares[k].slice() : seedOpenings(a.total, a.n);
      var before=overallOf(cur);
      /* The merged bay is a+b+25.4 in real millimetres, but the boxes hold whole millimetres.
         Rounding it blindly moves the OVERALL size by 1mm on most sizes - the customer's
         5350 quietly becoming 5349. So pick the whole-millimetre bay that keeps the overall
         EXACTLY where it was, and refuse to act if none of them does. Never silently resize
         the frame the customer typed. */
      var pair=cur[j]+cur[j+1], merged=null;
      for(var d=25; d<=26 && merged===null; d++){
        var t=cur.slice(); t.splice(j,2,pair+d);
        if(overallOf(t)===before) merged=pair+d;
      }
      if(merged===null) return;
      /* snapshot AFTER every refusal path above, so a click that does nothing never lands a
         dead entry on the undo stack */
      qdSnap('removing the ' + ({w:'width',d:'depth',h:'height'}[k]||'') + ' support (it was '
             + cur[j] + ' + ' + cur[j+1] + 'mm)');
      cur.splice(j, 2, merged);
      /* write the new openings BEFORE driving the count control, so the recalc that the
         control fires already sees an opening list of the right length. Sending the old
         list would make the Worker refuse - correctly - and flash an error at the customer. */
      openShares = openShares || {};
      if(cur.length>1) openShares[k]=cur; else delete openShares[k];
      var ctlId = (k==='w') ? 'qd-cols' : (k==='d') ? 'qd-rows' : 'qd-tiers';
      var want  = (k==='h') ? (cur.length+1) : cur.length;   // h openings = levels - 1
      var el=$(ctlId);
      if(el){ qdRmGuard=true; el.value=String(want); el.dispatchEvent(new Event('change',{bubbles:true})); qdRmGuard=false; }
      var on=$('qd-open-on'); if(on) on.checked=true;
      openFields();        // rebuild the boxes, seeded from the merged list
      readOpenFields();    // recompute the overall size and reprice
    }catch(e){ qdRmGuard=false; }
  }
  /* r79 ADD A SUPPORT (26 Aug, from a customer's marked-up plan: "place new support legs
     in green position"). ZERO engine changes - measured before building: the recipe below
     prices a placed leg correctly on 1.15.0 (+$11.06 on the test frame), the far side's
     rails MERGE BACK as if the line never existed, and the leg-through-a-rail crossing
     takes the 3 way flat (settled 1.10.0). The gesture writes ordinary state:
       cols+1  +  openings split at the tapped spot (every other line HOLDS its position)
       + delete the new line's legs on the NOT-tapped depth lines
       + delete the new line's own depth rails (so nothing else changes shape).
     Existing deletions are REMAPPED, not cleared - a removed leg keeps naming the same
     physical leg (the r65 identity rule, done properly this time). A removed W-rail or
     panel in the bay being SPLIT is put back with a note: once the bay is two bays it no
     longer names one thing. */
  var QD_S3=1/1000;
  /* ---- r92: ADD A CROSS BAR --------------------------------------------------------------
     Grid heights: within 40mm of an existing level the bar snaps to it - a deleted bar there
     is put back; a bar already present says so; a level whose interior rails are switched off
     by "Interior supports" refuses honestly (v1).
     Arbitrary heights: the LEVEL-INSERT recipe, measured on the deployed engine 26 Aug 2026
     (bench $91.75 -> +bar at 400mm = $98.71; railed legs cut 361+312 with 3-way flats, the
     un-railed legs merged straight through): tiers+1 with h-shares placing the new level at
     the asked height, then every rail at that level is deleted except the one wanted. The
     engine needs no change at all. */
  var qdBarPending=null;   // {axis:'w'|'d', h:mm-up, line:index on the other axis, bay:index}
  var qdFsScroll=0;        // r93: where the page was before full-screen edit took over
  function qdOfferBar(xi, zi, pt){
    try{
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var h=Math.round(((pt.y/QD_S3)+state.H/2)/10)*10;   // world y is CENTERED - mm-up mirrors r79's mm-from-left
      if(h<0) h=0; if(h>state.H) h=state.H;
      var colsN=Math.max(1,g.xs.length-1);
      var bay=Math.min(colsN-1, Math.max(0, xi<colsN ? xi : xi-1));
      qdBarPending={axis:'w', h:h, line:zi, bay:bay};
      qdSyncBarUI(); rebuild3D();
    }catch(e){}
  }
  function qdSyncBarUI(){
    var w=$('qd-bar-wrap'); if(!w) return;
    if(qdBarPending && qdDelRail){
      w.style.display='flex';
      var hb=$('qd-bar-h'); if(hb) hb.value=qdBarPending.h;
      var _ax=qdBarPending.axis||'w';
      var bwb=$('qd-bar-ax-w'), bdb=$('qd-bar-ax-d');
      var hi=function(el,on){ if(!el) return; el.style.background=on?'#0e1a4d':'#fff'; el.style.color=on?'#fff':'#475569'; };
      hi(bwb,_ax==='w'); hi(bdb,_ax==='d');
      try{
        var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
        var ls=$('qd-bar-line'), bs=$('qd-bar-bay');
        var lines=_ax==='w'?g.zs:g.xs, bays=(_ax==='w'?g.xs:g.zs).length-1;
        if(ls){ ls.innerHTML='';
          for(var i=0;i<lines.length;i++){ var o=document.createElement('option'); o.value=i;
            o.textContent = _ax==='w'
              ? (i===0?'the front edge':(i===lines.length-1?'the back edge':(Math.round(lines[i]-lines[0])+'mm from the front')))
              : (i===0?'the left edge':(i===lines.length-1?'the right edge':(Math.round(lines[i]-lines[0])+'mm from the left')));
            ls.appendChild(o); }
          if(qdBarPending.line>=lines.length) qdBarPending.line=0;
          ls.value=String(qdBarPending.line); }
        if(bs){ bs.innerHTML='';
          var ORD=['1st','2nd','3rd','4th','5th','6th'];
          for(var j=0;j<bays;j++){ var o2=document.createElement('option'); o2.value=j; o2.textContent=(ORD[j]||(j+1))+' bay'; bs.appendChild(o2); }
          if(qdBarPending.bay>=bays) qdBarPending.bay=0;
          bs.value=String(qdBarPending.bay); }
      }catch(e){}
    } else w.style.display='none';
    qdStageRoom();   /* r230 */
  }
  function qdBarCommit(){
    try{
      if(!qdBarPending) return;
      var ax=qdBarPending.axis, h=qdBarPending.h, line=qdBarPending.line, bay=qdBarPending.bay;
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var ys=g.ys, N=ys.length;
      var yUp=ys.map(function(y){ return y + state.H/2; });   // mm-up, same convention as r79's centres
      /* GRID SNAP: within 40mm of a level, this is about THAT level's bar, not a new level */
      var Lnear=-1; for(var li=0; li<N; li++) if(Math.abs(yUp[li]-h)<=40){ Lnear=li; break; }
      var lines=(ax==='w')?g.zs:g.xs;
      var interiorLine = line>0 && line<lines.length-1;
      if(Lnear>=0){
        var want=[ax, Lnear, line, bay];
        if(nrHas(want)){
          qdNoRails=qdNoRails.filter(function(a){ return nrKey(a)!==nrKey(want); });
          qdCommit('putting a cross bar back at '+Math.round(yUp[Lnear])+'mm');
          qdBarPending=null; qdSyncBarUI(); rebuild3D(); recalc();
          postMsg('That height is an existing shelf level — the removed bar there has been put back.', false);
          return;
        }
        var lvlOn = !railLevels || railLevels==='all'
          || (railLevels==='ends' && (Lnear===0||Lnear===N-1))
          || (railLevels==='top' && Lnear===N-1)
          || (railLevels==='bottom' && Lnear===0);
        if(interiorLine && !lvlOn){
          postMsg('That height is an existing shelf level, but "Interior supports" has its cross bars switched off. Change that setting to every level, or place the bar at least 40mm away from the level.', true);
          return;
        }
        postMsg('There is already a cross bar at that height — place the new one at least 40mm away, or tap the existing bar to remove it.', true);
        return;
      }
      /* r230: the level-insert recipe writes shares + removed rails, which the engine refuses under
         a back board. Say so before the quote is sent, instead of a refusal over the old pills. */
      if(qdUpstand){ postMsg('With the back board on, a bar at its own height cannot be priced online \u2014 take the board off first, or add a shelf level with the Tiers control.', true); return; }
      /* ARBITRARY HEIGHT - the level-insert recipe */
      if(interiorLine && railLevels && railLevels!=='all'){
        postMsg('A bar on an interior line needs "Interior supports" set to every level — change that first, or put the bar on the front, back, left or right face.', true);
        return;
      }
      if(N>=6){ postMsg('This frame already has the maximum levels (6) — remove a shelf tier before adding another bar height.', true); return; }
      if($('qd-type').value==='box'){
        if(panelMode==='back'||panelMode==='backfront'){
          postMsg('Front/back panels are a box-frame option, and adding a bar at its own height turns the frame into a shelving unit. Take the panels off first.', true);
          return;
        }
      }
      var L=-1; for(var i4=0;i4<N-1;i4++) if(h>yUp[i4]&&h<yUp[i4+1]) L=i4+1;
      if(L<1){ postMsg('Place the bar between the floor and the top of the frame.', true); return; }
      var cur=(openShares&&openShares.h&&openShares.h.length===N-1)?openShares.h.slice():null;
      if(!cur){ cur=[]; for(var i5=0;i5<N-1;i5++) cur.push(Math.round(yUp[i5+1]-yUp[i5]-25.4)); }
      var before=overallOf(cur);
      var t1=Math.round(h-yUp[L-1]-25.4);
      var split=null;
      for(var dd=25; dd<=26 && split===null; dd++){
        var t2=cur[L-1]-t1-dd;
        var t3=cur.slice(); t3.splice(L-1,1,t1,t2);
        if(t1>=60 && t2>=60 && overallOf(t3)===before) split=t3;
      }
      if(split===null){ postMsg('That height leaves an opening under 60mm — move the bar up or down a little.', true); return; }
      qdHistBusy=true;
      var wasBox=($('qd-type').value==='box');
      if(wasBox){
        var te=$('qd-type'); qdRmGuard=true; te.value='shelf'; te.dispatchEvent(new Event('change',{bubbles:true}));
        var ti0=$('qd-tiers'); if(ti0){ ti0.value='2'; ti0.dispatchEvent(new Event('change',{bubbles:true})); } qdRmGuard=false;
      }
      var splitKept=false;
      /* level-index remaps: rails ['w'|'d', li, line, bay] li at index 1; panels [li,bk,dj] li at 0;
         leg PIECES [xi,zi,p] span level p..p+1 - the piece the new level lands INSIDE becomes two */
      qdNoRails=qdNoRails.map(function(a){ var b2=a.slice(); if(b2[1]>=L) b2[1]+=1; return b2; });
      qdNoPanels=qdNoPanels.map(function(a){ var b2=a.slice(); if(b2[0]>=L) b2[0]+=1; return b2; });
      var _np3=[];
      qdNoPosts.forEach(function(p){
        if(p.length<3){ _np3.push(p.slice()); return; }
        var q=p.slice();
        if(q[2]>=L){ q[2]+=1; _np3.push(q); return; }
        if(q[2]===L-1){ var q2=q.slice(); q2[2]=L; _np3.push(q,q2); splitKept=true; return; }   // r80 rule for the split piece
        _np3.push(q);
      });
      qdNoPosts=_np3;
      /* delete EVERYTHING at the new level except the one wanted bar */
      var colsN=Math.max(1,g.xs.length-1), rowsN=Math.max(1,g.zs.length-1);
      for(var z6=0;z6<g.zs.length;z6++) for(var b6=0;b6<colsN;b6++)
        if(!(ax==='w'&&z6===line&&b6===bay)) qdNoRails.push(['w',L,z6,b6]);
      for(var x6=0;x6<g.xs.length;x6++) for(var d6=0;d6<rowsN;d6++)
        if(!(ax==='d'&&x6===line&&d6===bay)) qdNoRails.push(['d',L,x6,d6]);
      if(panelMode==='all'){ for(var bk6=0;bk6<colsN;bk6++) for(var dj6=0;dj6<rowsN;dj6++) qdNoPanels.push([L,bk6,dj6]); }
      openShares=openShares||{}; openShares.h=split;
      var ti=$('qd-tiers');
      if(ti){ qdRmGuard=true; ti.value=String(N+1); ti.dispatchEvent(new Event('change',{bubbles:true})); qdRmGuard=false; }
      var on=$('qd-open-on'); if(on) on.checked=true;
      openFields(); readOpenFields();
      qdBarPending=null; qdSyncBarUI();
      qdHistBusy=false; qdCommit('adding a cross bar at '+h+'mm');
      postMsg((wasBox?'The frame is now a shelving unit (a box with an extra bar height is one). ':'')
        + 'Cross bar added at '+h+'mm'
        + (splitKept?' — pieces you had removed around that height stay removed.':' — the legs it meets are cut there and joined with flat connectors; every other leg runs straight through.')
        + ' The tiers control now counts this height as a level.', false);
    }catch(e){ qdRmGuard=false; qdHistBusy=false; }
  }
  function qdOfferAdd(){
    try{
      var g2=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var yf=g2.ys[0]*QD_S3;
      var o=qdRay.ray.origin, d=qdRay.ray.direction;
      if(Math.abs(d.y)<1e-6) return;
      var tt=(yf-o.y)/d.y; if(tt<=0) return;
      var wx=(o.x+d.x*tt)/QD_S3, wz=(o.z+d.z*tt)/QD_S3;
      if(Math.abs(wz)>state.D/2+150) return;             // tapped well outside the frame
      var X=Math.round((wx+state.W/2)/10)*10;
      if(X<90||X>state.W-90) return;                     // clear of the corner posts
      var zi=0,bd=1e9; for(var i2=0;i2<g2.zs.length;i2++){ var dv=Math.abs(g2.zs[i2]-wz); if(dv<bd){bd=dv; zi=i2;} }
      qdAddPending={axis:'w', X:X, zi:zi};
      qdSyncAddUI(); rebuild3D();
    }catch(e){}
  }
  /* r100: WHICH BAY did the finger land in, and where is its middle?
     The grid lines are the uprights, in centred mm - the same space the tapped point converts
     to - so the bay is just the pair of lines the tap falls between. Returns the centre of that
     bay in mm from the left/front edge, or null if the geometry cannot be read, in which case
     the caller falls back to the raw tap point exactly as r91 did. */
  function qdBayCentre(ax, raw){
    try{
      var g=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var lines=(ax==='w')?g.xs:g.zs;
      if(!lines || lines.length<2) return null;
      var i=0;
      while(i<lines.length-2 && raw>lines[i+1]) i++;
      var mid=(lines[i]+lines[i+1])/2;
      return Math.round((mid + ((ax==='w')?state.W:state.D)/2)/10)*10;
    }catch(e){ return null; }
  }
  function qdOfferAddOnRail(rail, pt){
    try{
      /* Patryk, 27 Aug: "i click on the left side of the cross bar and it snaps it to the right
         side". The mapping was never inverted - measured monotonic left to right - but a RAW tap
         point, rounded to 10mm and then clamped 90mm off each end, can finish the far side of an
         upright on a narrow bay. Tap the bay you mean and the support now halves THAT bay, which
         is what "add a support here" means to everyone who is not holding the source. The
         millimetre box below is still editable, so an exact position is one keystroke away. */
      var rawX=(pt.x/QD_S3), rawZ=(pt.z/QD_S3);
      var xmm=qdBayCentre('w', rawX); if(xmm===null) xmm=Math.round((rawX+state.W/2)/10)*10;
      var zmm=qdBayCentre('d', rawZ); if(zmm===null) zmm=Math.round((rawZ+state.D/2)/10)*10;
      if(rail.ax==='w'){
        if(xmm<90) xmm=90; if(xmm>state.W-90) xmm=state.W-90;
        qdAddPending={axis:'w', X:xmm, zi:rail.line};
      } else {
        if(zmm<90) zmm=90; if(zmm>state.D-90) zmm=state.D-90;
        qdAddPending={axis:'d', X:zmm, zi:rail.line};
      }
      qdSyncAddUI(); rebuild3D();
    }catch(e){}
  }
  /* r230: the "one leg only" tick in the New support box. Unticked = a full support line. */
  var QD_TAP_ONELEG_DEFAULT=false;
  function qdAddOneLeg(){ var c=$('qd-add-oneleg'); return c ? !!c.checked : QD_TAP_ONELEG_DEFAULT; }
  function qdSyncAddUI(){
    var w=$('qd-add-wrap'); if(!w) return;
    if(qdAddPending && qdDelMode){
      w.style.display='flex';
      var xb=$('qd-add-x'); if(xb) xb.value=qdAddPending.X;
      var _ax=qdAddPending.axis||'w';
      var un=$('qd-add-unit'); if(un) un.textContent = _ax==='d' ? 'mm from the front edge, on' : 'mm from the left edge, on';
      var bw=$('qd-add-ax-w'), bd=$('qd-add-ax-d');
      var hi=function(el,on){ if(!el) return; el.style.background=on?'#0e1a4d':'#fff'; el.style.color=on?'#fff':'#475569'; };
      hi(bw,_ax==='w'); hi(bd,_ax==='d');
      var zsel=$('qd-add-z');
      if(zsel){ try{
        var g5=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
        zsel.innerHTML='';
        var lines = _ax==='d' ? g5.xs : g5.zs;
        for(var z5=0; z5<lines.length; z5++){ var o5=document.createElement('option'); o5.value=z5;
          o5.textContent = _ax==='d'
            ? (z5===0 ? 'the left edge' : (z5===lines.length-1 ? 'the right edge' : (Math.round(lines[z5]-lines[0])+'mm from the left')))
            : (z5===0 ? 'the front edge' : (z5===lines.length-1 ? 'the back edge' : (Math.round(lines[z5]-lines[0])+'mm from the front')));
          zsel.appendChild(o5); }
        zsel.value=String(qdAddPending.zi);
      }catch(e5){} }
      var wh=$('qd-add-where'); if(wh) wh.textContent='full height, in the middle of the opening you tapped \u2014 type a number to move it';
    } else w.style.display='none';
    qdStageRoom();   /* r230 */
  }
  function qdAddCommit(){
    if(qdAddPending && qdAddPending.axis==='d') return qdAddCommitDepth();
    try{
      if(!qdAddPending) return;
      var colsNow=Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1);
      if(colsNow>=6){ postMsg('This frame already has the maximum vertical supports (6 columns) \u2014 remove one before adding another.', true); return; }
      /* r230: with the back board on, the engine prices only the full frame at even spacing
         (alucut refuses shares / removed pieces under a board - "put the removed pieces back").
         Add the support evenly, the way the Supports control does, and say so - rather than send
         a design that comes back refused with the previous frame's pills still on the drawing. */
      if(qdUpstand){
        var _elc=$('qd-cols'); if(!_elc) return;
        qdAddPending=null; qdSyncAddUI();
        qdDriveControl(_elc, String(colsNow+1), 'adding a support (even spacing, back board on)', 'Support added.');
        postMsg('Support added at even spacing \u2014 with the back board on, the frame prices only with evenly spaced supports. To place one exactly, take the board off first.', false);
        return;
      }
      var g2=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var X=qdAddPending.X, zi=qdAddPending.zi;
      var centres=g2.xs.map(function(x){ return x + state.W/2; });
      for(var ci=0;ci<centres.length;ci++) if(Math.abs(centres[ci]-X)<90){ postMsg('That spot is too close to an existing support \u2014 move it at least 90mm away.', true); return; }
      var k=-1; for(var i2=0;i2<centres.length-1;i2++) if(X>centres[i2]&&X<centres[i2+1]) k=i2;
      if(k<0){ postMsg('Tap a spot between two existing supports.', true); return; }
      var n=centres.length-1;
      var cur=(openShares&&openShares.w&&openShares.w.length===n)?openShares.w.slice():null;
      if(!cur){ cur=[]; for(var i3=0;i3<n;i3++) cur.push(Math.round(centres[i3+1]-centres[i3]-25.4)); }
      var before=overallOf(cur);
      /* split bay k at the tapped centre - whole millimetres, overall EXACTLY preserved
         (same d=25/26 hunt removeSupport uses in reverse) */
      var t1=Math.round(X-centres[k]-25.4);
      var split=null;
      for(var dd=25; dd<=26 && split===null; dd++){
        var t2=cur[k]-t1-dd;
        var t3=cur.slice(); t3.splice(k,1,t1,t2);
        if(t1>=60 && t2>=60 && overallOf(t3)===before) split=t3;
      }
      if(split===null){ postMsg('That spot leaves an opening under 60mm \u2014 move the new support along a little.', true); return; }
      qdHistBusy=true;   // r79: the whole add is ONE undo step - suppress the mid-flight commits
      var newXi=k+1, splitKept=false;
      qdNoPosts=qdNoPosts.map(function(p){ var q=p.slice(); if(q[0]>=newXi) q[0]+=1; return q; });
      /* r80: a removed rail or panel in the bay being split STAYS removed - as two pieces, one
         per child bay. r79 dropped the deletion ("put it back"), and on a frame whose
         neighbouring pieces were also gone the resurrected rail floated free of everything -
         the engine (rightly) refused the design as not joined, the price went to a dash, and
         the add looked broken. Found on Patryk's own 5350x3650 frame, 26 Aug 2026. */
      var _nr2=[];
      qdNoRails.forEach(function(a){ var b2=a.slice();
        if(b2[0]==='w'&&b2[3]===k){ var c2=b2.slice(); c2[3]=k+1; _nr2.push(b2,c2); splitKept=true; return; }
        if(b2[0]==='w'&&b2[3]>k) b2[3]+=1;
        if(b2[0]==='d'&&b2[2]>=newXi) b2[2]+=1;
        _nr2.push(b2); });
      qdNoRails=_nr2;
      var _np2=[];
      qdNoPanels.forEach(function(a){ var b2=a.slice();
        if(b2[1]===k){ var c2=b2.slice(); c2[1]=k+1; _np2.push(b2,c2); splitKept=true; return; }
        if(b2[1]>k) b2[1]+=1;
        _np2.push(b2); });
      qdNoPanels=_np2;
      /* r230 (Patryk, 3 Sep: "the cross bars dont get implemented when adding uprights"): the new
         line is a FULL support line - a leg on every depth line and its cross bars at every level,
         exactly what the Supports control adds, at the tapped position. "One leg only" (the tick
         in the box) keeps r79's single placed leg with no cross bars. */
      var _one=qdAddOneLeg();
      if(_one) for(var z2=0;z2<g2.zs.length;z2++) if(z2!==zi) qdNoPosts.push([newXi,z2]);
      var N2=g2.ys.length, lvls=[];
      if(!railLevels||railLevels==='all'){ for(var l2=0;l2<N2;l2++) lvls.push(l2); }
      else if(railLevels==='ends'){ lvls=[0,N2-1]; }
      else String(railLevels).split(/[^0-9]+/).forEach(function(v){ if(v!==''){ var n3=+v; if(n3>=0&&n3<N2&&lvls.indexOf(n3)<0) lvls.push(n3); } });
      var rowsN=Math.max(1,+($('qd-rows')?$('qd-rows').value:1)||1);
      if(_one) lvls.forEach(function(l3){ for(var j2=0;j2<rowsN;j2++) qdNoRails.push(['d',l3,newXi,j2]); });
      openShares=openShares||{}; openShares.w=split;
      qdAddPending=null; qdSyncAddUI();
      var el=$('qd-cols');
      if(el){ qdRmGuard=true; el.value=String(n+1); el.dispatchEvent(new Event('change',{bubbles:true})); qdRmGuard=false; }
      /* r230: a full line brings its floor cross bars; on castors those have to come back out (the
         same step the Supports control takes in qdDriveControl) or the engine refuses the wheels. */
      var _fl230=0;
      if(!_one && qdFeet==='castors' && qdFloorRailsFn){ var _fr230=qdFloorRailsFn(); for(var _fi=0;_fi<_fr230.length;_fi++) qdNoRails.push(_fr230[_fi]); _fl230=_fr230.length; if(qdCastorUIFn) try{ qdCastorUIFn(); }catch(_ec230){} }
      var on=$('qd-open-on'); if(on) on.checked=true;
      openFields(); readOpenFields();
      qdHistBusy=false; qdCommit('adding a support at '+X+'mm');
      postMsg((splitKept ? 'Support added. Pieces you had removed in the bay you split stay removed on both sides of the new support.'
                         : (_one ? 'Support added \u2014 one full-height leg, no cross bars, priced with its connectors.'
                                 : 'Support added \u2014 a leg on every depth line with its cross bars, priced with its connectors.'))
              + (_fl230 ? ' The floor cross bars stay out for the wheels.' : '')
              + ' Tap a piece to remove what you don\u2019t need.', false);
    }catch(e){ qdRmGuard=false; qdHistBusy=false; }
  }
  /* r91: the DEPTH mirror of the width add - measured on the engine first (26 Aug 2026):
     base 1500x1200x1000 $195.59 -> +left-line support at ~600 = $206.65; the tapped side's
     depth rails cut at the new leg (3x575+3x548), the far side merges through untouched
     (1148 reclaimed run), joints 2 x 3-way flat + 1 x 4-way flat - the settled shapes. */
  function qdAddCommitDepth(){
    try{
      if(!qdAddPending) return;
      var rowsNow=Math.max(1,+($('qd-rows')?$('qd-rows').value:1)||1);
      if(rowsNow>=6){ postMsg('This frame already has the maximum depth supports (6 rows) \u2014 remove one before adding another.', true); return; }
      if(qdUpstand){   /* r230: see qdAddCommit */
        var _elr=$('qd-rows'); if(!_elr) return;
        qdAddPending=null; qdSyncAddUI();
        qdDriveControl(_elr, String(rowsNow+1), 'adding a depth support (even spacing, back board on)', 'Support added.');
        postMsg('Support added at even spacing \u2014 with the back board on, the frame prices only with evenly spaced supports. To place one exactly, take the board off first.', false);
        return;
      }
      var g2=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
      var Z=qdAddPending.X, xi=qdAddPending.zi;
      var centres=g2.zs.map(function(z){ return z + state.D/2; });
      for(var ci=0;ci<centres.length;ci++) if(Math.abs(centres[ci]-Z)<90){ postMsg('That spot is too close to an existing support \u2014 move it at least 90mm away.', true); return; }
      var k=-1; for(var i2=0;i2<centres.length-1;i2++) if(Z>centres[i2]&&Z<centres[i2+1]) k=i2;
      if(k<0){ postMsg('Tap a spot between two existing supports.', true); return; }
      var n=centres.length-1;
      var cur=(openShares&&openShares.d&&openShares.d.length===n)?openShares.d.slice():null;
      if(!cur){ cur=[]; for(var i3=0;i3<n;i3++) cur.push(Math.round(centres[i3+1]-centres[i3]-25.4)); }
      var before=overallOf(cur);
      var t1=Math.round(Z-centres[k]-25.4);
      var split=null;
      for(var dd=25; dd<=26 && split===null; dd++){
        var t2=cur[k]-t1-dd;
        var t3=cur.slice(); t3.splice(k,1,t1,t2);
        if(t1>=60 && t2>=60 && overallOf(t3)===before) split=t3;
      }
      if(split===null){ postMsg('That spot leaves an opening under 60mm \u2014 move the new support along a little.', true); return; }
      qdHistBusy=true;
      var newZi=k+1, splitKept=false;
      qdNoPosts=qdNoPosts.map(function(p){ var q=p.slice(); if(q[1]>=newZi) q[1]+=1; return q; });
      var _nr2=[];
      qdNoRails.forEach(function(a){ var b2=a.slice();
        if(b2[0]==='d'&&b2[3]===k){ var c2=b2.slice(); c2[3]=k+1; _nr2.push(b2,c2); splitKept=true; return; }   // r80 rule, depth bays
        if(b2[0]==='d'&&b2[3]>k) b2[3]+=1;
        if(b2[0]==='w'&&b2[2]>=newZi) b2[2]+=1;
        _nr2.push(b2); });
      qdNoRails=_nr2;
      var _np2=[];
      qdNoPanels.forEach(function(a){ var b2=a.slice();
        if(b2[2]===k){ var c2=b2.slice(); c2[2]=k+1; _np2.push(b2,c2); splitKept=true; return; }
        if(b2[2]>k) b2[2]+=1;
        _np2.push(b2); });
      qdNoPanels=_np2;
      /* r230: full support line unless "one leg only" is ticked - see qdAddCommit */
      var _one=qdAddOneLeg();
      if(_one) for(var x2=0;x2<g2.xs.length;x2++) if(x2!==xi) qdNoPosts.push([x2,newZi]);
      var N2=g2.ys.length, lvls=[];
      if(!railLevels||railLevels==='all'){ for(var l2=0;l2<N2;l2++) lvls.push(l2); }
      else if(railLevels==='ends'){ lvls=[0,N2-1]; }
      else String(railLevels).split(/[^0-9]+/).forEach(function(v){ if(v!==''){ var n3=+v; if(n3>=0&&n3<N2&&lvls.indexOf(n3)<0) lvls.push(n3); } });
      var colsN=Math.max(1,+($('qd-cols')?$('qd-cols').value:1)||1);
      if(_one) lvls.forEach(function(l3){ for(var j2=0;j2<colsN;j2++) qdNoRails.push(['w',l3,newZi,j2]); });
      openShares=openShares||{}; openShares.d=split;
      qdAddPending=null; qdSyncAddUI();
      var el=$('qd-rows');
      if(el){ qdRmGuard=true; el.value=String(n+1); el.dispatchEvent(new Event('change',{bubbles:true})); qdRmGuard=false; }
      var _fl230=0;
      if(!_one && qdFeet==='castors' && qdFloorRailsFn){ var _fr230=qdFloorRailsFn(); for(var _fi=0;_fi<_fr230.length;_fi++) qdNoRails.push(_fr230[_fi]); _fl230=_fr230.length; if(qdCastorUIFn) try{ qdCastorUIFn(); }catch(_ec230){} }
      var on=$('qd-open-on'); if(on) on.checked=true;
      openFields(); readOpenFields();
      qdHistBusy=false; qdCommit('adding a support at '+Z+'mm from the front');
      postMsg((splitKept ? 'Support added. Pieces you had removed in the bay you split stay removed on both sides of the new support.'
                         : (_one ? 'Support added \u2014 one full-height leg, no cross bars, priced with its connectors.'
                                 : 'Support added \u2014 a leg on every width line with its cross bars, priced with its connectors.'))
              + (_fl230 ? ' The floor cross bars stay out for the wheels.' : '')
              + ' Tap a piece to remove what you don\u2019t need.', false);
    }catch(e){ qdRmGuard=false; qdHistBusy=false; }
  }
  (function(){
    var go=$('qd-add-go'), cx=$('qd-add-cancel'), xb=$('qd-add-x');
    if(go) go.addEventListener('click', function(ev){ ev.preventDefault(); qdAddCommit(); });
    if(cx) cx.addEventListener('click', function(ev){ ev.preventDefault(); qdAddPending=null; qdSyncAddUI(); rebuild3D(); });
    var zb=$('qd-add-z');
    if(zb) zb.addEventListener('change', function(){ if(!qdAddPending) return; qdAddPending.zi=(+this.value||0); rebuild3D(); });
    /* r81: the tap was the only way in, and on a busy frame nearly every tap ray lands on a
       piece before it reaches the floor - Patryk could not find a spot at all on his own
       5350x3650 frame, 26 Aug 2026. The button opens the same New support bar directly:
       X defaults to the middle of the widest bay, the depth line to the front edge, and
       both sit right there in the bar to change. Tapping an empty spot still works too. */
    var ob=$('qd-add-open');
    if(ob) ob.addEventListener('click', function(ev){ ev.preventDefault();
      try{
        var g6=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
        var cs6=g6.xs.map(function(x){ return x+state.W/2; });
        var bk6=0,bw6=-1; for(var i6=0;i6<cs6.length-1;i6++){ var wd6=cs6[i6+1]-cs6[i6]; if(wd6>bw6){ bw6=wd6; bk6=i6; } }
        var X6=Math.round(((cs6[bk6]+cs6[bk6+1])/2)/10)*10;
        if(X6<90) X6=90; if(X6>state.W-90) X6=state.W-90;
        qdAddPending={axis:'w', X:X6, zi:0};
        qdSyncAddUI(); rebuild3D();
      }catch(e6){}
    });
    /* r91: axis toggle in the bar - switching recomputes a sensible default position */
    var axDef=function(ax){
      try{
        var g7=qdGrid(state.type,state.W,state.D,state.H,state.tiers,state.cols,state.rows,openShares);
        var cs7=(ax==='d'?g7.zs:g7.xs).map(function(v){ return v+(ax==='d'?state.D:state.W)/2; });
        var bk7=0,bw7=-1; for(var i7=0;i7<cs7.length-1;i7++){ var wd7=cs7[i7+1]-cs7[i7]; if(wd7>bw7){ bw7=wd7; bk7=i7; } }
        var v7=Math.round(((cs7[bk7]+cs7[bk7+1])/2)/10)*10;
        var lim=(ax==='d'?state.D:state.W);
        if(v7<90) v7=90; if(v7>lim-90) v7=lim-90;
        qdAddPending={axis:ax, X:v7, zi:0};
        qdSyncAddUI(); rebuild3D();
      }catch(e7){}
    };
    /* r93 wiring: full-screen edit chips (phone) */
    var fsChip=function(chip, box){ var el=$(chip); if(!el) return;
      el.addEventListener('click', function(ev){ ev.preventDefault(); var b=$(box); if(b){ b.checked=!b.checked; b.dispatchEvent(new Event('change',{bubbles:true})); } }); };
    fsChip('qd-fs-up','qd-del-on'); fsChip('qd-fs-rail','qd-delr-on'); fsChip('qd-fs-pan','qd-delp-on');
    /* r168: the phone's single Edit chip - switch the Uprights mode on and the
       existing r93 fullscreen editor engages itself (innerWidth<=768). */
    (function(){ var em=$('qd-edit-mob'); if(!em) return;
      em.addEventListener('click', function(ev){ ev.preventDefault();
        var b=$('qd-del-on'); if(b && !b.checked){ b.checked=true; b.dispatchEvent(new Event('change',{bubbles:true})); }
      }); })();
    var fsd=$('qd-fs-done');
    if(fsd) fsd.addEventListener('click', function(ev){ ev.preventDefault();
      ['qd-del-on','qd-delr-on','qd-delp-on'].forEach(function(id){ var b=$(id); if(b&&b.checked){ b.checked=false; b.dispatchEvent(new Event('change',{bubbles:true})); } });
    });
    /* the floating price mirrors #qd-price */
    try{
      var _pm=$('qd-price'), _pf=$('qd-fs-price');
      if(_pm&&_pf&&window.MutationObserver){
        var _sync=function(){ _pf.textContent=_pm.textContent.trim(); };
        new MutationObserver(_sync).observe(_pm,{childList:true,characterData:true,subtree:true});
        _sync();
      }
    }catch(ePF){}
    /* r92 wiring: the cross-bar form */
    var bgo=$('qd-bar-go'), bcx=$('qd-bar-cancel'), bhb=$('qd-bar-h'), bob=$('qd-bar-open');
    if(bgo) bgo.addEventListener('click', function(ev){ ev.preventDefault(); qdBarCommit(); });
    if(bcx) bcx.addEventListener('click', function(ev){ ev.preventDefault(); qdBarPending=null; qdSyncBarUI(); rebuild3D(); });
    if(bhb) bhb.addEventListener('input', function(){ if(!qdBarPending) return; var v=Math.round((+this.value||0)/10)*10; if(v<0) v=0; if(v>state.H) v=state.H; qdBarPending.h=v; rebuild3D(); });
    if(bob) bob.addEventListener('click', function(ev){ ev.preventDefault();
      try{ qdBarPending={axis:'w', h:Math.round((state.H/2)/10)*10, line:0, bay:0}; qdSyncBarUI(); rebuild3D(); }catch(e){}
    });
    var bls=$('qd-bar-line'), bbs=$('qd-bar-bay');
    if(bls) bls.addEventListener('change', function(){ if(!qdBarPending) return; qdBarPending.line=(+this.value||0); rebuild3D(); });
    if(bbs) bbs.addEventListener('change', function(){ if(!qdBarPending) return; qdBarPending.bay=(+this.value||0); rebuild3D(); });
    var bxw=$('qd-bar-ax-w'), bxd=$('qd-bar-ax-d');
    if(bxw) bxw.addEventListener('click', function(ev){ ev.preventDefault(); if(qdBarPending&&qdBarPending.axis!=='w'){ qdBarPending.axis='w'; qdBarPending.line=0; qdBarPending.bay=0; qdSyncBarUI(); rebuild3D(); } });
    if(bxd) bxd.addEventListener('click', function(ev){ ev.preventDefault(); if(qdBarPending&&qdBarPending.axis!=='d'){ qdBarPending.axis='d'; qdBarPending.line=0; qdBarPending.bay=0; qdSyncBarUI(); rebuild3D(); } });
    var axw=$('qd-add-ax-w'), axd=$('qd-add-ax-d');
    if(axw) axw.addEventListener('click', function(ev){ ev.preventDefault(); if(qdAddPending&&qdAddPending.axis!=='w') axDef('w'); });
    if(axd) axd.addEventListener('click', function(ev){ ev.preventDefault(); if(qdAddPending&&qdAddPending.axis!=='d') axDef('d'); });
    if(xb) xb.addEventListener('input', function(){ if(!qdAddPending) return; var lim=(qdAddPending.axis==='d'?state.D:state.W); var v=Math.round((+this.value||0)/10)*10; if(v<90) v=90; if(v>lim-90) v=lim-90; qdAddPending.X=v; rebuild3D(); });
  })();
  /* r57 THE FLIP. Until now the openings were the INPUT and the overall size was whatever they
     added up to - so the moment a customer typed in a box, the size they had measured drifted.
     Patryk's own screen read 3646 after he asked for 3650. Now the overall size is the master:
     it never moves, and the openings are rebalanced to fit inside it.

     The arithmetic: an edge of length L divided into n openings has (n+1) joints eating 25.4mm
     each, so the openings must always add up to AVAIL = L - (n+1) x 25.4. Change one, and the
     others take up the difference in proportion to what they already were. That keeps the
     customer's own ratio between the bays they did not touch. */
  var MIN_OPEN = 60;                          // the engine refuses anything under this
  function availFor(total, n){ return Math.round(total - (n + 1) * A_HALF); }
  /* r57b: WHICH OPENINGS HOLD STILL. The first version rebalanced every opening except the one
     being typed - so setting the 1st bay and then the 3rd made the 1st drift back off the number
     the customer had just put in it (1177/2036/2035, then 1491/2580/1177). Useless.
     An opening the customer has typed is PINNED and does not move again. Only the ones they have
     not touched absorb the difference. If they pin every one, the oldest pin gives way, because
     something has to. Typing 1177 then 1177 on a locked 5350 now lands on 1177 / 2894 / 1177 -
     his drawing, in two keystrokes. */
  var qdPin = { w:[], d:[], h:[] };
  function pinOpen(ax,i){ var l=qdPin[ax]; if(!l) return; var k=l.indexOf(i); if(k>=0) l.splice(k,1); l.push(i); }
  function clearPins(){ qdPin={w:[],d:[],h:[]}; }
  function rebalance(list, avail, fixed, ax){
    var n=list.length; if(!n) return list;
    var out=list.map(function(v){ return Math.round(+v||0); });
    if(n===1) return [Math.max(MIN_OPEN, avail)];
    var pins=(ax && qdPin[ax]) ? qdPin[ax].filter(function(i){ return i>=0 && i<n; }) : [];
    var held={}, order=[];
    pins.forEach(function(i){ if(i!==fixed){ held[i]=1; order.push(i); } });
    if(fixed!=null) held[fixed]=1;
    var free=[], i2;
    for(i2=0;i2<n;i2++) if(!held[i2]) free.push(i2);
    /* everything pinned: the oldest pin gives way so there is somewhere for the difference to go */
    while(!free.length && order.length){ var give=order.shift(); delete held[give]; free.push(give); }
    if(!free.length){ for(i2=0;i2<n;i2++) if(i2!==fixed) free.push(i2); free.forEach(function(k){ delete held[k]; }); }
    /* clamp the typed one so the free ones can still be at least MIN_OPEN each */
    var heldSum=0; for(var k2 in held) heldSum+=Math.max(MIN_OPEN, out[k2]|0);
    if(fixed!=null){
      var others=heldSum-Math.max(MIN_OPEN,out[fixed]|0);
      var room=avail-others-free.length*MIN_OPEN;
      out[fixed]=Math.max(MIN_OPEN, Math.min(Math.max(MIN_OPEN,out[fixed]|0), room));
    }
    heldSum=0; for(var k3 in held) heldSum+=(out[k3]=Math.max(MIN_OPEN,out[k3]|0));
    var rest=avail-heldSum;
    var fsum=0; free.forEach(function(k){ fsum+=Math.max(MIN_OPEN,out[k]|0); });
    if(rest < free.length*MIN_OPEN){                     // still no room: give the pins back
      free=[]; for(i2=0;i2<n;i2++) if(i2!==fixed) free.push(i2);
      heldSum=(fixed!=null)?out[fixed]:0; rest=avail-heldSum; fsum=0;
      free.forEach(function(k){ fsum+=Math.max(MIN_OPEN,out[k]|0); });
    }
    if(free.length){
      if(fsum<=0) free.forEach(function(k){ out[k]=Math.max(MIN_OPEN, Math.round(rest/free.length)); });
      else free.forEach(function(k){ out[k]=Math.max(MIN_OPEN, Math.round(rest*Math.max(MIN_OPEN,out[k]|0)/fsum)); });
    }
    /* the last millimetre or two of rounding lands on a free opening, never on the one being typed */
    var sum=0; out.forEach(function(v){ sum+=v; });
    var slack=avail-sum;
    if(slack!==0){
      var pool=free.length?free.slice():[]; for(i2=n-1;i2>=0 && !pool.length;i2--) if(i2!==fixed) pool.push(i2);
      for(var q=pool.length-1;q>=0;q--){ if(out[pool[q]]+slack>=MIN_OPEN){ out[pool[q]]+=slack; slack=0; break; } }
      if(slack!==0 && fixed!=null && out[fixed]+slack>=MIN_OPEN) out[fixed]+=slack;
    }
    return out;
  }
  function readOpenFields(skipRecalc, fixedAx, fixedIdx){
    try{
      var on=$('qd-open-on');
      if(!on||!on.checked){ openShares=null; return; }
      if(fixedAx!=null && fixedIdx!=null && isFinite(fixedIdx)) pinOpen(fixedAx, fixedIdx);
      var got={};
      Array.prototype.forEach.call(document.querySelectorAll('.qd-openf'), function(el){
        var k=el.getAttribute('data-ax'), i=+el.getAttribute('data-i');
        (got[k]=got[k]||[])[i]=Math.max(1, +el.value||0);
      });
      var keep={}, any=false;
      [['w','qd-w'],['d','qd-d'],['h','qd-h']].forEach(function(pr){
        var list=got[pr[0]]; if(!list||!list.length) return;
        var total=+($(pr[1])||{}).value||0;                       // the LOCKED overall - the master
        if(!(total>0)) return;
        /* r65: with ONE opening there is nothing to rebalance, so this axis was a dead end -
           whatever was typed got snapped straight back to (overall - 50.8) and the box did
           nothing at all (Patryk, 25 Aug: "openning front to back does nothing"). One opening
           DRIVES the overall instead: overall = the opening + a connector each side. */
        if(list.length===1 && fixedAx===pr[0]){
          total=Math.round(Math.max(MIN_OPEN, +list[0]||0) + 2*A_HALF);
          var ovEl=$(pr[1]); if(ovEl && +ovEl.value!==total) ovEl.value=total;
        }
        var avail=availFor(total, list.length);
        var fixed=(fixedAx===pr[0]) ? fixedIdx : null;
        /* r95: floor mode hands the boxes to resolveFloor instead of rebalance - see there for
           why proportional sharing is the wrong rule once the numbers are heights. Either way
           what comes out is GAPS, which is the only thing openShares and the engine ever see. */
        var HF=(pr[0]==='h' && qdHFloor && list.length>1);
        var fitted= HF ? resolveFloor(list, avail)
                       : rebalance(list, avail, fixed, pr[0]);
        var show  = HF ? gapsToFloor(fitted) : fitted;
        /* write the rebalanced numbers back into the boxes, but never fight the one being typed */
        for(var i=0;i<fitted.length;i++){
          var el2=document.querySelector('.qd-openf[data-ax="'+pr[0]+'"][data-i="'+i+'"]');
          if(el2 && +el2.value!==show[i] && !(fixed===i && document.activeElement===el2)) el2.value=show[i];
        }
        var used=0; fitted.forEach(function(v){ used+=v; });
        var tot=$('qd-tot-'+pr[0]);
        if(tot) tot.textContent = total + 'mm overall';
        var bar=$('qd-bar-'+pr[0]);
        if(bar){
          bar.innerHTML = fitted.map(function(v,ix){
            return '<i style="width:'+(100*v/Math.max(1,avail))+'%;background:'+(ix%2?'#0e1a4d':'#12b8e5')+'"></i>';
          }).join('<i style="width:1.4%;background:transparent"></i>');
        }
        var bud=$('qd-bud-'+pr[0]);
        if(bud) bud.innerHTML = HF
          ? ('<span>1st sits on the floor at '+A_HALF+'mm</span><span><strong>top at '+show[show.length-1]+'mm</strong></span>')
          : ('<span>'+avail+'mm of tube to share out</span><span><strong>'
             + (avail-used===0 ? '0mm spare' : (avail-used)+'mm spare') + '</strong></span>');
        if(fitted.length>1 && fitted.some(function(v){return v!==fitted[0];})){ keep[pr[0]]=fitted; any=true; }
      });
      openShares = any ? keep : null;
      GZ.rx=null;
      if(!skipRecalc) recalc();
    }catch(e){ openShares=null; }
  }
  function showOpenResult(res){
    try{
      var n=$('qd-open-note'); if(!n) return;
      if(!openShares || !res || !res.input || !res.input.openings) return;
      var o=res.input.openings, bits=[], off=false;
      [['w','Width'],['d','Depth'],['h','Height']].forEach(function(p){
        var got=o[p[0]], want=openShares[p[0]];
        if(!want) return;
        bits.push(p[1]+' '+got.join(' / ')+'mm');
        for(var i=0;i<want.length;i++) if(Math.abs(got[i]-want[i])>1) off=true;
      });
      if(!bits.length) return;
      /* r51b: showOpenResult() overwrites the note every time a quote comes back, which wiped
         the only on-screen explanation of the X. There are no tooltips on a phone, so the hint
         has to be in the text. Only shown while there is actually a support to remove. */
      var multi=false;
      ['w','d','h'].forEach(function(kk){ if(openShares[kk] && openShares[kk].length>1) multi=true; });
      n.innerHTML = (off ? '<strong>Rounded to fit:</strong> ' : 'Cut to: ') + bits.join(' &nbsp;&middot;&nbsp; ')
        + '. The outside sizes stay where you set them.'
        + (multi ? ' Press <strong>\u2715</strong> to remove the support beside an opening.' : '');
    }catch(e){}
  }
  /* The control is meaningless on a single-bay, single-row frame: there are no interior rails to
     skip. Hide it rather than offer a choice that does nothing. */
  function syncRail(){
    try{
      var w=$('qd-rail-wrap'); if(!w) return;
      var any=((+($('qd-cols')?$('qd-cols').value:1)||1)>1) || ((+($('qd-rows')?$('qd-rows').value:1)||1)>1);
      w.hidden = !(ENGINE15 && any);
      if(w.hidden && railLevels!=='all'){ railLevels='all'; var sel=$('qd-rail'); if(sel) sel.value='all'; }
      var n=$('qd-rail-note');
      if(n) n.innerHTML = (railLevels==='all')
        ? 'The divider carries a cross bar at every level. Strongest, and what you get unless you change it.'
        : 'The divider bar is left out at the other levels. <strong>Every leg and the whole outer frame stay exactly as they are</strong> \u2014 only the divider bars go, so it saves tube and cuts. It is a looser frame front-to-back at those levels: fine for storage, think twice for a heavy bench.';
      qdSyncFolds();   /* the SAME element just changed between help and a load caution */
    }catch(e){}
  }
  (function(){
    var rl=$('qd-rail');
    if(rl) rl.addEventListener('change', function(){ railLevels=rl.value||'all'; syncRail(); rebuild3D(); recalc(); });
    ['qd-type','qd-tiers','qd-cols','qd-rows'].forEach(function(id){ var el=$(id); if(el) el.addEventListener('change', syncRail); });
    var on=$('qd-open-on');
    if(on) on.addEventListener('change', function(){ openFields(); recalc(); });
    var box=$('qd-open-fields');
    if(box){
      box.addEventListener('input', function(ev){
        var t=ev.target;
        if(t && t.classList && t.classList.contains('qd-openf')) readOpenFields(false, t.getAttribute('data-ax'), +t.getAttribute('data-i'));
      });
      box.addEventListener('focusin', function(ev){ var t=ev.target; if(t&&t.classList.contains('qd-openf')){ OPEN_HL=t.getAttribute('data-ax')+t.getAttribute('data-i'); GZ.rx=null; rebuild3D(); } });
      /* Escape is the way out. It is the one key everybody already tries. */
      document.addEventListener('keydown', function(ev){
        if(ev.key==='Escape' && OPEN_HL){ OPEN_HL=null; GZ.rx=null; rebuild3D(); }
      });
      /* r110, Patryk: "it needs to hold the dimslim when ive got it on on an imput, right now
         if i click somwhere eles or rotate, or click on another screen it disapeers". Right -
         you stop typing precisely BECAUSE you want to look at it. The chain now survives
         losing focus, rotating, scrolling and switching windows. It changes when you click a
         different opening, and it clears on Escape, on the openings tick going off, and on a
         shape change that rebuilds the boxes underneath it. Nothing new was added to the
         drawing to dismiss it: this stage already carries enough furniture. */
      box.addEventListener('focusout', function(){ GZ.rx=null; rebuild3D();
        /* r95: the box being typed in is the one place the ACHIEVED height cannot be written
           while the customer is mid-keystroke (it would snap "2" to a shelf height). Correct
           it on the way out, so the number left on screen is what the frame is cut to. */
        if(qdHFloor) try{ readOpenFields(true); }catch(e){} });
    }
    var ch225=$('qd-connhl');
    if(ch225) ch225.addEventListener('change', function(){ qdConnsOn=!!ch225.checked; GZ.rx=null; });   /* r225: connector-type pills */
    var dh=$('qd-dimhl');
    if(dh) dh.addEventListener('change', function(){
      var g=$('qd-gizmo'); if(g) g.style.display = dh.checked ? '' : 'none';
    });
    /* r62: the three size pills came OFF the drawing - Patryk, 24 Aug: "i really dont like how
       the height, width and depth are shown on the 3d designer". The sizes now live in a quiet
       line under the frame, which cannot overlap anything, and the edge labels become an
       opt-IN for anyone who wants to know which edge is which. */
    if(dh){ dh.checked=false; var g0=$('qd-gizmo'); if(g0) g0.style.display='none'; }
    (function(){
      var lw=$('qd-dimhl-wrap'); if(!lw) return;
      var last=lw.lastChild; if(last&&last.nodeType===3) last.nodeValue='Label the edges on the drawing';
    })();
    Array.prototype.forEach.call(document.querySelectorAll('.qd-vbtn'), function(b){
      b.addEventListener('click', function(){ setView(b.getAttribute('data-v')); });
    });
    qdSyncFolds();   /* first pass, before anyone has touched a control */
    var fx=$('qd-fix');
    if(fx) fx.addEventListener('change', function(){
      panelFix = (fx.value==='angle') ? 'angle' : 'lip';
      var n=$('qd-fix-note');
      if(n) n.innerHTML = (panelFix==='angle')
        ? 'We cut 20 &times; 20 &times; 1.6 aluminium angle to suit and supply it in your frame finish. You screw it to the rails &mdash; <strong>screws are not included</strong>. This is what makes an enclosure, side panels and depth-divided shelves possible, and it holds the panel on all four edges.'
        : 'The panel drops into the lipped rail &mdash; nothing to fix. Held on two opposite edges, one bay deep. <strong>Tip:</strong> for an enclosure, side panels or panels with depth supports, choose the angle ledge.';
      qdSyncFolds();   /* likewise: lip = help, angle = "screws are not included" */
      syncFixKey();
      syncFixNeed();
      try{ if(window.qdUpSync) window.qdUpSync(); }catch(eUp){}   /* r172: the board is a lipped-rail feature */
      recalc();
    });
  })();
  (function(){ Array.prototype.forEach.call(document.querySelectorAll('.qd-preset'),function(b){ b.addEventListener('click',function(){ var a=(b.getAttribute('data-p')||'').split(',');
      qdApplyingPreset=true; qdPresetName=(b.textContent||'').trim()||null;
      setTimeout(function(){ qdApplyingPreset=false; },0); var sv=function(id,v){ var el=$(id); if(el && v!=null && v!==''){ el.value=v; } }; sv('qd-type',a[0]); sv('qd-w',a[1]); sv('qd-d',a[2]); sv('qd-h',a[3]); sv('qd-tiers',a[4]); sv('qd-cols',a[5]); sv('qd-rows',a[6]||'1');
      /* positions 7 and 8 are the panel mode and how it is held. A preset that needs them is
         hidden until the engine reports 1.4.0, so clicking one can never ask for something the
         Worker cannot price. Openings are reset to even — a preset describes a shape, not a
         previous customer's uneven bays left over on the page. */
      openShares=null; var _oo=$('qd-open-on'); if(_oo) _oo.checked=false;
      if(a[8]){ panelFix = (a[8]==='angle') ? 'angle' : 'lip'; var _fx=$('qd-fix'); if(_fx){ _fx.value=panelFix; _fx.dispatchEvent(new Event('change')); } }
      if(a[7]){ var _pn=$('qd-panel'); if(_pn){ _pn.value=a[7]; _pn.dispatchEvent(new Event('change')); } }
      $('qd-type').dispatchEvent(new Event('change')); syncCols(); syncRows();
      /* slot 9 = the openings in MILLIMETRES, e.g. "w1068:356". It has to be applied AFTER the
         change events above: the shape listener clears the openings on any type/tiers/cols/rows
         change and would have wiped these on the way past. The button carrying slot 9 stays
         hidden until the engine reports 1.4.0, so it can never fire at a Worker that ignores it. */
      if(a[9] && ENGINE14){
        var _m=String(a[9]).match(/^([wdh])(.+)$/);
        if(_m){ var _vals=_m[2].split(':').map(Number);
          if(_vals.length>1 && _vals.every(function(v){return v>=60;})){
            var _oc=$('qd-open-on'); if(_oc) _oc.checked=true;
            openShares={}; openShares[_m[1]]=_vals;
          } }
      }
      /* r41 slot 10 = who supplies the panels. Every preset that used to default to 6mm
         aluminium plate on every face now says 'byo' - the frame is ours, the cladding is
         theirs. That is what took the dog kennel from $719.96 to $170.64 and let a coop be
         clad in mesh where it needs air. */
      if(a[10]){ var _sp=$('qd-supply'); panelSupply=(a[10]==='byo')?'byo':'us';
        if(_sp){ _sp.value=panelSupply; _sp.dispatchEvent(new Event('change')); } }
      /* r229 slot 11 = feet, slot 12 = castor fit. The trolley kit is "on castors": set the real
         Feet control, then press the real "take the floor bars out" button - what a customer does
         by hand, in that order, after the shape events above have reset qdNoRails. */
      /* Every preset SETS the feet - 'none' unless slot 11 says otherwise. Found by the r229 proof:
         after the trolley, the next preset kept castors and the engine refused it (legs end in
         connectors), so the page showed the trolley's price under the potting bench's name. */
      (function(){ var _ft=$('qd-feet'), _fv=(a[11]==='castors')?'castors':(a[11]==='caps'?'caps':'none');
        if(_ft && _ft.value!==_fv){ _ft.value=_fv; _ft.dispatchEvent(new Event('change')); }
        if(_fv==='castors'){
          if(a[12]){ var _cf=$('qd-castor-fit'); if(_cf){ _cf.value=(a[12]==='under')?'under':'trim'; _cf.dispatchEvent(new Event('change')); } }
          var _cl=$('qd-castor-clear'); if(_cl) _cl.click(); } })();
      openFields(); syncFixNeed(); recalc(); }); }); })();
  $('qd-spin').addEventListener('click',function(){
    spin=!spin;
    $('qd-spin-ic').innerHTML = spin ? '&#10073;&#10073;' : '&#9658;';
    $('qd-spin-tx').textContent = spin ? 'Pause spin' : 'Spin';
  });
  /* r59: what the widest opening was at the moment they ticked. Compared at Add time. */
  var qdTickedAtSpan=null;
  (function(){ var _cc=$('qd-consent'); if(_cc) _cc.addEventListener('change',function(){ qdTickedAtSpan = _cc.checked ? qdSpanFacts().mm : null; }); })();
  $('qd-add').addEventListener('click',function(){
    var btn=this; if(!state.lineItems||!state.lineItems.length){return;}
    /* r199 consent: AluCube cuts tube + plate to size; the global aa-cut-consent gate
       does not cover the "Add frame to cart" button, so block here until confirmed. */
    var _c=$('qd-consent'); if(_c&&!_c.checked){ $('qd-msg').style.color='#b42318'; $('qd-msg').textContent="Please confirm you've checked your measurements before adding to cart."; try{ var _cl=_c.closest('label'); if(_cl&&_cl.scrollIntoView) _cl.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} return; }
    /* r59: one tick, so the only extra question is whether the opening has CHANGED since they
       ticked it. Fail closed: clear the tick and make them read it again. Checked here and not
       on every recalc, so nobody is un-ticked mid-keystroke. */
    var _spanNow=qdSpanFacts().mm;
    if(_c && _spanNow>QD_SPAN_MAX && qdTickedAtSpan!==_spanNow){
      _c.checked=false; qdTickedAtSpan=null;
      $('qd-msg').style.color='#b42318';
      $('qd-msg').textContent='Your opening size has changed since you ticked the box \u2014 please read it and confirm again.';
      try{ var _cl2=_c.closest('label'); if(_cl2&&_cl2.scrollIntoView) _cl2.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){}
      return;
    }
    var items=state.lineItems;
    var bundleId='ac-'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);
    var recipeJson=JSON.stringify({v:'aa-alucube/1.8',openings:openShares,panelFix:panelFix,feet:qdFeet,castorFit:qdCastorFit,railLevels:railLevels,noPosts:(qdNoPosts.length?qdNoPosts:null),noRails:(qdNoRails.length?qdNoRails:null),noPanels:(qdNoPanels.length?qdNoPanels:null),type:state.type,W:state.W,D:state.D,H:state.H,tiers:state.tiers,cols:Math.max(1,state.cols||1),rows:Math.max(1,state.rows||1),finish:state.finish,panels:panelMode,panelSupply:(panelMode==='none'?'us':panelSupply),priceExGst:(typeof state.total==='number'?state.total:null),link:qdShareURL()});
    var designUrl=qdShareURL();
    items.forEach(function(it,i){ it.properties=it.properties||{}; it.properties['_bundle_id']=bundleId; if(i===0){ it.properties['_design_spec']=recipeJson; if(state.spaceText){ it.properties['_Internal opening']=state.spaceText; } var _editUrl=designUrl+(designUrl.indexOf('?')>=0?'&':'?')+'edit_bundle='+bundleId; /* r241 (Patryk 3 Sep): 'Internal opening' is a _ key now - the invoice shows what is bought, not an essay; staff and the OS still have it. The design link STAYS visible - Patryk: the customer must be able to reopen what he is paying for. */ /* r103: the PRINTED link must NOT carry edit_bundle - this property goes onto the order, the Order Printer documents and the confirmation email, and a forwarded copy would let a stranger edit this frame in their own cart. The hidden _edit keeps the token, so the customer's own Edit design button is unaffected. */ it.properties['View / edit this design']=designUrl; it.properties['_edit']=_editUrl; } });
    /* r58: if the customer accepted a wide opening, the ORDER has to say so - not just the screen. */
    if(_spanNow>QD_SPAN_MAX && items[0] && items[0].properties){
      items[0].properties['Wide span accepted']='This design has a '+_spanNow+'mm unsupported run, and you have ticked to accept it. Our guide is '+QD_SPAN_MAX+'mm. AluCube is a domestic, office and retail system and we have no deflection data at spans this long, so it will flex under load. Adding uprights in that run shortens the span.';
    }
    var _keepOff=($('qd-keepoffcuts')&&$('qd-keepoffcuts').checked);
    if(items[0]&&items[0].properties){ var _hasPlate=items.some(function(it){return it.properties&&it.properties['_Plate charge'];}); var _offMsg=_keepOff?'Included with your order.':'Not included.'; if(_hasPlate)_offMsg+=' 6mm plate panels are cut to size, so there are no offcuts.'; items[0].properties['Offcuts']=_offMsg; items[0].properties['_keep_tube_offcuts']=_keepOff?'yes':'no'; if(items[0].properties['_Freight']) items[0].properties['_Freight']+=' | offcuts '+(_keepOff?'SHIP - customer ticked keep offcuts':'stay in the workshop - not ticked'); }
    btn.disabled=true; $('qd-msg').style.color='#374151';
    $('qd-msg').textContent=(qdEditBundle||qdEditKey)?'Updating your design in the cart...':'Adding...';
    try{ if(window.__ACB_CLOAK__) window.__ACB_CLOAK__(); }catch(e){}
    var qdDoAdd=function(){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});});
    };
    var qdAddFail=function(res){ try{ if(window.__ACB_UNCLOAK__) window.__ACB_UNCLOAK__(); }catch(e){} btn.disabled=false; $('qd-msg').style.color='#b42318'; $('qd-msg').textContent=(res&&res.d&&res.d.description)||'Could not add - items may not be available yet.'; };
    if(qdEditBundle||qdEditKey){
      // r43: edit-replace now removes the OLD bundle BEFORE adding the new one.
      // r39 added first and removed after; Shopify coalesces a new line into an
      // existing line of the same variant when their line properties match, and
      // the cutting-charge line is exactly such a twin (same fee variant, same
      // customer-visible props for the same frame). The coalesced line kept the
      // OLD bundle id, so the old-line sweep deleted it - the reproduced missing
      // 9 dollar Cutting Service line. Removing first leaves nothing to merge
      // into and the sweep can never touch the new bundle. Old keys are zeroed
      // in ONE /cart/update.js call (same pattern as the bundle snippet Remove).
      // If the removal fails we abort and the original frame stays in the cart.
      var oldB=qdEditBundle, oldK=qdEditKey;
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
        var its=cart.items||[], oldBs={};
        if(oldB) oldBs[oldB]=1;
        if(oldK) its.forEach(function(it){ if(it.key===oldK){ var b=it.properties&&it.properties['_bundle_id']; if(b) oldBs[b]=1; } });
        var upd={}, n=0;
        its.forEach(function(it){ var b=it.properties&&it.properties['_bundle_id']; if((b&&oldBs[b])||(oldK&&it.key===oldK)){ upd[it.key]=0; n++; } });
        if(!n) return {ok:true};
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:upd})}).then(function(r){return {ok:r.ok};});
      }).then(function(rm){
        if(!rm||!rm.ok){
          btn.disabled=false; $('qd-msg').style.color='#b42318';
          $('qd-msg').textContent='Could not update the cart. Your frame is unchanged - try again.';
          try{ if(window.__ACB_UNCLOAK__) window.__ACB_UNCLOAK__(); }catch(e){}
          return;
        }
        qdEditBundle=null; qdEditKey=null;
        return qdDoAdd().then(function(res){
          if(res.ok){ window.location='/cart'; return; }
          qdAddFail(res);
          $('qd-msg').textContent='The new frame could not be added - please press again.';
          var ab=$('qd-add'); if(ab) ab.textContent='Add frame to cart';
        });
      }).catch(function(){
        btn.disabled=false; $('qd-msg').style.color='#b42318';
        $('qd-msg').textContent='Something went wrong. Please try again.';
        try{ if(window.__ACB_UNCLOAK__) window.__ACB_UNCLOAK__(); }catch(e){}
      });
      return;
    }
    qdDoAdd()
      .then(function(res){ btn.disabled=false;
        if(res.ok){
          $('qd-msg').style.color='#0f7a3d'; $('qd-msg').innerHTML='Added to cart. <a href="/cart">View cart &#8594;</a>';
          try{ if(window.__ACB_LOCK__){ window.__ACB_LOCK__(); setTimeout(window.__ACB_LOCK__,400); } }catch(e){}
          try{ fetch(QD_ENDPOINT.replace('/quote','/added'),{method:'POST',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({tool:'Qubelok Frame Designer',product:(state.type==='shelf'?'Shelving unit':'Box frame'),sizes:(state.W+' x '+state.D+' x '+state.H)})}).catch(function(){}); }catch(e){}
        }
        else { try{ if(window.__ACB_UNCLOAK__) window.__ACB_UNCLOAK__(); }catch(e){} $('qd-msg').style.color='#b42318'; $('qd-msg').textContent=(res.d&&res.d.description)||'Could not add — items may not be available yet.'; }
      })
      .catch(function(){ try{ if(window.__ACB_UNCLOAK__) window.__ACB_UNCLOAK__(); }catch(e){} btn.disabled=false; $('qd-msg').style.color='#b42318'; $('qd-msg').textContent='Something went wrong. Please try again.'; });
  });
  $('qd-share').addEventListener('click',function(){
    var url=qdShareURL(), msg=$('qd-share-msg');
    var show=function(t){ msg.textContent=t; msg.style.display='block'; };
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(function(){show('Link copied — paste it anywhere to reopen this exact design.');},function(){show(url);}); }
    else { show(url); }
  });
  $('qd-img').addEventListener('click',qdDownloadImg);

  // Staff-only: server-generated AluCube cut-plan PDF (recomputed server-side).
  var _qdCubePdf=$('qd-cubepdf');
  if(_qdCubePdf) _qdCubePdf.addEventListener('click',function(){
    if(!state.type||!state.W||!state.H) return;
    var _keepOffPdf=($('qd-keepoffcuts')&&$('qd-keepoffcuts').checked);
    var payload={ mode:'alucube-basket', frameType:state.type, W:state.W, D:state.D, H:state.H, tiers:state.tiers, cols:state.cols, rows:state.rows, finish:qdFinish, panels:(panelMode==='custom'?'none':panelMode), faces:(panelMode==='custom'?qdFaces:null), lips4:(panelMode==='custom'&&qdLips4Any()?qdLips4:null), panelSupply:(panelMode==='none'?'us':panelSupply), panelFix:panelFix,feet:qdFeet, castorFit:qdCastorFit, shares:openShares, railLevels:railLevels, noPosts:(qdNoPosts.length?qdNoPosts:null), noRails:(qdNoRails.length?qdNoRails:null), noPanels:(qdNoPanels.length?qdNoPanels:null), cat:qdCatalog(), jobName:'', staffName:'', keepTubeOffcuts:_keepOffPdf };
    var url=QD_ENDPOINT.replace('/quote','/cubeplan.pdf');
    /* r56: this used to fail in silence. window.open() after an await is not a user gesture any
       more, so a phone's popup blocker eats it; the <a download> fallback does nothing on iOS;
       and the AACut path had no .catch at all, so an error there ended the story with no message
       and no PDF. Now: one code path, an anchor click first, a same-tab open as the fallback,
       and a REASON on screen if it genuinely could not be fetched. */
    var say=function(t){ var m=$('qd-msg'); if(m){ m.style.color='#b42318'; m.textContent=t; } };
    var openBlob=function(blob){
      if(!blob || !blob.size){ say('The cut plan did not come back. Try again, or call the office \u2014 the quote itself is unaffected.'); return; }
      try{
        var u=URL.createObjectURL(blob);
        var a=document.createElement('a');
        a.href=u; a.target='_blank'; a.rel='noopener'; a.download='alucube-cut-plan.pdf';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function(){ try{ URL.revokeObjectURL(u); }catch(e){} },60000);
      }catch(e){ say('The cut plan could not be opened on this device.'); }
    };
    var viaPlain=function(){
      return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
        .then(function(r){ return r.ok ? r.blob() : null; });
    };
    var p0;
    if(window.AACut && typeof window.AACut.fetchBlob==='function'){
      try{ p0=Promise.resolve(window.AACut.fetchBlob(url,payload)).catch(function(){ return null; }); }
      catch(e){ p0=Promise.resolve(null); }
      p0=p0.then(function(b){ return (b && b.size) ? b : viaPlain(); });
    } else { p0=viaPlain(); }
    p0.then(openBlob).catch(function(){ say('The cut plan did not come back. Try again, or call the office \u2014 the quote itself is unaffected.'); });
  });
  qdLoadFromURL();
  try{ syncMode(); }catch(e){}                                   // rebuild an exact design if the URL carries one (or a kit deep-link)
  $('qd-type').dispatchEvent(new Event('change'));   // apply type-dependent UI (shelf tier selector, panel options)
  syncCols();                                        // show/hide the columns note for a loaded design
  syncRows();                                        // ditto for the depth-supports note
  $('qd-panel').dispatchEvent(new Event('change'));  // apply the panel note for a loaded design
  recalc();

  // First-load fix: on a cold page load the designer sat on $0.00 with an empty cut
  // list and never even called the server - it only came alive once you changed a
  // field. Re-running once the page has settled fixes it. Cheap: if the first pass
  // already worked, this just re-renders the cached answer.
  if(document.readyState === 'complete'){ setTimeout(recalc, 250); }
  else { window.addEventListener('load', function(){ setTimeout(recalc, 250); }); }

  /* ===== r64  HISTORY HOOKS ================================================
     Registered LAST, deliberately. The shape-change listener above clears the
     openings and the deleted pieces; listeners run in the order they were added, so
     recording after it means the step we save is the design the customer can see,
     not the one that existed for a microsecond before the clear. */
  QD_CTL.concat(['qd-open-on']).forEach(function(id){
    var el=$(id); if(!el) return;
    el.addEventListener('change', function(){
      qdFlushTyping(el);
      /* F2: ticking the openings panel open SEEDS the opening sizes, and until this the
         seed happened without being recorded - so the state the first opening edit was
         measured against still had no openings in it, and undoing that edit re-seeded
         from scratch and landed on a different number than the customer started with.
         Materialise the seed here, then record. */
      if(id==='qd-open-on' && el.checked && !openShares){ try{ readOpenFields(true); }catch(e){} }
      qdCommit();
    });
  });
  ['qd-w','qd-d','qd-h','qd-tiers','qd-cols','qd-rows'].forEach(function(id){
    var el=$(id); if(el) el.addEventListener('input', function(){ qdTypePending(el); });
  });
  (function(){
    /* The opening boxes are thrown away and rebuilt by openFields() every time, so the
       listener goes on the CONTAINER, which is not. Binding to the boxes themselves
       would work exactly once. */
    var box=$('qd-open-fields'); if(!box) return;
    box.addEventListener('change', function(ev){
      if(ev.target && ev.target.classList && ev.target.classList.contains('qd-openf')){
        qdFlushTyping(ev.target);
        /* NEXT TICK, deliberately. readOpenFields() is what writes the new sizes into
           openShares, and it runs from the box's OWN listener - which fires before this
           one on the container. Recording here and now would compare the design against
           itself, find nothing moved, and file no step at all: the browser test caught
           exactly that, an opening edit that Ctrl+Z would not take back. */
        setTimeout(function(){ qdCommit('the openings'); }, 0);
      }
    });
    box.addEventListener('input', function(ev){
      if(ev.target && ev.target.classList && ev.target.classList.contains('qd-openf')) qdTypePending(ev.target);
    });
  })();
  (function(){ var u=$('qd-undo-b'); if(u) u.addEventListener('click', function(e){ e.preventDefault(); qdUndoStep(); }); })();
  (function(){ var r=$('qd-redo-b'); if(r) r.addEventListener('click', function(e){ e.preventDefault(); qdRedoStep(); }); })();
  document.addEventListener('keydown', function(e){
    if(!(e.ctrlKey||e.metaKey) || e.altKey) return;
    var k=(e.key||'').toLowerCase();
    if(k!=='z' && k!=='y') return;
    /* Leave a plain text box alone. Ctrl+Z inside the job-name field is the browser's own
       undo of what was typed there, and stealing it to rebuild the frame would be worse
       than not having the shortcut at all. The design's own boxes DO belong to us. */
    var t=e.target, id=(t&&t.id)||'';
    var mine = QD_CTL.indexOf(id)>=0 || (t && t.classList && t.classList.contains('qd-openf'));
    var typing = t && (t.tagName==='INPUT'||t.tagName==='TEXTAREA'||t.tagName==='SELECT');
    if(typing && !mine) return;
    e.preventDefault();
    if(k==='y' || (k==='z' && e.shiftKey)) qdRedoStep(); else qdUndoStep();
  });
  /* The design as it stands on arrival - including anything a share link just rebuilt.
     Without this the first change has nothing to go back to. */
  (function(){ var st0=qdStateNow(); qdLast={ s:st0, k:qdKeyOf(st0) }; qdHistUI(); })();

  var s=document.createElement('script'); s.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js'; s.integrity='sha512-dLxUelApnYxpLt6K2iomGngnHO83iUvZytA3YjDUCjT0HDOHKXnVYdf3hU4JjM8uEhxf9nD1/ey98U3t2vZ0qQ=='; s.crossOrigin='anonymous'; s.onload=init3D; s.onerror=function(){var st=document.querySelector('.qd-stage');if(st)st.style.display='none';}; document.head.appendChild(s);
})();
